import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  TranslationKeysScalar: any;
  Upload: any;
};

export type AchDetails = {
  __typename?: 'ACHDetails';
  account_holder_type?: Maybe<Scalars['String']>;
  account_type?: Maybe<Scalars['String']>;
  bank_name?: Maybe<Scalars['String']>;
  fingerprint?: Maybe<Scalars['String']>;
  last4?: Maybe<Scalars['String']>;
  networks?: Maybe<AchNetworks>;
  routing_number?: Maybe<Scalars['String']>;
};

export type AchNetworks = {
  __typename?: 'ACHNetworks';
  preferred?: Maybe<Scalars['String']>;
  supported?: Maybe<Array<Scalars['String']>>;
};

export type ArCodeObject = {
  __typename?: 'ARCodeObject';
  active: Scalars['Boolean'];
  id: Scalars['String'];
  index: Scalars['Int'];
  property?: Maybe<PropertyObject>;
  title: Scalars['String'];
};

export type ActivityChangeLogModel = {
  __typename?: 'ActivityChangeLogModel';
  action: ActivityLogActions;
  text: Scalars['String'];
};

export enum ActivityLogActions {
  Add = 'add',
  Archive = 'archive',
  CheckIn = 'check_in',
  Company = 'company',
  Create = 'create',
  Date = 'date',
  Delete = 'delete',
  EmailSend = 'email_send',
  Generate = 'generate',
  Payment = 'payment',
  Print = 'print',
  Priority = 'priority',
  Rating = 'rating',
  Refund = 'refund',
  Remove = 'remove',
  SmsSend = 'sms_send',
  Status = 'status',
  Update = 'update',
  User = 'user'
}

export type ActivityLogModel = {
  __typename?: 'ActivityLogModel';
  activityType: ActivityTypeEnum;
  author?: Maybe<AuthorObject>;
  changeLog: Array<ActivityChangeLogModel>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  internal: Scalars['Boolean'];
  property: PropertyObject;
  referToRecord: ReferToObject;
};

export enum ActivityTypeEnum {
  Changelog = 'CHANGELOG',
  Comment = 'COMMENT'
}

export type Address = {
  __typename?: 'Address';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type AddressInput = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** The supported values for get users request. */
export enum ArchiveStatusEnum {
  /** All records */
  All = 'ALL',
  /** Archived record list */
  Archived = 'ARCHIVED',
  /** Non archived record list */
  NotArchived = 'NOT_ARCHIVED'
}

export type AuthorObject = {
  __typename?: 'AuthorObject';
  active: Scalars['Boolean'];
  firstName: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  photo?: Maybe<FileObject>;
};

export type BillingAddress = {
  __typename?: 'BillingAddress';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type BuildingInput = {
  propertyId: Scalars['String'];
  title: Scalars['String'];
};

export type BuildingObject = {
  __typename?: 'BuildingObject';
  active: Scalars['Boolean'];
  id: Scalars['String'];
  index: Scalars['Int'];
  property: PropertyObject;
  title: Scalars['String'];
  userCount: Scalars['Int'];
};

export type CoiWidget = {
  __typename?: 'COIWidget';
  count: Scalars['Int'];
  name: CoiWidgetStatusEnum;
  percentage: Scalars['Float'];
};

export type Card = {
  __typename?: 'Card';
  brand?: Maybe<Scalars['String']>;
  checks?: Maybe<Checks>;
  country?: Maybe<Scalars['String']>;
  exp_month?: Maybe<Scalars['Float']>;
  exp_year?: Maybe<Scalars['Float']>;
  fingerprint?: Maybe<Scalars['String']>;
  funding?: Maybe<Scalars['String']>;
  generated_from?: Maybe<Scalars['String']>;
  last4?: Maybe<Scalars['String']>;
  networks?: Maybe<Networks>;
  three_d_secure_usage?: Maybe<ThreeSecure>;
};

export type CategoryGroupInput = {
  icon?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CategoryGroupObject = {
  __typename?: 'CategoryGroupObject';
  active: Scalars['Boolean'];
  categories?: Maybe<Array<CategoryObject>>;
  categoryCount: Scalars['Int'];
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  index: Scalars['Int'];
  property?: Maybe<PropertyObject>;
  title: Scalars['String'];
};

export type CategoryInput = {
  defaultPriorityId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['String']>;
  icon?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CategoryObject = {
  __typename?: 'CategoryObject';
  active: Scalars['Boolean'];
  defaultPriority?: Maybe<PriorityObject>;
  description?: Maybe<Scalars['String']>;
  employee?: Maybe<EmployeeObject>;
  group?: Maybe<CategoryGroupObject>;
  id: Scalars['String'];
  index: Scalars['Int'];
  property?: Maybe<PropertyObject>;
  title: Scalars['String'];
  usersNotify?: Maybe<Array<UserObject>>;
};

/** The supported records type. */
export enum CategoryRecordType {
  /** For Incident component */
  Incident = 'incident',
  /** For Work Order component */
  WorkOrder = 'workOrder'
}

export type ChargeCodeObject = {
  __typename?: 'ChargeCodeObject';
  active: Scalars['Boolean'];
  id: Scalars['String'];
  index: Scalars['Int'];
  property?: Maybe<PropertyObject>;
  title: Scalars['String'];
};

export enum ChargeEnum {
  Labor = 'labor',
  Material = 'material'
}

export type ChargeObject = {
  __typename?: 'ChargeObject';
  baseTaxable: Scalars['Boolean'];
  billable: Scalars['Boolean'];
  date?: Maybe<Scalars['String']>;
  employeeUser?: Maybe<UserObject>;
  hours?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  laborRate?: Maybe<LaborRateObject>;
  markup?: Maybe<MarkupObject>;
  markupAmount?: Maybe<Scalars['Float']>;
  markupTaxable: Scalars['Boolean'];
  markupType?: Maybe<ValueUnit>;
  material?: Maybe<MaterialObject>;
  notes?: Maybe<Scalars['String']>;
  price: Scalars['Float'];
  quantity?: Maybe<Scalars['Float']>;
  taxAmount?: Maybe<Scalars['Float']>;
  total: Scalars['Float'];
  type: ChargeEnum;
};

export type Checks = {
  __typename?: 'Checks';
  address_line1_check?: Maybe<Scalars['String']>;
  address_postal_code_check?: Maybe<Scalars['String']>;
  cvc_check?: Maybe<Scalars['String']>;
};

export enum CoiExpirationEnum {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  ExpiresSoon = 'EXPIRES_SOON',
  Today = 'TODAY'
}

export type CoiObject = {
  __typename?: 'CoiObject';
  attachment: FileObject;
  company: CompanyObject;
  contactEmails: Array<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<UserObject>;
  expiration: Scalars['String'];
  id: Scalars['String'];
  isArchived: Scalars['Boolean'];
  note?: Maybe<Scalars['String']>;
  property: PropertyObject;
  status: CoiStatusEnum;
  title: Scalars['String'];
  validFrom: Scalars['String'];
  validTo: Scalars['String'];
};

export enum CoiStatusEnum {
  Compliant = 'COMPLIANT',
  NotCompliant = 'NOT_COMPLIANT',
  Pending = 'PENDING'
}

export enum CoiWidgetStatusEnum {
  Compliant = 'COMPLIANT',
  Expired = 'EXPIRED',
  NotCompliant = 'NOT_COMPLIANT',
  Pending = 'PENDING'
}

export type CommentModel = {
  __typename?: 'CommentModel';
  author: AuthorObject;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  internal: Scalars['Boolean'];
  parent?: Maybe<CommentModel>;
  text: Scalars['String'];
};

export type CompanyBillObject = {
  __typename?: 'CompanyBillObject';
  billTo?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};

export type CompanyInput = {
  phone?: InputMaybe<Scalars['String']>;
  photo?: InputMaybe<FileObjectInput>;
  properties: Array<Scalars['String']>;
  taxCode?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type: CompanyTypeEnum;
  vendorId?: InputMaybe<Scalars['String']>;
};

export type CompanyObject = {
  __typename?: 'CompanyObject';
  active: Scalars['Boolean'];
  address?: Maybe<Address>;
  billing?: Maybe<CompanyBillObject>;
  complianceId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  geneaTenant?: Maybe<GeneaTenantObject>;
  id: Scalars['String'];
  index: Scalars['Int'];
  phone?: Maybe<Scalars['String']>;
  photo?: Maybe<FileObject>;
  taxCode?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type: CompanyTypeEnum;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userCount: Scalars['Int'];
  vendorId?: Maybe<Scalars['String']>;
};

export type CompanyPropertyObject = {
  __typename?: 'CompanyPropertyObject';
  active: Scalars['Boolean'];
  property: PropertyObject;
  suiteId?: Maybe<Scalars['String']>;
};

export enum CompanyTypeEnum {
  Management = 'MANAGEMENT',
  Other = 'OTHER',
  Tenant = 'TENANT',
  Vendor = 'VENDOR'
}

export type CompanyUpdateInput = {
  phone?: InputMaybe<Scalars['String']>;
  taxCode?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type: CompanyTypeEnum;
  vendorId?: InputMaybe<Scalars['String']>;
};

export type CreateGlobalUserInput = {
  addPortfolio: Scalars['Boolean'];
  controlGlobalUsers: Scalars['Boolean'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  globalEmailAccess: Scalars['Boolean'];
  lastName: Scalars['String'];
  password: Scalars['String'];
  photo?: InputMaybe<FileObjectInput>;
  portfolioIds: Array<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  viewPortfolioCOIs: Scalars['Boolean'];
  viewPortfolioDashboard: Scalars['Boolean'];
  viewPortfolioSettings: Scalars['Boolean'];
  viewPortfolioWorkOrders: Scalars['Boolean'];
};

export type CursorPagination = {
  __typename?: 'CursorPagination';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']>;
  startCursor?: Maybe<Scalars['String']>;
  totalCount: Scalars['Int'];
};

export type DefaultEmailTemplateObject = {
  __typename?: 'DefaultEmailTemplateObject';
  appBody?: Maybe<Scalars['String']>;
  category: Scalars['String'];
  emailBody?: Maybe<Scalars['String']>;
  globalParams: Array<Scalars['String']>;
  id: Scalars['String'];
  localParams?: Maybe<Array<Scalars['String']>>;
  smsBody?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  trigger: Scalars['String'];
  type: EmailTemplateType;
};

export type DeleteRecordsInput = {
  ids: Array<Scalars['String']>;
};

export type EmailTemplateObject = {
  __typename?: 'EmailTemplateObject';
  appActive?: Maybe<Scalars['Boolean']>;
  appBody?: Maybe<Scalars['String']>;
  bcc?: Maybe<Array<Scalars['String']>>;
  category: Scalars['String'];
  cc?: Maybe<Array<Scalars['String']>>;
  custom: Scalars['Boolean'];
  emailActive?: Maybe<Scalars['Boolean']>;
  emailBody?: Maybe<Scalars['String']>;
  globalParams: Array<Scalars['String']>;
  id: Scalars['String'];
  localParams?: Maybe<Array<Scalars['String']>>;
  portfolioId?: Maybe<Scalars['String']>;
  smsActive?: Maybe<Scalars['Boolean']>;
  smsBody?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  trigger: Scalars['String'];
  type: EmailTemplateType;
};

export enum EmailTemplateType {
  CoiApproved = 'COI_APPROVED',
  CoiExpired = 'COI_EXPIRED',
  CoiExpire_7Days = 'COI_EXPIRE_7_DAYS',
  CoiExpire_15Days = 'COI_EXPIRE_15_DAYS',
  CoiExpire_30Days = 'COI_EXPIRE_30_DAYS',
  CoiReceived = 'COI_RECEIVED',
  CoiRejected = 'COI_REJECTED',
  CoiRequestDocument = 'COI_REQUEST_DOCUMENT',
  CommentAdded = 'COMMENT_ADDED',
  CustomMessage = 'CUSTOM_MESSAGE',
  Email_2Fa = 'EMAIL_2FA',
  ForgotPassword = 'FORGOT_PASSWORD',
  GuestAddWatcher = 'GUEST_ADD_WATCHER',
  GuestApproved = 'GUEST_APPROVED',
  GuestCanceled = 'GUEST_CANCELED',
  GuestCheckIn = 'GUEST_CHECK_IN',
  GuestCreatedHost = 'GUEST_CREATED_HOST',
  GuestCreatedVisitor = 'GUEST_CREATED_VISITOR',
  GuestCsvUpload = 'GUEST_CSV_UPLOAD',
  GuestPending = 'GUEST_PENDING',
  GuestUpdated = 'GUEST_UPDATED',
  GuestVisitReminder = 'GUEST_VISIT_REMINDER',
  IncidentCreated = 'INCIDENT_CREATED',
  IncidentShare = 'INCIDENT_SHARE',
  InvocieCreate = 'INVOCIE_CREATE',
  InvoiceSend = 'INVOICE_SEND',
  InvoiceShare = 'INVOICE_SHARE',
  MagicLogin = 'MAGIC_LOGIN',
  NotificationMail = 'NOTIFICATION_MAIL',
  ParkingBarcode = 'PARKING_BARCODE',
  PmTaskCreated = 'PM_TASK_CREATED',
  RecurringInvocieCreate = 'RECURRING_INVOCIE_CREATE',
  ReportDelivery = 'REPORT_DELIVERY',
  ResetPassword = 'RESET_PASSWORD',
  RoomReservationApprove = 'ROOM_RESERVATION_APPROVE',
  RoomReservationCancel = 'ROOM_RESERVATION_CANCEL',
  RoomReservationConfirm = 'ROOM_RESERVATION_CONFIRM',
  RoomReservationNotApproved = 'ROOM_RESERVATION_NOT_APPROVED',
  RoomReservationPending = 'ROOM_RESERVATION_PENDING',
  SubscriptionActivated = 'SUBSCRIPTION_ACTIVATED',
  SubscriptionCanceled = 'SUBSCRIPTION_CANCELED',
  SubscriptionDeactivated = 'SUBSCRIPTION_DEACTIVATED',
  SubscriptionPaymentFailed = 'SUBSCRIPTION_PAYMENT_FAILED',
  SubscriptionPaymentFailedAdmin = 'SUBSCRIPTION_PAYMENT_FAILED_ADMIN',
  SubscriptionPaymentFinalFailed = 'SUBSCRIPTION_PAYMENT_FINAL_FAILED',
  SubscriptionPaymentProcessed = 'SUBSCRIPTION_PAYMENT_PROCESSED',
  SubscriptionPaymentProcessedAdmin = 'SUBSCRIPTION_PAYMENT_PROCESSED_ADMIN',
  SubscriptionRenew = 'SUBSCRIPTION_RENEW',
  SubscriptionUpdated = 'SUBSCRIPTION_UPDATED',
  UserActivated = 'USER_ACTIVATED',
  UserDeactivated = 'USER_DEACTIVATED',
  UserPasswordChanged = 'USER_PASSWORD_CHANGED',
  UserRegistered = 'USER_REGISTERED',
  UserResetPassword = 'USER_RESET_PASSWORD',
  VendorAccessApproved = 'VENDOR_ACCESS_APPROVED',
  VendorAccessCanceled = 'VENDOR_ACCESS_CANCELED',
  VendorAccessCheckIn = 'VENDOR_ACCESS_CHECK_IN',
  VendorAccessCreatedHost = 'VENDOR_ACCESS_CREATED_HOST',
  VendorAccessCreatedVisitor = 'VENDOR_ACCESS_CREATED_VISITOR',
  VendorAccessCsvUpload = 'VENDOR_ACCESS_CSV_UPLOAD',
  VendorAccessPending = 'VENDOR_ACCESS_PENDING',
  VendorAccessUpdated = 'VENDOR_ACCESS_UPDATED',
  VendorAccessVisitReminder = 'VENDOR_ACCESS_VISIT_REMINDER',
  WatcherAdd = 'WATCHER_ADD',
  WorkOrderAcknowledgeReminder = 'WORK_ORDER_ACKNOWLEDGE_REMINDER',
  WorkOrderAcknowledgeReminderPriority = 'WORK_ORDER_ACKNOWLEDGE_REMINDER_PRIORITY',
  WorkOrderCompleted = 'WORK_ORDER_COMPLETED',
  WorkOrderCreated = 'WORK_ORDER_CREATED',
  WorkOrderDetails = 'WORK_ORDER_DETAILS',
  WorkOrderEmailError = 'WORK_ORDER_EMAIL_ERROR',
  WorkOrderReassigned = 'WORK_ORDER_REASSIGNED',
  WorkOrderScheduled = 'WORK_ORDER_SCHEDULED',
  WorkOrderShare = 'WORK_ORDER_SHARE',
  WorkOrderUpdates = 'WORK_ORDER_UPDATES',
  WoTemplateCancel = 'WO_TEMPLATE_CANCEL',
  WoTemplateCreate = 'WO_TEMPLATE_CREATE',
  WoTemplatePause = 'WO_TEMPLATE_PAUSE',
  WoTemplateSkip = 'WO_TEMPLATE_SKIP',
  WoTemplateUpdate = 'WO_TEMPLATE_UPDATE'
}

export enum EmailToggleEnum {
  App = 'APP',
  Email = 'EMAIL',
  Sms = 'SMS'
}

export type EmployeeObject = {
  __typename?: 'EmployeeObject';
  active: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  index: Scalars['Int'];
  laborRate?: Maybe<LaborRateObject>;
  updatedAt: Scalars['DateTime'];
  user: UserObject;
};

export type EquipmentCategoryModel = {
  __typename?: 'EquipmentCategoryModel';
  createdAt: Scalars['DateTime'];
  equipmentCount?: Maybe<Scalars['Float']>;
  equipmentList?: Maybe<Array<EquipmentModel>>;
  id: Scalars['String'];
  index: Scalars['Float'];
  title: Scalars['String'];
};

export type EquipmentModel = {
  __typename?: 'EquipmentModel';
  active: Scalars['Boolean'];
  assetTag?: Maybe<Scalars['String']>;
  attachments?: Maybe<Array<FileObject>>;
  category: EquipmentCategoryModel;
  createdBy: UserObject;
  details?: Maybe<Scalars['String']>;
  floor?: Maybe<FloorObject>;
  id: Scalars['String'];
  index: Scalars['Float'];
  manufacturer?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  specificLocation?: Maybe<Scalars['String']>;
  suite?: Maybe<SuiteObject>;
  title: Scalars['String'];
};

export type FileObject = {
  __typename?: 'FileObject';
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  size: Scalars['Float'];
  url: Scalars['String'];
};

export type FileObjectInput = {
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  size: Scalars['Float'];
  url: Scalars['String'];
};

/** The supported records type. */
export enum FilterableCategoryLocationType {
  /** For Incident component */
  Incident = 'incident',
  /** For Work Order component */
  WorkOrder = 'workOrder',
  /** For Work Order Template components */
  WorkOrderTemplate = 'workOrderTemplate'
}

export type FilterableCategoryObject = {
  __typename?: 'FilterableCategoryObject';
  active: Scalars['Boolean'];
  id: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  title: Scalars['String'];
};

export type FilterableCompanyObject = {
  __typename?: 'FilterableCompanyObject';
  active: Scalars['Boolean'];
  id: Scalars['String'];
  photo?: Maybe<FileObject>;
  title: Scalars['String'];
};

export type FilterableGroupedCategoryObject = {
  __typename?: 'FilterableGroupedCategoryObject';
  active: Scalars['Boolean'];
  categories: Array<FilterableCategoryObject>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  title: Scalars['String'];
};

/** The supported records type. */
export enum FilterablePriorityLocationType {
  /** For Work Order component */
  WorkOrder = 'workOrder',
  /** For Work Order Template components */
  WorkOrderTemplate = 'workOrderTemplate'
}

export type FilterablePriorityObject = {
  __typename?: 'FilterablePriorityObject';
  active: Scalars['Boolean'];
  color?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  title: Scalars['String'];
};

/** The supported records type. */
export enum FilterableStatusLocationType {
  /** For Incident component */
  Incident = 'incident',
  /** For Work Order component */
  WorkOrder = 'workOrder'
}

export type FilterableStatusObject = {
  __typename?: 'FilterableStatusObject';
  active: Scalars['Boolean'];
  color?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  title: Scalars['String'];
};

export type FloorObject = {
  __typename?: 'FloorObject';
  attachment?: Maybe<FileObject>;
  id: Scalars['String'];
  index: Scalars['Int'];
  order: Scalars['Int'];
  size: Scalars['Float'];
  suites?: Maybe<Array<SuiteObject>>;
  title: Scalars['String'];
};

export type GlAccountObject = {
  __typename?: 'GLAccountObject';
  active: Scalars['Boolean'];
  id: Scalars['String'];
  index: Scalars['Int'];
  property?: Maybe<PropertyObject>;
  title: Scalars['String'];
};

export type GeneaAccessGroupObject = {
  __typename?: 'GeneaAccessGroupObject';
  accgrp?: Maybe<Scalars['String']>;
  customerId: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  locationId: Scalars['String'];
  sets?: Maybe<Array<SetsObject>>;
  title: Scalars['String'];
};

export type GeneaTenantObject = {
  __typename?: 'GeneaTenantObject';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  locationId: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type GetActivityLogsObject = {
  __typename?: 'GetActivityLogsObject';
  data: Array<ActivityLogModel>;
  pagination: CursorPagination;
};

export type GetBuildings = {
  __typename?: 'GetBuildings';
  data: Array<BuildingObject>;
  pagination: CursorPagination;
};

export type GetCategories = {
  __typename?: 'GetCategories';
  data: Array<CategoryObject>;
  pagination: CursorPagination;
};

export type GetCategoriesGrouped = {
  __typename?: 'GetCategoriesGrouped';
  data: Array<CategoryGroupObject>;
  pagination: CursorPagination;
};

export type GetCategoryGroups = {
  __typename?: 'GetCategoryGroups';
  data: Array<CategoryGroupObject>;
  pagination: CursorPagination;
};

export type GetCoiObject = {
  __typename?: 'GetCoiObject';
  data: Array<CoiObject>;
  pagination: CursorPagination;
};

export type GetCompanyObject = {
  __typename?: 'GetCompanyObject';
  data: Array<CompanyObject>;
  pagination: CursorPagination;
};

export type GetEquipmentsObject = {
  __typename?: 'GetEquipmentsObject';
  data: Array<EquipmentModel>;
  pagination: CursorPagination;
};

export type GetFilterableGroupedCategories = {
  __typename?: 'GetFilterableGroupedCategories';
  data: Array<FilterableGroupedCategoryObject>;
  pagination: CursorPagination;
};

export type GetGlobalUserList = {
  __typename?: 'GetGlobalUserList';
  data: Array<GlobalUserObject>;
  pagination: CursorPagination;
};

export type GetPortfolios = {
  __typename?: 'GetPortfolios';
  data: Array<PortfolioModel>;
  pagination: CursorPagination;
};

export type GetProperties = {
  __typename?: 'GetProperties';
  data: Array<PropertyObject>;
  pagination: CursorPagination;
};

export type GetRolesObject = {
  __typename?: 'GetRolesObject';
  data: Array<RoleObject>;
  pagination: CursorPagination;
};

export type GetUsersObject = {
  __typename?: 'GetUsersObject';
  data: Array<UserObject>;
  pagination: CursorPagination;
};

export type GetWorkOrdersObject = {
  __typename?: 'GetWorkOrdersObject';
  data: Array<WorkOrderObject>;
  pagination: CursorPagination;
};

export type GlobalBaseTranslationInput = {
  file: FileObjectInput;
  password: Scalars['String'];
};

export type GlobalTranslationFilteredObject = {
  __typename?: 'GlobalTranslationFilteredObject';
  descriptions: Scalars['TranslationKeysScalar'];
  sources: Scalars['TranslationKeysScalar'];
};

export type GlobalTranslationInput = {
  countryCode: Scalars['String'];
  title: Scalars['String'];
};

export type GlobalTranslationObject = {
  __typename?: 'GlobalTranslationObject';
  active: Scalars['Boolean'];
  countryCode: Scalars['String'];
  descriptions?: Maybe<Scalars['TranslationKeysScalar']>;
  id: Scalars['String'];
  sources?: Maybe<Scalars['TranslationKeysScalar']>;
  title: Scalars['String'];
};

export type GlobalUserObject = {
  __typename?: 'GlobalUserObject';
  addPortfolio: Scalars['Boolean'];
  controlGlobalUsers: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  globalEmailAccess: Scalars['Boolean'];
  id: Scalars['String'];
  lastName: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  photo?: Maybe<FileObject>;
  portfolios?: Maybe<Array<PortfolioModel>>;
  title?: Maybe<Scalars['String']>;
  viewPortfolioCOIs: Scalars['Boolean'];
  viewPortfolioDashboard: Scalars['Boolean'];
  viewPortfolioSettings: Scalars['Boolean'];
  viewPortfolioWorkOrders: Scalars['Boolean'];
};

export type IncidentStatusInput = {
  default?: InputMaybe<Scalars['String']>;
};

export type IncidentStatusSettingObject = {
  __typename?: 'IncidentStatusSettingObject';
  default?: Maybe<StatusObject>;
};

export type IntegrationBlocksDto = {
  __typename?: 'IntegrationBlocksDTO';
  isPublic: Scalars['Boolean'];
  key: Scalars['String'];
  label: Scalars['String'];
  required: Scalars['Boolean'];
  value?: Maybe<Scalars['String']>;
};

export type LaborRateInput = {
  arCodeId?: InputMaybe<Scalars['String']>;
  chargeCodeId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  glAccountId?: InputMaybe<Scalars['String']>;
  markupId?: InputMaybe<Scalars['String']>;
  rate: Scalars['Float'];
  title: Scalars['String'];
};

export type LaborRateObject = {
  __typename?: 'LaborRateObject';
  active: Scalars['Boolean'];
  arCode?: Maybe<ArCodeObject>;
  chargeCode?: Maybe<ChargeCodeObject>;
  description?: Maybe<Scalars['String']>;
  glAccount?: Maybe<GlAccountObject>;
  id: Scalars['String'];
  index: Scalars['Int'];
  markup?: Maybe<MarkupObject>;
  property?: Maybe<PropertyObject>;
  rate: Scalars['Float'];
  title: Scalars['String'];
};

export type LeaseChargeTypeObject = {
  __typename?: 'LeaseChargeTypeObject';
  active: Scalars['Boolean'];
  id: Scalars['String'];
  index: Scalars['Int'];
  property?: Maybe<PropertyObject>;
  title: Scalars['String'];
};

export enum LeaseFeeUnitEnum {
  Percent = 'PERCENT',
  Value = 'VALUE'
}

export type LeaseObject = {
  __typename?: 'LeaseObject';
  attachments?: Maybe<Array<FileObject>>;
  company: CompanyObject;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: UserObject;
  gracePeriod?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  index: Scalars['Int'];
  lateFeeAmount?: Maybe<Scalars['Float']>;
  lateFeeUnit?: Maybe<LeaseFeeUnitEnum>;
  leaseEnd: Scalars['String'];
  leaseStart: Scalars['String'];
  rentFootage?: Maybe<Scalars['Float']>;
  rents: Array<LeaseRentObject>;
  status: LeaseStatusEnum;
  suites: Array<SuiteObject>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LeaseRentObject = {
  __typename?: 'LeaseRentObject';
  amount: Scalars['Float'];
  chargeType: LeaseChargeTypeObject;
  endDate: Scalars['String'];
  id: Scalars['String'];
  startDate: Scalars['String'];
  suites: Array<SuiteObject>;
};

export enum LeaseStatusEnum {
  Active = 'ACTIVE',
  Expired = 'EXPIRED'
}

export type LoginInput = {
  email: Scalars['String'];
  password: Scalars['String'];
  rememberMe: Scalars['Boolean'];
};

export type LoginObject = {
  __typename?: 'LoginObject';
  token: Scalars['String'];
};

export type MarkUpInput = {
  amount: Scalars['Float'];
  arCodeId?: InputMaybe<Scalars['String']>;
  chargeCodeId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  glAccountId?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type: ValueUnit;
};

export type MarkupObject = {
  __typename?: 'MarkupObject';
  active: Scalars['Boolean'];
  amount: Scalars['Float'];
  arCode?: Maybe<ArCodeObject>;
  chargeCode?: Maybe<ChargeCodeObject>;
  description?: Maybe<Scalars['String']>;
  glAccount?: Maybe<GlAccountObject>;
  id: Scalars['String'];
  index: Scalars['Int'];
  property?: Maybe<PropertyObject>;
  title: Scalars['String'];
  type: ValueUnit;
};

export type MaterialGroupObject = {
  __typename?: 'MaterialGroupObject';
  categoryCount: Scalars['Int'];
  id: Scalars['String'];
  index: Scalars['Int'];
  materials?: Maybe<Array<MaterialObject>>;
  title: Scalars['String'];
};

export type MaterialObject = {
  __typename?: 'MaterialObject';
  active: Scalars['Boolean'];
  arCode?: Maybe<ArCodeObject>;
  chargeCode?: Maybe<ChargeCodeObject>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  glAccount?: Maybe<GlAccountObject>;
  group: MaterialGroupObject;
  id: Scalars['String'];
  index: Scalars['Int'];
  markup?: Maybe<MarkupObject>;
  price?: Maybe<Scalars['Float']>;
  tax?: Maybe<TaxObject>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addCompanyProperty: Scalars['Boolean'];
  addUserProperty: Scalars['Boolean'];
  cloneProperty: Scalars['Boolean'];
  createARCode: ArCodeObject;
  createBuilding: BuildingObject;
  createCategory: CategoryObject;
  createCategoryGroup: CategoryGroupObject;
  createChargeCode: ChargeCodeObject;
  createCompany: CompanyObject;
  createGLAccount: GlAccountObject;
  createGlobalTranslation: GlobalTranslationObject;
  createGlobalUser: GlobalUserObject;
  createLaborRate: LaborRateObject;
  createLeaseChargeType: LeaseChargeTypeObject;
  createMarkup: MarkupObject;
  createPortfolio: PortfolioModel;
  createPriority: PriorityObject;
  createProperty: PropertyObject;
  createRole: RoleObject;
  createStatus: StatusObject;
  createTax: TaxObject;
  createTranslation: TranslationObject;
  createUser: UserObject;
  forgotPassword: Scalars['Boolean'];
  importGlobalTranslation: Scalars['Boolean'];
  importTranslation: Scalars['Boolean'];
  login: LoginObject;
  loginAsUser: Scalars['String'];
  magicLogin: Scalars['Boolean'];
  removeARCodes: Scalars['Boolean'];
  removeBuildings: Scalars['Boolean'];
  removeCategories: Scalars['Boolean'];
  removeCategoryGroups: Scalars['Boolean'];
  removeChargeCodes: Scalars['Boolean'];
  removeCompanies: Scalars['Boolean'];
  removeGLAccounts: Scalars['Boolean'];
  removeGlobalTranslations: Scalars['Boolean'];
  removeGlobalUsers: Scalars['Boolean'];
  removeLaborRates: Scalars['Boolean'];
  removeLeaseChargeTypes: Scalars['Boolean'];
  removeMarkups: Scalars['Boolean'];
  removePortfolios: Scalars['Boolean'];
  removePriorities: Scalars['Boolean'];
  removeProperties: Scalars['Boolean'];
  removeRoles: Scalars['Boolean'];
  removeStatuses: Scalars['Boolean'];
  removeTaxes: Scalars['Boolean'];
  removeTranslations: Scalars['Boolean'];
  removeUsers: Scalars['Boolean'];
  reorderCategories: Scalars['Boolean'];
  reorderLeaseChargeTypes: Scalars['Boolean'];
  reorderMarkups: Scalars['Boolean'];
  reorderPriorities: Scalars['Boolean'];
  reorderStatuses: Scalars['Boolean'];
  reorderTaxes: Scalars['Boolean'];
  resendWelcomeEmail: Scalars['Boolean'];
  resetPassword: Scalars['Boolean'];
  resetTranslation: Scalars['Boolean'];
  sendTestMail: Scalars['Boolean'];
  toggleARCode: Scalars['Boolean'];
  toggleBuilding: Scalars['Boolean'];
  toggleCategory: Scalars['Boolean'];
  toggleCategoryGroup: Scalars['Boolean'];
  toggleChargeCode: Scalars['Boolean'];
  toggleCompany: Scalars['Boolean'];
  toggleCompanyProperty: Scalars['Boolean'];
  toggleCustomTemplate: EmailTemplateObject;
  toggleEmailTemplate: Scalars['Boolean'];
  toggleGLAccount: Scalars['Boolean'];
  toggleGlobalTranslation: Scalars['Boolean'];
  toggleLaborRate: Scalars['Boolean'];
  toggleLeaseChargeType: Scalars['Boolean'];
  toggleMarkup: Scalars['Boolean'];
  togglePortfolio: Scalars['Boolean'];
  togglePriority: Scalars['Boolean'];
  toggleProperty: Scalars['Boolean'];
  toggleRole: Scalars['Boolean'];
  toggleStatus: Scalars['Boolean'];
  toggleTax: Scalars['Boolean'];
  toggleTranslation: Scalars['Boolean'];
  toggleUser: Scalars['Boolean'];
  updateARCode: ArCodeObject;
  updateBuilding: BuildingObject;
  updateCategory: CategoryObject;
  updateCategoryGroup: CategoryGroupObject;
  updateChargeCode: ChargeCodeObject;
  updateCompany: CompanyObject;
  updateCompanyAddress: CompanyObject;
  updateCompanyPhoto: CompanyObject;
  updateDefaultEmailTemplate: Scalars['Boolean'];
  updateEmailTemplate: Scalars['Boolean'];
  updateGLAccount: GlAccountObject;
  updateGlobalTranslation: GlobalTranslationObject;
  updateGlobalTranslationTexts: Scalars['Boolean'];
  updateGlobalUser: GlobalUserObject;
  updateIncidentStatusSetting: IncidentStatusSettingObject;
  updateLaborRate: LaborRateObject;
  updateLeaseChargeType: LeaseChargeTypeObject;
  updateMarkup: MarkupObject;
  updatePortfolio: PortfolioModel;
  updatePriority: PriorityObject;
  updateProperty: PropertyObject;
  updateRole: RoleObject;
  updateStatus: StatusObject;
  updateTax: TaxObject;
  updateTranslation: TranslationObject;
  updateTranslationTranslations: Scalars['Boolean'];
  updateUser: UserObject;
  updateUserPhoto: UserObject;
  updateUserProperty: Scalars['Boolean'];
  updateWorkOrderStatusSetting: WorkOrderStatusSettingObject;
  uploadFiles: Array<UploadFileDto>;
  uploadTranslation: Scalars['Boolean'];
};


export type MutationAddCompanyPropertyArgs = {
  companyId: Scalars['String'];
  propertyId: Scalars['String'];
};


export type MutationAddUserPropertyArgs = {
  input: UserPropertyInput;
  userId: Scalars['String'];
};


export type MutationClonePropertyArgs = {
  input: PropertyCloneInput;
};


export type MutationCreateArCodeArgs = {
  portfolioId: Scalars['String'];
  title: Scalars['String'];
};


export type MutationCreateBuildingArgs = {
  input: BuildingInput;
};


export type MutationCreateCategoryArgs = {
  input: CategoryInput;
  portfolioId: Scalars['String'];
  recordType: CategoryRecordType;
};


export type MutationCreateCategoryGroupArgs = {
  input: CategoryGroupInput;
  portfolioId: Scalars['String'];
  recordType: CategoryRecordType;
};


export type MutationCreateChargeCodeArgs = {
  portfolioId: Scalars['String'];
  title: Scalars['String'];
};


export type MutationCreateCompanyArgs = {
  input: CompanyInput;
  portfolioId: Scalars['String'];
};


export type MutationCreateGlAccountArgs = {
  portfolioId: Scalars['String'];
  title: Scalars['String'];
};


export type MutationCreateGlobalTranslationArgs = {
  input: GlobalTranslationInput;
};


export type MutationCreateGlobalUserArgs = {
  input: CreateGlobalUserInput;
};


export type MutationCreateLaborRateArgs = {
  input: LaborRateInput;
  portfolioId: Scalars['String'];
};


export type MutationCreateLeaseChargeTypeArgs = {
  portfolioId: Scalars['String'];
  title: Scalars['String'];
};


export type MutationCreateMarkupArgs = {
  input: MarkUpInput;
  portfolioId: Scalars['String'];
};


export type MutationCreatePortfolioArgs = {
  input: PortfolioInput;
};


export type MutationCreatePriorityArgs = {
  input: PriorityInput;
  portfolioId: Scalars['String'];
};


export type MutationCreatePropertyArgs = {
  input: PropertyInput;
  portfolioId: Scalars['String'];
};


export type MutationCreateRoleArgs = {
  input: RoleInput;
  portfolioId: Scalars['String'];
};


export type MutationCreateStatusArgs = {
  input: StatusInput;
  portfolioId: Scalars['String'];
};


export type MutationCreateTaxArgs = {
  input: TaxInput;
  portfolioId: Scalars['String'];
};


export type MutationCreateTranslationArgs = {
  input: TranslationInput;
  portfolioId: Scalars['String'];
};


export type MutationCreateUserArgs = {
  input: UserInput;
  portfolioId: Scalars['String'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String'];
};


export type MutationImportGlobalTranslationArgs = {
  id: Scalars['String'];
  link: Scalars['String'];
};


export type MutationImportTranslationArgs = {
  id: Scalars['String'];
  link: Scalars['String'];
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationLoginAsUserArgs = {
  portfolioId: Scalars['String'];
  userId: Scalars['String'];
};


export type MutationMagicLoginArgs = {
  email: Scalars['String'];
  rememberMe?: InputMaybe<Scalars['Boolean']>;
};


export type MutationRemoveArCodesArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveBuildingsArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveCategoriesArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveCategoryGroupsArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveChargeCodesArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveCompaniesArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveGlAccountsArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveGlobalTranslationsArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveGlobalUsersArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveLaborRatesArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveLeaseChargeTypesArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveMarkupsArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemovePortfoliosArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemovePrioritiesArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemovePropertiesArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveRolesArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveStatusesArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveTaxesArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveTranslationsArgs = {
  input: DeleteRecordsInput;
};


export type MutationRemoveUsersArgs = {
  input: DeleteRecordsInput;
};


export type MutationReorderCategoriesArgs = {
  id: Scalars['String'];
  secondId: Scalars['String'];
};


export type MutationReorderLeaseChargeTypesArgs = {
  id: Scalars['String'];
  secondId: Scalars['String'];
};


export type MutationReorderMarkupsArgs = {
  id: Scalars['String'];
  secondId: Scalars['String'];
};


export type MutationReorderPrioritiesArgs = {
  id: Scalars['String'];
  secondId: Scalars['String'];
};


export type MutationReorderStatusesArgs = {
  id: Scalars['String'];
  secondId: Scalars['String'];
};


export type MutationReorderTaxesArgs = {
  id: Scalars['String'];
  secondId: Scalars['String'];
};


export type MutationResendWelcomeEmailArgs = {
  propertyId: Scalars['String'];
  userId: Scalars['String'];
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationResetTranslationArgs = {
  id: Scalars['String'];
};


export type MutationSendTestMailArgs = {
  input: SendTestMailInput;
};


export type MutationToggleArCodeArgs = {
  id: Scalars['String'];
};


export type MutationToggleBuildingArgs = {
  id: Scalars['String'];
};


export type MutationToggleCategoryArgs = {
  id: Scalars['String'];
};


export type MutationToggleCategoryGroupArgs = {
  id: Scalars['String'];
};


export type MutationToggleChargeCodeArgs = {
  id: Scalars['String'];
};


export type MutationToggleCompanyArgs = {
  id: Scalars['String'];
};


export type MutationToggleCompanyPropertyArgs = {
  companyId: Scalars['String'];
  propertyId: Scalars['String'];
};


export type MutationToggleCustomTemplateArgs = {
  portfolioId: Scalars['String'];
  type: EmailTemplateType;
};


export type MutationToggleEmailTemplateArgs = {
  input: ToggleEmailTemplateInput;
};


export type MutationToggleGlAccountArgs = {
  id: Scalars['String'];
};


export type MutationToggleGlobalTranslationArgs = {
  id: Scalars['String'];
};


export type MutationToggleLaborRateArgs = {
  id: Scalars['String'];
};


export type MutationToggleLeaseChargeTypeArgs = {
  id: Scalars['String'];
};


export type MutationToggleMarkupArgs = {
  id: Scalars['String'];
};


export type MutationTogglePortfolioArgs = {
  id: Scalars['String'];
};


export type MutationTogglePriorityArgs = {
  id: Scalars['String'];
};


export type MutationTogglePropertyArgs = {
  id: Scalars['String'];
};


export type MutationToggleRoleArgs = {
  id: Scalars['String'];
};


export type MutationToggleStatusArgs = {
  id: Scalars['String'];
};


export type MutationToggleTaxArgs = {
  id: Scalars['String'];
};


export type MutationToggleTranslationArgs = {
  id: Scalars['String'];
};


export type MutationToggleUserArgs = {
  userId: Scalars['String'];
};


export type MutationUpdateArCodeArgs = {
  id: Scalars['String'];
  title: Scalars['String'];
};


export type MutationUpdateBuildingArgs = {
  id: Scalars['String'];
  title: Scalars['String'];
};


export type MutationUpdateCategoryArgs = {
  id: Scalars['String'];
  input: CategoryInput;
};


export type MutationUpdateCategoryGroupArgs = {
  id: Scalars['String'];
  input: CategoryGroupInput;
};


export type MutationUpdateChargeCodeArgs = {
  id: Scalars['String'];
  title: Scalars['String'];
};


export type MutationUpdateCompanyArgs = {
  id: Scalars['String'];
  input: CompanyUpdateInput;
};


export type MutationUpdateCompanyAddressArgs = {
  address: AddressInput;
  companyId: Scalars['String'];
};


export type MutationUpdateCompanyPhotoArgs = {
  companyId: Scalars['String'];
  photo?: InputMaybe<FileObjectInput>;
};


export type MutationUpdateDefaultEmailTemplateArgs = {
  input: UpdateDefaultEmailTemplateInput;
  type: EmailTemplateType;
};


export type MutationUpdateEmailTemplateArgs = {
  input: UpdateEmailTemplateInput;
  portfolioId: Scalars['String'];
  type: EmailTemplateType;
};


export type MutationUpdateGlAccountArgs = {
  id: Scalars['String'];
  title: Scalars['String'];
};


export type MutationUpdateGlobalTranslationArgs = {
  id: Scalars['String'];
  input: GlobalTranslationInput;
};


export type MutationUpdateGlobalTranslationTextsArgs = {
  descriptions?: InputMaybe<Scalars['TranslationKeysScalar']>;
  id: Scalars['String'];
  key: Scalars['String'];
  sources?: InputMaybe<Scalars['TranslationKeysScalar']>;
};


export type MutationUpdateGlobalUserArgs = {
  id: Scalars['String'];
  input: UpdateGlobalUserInput;
};


export type MutationUpdateIncidentStatusSettingArgs = {
  input: IncidentStatusInput;
  portfolioId: Scalars['String'];
};


export type MutationUpdateLaborRateArgs = {
  id: Scalars['String'];
  input: LaborRateInput;
};


export type MutationUpdateLeaseChargeTypeArgs = {
  id: Scalars['String'];
  title: Scalars['String'];
};


export type MutationUpdateMarkupArgs = {
  id: Scalars['String'];
  input: MarkUpInput;
};


export type MutationUpdatePortfolioArgs = {
  id: Scalars['String'];
  input: PortfolioUpdateInput;
};


export type MutationUpdatePriorityArgs = {
  id: Scalars['String'];
  input: PriorityUpdateInput;
};


export type MutationUpdatePropertyArgs = {
  id: Scalars['String'];
  input: PropertyInput;
};


export type MutationUpdateRoleArgs = {
  id: Scalars['String'];
  input: RoleInput;
};


export type MutationUpdateStatusArgs = {
  id: Scalars['String'];
  input: StatusUpdateInput;
};


export type MutationUpdateTaxArgs = {
  id: Scalars['String'];
  input: TaxInput;
};


export type MutationUpdateTranslationArgs = {
  id: Scalars['String'];
  input: TranslationInput;
};


export type MutationUpdateTranslationTranslationsArgs = {
  id: Scalars['String'];
  key: Scalars['String'];
  translations?: InputMaybe<Scalars['TranslationKeysScalar']>;
};


export type MutationUpdateUserArgs = {
  id: Scalars['String'];
  input: UserUpdateInput;
};


export type MutationUpdateUserPhotoArgs = {
  photo?: InputMaybe<FileObjectInput>;
  userId: Scalars['String'];
};


export type MutationUpdateUserPropertyArgs = {
  input: UserPropertyInput;
  userId: Scalars['String'];
};


export type MutationUpdateWorkOrderStatusSettingArgs = {
  input: WorkOrderStatusInput;
  portfolioId: Scalars['String'];
};


export type MutationUploadFilesArgs = {
  files: Array<Scalars['Upload']>;
  save?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUploadTranslationArgs = {
  input: GlobalBaseTranslationInput;
};

export type Networks = {
  __typename?: 'Networks';
  available?: Maybe<Array<Scalars['String']>>;
  preferred?: Maybe<Scalars['String']>;
};

export type PmCustomIdObject = {
  __typename?: 'PMCustomIdObject';
  active: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  index: Scalars['Int'];
  title: Scalars['String'];
};

export enum PmStepInputType {
  Number = 'NUMBER',
  Text = 'TEXT'
}

export enum PmStepType {
  Attachments = 'ATTACHMENTS',
  Checkbox = 'CHECKBOX',
  Dropdown = 'DROPDOWN',
  Input = 'INPUT'
}

export type PermissionInput = {
  accessFileManagerPrivate?: InputMaybe<Scalars['Boolean']>;
  addCoi?: InputMaybe<Scalars['Boolean']>;
  addCompany?: InputMaybe<Scalars['Boolean']>;
  addCompanyGuest?: InputMaybe<Scalars['Boolean']>;
  addCompanyIncident?: InputMaybe<Scalars['Boolean']>;
  addCompanyRoomReservation?: InputMaybe<Scalars['Boolean']>;
  addCompanySubscriptions?: InputMaybe<Scalars['Boolean']>;
  addCompanyVendorAccess?: InputMaybe<Scalars['Boolean']>;
  addCompanyWatchList?: InputMaybe<Scalars['Boolean']>;
  addCompanyWorkOrder?: InputMaybe<Scalars['Boolean']>;
  addCompanyWorkOrderTemplate?: InputMaybe<Scalars['Boolean']>;
  addEventPost?: InputMaybe<Scalars['Boolean']>;
  addInternalNotes?: InputMaybe<Scalars['Boolean']>;
  addMessage?: InputMaybe<Scalars['Boolean']>;
  addMyGuest?: InputMaybe<Scalars['Boolean']>;
  addMyIncident?: InputMaybe<Scalars['Boolean']>;
  addMyRoomReservation?: InputMaybe<Scalars['Boolean']>;
  addMyVendorAccess?: InputMaybe<Scalars['Boolean']>;
  addMyWatchList?: InputMaybe<Scalars['Boolean']>;
  addMyWorkOrder?: InputMaybe<Scalars['Boolean']>;
  addMyWorkOrderTemplate?: InputMaybe<Scalars['Boolean']>;
  addNewsFeedPost?: InputMaybe<Scalars['Boolean']>;
  addNewsFeedPostComment?: InputMaybe<Scalars['Boolean']>;
  addUser?: InputMaybe<Scalars['Boolean']>;
  approveGuest?: InputMaybe<Scalars['Boolean']>;
  approveVendorAccess?: InputMaybe<Scalars['Boolean']>;
  canCloseWorkOrder?: InputMaybe<Scalars['Boolean']>;
  cancelCompanySubscriptions?: InputMaybe<Scalars['Boolean']>;
  checkInGuest?: InputMaybe<Scalars['Boolean']>;
  checkInVendorAccess?: InputMaybe<Scalars['Boolean']>;
  controlUserWallet?: InputMaybe<Scalars['Boolean']>;
  creditCardPayments?: InputMaybe<Scalars['Boolean']>;
  deactivateCompanyWatchList?: InputMaybe<Scalars['Boolean']>;
  deactivateMyWatchList?: InputMaybe<Scalars['Boolean']>;
  deleteCoi?: InputMaybe<Scalars['Boolean']>;
  deleteCompany?: InputMaybe<Scalars['Boolean']>;
  deleteCompanyIncident?: InputMaybe<Scalars['Boolean']>;
  deleteCompanyWatchList?: InputMaybe<Scalars['Boolean']>;
  deleteCompanyWorkOrder?: InputMaybe<Scalars['Boolean']>;
  deleteCompanyWorkOrderTemplate?: InputMaybe<Scalars['Boolean']>;
  deleteMyIncident?: InputMaybe<Scalars['Boolean']>;
  deleteMyWatchList?: InputMaybe<Scalars['Boolean']>;
  deleteMyWorkOrder?: InputMaybe<Scalars['Boolean']>;
  deleteMyWorkOrderTemplate?: InputMaybe<Scalars['Boolean']>;
  deleteOtherUsersEventPost?: InputMaybe<Scalars['Boolean']>;
  deleteOtherUsersNewsFeedComment?: InputMaybe<Scalars['Boolean']>;
  deleteOtherUsersNewsFeedPost?: InputMaybe<Scalars['Boolean']>;
  deleteUser?: InputMaybe<Scalars['Boolean']>;
  editOtherUsersEventPost?: InputMaybe<Scalars['Boolean']>;
  editOtherUsersNewsFeedPost?: InputMaybe<Scalars['Boolean']>;
  manageAllTasks?: InputMaybe<Scalars['Boolean']>;
  manageCompanyRoomReservation?: InputMaybe<Scalars['Boolean']>;
  manageConciergeHub?: InputMaybe<Scalars['Boolean']>;
  manageFileManager?: InputMaybe<Scalars['Boolean']>;
  manageInvoices?: InputMaybe<Scalars['Boolean']>;
  manageLease?: InputMaybe<Scalars['Boolean']>;
  manageMyTasks?: InputMaybe<Scalars['Boolean']>;
  managePackage?: InputMaybe<Scalars['Boolean']>;
  managePreventiveMaintenance?: InputMaybe<Scalars['Boolean']>;
  manageRecurringInvoices?: InputMaybe<Scalars['Boolean']>;
  manageTaskCharges?: InputMaybe<Scalars['Boolean']>;
  manageWOCharges?: InputMaybe<Scalars['Boolean']>;
  manageWOTCharges?: InputMaybe<Scalars['Boolean']>;
  offlinePayments?: InputMaybe<Scalars['Boolean']>;
  printBadgeGuest?: InputMaybe<Scalars['Boolean']>;
  printBadgeVendorAccess?: InputMaybe<Scalars['Boolean']>;
  propertyAdmin?: InputMaybe<Scalars['Boolean']>;
  refundSubscriptionCharges?: InputMaybe<Scalars['Boolean']>;
  toggleGeneaDoor?: InputMaybe<Scalars['Boolean']>;
  updateCoi?: InputMaybe<Scalars['Boolean']>;
  updateCoiStatus?: InputMaybe<Scalars['Boolean']>;
  updateCompany?: InputMaybe<Scalars['Boolean']>;
  updateCompanyGuest?: InputMaybe<Scalars['Boolean']>;
  updateCompanyIncident?: InputMaybe<Scalars['Boolean']>;
  updateCompanyRoomReservation?: InputMaybe<Scalars['Boolean']>;
  updateCompanySubscriptions?: InputMaybe<Scalars['Boolean']>;
  updateCompanyVendorAccess?: InputMaybe<Scalars['Boolean']>;
  updateCompanyWatchList?: InputMaybe<Scalars['Boolean']>;
  updateCompanyWorkOrder?: InputMaybe<Scalars['Boolean']>;
  updateCompanyWorkOrderTemplate?: InputMaybe<Scalars['Boolean']>;
  updateGeneaCards?: InputMaybe<Scalars['Boolean']>;
  updateMyGuest?: InputMaybe<Scalars['Boolean']>;
  updateMyIncident?: InputMaybe<Scalars['Boolean']>;
  updateMyRoomReservation?: InputMaybe<Scalars['Boolean']>;
  updateMyVendorAccess?: InputMaybe<Scalars['Boolean']>;
  updateMyWatchList?: InputMaybe<Scalars['Boolean']>;
  updateMyWorkOrder?: InputMaybe<Scalars['Boolean']>;
  updateMyWorkOrderTemplate?: InputMaybe<Scalars['Boolean']>;
  updateUser?: InputMaybe<Scalars['Boolean']>;
  updateWorkOrderAssignee?: InputMaybe<Scalars['Boolean']>;
  updateWorkOrderAssigneeTemplate?: InputMaybe<Scalars['Boolean']>;
  updateWorkOrderPriority?: InputMaybe<Scalars['Boolean']>;
  updateWorkOrderPriorityTemplate?: InputMaybe<Scalars['Boolean']>;
  updateWorkOrderStatus?: InputMaybe<Scalars['Boolean']>;
  viewAllTasks?: InputMaybe<Scalars['Boolean']>;
  viewAnalytics?: InputMaybe<Scalars['Boolean']>;
  viewCoi?: InputMaybe<Scalars['Boolean']>;
  viewCompanyFullAccessUsers?: InputMaybe<Scalars['Boolean']>;
  viewCompanyGuest?: InputMaybe<Scalars['Boolean']>;
  viewCompanyIncident?: InputMaybe<Scalars['Boolean']>;
  viewCompanyPage?: InputMaybe<Scalars['Boolean']>;
  viewCompanyRoomReservation?: InputMaybe<Scalars['Boolean']>;
  viewCompanySubscriptions?: InputMaybe<Scalars['Boolean']>;
  viewCompanyVendorAccess?: InputMaybe<Scalars['Boolean']>;
  viewCompanyWatchList?: InputMaybe<Scalars['Boolean']>;
  viewCompanyWorkOrder?: InputMaybe<Scalars['Boolean']>;
  viewCompanyWorkOrderTemplate?: InputMaybe<Scalars['Boolean']>;
  viewConciergeHub?: InputMaybe<Scalars['Boolean']>;
  viewFileManager?: InputMaybe<Scalars['Boolean']>;
  viewGeneaCards?: InputMaybe<Scalars['Boolean']>;
  viewGeneaDoors?: InputMaybe<Scalars['Boolean']>;
  viewInternalNotes?: InputMaybe<Scalars['Boolean']>;
  viewInvoices?: InputMaybe<Scalars['Boolean']>;
  viewLease?: InputMaybe<Scalars['Boolean']>;
  viewMessages?: InputMaybe<Scalars['Boolean']>;
  viewMyGuest?: InputMaybe<Scalars['Boolean']>;
  viewMyIncident?: InputMaybe<Scalars['Boolean']>;
  viewMyRoomReservation?: InputMaybe<Scalars['Boolean']>;
  viewMySubscriptions?: InputMaybe<Scalars['Boolean']>;
  viewMyTasks?: InputMaybe<Scalars['Boolean']>;
  viewMyVendorAccess?: InputMaybe<Scalars['Boolean']>;
  viewMyWatchList?: InputMaybe<Scalars['Boolean']>;
  viewMyWorkOrder?: InputMaybe<Scalars['Boolean']>;
  viewMyWorkOrderTemplate?: InputMaybe<Scalars['Boolean']>;
  viewPackage?: InputMaybe<Scalars['Boolean']>;
  viewPreventiveMaintenance?: InputMaybe<Scalars['Boolean']>;
  viewPropertyNewsFeedPost?: InputMaybe<Scalars['Boolean']>;
  viewRecurringInvoices?: InputMaybe<Scalars['Boolean']>;
  viewReports?: InputMaybe<Scalars['Boolean']>;
  viewStackingPlan?: InputMaybe<Scalars['Boolean']>;
  viewTaskCharges?: InputMaybe<Scalars['Boolean']>;
  viewUser?: InputMaybe<Scalars['Boolean']>;
  viewWOCharges?: InputMaybe<Scalars['Boolean']>;
  viewWOTCharges?: InputMaybe<Scalars['Boolean']>;
};

export type PermissionsObject = {
  __typename?: 'PermissionsObject';
  accessFileManagerPrivate?: Maybe<Scalars['Boolean']>;
  addCoi?: Maybe<Scalars['Boolean']>;
  addCompany?: Maybe<Scalars['Boolean']>;
  addCompanyGuest?: Maybe<Scalars['Boolean']>;
  addCompanyIncident?: Maybe<Scalars['Boolean']>;
  addCompanyRoomReservation?: Maybe<Scalars['Boolean']>;
  addCompanySubscriptions?: Maybe<Scalars['Boolean']>;
  addCompanyVendorAccess?: Maybe<Scalars['Boolean']>;
  addCompanyWatchList?: Maybe<Scalars['Boolean']>;
  addCompanyWorkOrder?: Maybe<Scalars['Boolean']>;
  addCompanyWorkOrderTemplate?: Maybe<Scalars['Boolean']>;
  addEventPost?: Maybe<Scalars['Boolean']>;
  addInternalNotes?: Maybe<Scalars['Boolean']>;
  addMessage?: Maybe<Scalars['Boolean']>;
  addMyGuest?: Maybe<Scalars['Boolean']>;
  addMyIncident?: Maybe<Scalars['Boolean']>;
  addMyRoomReservation?: Maybe<Scalars['Boolean']>;
  addMyVendorAccess?: Maybe<Scalars['Boolean']>;
  addMyWatchList?: Maybe<Scalars['Boolean']>;
  addMyWorkOrder?: Maybe<Scalars['Boolean']>;
  addMyWorkOrderTemplate?: Maybe<Scalars['Boolean']>;
  addNewsFeedPost?: Maybe<Scalars['Boolean']>;
  addNewsFeedPostComment?: Maybe<Scalars['Boolean']>;
  addUser?: Maybe<Scalars['Boolean']>;
  approveGuest?: Maybe<Scalars['Boolean']>;
  approveVendorAccess?: Maybe<Scalars['Boolean']>;
  canCloseWorkOrder?: Maybe<Scalars['Boolean']>;
  cancelCompanySubscriptions?: Maybe<Scalars['Boolean']>;
  checkInGuest?: Maybe<Scalars['Boolean']>;
  checkInVendorAccess?: Maybe<Scalars['Boolean']>;
  controlUserWallet?: Maybe<Scalars['Boolean']>;
  creditCardPayments?: Maybe<Scalars['Boolean']>;
  deactivateCompanyWatchList?: Maybe<Scalars['Boolean']>;
  deactivateMyWatchList?: Maybe<Scalars['Boolean']>;
  deleteCoi?: Maybe<Scalars['Boolean']>;
  deleteCompany?: Maybe<Scalars['Boolean']>;
  deleteCompanyIncident?: Maybe<Scalars['Boolean']>;
  deleteCompanyWatchList?: Maybe<Scalars['Boolean']>;
  deleteCompanyWorkOrder?: Maybe<Scalars['Boolean']>;
  deleteCompanyWorkOrderTemplate?: Maybe<Scalars['Boolean']>;
  deleteMyIncident?: Maybe<Scalars['Boolean']>;
  deleteMyWatchList?: Maybe<Scalars['Boolean']>;
  deleteMyWorkOrder?: Maybe<Scalars['Boolean']>;
  deleteMyWorkOrderTemplate?: Maybe<Scalars['Boolean']>;
  deleteOtherUsersEventPost?: Maybe<Scalars['Boolean']>;
  deleteOtherUsersNewsFeedComment?: Maybe<Scalars['Boolean']>;
  deleteOtherUsersNewsFeedPost?: Maybe<Scalars['Boolean']>;
  deleteUser?: Maybe<Scalars['Boolean']>;
  editOtherUsersEventPost?: Maybe<Scalars['Boolean']>;
  editOtherUsersNewsFeedPost?: Maybe<Scalars['Boolean']>;
  manageAllTasks?: Maybe<Scalars['Boolean']>;
  manageCompanyRoomReservation?: Maybe<Scalars['Boolean']>;
  manageConciergeHub?: Maybe<Scalars['Boolean']>;
  manageFileManager?: Maybe<Scalars['Boolean']>;
  manageInvoices?: Maybe<Scalars['Boolean']>;
  manageLease?: Maybe<Scalars['Boolean']>;
  manageMyTasks?: Maybe<Scalars['Boolean']>;
  managePackage?: Maybe<Scalars['Boolean']>;
  managePreventiveMaintenance?: Maybe<Scalars['Boolean']>;
  manageRecurringInvoices?: Maybe<Scalars['Boolean']>;
  manageTaskCharges?: Maybe<Scalars['Boolean']>;
  manageWOCharges?: Maybe<Scalars['Boolean']>;
  manageWOTCharges?: Maybe<Scalars['Boolean']>;
  offlinePayments?: Maybe<Scalars['Boolean']>;
  printBadgeGuest?: Maybe<Scalars['Boolean']>;
  printBadgeVendorAccess?: Maybe<Scalars['Boolean']>;
  propertyAdmin?: Maybe<Scalars['Boolean']>;
  refundSubscriptionCharges?: Maybe<Scalars['Boolean']>;
  toggleGeneaDoor?: Maybe<Scalars['Boolean']>;
  updateCoi?: Maybe<Scalars['Boolean']>;
  updateCoiStatus?: Maybe<Scalars['Boolean']>;
  updateCompany?: Maybe<Scalars['Boolean']>;
  updateCompanyGuest?: Maybe<Scalars['Boolean']>;
  updateCompanyIncident?: Maybe<Scalars['Boolean']>;
  updateCompanyRoomReservation?: Maybe<Scalars['Boolean']>;
  updateCompanySubscriptions?: Maybe<Scalars['Boolean']>;
  updateCompanyVendorAccess?: Maybe<Scalars['Boolean']>;
  updateCompanyWatchList?: Maybe<Scalars['Boolean']>;
  updateCompanyWorkOrder?: Maybe<Scalars['Boolean']>;
  updateCompanyWorkOrderTemplate?: Maybe<Scalars['Boolean']>;
  updateGeneaCards?: Maybe<Scalars['Boolean']>;
  updateMyGuest?: Maybe<Scalars['Boolean']>;
  updateMyIncident?: Maybe<Scalars['Boolean']>;
  updateMyRoomReservation?: Maybe<Scalars['Boolean']>;
  updateMyVendorAccess?: Maybe<Scalars['Boolean']>;
  updateMyWatchList?: Maybe<Scalars['Boolean']>;
  updateMyWorkOrder?: Maybe<Scalars['Boolean']>;
  updateMyWorkOrderTemplate?: Maybe<Scalars['Boolean']>;
  updateUser?: Maybe<Scalars['Boolean']>;
  updateWorkOrderAssignee?: Maybe<Scalars['Boolean']>;
  updateWorkOrderAssigneeTemplate?: Maybe<Scalars['Boolean']>;
  updateWorkOrderPriority?: Maybe<Scalars['Boolean']>;
  updateWorkOrderPriorityTemplate?: Maybe<Scalars['Boolean']>;
  updateWorkOrderStatus?: Maybe<Scalars['Boolean']>;
  viewAllTasks?: Maybe<Scalars['Boolean']>;
  viewAnalytics?: Maybe<Scalars['Boolean']>;
  viewCoi?: Maybe<Scalars['Boolean']>;
  viewCompanyFullAccessUsers?: Maybe<Scalars['Boolean']>;
  viewCompanyGuest?: Maybe<Scalars['Boolean']>;
  viewCompanyIncident?: Maybe<Scalars['Boolean']>;
  viewCompanyPage?: Maybe<Scalars['Boolean']>;
  viewCompanyRoomReservation?: Maybe<Scalars['Boolean']>;
  viewCompanySubscriptions?: Maybe<Scalars['Boolean']>;
  viewCompanyVendorAccess?: Maybe<Scalars['Boolean']>;
  viewCompanyWatchList?: Maybe<Scalars['Boolean']>;
  viewCompanyWorkOrder?: Maybe<Scalars['Boolean']>;
  viewCompanyWorkOrderTemplate?: Maybe<Scalars['Boolean']>;
  viewConciergeHub?: Maybe<Scalars['Boolean']>;
  viewFileManager?: Maybe<Scalars['Boolean']>;
  viewGeneaCards?: Maybe<Scalars['Boolean']>;
  viewGeneaDoors?: Maybe<Scalars['Boolean']>;
  viewInternalNotes?: Maybe<Scalars['Boolean']>;
  viewInvoices?: Maybe<Scalars['Boolean']>;
  viewLease?: Maybe<Scalars['Boolean']>;
  viewMessages?: Maybe<Scalars['Boolean']>;
  viewMyGuest?: Maybe<Scalars['Boolean']>;
  viewMyIncident?: Maybe<Scalars['Boolean']>;
  viewMyRoomReservation?: Maybe<Scalars['Boolean']>;
  viewMySubscriptions?: Maybe<Scalars['Boolean']>;
  viewMyTasks?: Maybe<Scalars['Boolean']>;
  viewMyVendorAccess?: Maybe<Scalars['Boolean']>;
  viewMyWatchList?: Maybe<Scalars['Boolean']>;
  viewMyWorkOrder?: Maybe<Scalars['Boolean']>;
  viewMyWorkOrderTemplate?: Maybe<Scalars['Boolean']>;
  viewPackage?: Maybe<Scalars['Boolean']>;
  viewPreventiveMaintenance?: Maybe<Scalars['Boolean']>;
  viewPropertyNewsFeedPost?: Maybe<Scalars['Boolean']>;
  viewRecurringInvoices?: Maybe<Scalars['Boolean']>;
  viewReports?: Maybe<Scalars['Boolean']>;
  viewStackingPlan?: Maybe<Scalars['Boolean']>;
  viewTaskCharges?: Maybe<Scalars['Boolean']>;
  viewUser?: Maybe<Scalars['Boolean']>;
  viewWOCharges?: Maybe<Scalars['Boolean']>;
  viewWOTCharges?: Maybe<Scalars['Boolean']>;
};

export type PopulatedCompanyObject = {
  __typename?: 'PopulatedCompanyObject';
  active: Scalars['Boolean'];
  id: Scalars['String'];
  photo?: Maybe<FileObject>;
  title: Scalars['String'];
};

export type PortfolioInput = {
  background?: InputMaybe<FileObjectInput>;
  globalTranslationId: Scalars['String'];
  logo?: InputMaybe<FileObjectInput>;
  title: Scalars['String'];
  url: Scalars['String'];
};

export type PortfolioModel = {
  __typename?: 'PortfolioModel';
  active: Scalars['Boolean'];
  background?: Maybe<FileObject>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  index: Scalars['Int'];
  logo?: Maybe<FileObject>;
  propertyCount: Scalars['Int'];
  stripeSettings: PortfolioStripeSettings;
  title: Scalars['String'];
  translation: TranslationObject;
  updatedAt: Scalars['DateTime'];
  url: Scalars['String'];
  userCount: Scalars['Int'];
};

export type PortfolioStripeSettings = {
  __typename?: 'PortfolioStripeSettings';
  paymentACHCap?: Maybe<Scalars['Float']>;
  paymentACHFee?: Maybe<Scalars['Float']>;
  paymentACHUnit?: Maybe<ValueUnit>;
  paymentCardFee?: Maybe<Scalars['Float']>;
  paymentCardUnit?: Maybe<ValueUnit>;
};

export type PortfolioStripeSettingsInput = {
  paymentACHCap?: InputMaybe<Scalars['Float']>;
  paymentACHFee?: InputMaybe<Scalars['Float']>;
  paymentACHUnit?: InputMaybe<ValueUnit>;
  paymentCardFee?: InputMaybe<Scalars['Float']>;
  paymentCardUnit?: InputMaybe<ValueUnit>;
};

export type PortfolioUpdateInput = {
  background?: InputMaybe<FileObjectInput>;
  logo?: InputMaybe<FileObjectInput>;
  stripeSettings: PortfolioStripeSettingsInput;
  title: Scalars['String'];
  translationId: Scalars['String'];
  url: Scalars['String'];
};

export type PriceBhSettings = {
  __typename?: 'PriceBHSettings';
  dateSelection?: Maybe<Scalars['Boolean']>;
  timeFrom?: Maybe<Scalars['String']>;
  timeTo?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};

export type PrinterModel = {
  __typename?: 'PrinterModel';
  building?: Maybe<BuildingObject>;
  id: Scalars['String'];
  ipAddress: Scalars['String'];
  modelId?: Maybe<Scalars['Int']>;
  modelName: PrinterModelTypes;
  paperId?: Maybe<Scalars['Int']>;
  paperType: PrinterPaperTypes;
  synced: Scalars['Boolean'];
  title: Scalars['String'];
};

export enum PrinterModelTypes {
  BrlmPrinterModelQl_710W = 'BRLMPrinterModelQL_710W',
  BrlmPrinterModelQl_720Nw = 'BRLMPrinterModelQL_720NW',
  BrlmPrinterModelQl_810W = 'BRLMPrinterModelQL_810W',
  BrlmPrinterModelQl_820Nwb = 'BRLMPrinterModelQL_820NWB',
  BrlmPrinterModelQl_1110Nwb = 'BRLMPrinterModelQL_1110NWB',
  BrlmPrinterModelQl_1115Nwb = 'BRLMPrinterModelQL_1115NWB'
}

export enum PrinterPaperTypes {
  BrlmqlPrintSettingsLabelSizeDieCutW62H100 = 'BRLMQLPrintSettingsLabelSizeDieCutW62H100'
}

export type PriorityInput = {
  color: Scalars['String'];
  recordType: PriorityRecordType;
  title: Scalars['String'];
};

export type PriorityObject = {
  __typename?: 'PriorityObject';
  active: Scalars['Boolean'];
  color: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  index: Scalars['Int'];
  property?: Maybe<PropertyObject>;
  recordType: PriorityRecordType;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

/** The supported records type. */
export enum PriorityRecordType {
  /** For Work Order component */
  WorkOrder = 'workOrder'
}

export type PriorityUpdateInput = {
  color: Scalars['String'];
  title: Scalars['String'];
};

export type ProcedureObject = {
  __typename?: 'ProcedureObject';
  active: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  createdBy: UserObject;
  estimatedLabor?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  index: Scalars['Float'];
  notes?: Maybe<Scalars['String']>;
  schedulesCount: Scalars['Float'];
  sections?: Maybe<Array<ProcedureSectionObject>>;
  title: Scalars['String'];
};

export type ProcedureSectionObject = {
  __typename?: 'ProcedureSectionObject';
  steps: Array<ProcedureSectionStepObject>;
  title: Scalars['String'];
};

export type ProcedureSectionStepDropdownOptionObject = {
  __typename?: 'ProcedureSectionStepDropdownOptionObject';
  items?: Maybe<Array<Scalars['String']>>;
  multi?: Maybe<Scalars['Boolean']>;
};

export type ProcedureSectionStepInputOptionObject = {
  __typename?: 'ProcedureSectionStepInputOptionObject';
  type?: Maybe<PmStepInputType>;
  unit?: Maybe<Scalars['String']>;
};

export type ProcedureSectionStepObject = {
  __typename?: 'ProcedureSectionStepObject';
  customId?: Maybe<Scalars['String']>;
  dropdownOptions?: Maybe<ProcedureSectionStepDropdownOptionObject>;
  inputOptions?: Maybe<ProcedureSectionStepInputOptionObject>;
  predefinedCustomField?: Maybe<PmCustomIdObject>;
  title: Scalars['String'];
  type: PmStepType;
};

export type PropertyAddressInput = {
  address?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
};

export type PropertyAddressObject = {
  __typename?: 'PropertyAddressObject';
  address?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

export type PropertyCloneInput = {
  conciergeHubDeals?: InputMaybe<Scalars['Boolean']>;
  employees?: InputMaybe<Scalars['Boolean']>;
  kioskSettings?: InputMaybe<Scalars['Boolean']>;
  meetingHubRooms?: InputMaybe<Scalars['Boolean']>;
  menuManager?: InputMaybe<Scalars['Boolean']>;
  propertyId: Scalars['String'];
};

export type PropertyInput = {
  address?: InputMaybe<PropertyAddressInput>;
  bgImg?: InputMaybe<FileObjectInput>;
  favicon?: InputMaybe<FileObjectInput>;
  logo?: InputMaybe<FileObjectInput>;
  primaryColor?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
  title: Scalars['String'];
};

export type PropertyObject = {
  __typename?: 'PropertyObject';
  active: Scalars['Boolean'];
  address?: Maybe<PropertyAddressObject>;
  bgImg?: Maybe<FileObject>;
  companyCount: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  favicon?: Maybe<FileObject>;
  id: Scalars['String'];
  index: Scalars['Int'];
  logo?: Maybe<FileObject>;
  portfolio: PortfolioModel;
  primaryColor?: Maybe<Scalars['String']>;
  timezone: Scalars['String'];
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userCount: Scalars['Int'];
};

export type Query = {
  __typename?: 'Query';
  exportGlobalTranslation: Scalars['String'];
  exportTranslation: Scalars['String'];
  getARCode: ArCodeObject;
  getARCodes: Array<ArCodeObject>;
  getActivityLog: GetActivityLogsObject;
  getBuilding: BuildingObject;
  getBuildings: GetBuildings;
  getCOIWidget: Array<CoiWidget>;
  getCategories: GetCategories;
  getCategoriesGrouped: GetCategoriesGrouped;
  getCategory: CategoryObject;
  getCategoryGroup: CategoryGroupObject;
  getCategoryGroups: GetCategoryGroups;
  getChargeCode: ChargeCodeObject;
  getChargeCodes: Array<ChargeCodeObject>;
  getCoi: CoiObject;
  getCois: GetCoiObject;
  getCompanies: GetCompanyObject;
  getCompany: CompanyObject;
  getCompanyProperties: Array<CompanyPropertyObject>;
  getDefaultEmailTemplate: DefaultEmailTemplateObject;
  getDefaultEmailTemplates: Array<DefaultEmailTemplateObject>;
  getEmailTemplate: EmailTemplateObject;
  getEmailTemplates: Array<EmailTemplateObject>;
  getFilterableGroupedCategories: GetFilterableGroupedCategories;
  getFilterablePriorities: Array<FilterablePriorityObject>;
  getFilterableStatuses: Array<FilterableStatusObject>;
  getGLAccount: GlAccountObject;
  getGLAccounts: Array<GlAccountObject>;
  getGlobalTranslation: GlobalTranslationObject;
  getGlobalTranslationFiltered: GlobalTranslationFilteredObject;
  getGlobalTranslations: Array<GlobalTranslationObject>;
  getGlobalUser: GlobalUserObject;
  getGlobalUsers: GetGlobalUserList;
  getIncidentStatusSetting: IncidentStatusSettingObject;
  getLaborRate: LaborRateObject;
  getLaborRates: Array<LaborRateObject>;
  getLeaseChargeType: LeaseChargeTypeObject;
  getLeaseChargeTypes: Array<LeaseChargeTypeObject>;
  getMarkup: MarkupObject;
  getMarkups: Array<MarkupObject>;
  getPortfolio: PortfolioModel;
  getPortfolios: GetPortfolios;
  getPriorities: Array<PriorityObject>;
  getPriority: PriorityObject;
  getProperties: GetProperties;
  getProperty: PropertyObject;
  getRecordActivityLog: GetActivityLogsObject;
  getRole: RoleObject;
  getRoleStructure: Array<RoleStructureObject>;
  getRoles: GetRolesObject;
  getStatus: StatusObject;
  getStatuses: Array<StatusObject>;
  getTaskOpenWidget: TaskOpenWidget;
  getTaskOverdueWidget: TaskOverdueWidget;
  getTax: TaxObject;
  getTaxes: Array<TaxObject>;
  getTranslation: TranslationObject;
  getTranslationFiltered: TranslationFilteredObject;
  getTranslations: Array<TranslationObject>;
  getUser: UserObject;
  getUserProperties: Array<UserPropertyObject>;
  getUsers: GetUsersObject;
  getWOCategoryWidget: Array<WoCategoryWidget>;
  getWORevenueWidget: Array<WoRevenueWidget>;
  getWOReviewsWidget: Array<WoReviewWidget>;
  getWOStatusWidget: Array<WoStatusWidget>;
  getWorkOrder: WorkOrderObject;
  getWorkOrderCharges: Array<ChargeObject>;
  getWorkOrderEquipment: GetEquipmentsObject;
  getWorkOrderStatusSetting: WorkOrderStatusSettingObject;
  getWorkOrders: GetWorkOrdersObject;
  me: GlobalUserObject;
};


export type QueryExportGlobalTranslationArgs = {
  id: Scalars['String'];
};


export type QueryExportTranslationArgs = {
  id: Scalars['String'];
  merge: Scalars['Boolean'];
};


export type QueryGetArCodeArgs = {
  id: Scalars['String'];
};


export type QueryGetArCodesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  portfolioId: Scalars['String'];
  propertyIds?: InputMaybe<Array<Scalars['String']>>;
  recordLevel?: InputMaybe<RecordLevel>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetActivityLogArgs = {
  activityType?: InputMaybe<ActivityTypeEnum>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['DateTime']>;
  portfolioId: Scalars['String'];
  propertyIds?: InputMaybe<Array<Scalars['String']>>;
  referType?: InputMaybe<ReferToType>;
  search?: InputMaybe<Scalars['String']>;
  sortBy?: SortActivityFieldEnum;
  sortByDir?: SortDirectionEnum;
  take?: Scalars['Int'];
  to?: InputMaybe<Scalars['DateTime']>;
  userIds?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryGetBuildingArgs = {
  id: Scalars['String'];
};


export type QueryGetBuildingsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  portfolioId: Scalars['String'];
  propertyIds?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  sortBy?: SortBuildingFieldEnum;
  sortByDir?: SortDirectionEnum;
  take?: Scalars['Int'];
};


export type QueryGetCoiWidgetArgs = {
  portfolioId: Scalars['String'];
  propertyId?: InputMaybe<Scalars['String']>;
};


export type QueryGetCategoriesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  portfolioId: Scalars['String'];
  propertyIds?: InputMaybe<Array<Scalars['String']>>;
  recordLevel?: InputMaybe<RecordLevel>;
  recordType: CategoryRecordType;
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
};


export type QueryGetCategoriesGroupedArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  portfolioId: Scalars['String'];
  propertyIds?: InputMaybe<Array<Scalars['String']>>;
  recordLevel?: InputMaybe<RecordLevel>;
  recordType: CategoryRecordType;
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
};


export type QueryGetCategoryArgs = {
  id: Scalars['String'];
};


export type QueryGetCategoryGroupArgs = {
  id: Scalars['String'];
};


export type QueryGetCategoryGroupsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  portfolioId: Scalars['String'];
  propertyIds?: InputMaybe<Array<Scalars['String']>>;
  recordLevel?: InputMaybe<RecordLevel>;
  recordType: CategoryRecordType;
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
};


export type QueryGetChargeCodeArgs = {
  id: Scalars['String'];
};


export type QueryGetChargeCodesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  portfolioId: Scalars['String'];
  propertyIds?: InputMaybe<Array<Scalars['String']>>;
  recordLevel?: InputMaybe<RecordLevel>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetCoiArgs = {
  coiId: Scalars['String'];
};


export type QueryGetCoisArgs = {
  after?: InputMaybe<Scalars['String']>;
  archived?: ArchiveStatusEnum;
  before?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['String']>>;
  companyTypes?: InputMaybe<Array<CompanyTypeEnum>>;
  createdByIds?: InputMaybe<Array<Scalars['String']>>;
  expiration?: CoiExpirationEnum;
  from?: InputMaybe<Scalars['DateTime']>;
  portfolioId: Scalars['String'];
  propertyIds?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<CoiStatusEnum>>;
  take?: Scalars['Int'];
  to?: InputMaybe<Scalars['DateTime']>;
};


export type QueryGetCompaniesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyTypes?: InputMaybe<Array<CompanyTypeEnum>>;
  portfolioId: Scalars['String'];
  propertyIds?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
};


export type QueryGetCompanyArgs = {
  id: Scalars['String'];
};


export type QueryGetCompanyPropertiesArgs = {
  id: Scalars['String'];
};


export type QueryGetDefaultEmailTemplateArgs = {
  type: EmailTemplateType;
};


export type QueryGetDefaultEmailTemplatesArgs = {
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetEmailTemplateArgs = {
  portfolioId: Scalars['String'];
  type: EmailTemplateType;
};


export type QueryGetEmailTemplatesArgs = {
  portfolioId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetFilterableGroupedCategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  location: FilterableCategoryLocationType;
  portfolioId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
};


export type QueryGetFilterablePrioritiesArgs = {
  location: FilterablePriorityLocationType;
  portfolioId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetFilterableStatusesArgs = {
  location: FilterableStatusLocationType;
  portfolioId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetGlAccountArgs = {
  id: Scalars['String'];
};


export type QueryGetGlAccountsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  portfolioId: Scalars['String'];
  propertyIds?: InputMaybe<Array<Scalars['String']>>;
  recordLevel?: InputMaybe<RecordLevel>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetGlobalTranslationArgs = {
  id: Scalars['String'];
};


export type QueryGetGlobalTranslationFilteredArgs = {
  id: Scalars['String'];
  key: Scalars['String'];
};


export type QueryGetGlobalTranslationsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetGlobalUserArgs = {
  id: Scalars['String'];
};


export type QueryGetGlobalUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
};


export type QueryGetIncidentStatusSettingArgs = {
  portfolioId: Scalars['String'];
};


export type QueryGetLaborRateArgs = {
  id: Scalars['String'];
};


export type QueryGetLaborRatesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  portfolioId: Scalars['String'];
  propertyIds?: InputMaybe<Array<Scalars['String']>>;
  recordLevel?: InputMaybe<RecordLevel>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetLeaseChargeTypeArgs = {
  id: Scalars['String'];
};


export type QueryGetLeaseChargeTypesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  portfolioId: Scalars['String'];
  propertyIds?: InputMaybe<Array<Scalars['String']>>;
  recordLevel?: InputMaybe<RecordLevel>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetMarkupArgs = {
  id: Scalars['String'];
};


export type QueryGetMarkupsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  portfolioId: Scalars['String'];
  propertyIds?: InputMaybe<Array<Scalars['String']>>;
  recordLevel?: InputMaybe<RecordLevel>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetPortfolioArgs = {
  id: Scalars['String'];
};


export type QueryGetPortfoliosArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
};


export type QueryGetPrioritiesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  portfolioId: Scalars['String'];
  propertyIds?: InputMaybe<Array<Scalars['String']>>;
  recordLevel?: InputMaybe<RecordLevel>;
  recordType: PriorityRecordType;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetPriorityArgs = {
  id: Scalars['String'];
};


export type QueryGetPropertiesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  portfolioId?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
};


export type QueryGetPropertyArgs = {
  id: Scalars['String'];
};


export type QueryGetRecordActivityLogArgs = {
  activityType?: InputMaybe<ActivityTypeEnum>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  recordId: Scalars['String'];
  referType: ReferToType;
  sortBy?: SortActivityFieldEnum;
  sortByDir?: SortDirectionEnum;
  take?: Scalars['Int'];
};


export type QueryGetRoleArgs = {
  id: Scalars['String'];
};


export type QueryGetRolesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  portfolioId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
};


export type QueryGetStatusArgs = {
  id: Scalars['String'];
};


export type QueryGetStatusesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  portfolioId: Scalars['String'];
  propertyIds?: InputMaybe<Array<Scalars['String']>>;
  recordLevel?: InputMaybe<RecordLevel>;
  recordType: StatusRecordType;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetTaskOpenWidgetArgs = {
  portfolioId: Scalars['String'];
  propertyId?: InputMaybe<Scalars['String']>;
};


export type QueryGetTaskOverdueWidgetArgs = {
  portfolioId: Scalars['String'];
  propertyId?: InputMaybe<Scalars['String']>;
};


export type QueryGetTaxArgs = {
  id: Scalars['String'];
};


export type QueryGetTaxesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  portfolioId: Scalars['String'];
  propertyIds?: InputMaybe<Array<Scalars['String']>>;
  recordLevel?: InputMaybe<RecordLevel>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetTranslationArgs = {
  id: Scalars['String'];
};


export type QueryGetTranslationFilteredArgs = {
  id: Scalars['String'];
  key: Scalars['String'];
};


export type QueryGetTranslationsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  portfolioId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetUserArgs = {
  id: Scalars['String'];
};


export type QueryGetUserPropertiesArgs = {
  id: Scalars['String'];
};


export type QueryGetUsersArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['String']>>;
  portfolioId: Scalars['String'];
  propertyIds?: InputMaybe<Array<Scalars['String']>>;
  roleIds?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
};


export type QueryGetWoCategoryWidgetArgs = {
  buildingIds?: InputMaybe<Array<Scalars['String']>>;
  categoryIds?: InputMaybe<Array<Scalars['String']>>;
  from?: InputMaybe<Scalars['DateTime']>;
  portfolioId: Scalars['String'];
  propertyId?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['DateTime']>;
};


export type QueryGetWoRevenueWidgetArgs = {
  buildingIds?: InputMaybe<Array<Scalars['String']>>;
  categoryIds?: InputMaybe<Array<Scalars['String']>>;
  from?: InputMaybe<Scalars['DateTime']>;
  portfolioId: Scalars['String'];
  propertyId?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['DateTime']>;
};


export type QueryGetWoReviewsWidgetArgs = {
  from?: InputMaybe<Scalars['DateTime']>;
  portfolioId: Scalars['String'];
  to?: InputMaybe<Scalars['DateTime']>;
};


export type QueryGetWoStatusWidgetArgs = {
  buildingIds?: InputMaybe<Array<Scalars['String']>>;
  categoryIds?: InputMaybe<Array<Scalars['String']>>;
  from?: InputMaybe<Scalars['DateTime']>;
  portfolioId: Scalars['String'];
  propertyId?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['DateTime']>;
};


export type QueryGetWorkOrderArgs = {
  workOrderId: Scalars['String'];
};


export type QueryGetWorkOrderChargesArgs = {
  search?: InputMaybe<Scalars['String']>;
  workOrderId: Scalars['String'];
};


export type QueryGetWorkOrderEquipmentArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
  workOrderId: Scalars['String'];
};


export type QueryGetWorkOrderStatusSettingArgs = {
  portfolioId: Scalars['String'];
};


export type QueryGetWorkOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  archived?: ArchiveStatusEnum;
  assigneeIds?: InputMaybe<Array<Scalars['String']>>;
  before?: InputMaybe<Scalars['String']>;
  buildingIds?: InputMaybe<Array<Scalars['String']>>;
  categoryIds?: InputMaybe<Array<Scalars['String']>>;
  closedAtFrom?: InputMaybe<Scalars['DateTime']>;
  closedAtTo?: InputMaybe<Scalars['DateTime']>;
  companyIds?: InputMaybe<Array<Scalars['String']>>;
  from?: InputMaybe<Scalars['DateTime']>;
  portfolioId: Scalars['String'];
  priorityIds?: InputMaybe<Array<Scalars['String']>>;
  propertyIds?: InputMaybe<Array<Scalars['String']>>;
  requestedForIds?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  statusIds?: InputMaybe<Array<Scalars['String']>>;
  take?: Scalars['Int'];
  to?: InputMaybe<Scalars['DateTime']>;
};

export type RRuleEndObject = {
  __typename?: 'RRuleEndObject';
  count?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['String']>;
  type: RRuleEndType;
};

/** The supported types of category. */
export enum RRuleEndType {
  /** Specific date of end */
  Date = 'date',
  /** Count of iterations */
  Interval = 'interval',
  /** infinity */
  Never = 'never'
}

/** The supported types of date in RRule. */
export enum RRuleFrequencyType {
  /** Every day */
  Daily = 'DAILY',
  /** Every month */
  Monthly = 'MONTHLY',
  /** Every week */
  Weekly = 'WEEKLY',
  /** Every year */
  Yearly = 'YEARLY'
}

/** The supported types of date in RRule. */
export enum RRuleMonthlyTypes {
  /** By number of month day */
  MonthDay = 'monthDay',
  /** By number of week day */
  PosDay = 'posDay'
}

export type RRuleObject = {
  __typename?: 'RRuleObject';
  days?: Maybe<Array<RRuleWeekdays>>;
  end: RRuleEndObject;
  frequency: RRuleFrequencyType;
  interval: Scalars['Int'];
  monthDay?: Maybe<Scalars['Int']>;
  monthlyType?: Maybe<RRuleMonthlyTypes>;
  pos?: Maybe<RRulePos>;
  weekDay?: Maybe<RRuleWeekdays>;
};

/** List of positions */
export enum RRulePos {
  First = 'first',
  Fourth = 'fourth',
  Last = 'last',
  Second = 'second',
  Third = 'third'
}

/** The supported statuses for RRule item. */
export enum RRuleStatuses {
  Active = 'active',
  Expired = 'expired',
  Paused = 'paused'
}

/** List of weekdays */
export enum RRuleWeekdays {
  Fr = 'fr',
  Mo = 'mo',
  Sa = 'sa',
  Su = 'su',
  Th = 'th',
  Tu = 'tu',
  We = 'we'
}

/** The level or records for respond. */
export enum RecordLevel {
  /** Records created on portfolio lvl */
  Portfolio = 'PORTFOLIO',
  /** Records created on property lvl */
  Property = 'PROPERTY'
}

export type ReferToObject = {
  __typename?: 'ReferToObject';
  id: Scalars['String'];
  index?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  type: ReferToType;
};

export enum ReferToType {
  Broadcast = 'BROADCAST',
  Coi = 'COI',
  Company = 'COMPANY',
  Deal = 'DEAL',
  Equipment = 'EQUIPMENT',
  Guest = 'GUEST',
  Incident = 'INCIDENT',
  Invoice = 'INVOICE',
  Lease = 'LEASE',
  MeetingHub = 'MEETING_HUB',
  Newsfeed = 'NEWSFEED',
  Other = 'OTHER',
  Package = 'PACKAGE',
  Procedure = 'PROCEDURE',
  RecurringInvoice = 'RECURRING_INVOICE',
  Schedule = 'SCHEDULE',
  Subscription = 'SUBSCRIPTION',
  Suite = 'SUITE',
  Task = 'TASK',
  VendorAccess = 'VENDOR_ACCESS',
  Watchlist = 'WATCHLIST',
  WorkOrder = 'WORK_ORDER',
  WorkOrderTemplate = 'WORK_ORDER_TEMPLATE'
}

export type ResetPasswordInput = {
  code: Scalars['String'];
  password: Scalars['String'];
};

export type RoleInput = {
  description?: InputMaybe<Scalars['String']>;
  permissions: PermissionInput;
  rolesAssignable?: InputMaybe<Array<Scalars['String']>>;
  templates?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
};

export type RoleObject = {
  __typename?: 'RoleObject';
  active: Scalars['Boolean'];
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  index: Scalars['Int'];
  permissions: PermissionsObject;
  portfolioId: Scalars['String'];
  rolesAssignable: Array<RoleObject>;
  templates: Array<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  userCount: Scalars['Float'];
};

export type RolePermissionObject = {
  __typename?: 'RolePermissionObject';
  dependencies?: Maybe<Array<Scalars['String']>>;
  key: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type RoleSectionObject = {
  __typename?: 'RoleSectionObject';
  notes?: Maybe<Scalars['String']>;
  permissions: Array<RolePermissionObject>;
  title: Scalars['String'];
};

export type RoleStructureObject = {
  __typename?: 'RoleStructureObject';
  description: Scalars['String'];
  sections: Array<RoleSectionObject>;
  title: Scalars['String'];
};

export type SchedulesObject = {
  __typename?: 'SchedulesObject';
  assignedTo?: Maybe<UserObject>;
  attachments?: Maybe<Array<FileObject>>;
  createdAt: Scalars['DateTime'];
  createdBy: UserObject;
  dueAfterDays?: Maybe<Scalars['Int']>;
  equipment: Array<EquipmentModel>;
  equipmentCount: Scalars['Float'];
  excludeDates?: Maybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  index: Scalars['Int'];
  nextGenerationDate?: Maybe<Scalars['DateTime']>;
  notes?: Maybe<Scalars['String']>;
  prevGenerationDate?: Maybe<Scalars['DateTime']>;
  procedureCount: Scalars['Float'];
  procedures: Array<ProcedureObject>;
  recordStatus: RRuleStatuses;
  rruleObject: RRuleObject;
  rruleText?: Maybe<Scalars['String']>;
  splitEquipmentOnTask: Scalars['Boolean'];
  startDate: Scalars['DateTime'];
  timezone: Scalars['String'];
  title: Scalars['String'];
};

export type SendTestMailInput = {
  body: Scalars['String'];
  subject: Scalars['String'];
};

export type SetDoorObject = {
  __typename?: 'SetDoorObject';
  doorOperatorType: Scalars['String'];
  id: Scalars['String'];
  title: Scalars['String'];
};

export type SetScheduleObject = {
  __typename?: 'SetScheduleObject';
  id: Scalars['String'];
  title: Scalars['String'];
};

export type SetsObject = {
  __typename?: 'SetsObject';
  door?: Maybe<SetDoorObject>;
  schedule?: Maybe<SetScheduleObject>;
};

export enum SortActivityFieldEnum {
  Creation = 'CREATION'
}

export enum SortBuildingFieldEnum {
  Creation = 'CREATION',
  Title = 'TITLE'
}

export enum SortDirectionEnum {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StatusInput = {
  color: Scalars['String'];
  recordType: StatusRecordType;
  title: Scalars['String'];
};

export type StatusObject = {
  __typename?: 'StatusObject';
  active: Scalars['Boolean'];
  color: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  index: Scalars['Int'];
  property?: Maybe<PropertyObject>;
  recordType: StatusRecordType;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

/** The supported records type. */
export enum StatusRecordType {
  /** For Incident component */
  Incident = 'incident',
  /** For Work Order component */
  WorkOrder = 'workOrder'
}

export type StatusUpdateInput = {
  color: Scalars['String'];
  title: Scalars['String'];
};

export type SuiteObject = {
  __typename?: 'SuiteObject';
  attachment?: Maybe<FileObject>;
  bomaSize?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['String']>;
  floor: FloorObject;
  id: Scalars['String'];
  index: Scalars['Int'];
  isPublic: Scalars['Boolean'];
  leases?: Maybe<Array<LeaseObject>>;
  order: Scalars['Int'];
  size: Scalars['Float'];
  title: Scalars['String'];
  type: SuiteType;
};

/** The supported types of suites. */
export enum SuiteType {
  /** Suite type */
  Amenity = 'amenity',
  /** Suite type, excluded form lease logic */
  Mechanical = 'mechanical',
  /** Suite type */
  Tenant = 'tenant'
}

export type TaskObject = {
  __typename?: 'TaskObject';
  assignedTo?: Maybe<UserObject>;
  attachments?: Maybe<Array<FileObject>>;
  charges?: Maybe<Scalars['Float']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  createdBy: UserObject;
  dueDate?: Maybe<Scalars['String']>;
  equipment: Array<EquipmentModel>;
  id: Scalars['String'];
  index: Scalars['Float'];
  notes?: Maybe<Scalars['String']>;
  procedures: Array<TaskProcedureObject>;
  schedule?: Maybe<SchedulesObject>;
  systemCompleted: Scalars['Boolean'];
  title: Scalars['String'];
  userCompleted: Scalars['Boolean'];
  watchers?: Maybe<Array<UserObject>>;
};

export type TaskOpenWidget = {
  __typename?: 'TaskOpenWidget';
  count: Scalars['Int'];
};

export type TaskOverdueWidget = {
  __typename?: 'TaskOverdueWidget';
  count: Scalars['Int'];
};

export type TaskProcedureObject = {
  __typename?: 'TaskProcedureObject';
  estimatedLabor?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  isDone: Scalars['Boolean'];
  notes?: Maybe<Scalars['String']>;
  procedure?: Maybe<ProcedureObject>;
  procedureId?: Maybe<Scalars['String']>;
  procedureIndex: Scalars['Float'];
  sections: Array<TaskSectionObject>;
  title: Scalars['String'];
};

export type TaskSectionObject = {
  __typename?: 'TaskSectionObject';
  id: Scalars['String'];
  isDone: Scalars['Boolean'];
  steps: Array<TaskStepObject>;
  title: Scalars['String'];
};

export type TaskStepObject = {
  __typename?: 'TaskStepObject';
  customId?: Maybe<Scalars['String']>;
  dropdownOptions?: Maybe<ProcedureSectionStepDropdownOptionObject>;
  id: Scalars['String'];
  title: Scalars['String'];
  type: PmStepType;
};

export type TaxInput = {
  amount: Scalars['Float'];
  arCodeId?: InputMaybe<Scalars['String']>;
  chargeCodeId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  glAccountId?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type TaxObject = {
  __typename?: 'TaxObject';
  active: Scalars['Boolean'];
  amount: Scalars['Float'];
  arCode?: Maybe<ArCodeObject>;
  chargeCode?: Maybe<ChargeCodeObject>;
  description?: Maybe<Scalars['String']>;
  glAccount?: Maybe<GlAccountObject>;
  id: Scalars['String'];
  index: Scalars['Int'];
  property?: Maybe<PropertyObject>;
  title: Scalars['String'];
};

export type ThreeSecure = {
  __typename?: 'ThreeSecure';
  supported?: Maybe<Scalars['String']>;
};

export type ToggleEmailTemplateInput = {
  portfolioId: Scalars['String'];
  toggleType: EmailToggleEnum;
  type: EmailTemplateType;
};

export type TranslationFilteredObject = {
  __typename?: 'TranslationFilteredObject';
  descriptions: Scalars['TranslationKeysScalar'];
  sources: Scalars['TranslationKeysScalar'];
  translations?: Maybe<Scalars['TranslationKeysScalar']>;
};

export type TranslationInput = {
  countryCode: Scalars['String'];
  globalTranslationId: Scalars['String'];
  title: Scalars['String'];
};

export type TranslationObject = {
  __typename?: 'TranslationObject';
  active: Scalars['Boolean'];
  countryCode: Scalars['String'];
  descriptions: Scalars['TranslationKeysScalar'];
  globalTranslation: GlobalTranslationObject;
  id: Scalars['String'];
  sources: Scalars['TranslationKeysScalar'];
  title: Scalars['String'];
  translations?: Maybe<Scalars['TranslationKeysScalar']>;
};

export type UpdateDefaultEmailTemplateInput = {
  appBody?: InputMaybe<Scalars['String']>;
  emailBody?: InputMaybe<Scalars['String']>;
  smsBody?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
};

export type UpdateEmailTemplateInput = {
  appActive?: InputMaybe<Scalars['Boolean']>;
  appBody?: InputMaybe<Scalars['String']>;
  bcc?: InputMaybe<Array<Scalars['String']>>;
  cc?: InputMaybe<Array<Scalars['String']>>;
  emailActive?: InputMaybe<Scalars['Boolean']>;
  emailBody?: InputMaybe<Scalars['String']>;
  smsActive?: InputMaybe<Scalars['Boolean']>;
  smsBody?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
};

export type UpdateGlobalUserInput = {
  addPortfolio: Scalars['Boolean'];
  controlGlobalUsers: Scalars['Boolean'];
  firstName: Scalars['String'];
  globalEmailAccess: Scalars['Boolean'];
  lastName: Scalars['String'];
  photo?: InputMaybe<FileObjectInput>;
  portfolioIds: Array<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  viewPortfolioCOIs: Scalars['Boolean'];
  viewPortfolioDashboard: Scalars['Boolean'];
  viewPortfolioSettings: Scalars['Boolean'];
  viewPortfolioWorkOrders: Scalars['Boolean'];
};

export type UploadFileDto = {
  __typename?: 'UploadFileDTO';
  name: Scalars['String'];
  size: Scalars['Float'];
  url: Scalars['String'];
};

export type UserInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  photo?: InputMaybe<FileObjectInput>;
  properties: Array<UserPropertyInput>;
};

export type UserObject = {
  __typename?: 'UserObject';
  active: Scalars['Boolean'];
  authSecurity?: Maybe<UserSettingObject>;
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['String'];
  index: Scalars['Int'];
  lastLoginAt?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  photo?: Maybe<FileObject>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserPropertyInput = {
  buildingIds: Array<Scalars['String']>;
  companyIds: Array<Scalars['String']>;
  propertyId: Scalars['String'];
  roleId: Scalars['String'];
  status: UserStatuses;
  title?: InputMaybe<Scalars['String']>;
};

export type UserPropertyObject = {
  __typename?: 'UserPropertyObject';
  buildings: Array<BuildingObject>;
  companies: Array<CompanyObject>;
  primaryCompany?: Maybe<CompanyObject>;
  printer?: Maybe<PrinterModel>;
  property: PropertyObject;
  role: RoleObject;
  status: UserStatuses;
  title?: Maybe<Scalars['String']>;
};

export type UserSettingObject = {
  __typename?: 'UserSettingObject';
  two_fa_email?: Maybe<Scalars['Boolean']>;
  two_fa_phone?: Maybe<Scalars['Boolean']>;
};

/** The supported types for menu items. */
export enum UserStatuses {
  /** User status which can do anything */
  Active = 'active',
  /** Status which set when user doesnt have role or he is deactivated */
  Deactivated = 'deactivated',
  /** User is deleted */
  Deleted = 'deleted'
}

export type UserUpdateInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
};

export type UserWidgetLayoutModel = {
  __typename?: 'UserWidgetLayoutModel';
  h: Scalars['Float'];
  w: Scalars['Float'];
  x: Scalars['Float'];
  y: Scalars['Float'];
};

/** The supported types of value unit. */
export enum ValueUnit {
  /** Amount type */
  Normal = 'normal',
  /** Percentage type */
  Percent = 'percent'
}

export type WoCategoryWidget = {
  __typename?: 'WOCategoryWidget';
  count: Scalars['Float'];
  name: Scalars['String'];
};

export type WoGuestUserObject = {
  __typename?: 'WOGuestUserObject';
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type WoRevenueWidget = {
  __typename?: 'WORevenueWidget';
  laborRevenue: Scalars['Float'];
  markupRevenue: Scalars['Float'];
  materialRevenue: Scalars['Float'];
  name: Scalars['String'];
};

export type WoReviewObject = {
  __typename?: 'WOReviewObject';
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy: UserObject;
  id: Scalars['String'];
  score: Scalars['Int'];
};

export type WoReviewWidget = {
  __typename?: 'WOReviewWidget';
  count: Scalars['Float'];
  name: Scalars['String'];
};

export type WoStatusWidget = {
  __typename?: 'WOStatusWidget';
  color: Scalars['String'];
  count: Scalars['Int'];
  name: Scalars['String'];
  percentage: Scalars['Float'];
};

export type WorkOrderObject = {
  __typename?: 'WorkOrderObject';
  acknowledged?: Maybe<Scalars['Boolean']>;
  assignedTo?: Maybe<UserObject>;
  attachments?: Maybe<Array<FileObject>>;
  building: BuildingObject;
  category: CategoryObject;
  charges?: Maybe<Scalars['Float']>;
  closedAt?: Maybe<Scalars['DateTime']>;
  company: CompanyObject;
  createdAt: Scalars['DateTime'];
  createdBy: UserObject;
  createdByGuest?: Maybe<WoGuestUserObject>;
  description?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['String']>;
  floor?: Maybe<FloorObject>;
  id: Scalars['String'];
  index: Scalars['Int'];
  isArchived: Scalars['Boolean'];
  priority?: Maybe<PriorityObject>;
  property: PropertyObject;
  requestedFor?: Maybe<UserObject>;
  review?: Maybe<WoReviewObject>;
  startDate: Scalars['DateTime'];
  status: StatusObject;
  suite?: Maybe<SuiteObject>;
  timezone: Scalars['String'];
  watchers?: Maybe<Array<UserObject>>;
  workOrderTemplate?: Maybe<WorkOrderTemplateObject>;
};

export type WorkOrderStatusInput = {
  acknowledge?: InputMaybe<Scalars['String']>;
  closed?: InputMaybe<Array<Scalars['String']>>;
  default?: InputMaybe<Scalars['String']>;
  rating?: InputMaybe<Array<Scalars['String']>>;
};

export type WorkOrderStatusSettingObject = {
  __typename?: 'WorkOrderStatusSettingObject';
  acknowledge?: Maybe<StatusObject>;
  closed: Array<StatusObject>;
  default?: Maybe<StatusObject>;
  rating: Array<StatusObject>;
};

export type WorkOrderTemplateObject = {
  __typename?: 'WorkOrderTemplateObject';
  assignedTo?: Maybe<UserObject>;
  attachments?: Maybe<Array<FileObject>>;
  category: CategoryObject;
  charges?: Maybe<Scalars['Float']>;
  company: CompanyObject;
  createdAt: Scalars['DateTime'];
  createdBy: UserObject;
  description?: Maybe<Scalars['String']>;
  dueAfterDays?: Maybe<Scalars['Int']>;
  excludeDates?: Maybe<Array<Scalars['String']>>;
  floor?: Maybe<FloorObject>;
  id: Scalars['String'];
  index: Scalars['Int'];
  nextGenerationDate?: Maybe<Scalars['DateTime']>;
  prevGenerationDate?: Maybe<Scalars['DateTime']>;
  priority?: Maybe<PriorityObject>;
  recordStatus: RRuleStatuses;
  requestedFor?: Maybe<UserObject>;
  rruleObject: RRuleObject;
  rruleText?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  suite?: Maybe<SuiteObject>;
  timezone: Scalars['String'];
};

export type ActivityLogCoreFieldsFragment = { __typename?: 'ActivityLogModel', id: string, activityType: ActivityTypeEnum, internal: boolean, createdAt: any, author?: { __typename?: 'AuthorObject', id?: string | null, firstName: string, lastName: string, active: boolean, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, changeLog: Array<{ __typename?: 'ActivityChangeLogModel', action: ActivityLogActions, text: string }> };

export type GetActivityLogQueryVariables = Exact<{
  activityType?: InputMaybe<ActivityTypeEnum>;
  referType?: InputMaybe<ReferToType>;
  portfolioId: Scalars['String'];
  propertyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  userIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  from?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<Scalars['DateTime']>;
  sortBy?: SortActivityFieldEnum;
  sortByDir?: SortDirectionEnum;
}>;


export type GetActivityLogQuery = { __typename?: 'Query', getActivityLog: { __typename?: 'GetActivityLogsObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'ActivityLogModel', id: string, activityType: ActivityTypeEnum, internal: boolean, createdAt: any, property: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, referToRecord: { __typename?: 'ReferToObject', id: string, index?: number | null, title?: string | null, type: ReferToType }, author?: { __typename?: 'AuthorObject', id?: string | null, firstName: string, lastName: string, active: boolean, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, changeLog: Array<{ __typename?: 'ActivityChangeLogModel', action: ActivityLogActions, text: string }> }> } };

export type GetRecordActivityLogQueryVariables = Exact<{
  activityType?: InputMaybe<ActivityTypeEnum>;
  recordId: Scalars['String'];
  referType: ReferToType;
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  sortBy?: SortActivityFieldEnum;
  sortByDir?: SortDirectionEnum;
}>;


export type GetRecordActivityLogQuery = { __typename?: 'Query', getRecordActivityLog: { __typename?: 'GetActivityLogsObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'ActivityLogModel', id: string, activityType: ActivityTypeEnum, internal: boolean, createdAt: any, author?: { __typename?: 'AuthorObject', id?: string | null, firstName: string, lastName: string, active: boolean, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, changeLog: Array<{ __typename?: 'ActivityChangeLogModel', action: ActivityLogActions, text: string }> }> } };

export type AddressFieldsFragment = { __typename?: 'Address', address?: string | null, city?: string | null, country?: string | null, zip?: string | null, state?: string | null };

export type ArCodeCoreFieldsFragment = { __typename?: 'ARCodeObject', id: string, title: string };

export type ArCodeFieldsFragment = { __typename?: 'ARCodeObject', id: string, title: string, property?: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null };

export type CreateArCodeMutationVariables = Exact<{
  title: Scalars['String'];
  portfolioId: Scalars['String'];
}>;


export type CreateArCodeMutation = { __typename?: 'Mutation', createARCode: { __typename?: 'ARCodeObject', id: string } };

export type UpdateArCodeMutationVariables = Exact<{
  id: Scalars['String'];
  title: Scalars['String'];
}>;


export type UpdateArCodeMutation = { __typename?: 'Mutation', updateARCode: { __typename?: 'ARCodeObject', id: string, title: string, property?: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null } };

export type ToggleArCodeMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ToggleArCodeMutation = { __typename?: 'Mutation', toggleARCode: boolean };

export type RemoveArCodesMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveArCodesMutation = { __typename?: 'Mutation', removeARCodes: boolean };

export type GetArCodesTableQueryVariables = Exact<{
  portfolioId: Scalars['String'];
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  recordLevel?: InputMaybe<RecordLevel>;
  propertyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetArCodesTableQuery = { __typename?: 'Query', getARCodes: Array<{ __typename?: 'ARCodeObject', index: number, active: boolean, id: string, title: string, property?: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null }> };

export type GetArCodesDropdownQueryVariables = Exact<{
  portfolioId: Scalars['String'];
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  recordLevel?: InputMaybe<RecordLevel>;
  propertyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetArCodesDropdownQuery = { __typename?: 'Query', getARCodes: Array<{ __typename?: 'ARCodeObject', active: boolean, id: string, title: string }> };

export type GetArCodeQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetArCodeQuery = { __typename?: 'Query', getARCode: { __typename?: 'ARCodeObject', id: string, title: string, property?: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null } };

export type LoginMutationVariables = Exact<{
  data: LoginInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'LoginObject', token: string } };

export type SendMagicLoginMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type SendMagicLoginMutation = { __typename?: 'Mutation', magicLogin: boolean };

export type SendForgottenPasswordMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type SendForgottenPasswordMutation = { __typename?: 'Mutation', forgotPassword: boolean };

export type SendResetPasswordMutationVariables = Exact<{
  data: ResetPasswordInput;
}>;


export type SendResetPasswordMutation = { __typename?: 'Mutation', resetPassword: boolean };

export type BuildingCoreFieldsFragment = { __typename?: 'BuildingObject', id: string, title: string };

export type CreateBuildingMutationVariables = Exact<{
  data: BuildingInput;
}>;


export type CreateBuildingMutation = { __typename?: 'Mutation', createBuilding: { __typename?: 'BuildingObject', id: string } };

export type UpdateBuildingMutationVariables = Exact<{
  id: Scalars['String'];
  title: Scalars['String'];
}>;


export type UpdateBuildingMutation = { __typename?: 'Mutation', updateBuilding: { __typename?: 'BuildingObject', id: string, title: string } };

export type ToggleBuildingMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ToggleBuildingMutation = { __typename?: 'Mutation', toggleBuilding: boolean };

export type RemoveBuildingsMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveBuildingsMutation = { __typename?: 'Mutation', removeBuildings: boolean };

export type GetBuildingsTableQueryVariables = Exact<{
  portfolioId: Scalars['String'];
  propertyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  sortBy?: SortBuildingFieldEnum;
  sortByDir?: SortDirectionEnum;
}>;


export type GetBuildingsTableQuery = { __typename?: 'Query', getBuildings: { __typename?: 'GetBuildings', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'BuildingObject', index: number, active: boolean, userCount: number, id: string, title: string }> } };

export type GetBuildingsDropdownQueryVariables = Exact<{
  portfolioId: Scalars['String'];
  propertyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  sortBy?: SortBuildingFieldEnum;
  sortByDir?: SortDirectionEnum;
}>;


export type GetBuildingsDropdownQuery = { __typename?: 'Query', getBuildings: { __typename?: 'GetBuildings', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'BuildingObject', active: boolean, id: string, title: string }> } };

export type GetBuildingQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetBuildingQuery = { __typename?: 'Query', getBuilding: { __typename?: 'BuildingObject', id: string, title: string, property: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } } };

export type ChargeCodeCoreFieldsFragment = { __typename?: 'ChargeCodeObject', id: string, title: string };

export type ChargeCodeFieldsFragment = { __typename?: 'ChargeCodeObject', id: string, title: string, property?: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null };

export type CreateChargeCodeMutationVariables = Exact<{
  title: Scalars['String'];
  portfolioId: Scalars['String'];
}>;


export type CreateChargeCodeMutation = { __typename?: 'Mutation', createChargeCode: { __typename?: 'ChargeCodeObject', id: string } };

export type UpdateChargeCodeMutationVariables = Exact<{
  id: Scalars['String'];
  title: Scalars['String'];
}>;


export type UpdateChargeCodeMutation = { __typename?: 'Mutation', updateChargeCode: { __typename?: 'ChargeCodeObject', id: string, title: string, property?: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null } };

export type ToggleChargeCodeMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ToggleChargeCodeMutation = { __typename?: 'Mutation', toggleChargeCode: boolean };

export type RemoveChargeCodesMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveChargeCodesMutation = { __typename?: 'Mutation', removeChargeCodes: boolean };

export type GetChargeCodesTableQueryVariables = Exact<{
  portfolioId: Scalars['String'];
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  recordLevel?: InputMaybe<RecordLevel>;
  propertyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetChargeCodesTableQuery = { __typename?: 'Query', getChargeCodes: Array<{ __typename?: 'ChargeCodeObject', index: number, active: boolean, id: string, title: string, property?: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null }> };

export type GetChargeCodesDropdownQueryVariables = Exact<{
  portfolioId: Scalars['String'];
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  recordLevel?: InputMaybe<RecordLevel>;
  propertyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetChargeCodesDropdownQuery = { __typename?: 'Query', getChargeCodes: Array<{ __typename?: 'ChargeCodeObject', active: boolean, id: string, title: string }> };

export type GetChargeCodeQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetChargeCodeQuery = { __typename?: 'Query', getChargeCode: { __typename?: 'ChargeCodeObject', id: string, title: string, property?: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null } };

export type CoiCoreFieldsFragment = { __typename?: 'CoiObject', id: string, title: string };

export type CoiFieldsFragment = { __typename?: 'CoiObject', note?: string | null, contactEmails: Array<string>, status: CoiStatusEnum, expiration: string, validFrom: string, validTo: string, createdAt: any, id: string, title: string, property: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, createdBy?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, active: boolean, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, attachment: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } };

export type GetCoisTableQueryVariables = Exact<{
  portfolioId: Scalars['String'];
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<CoiStatusEnum> | CoiStatusEnum>;
  search?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['DateTime']>;
  from?: InputMaybe<Scalars['DateTime']>;
  propertyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  companyTypes?: InputMaybe<Array<CompanyTypeEnum> | CompanyTypeEnum>;
  companyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  createdByIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  archived?: ArchiveStatusEnum;
  expiration?: InputMaybe<CoiExpirationEnum>;
}>;


export type GetCoisTableQuery = { __typename?: 'Query', getCois: { __typename?: 'GetCoiObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'CoiObject', isArchived: boolean, status: CoiStatusEnum, expiration: string, note?: string | null, validFrom: string, validTo: string, createdAt: any, id: string, title: string, property: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, createdBy?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, active: boolean, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null }> } };

export type GetCoiQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCoiQuery = { __typename?: 'Query', getCoi: { __typename?: 'CoiObject', note?: string | null, contactEmails: Array<string>, status: CoiStatusEnum, expiration: string, validFrom: string, validTo: string, createdAt: any, id: string, title: string, property: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, createdBy?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, active: boolean, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, attachment: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } } };

export type CompanyCoreFieldsFragment = { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null };

export type CompanyFieldsFragment = { __typename?: 'CompanyObject', taxCode?: string | null, vendorId?: string | null, phone?: string | null, id: string, title: string, active: boolean, type: CompanyTypeEnum, address?: { __typename?: 'Address', address?: string | null, city?: string | null, country?: string | null, zip?: string | null, state?: string | null } | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null };

export type CreateCompanyMutationVariables = Exact<{
  data: CompanyInput;
  portfolioId: Scalars['String'];
}>;


export type CreateCompanyMutation = { __typename?: 'Mutation', createCompany: { __typename?: 'CompanyObject', id: string } };

export type UpdateCompanyMutationVariables = Exact<{
  id: Scalars['String'];
  data: CompanyUpdateInput;
}>;


export type UpdateCompanyMutation = { __typename?: 'Mutation', updateCompany: { __typename?: 'CompanyObject', taxCode?: string | null, vendorId?: string | null, phone?: string | null, id: string, title: string, active: boolean, type: CompanyTypeEnum, address?: { __typename?: 'Address', address?: string | null, city?: string | null, country?: string | null, zip?: string | null, state?: string | null } | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } };

export type UpdateCompanyPhotoMutationVariables = Exact<{
  id: Scalars['String'];
  photo?: InputMaybe<FileObjectInput>;
}>;


export type UpdateCompanyPhotoMutation = { __typename?: 'Mutation', updateCompanyPhoto: { __typename?: 'CompanyObject', id: string, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } };

export type UpdateCompanyAddressMutationVariables = Exact<{
  id: Scalars['String'];
  address: AddressInput;
}>;


export type UpdateCompanyAddressMutation = { __typename?: 'Mutation', updateCompanyAddress: { __typename?: 'CompanyObject', id: string, address?: { __typename?: 'Address', address?: string | null, city?: string | null, country?: string | null, zip?: string | null, state?: string | null } | null } };

export type AddCompanyPropertyMutationVariables = Exact<{
  id: Scalars['String'];
  propertyId: Scalars['String'];
}>;


export type AddCompanyPropertyMutation = { __typename?: 'Mutation', addCompanyProperty: boolean };

export type ToggleCompanyPropertyMutationVariables = Exact<{
  id: Scalars['String'];
  propertyId: Scalars['String'];
}>;


export type ToggleCompanyPropertyMutation = { __typename?: 'Mutation', toggleCompanyProperty: boolean };

export type RemoveCompaniesMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveCompaniesMutation = { __typename?: 'Mutation', removeCompanies: boolean };

export type ToggleCompanyMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ToggleCompanyMutation = { __typename?: 'Mutation', toggleCompany: boolean };

export type GetCompaniesTableQueryVariables = Exact<{
  portfolioId: Scalars['String'];
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  companyTypes?: InputMaybe<Array<CompanyTypeEnum> | CompanyTypeEnum>;
  propertyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetCompaniesTableQuery = { __typename?: 'Query', getCompanies: { __typename?: 'GetCompanyObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'CompanyObject', index: number, taxCode?: string | null, vendorId?: string | null, createdAt?: any | null, userCount: number, id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> } };

export type GetCompaniesDropdownQueryVariables = Exact<{
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  portfolioId: Scalars['String'];
  companyTypes?: InputMaybe<Array<CompanyTypeEnum> | CompanyTypeEnum>;
  propertyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetCompaniesDropdownQuery = { __typename?: 'Query', getCompanies: { __typename?: 'GetCompanyObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> } };

export type GetCompanyQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCompanyQuery = { __typename?: 'Query', getCompany: { __typename?: 'CompanyObject', taxCode?: string | null, vendorId?: string | null, phone?: string | null, id: string, title: string, active: boolean, type: CompanyTypeEnum, address?: { __typename?: 'Address', address?: string | null, city?: string | null, country?: string | null, zip?: string | null, state?: string | null } | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } };

export type GetCompanyPropertiesQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCompanyPropertiesQuery = { __typename?: 'Query', getCompanyProperties: Array<{ __typename?: 'CompanyPropertyObject', active: boolean, property: { __typename?: 'PropertyObject', id: string, title: string } }> };

export type DefaultEmailTemplateFieldsFragment = { __typename?: 'DefaultEmailTemplateObject', category: string, trigger: string, type: EmailTemplateType, appBody?: string | null, smsBody?: string | null, emailBody?: string | null, subject?: string | null, localParams?: Array<string> | null, globalParams: Array<string> };

export type UpdateDefaultEmailTemplateMutationVariables = Exact<{
  data: UpdateDefaultEmailTemplateInput;
  type: EmailTemplateType;
}>;


export type UpdateDefaultEmailTemplateMutation = { __typename?: 'Mutation', updateDefaultEmailTemplate: boolean };

export type GetDefaultEmailTemplatesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetDefaultEmailTemplatesQuery = { __typename?: 'Query', getDefaultEmailTemplates: Array<{ __typename?: 'DefaultEmailTemplateObject', category: string, trigger: string, type: EmailTemplateType }> };

export type GetDefaultEmailTemplateQueryVariables = Exact<{
  type: EmailTemplateType;
}>;


export type GetDefaultEmailTemplateQuery = { __typename?: 'Query', getDefaultEmailTemplate: { __typename?: 'DefaultEmailTemplateObject', category: string, trigger: string, type: EmailTemplateType, appBody?: string | null, smsBody?: string | null, emailBody?: string | null, subject?: string | null, localParams?: Array<string> | null, globalParams: Array<string> } };

export type EmailTemplateFieldsFragment = { __typename?: 'EmailTemplateObject', category: string, trigger: string, type: EmailTemplateType, appActive?: boolean | null, smsActive?: boolean | null, emailActive?: boolean | null, appBody?: string | null, smsBody?: string | null, emailBody?: string | null, subject?: string | null, bcc?: Array<string> | null, cc?: Array<string> | null, localParams?: Array<string> | null, globalParams: Array<string>, custom: boolean };

export type UpdateEmailTemplateMutationVariables = Exact<{
  portfolioId: Scalars['String'];
  data: UpdateEmailTemplateInput;
  type: EmailTemplateType;
}>;


export type UpdateEmailTemplateMutation = { __typename?: 'Mutation', updateEmailTemplate: boolean };

export type ToggleEmailTemplateMutationVariables = Exact<{
  data: ToggleEmailTemplateInput;
}>;


export type ToggleEmailTemplateMutation = { __typename?: 'Mutation', toggleEmailTemplate: boolean };

export type ToggleCustomTemplateMutationVariables = Exact<{
  portfolioId: Scalars['String'];
  type: EmailTemplateType;
}>;


export type ToggleCustomTemplateMutation = { __typename?: 'Mutation', toggleCustomTemplate: { __typename?: 'EmailTemplateObject', category: string, trigger: string, type: EmailTemplateType, appActive?: boolean | null, smsActive?: boolean | null, emailActive?: boolean | null, appBody?: string | null, smsBody?: string | null, emailBody?: string | null, subject?: string | null, bcc?: Array<string> | null, cc?: Array<string> | null, localParams?: Array<string> | null, globalParams: Array<string>, custom: boolean } };

export type SendTestMailMutationVariables = Exact<{
  data: SendTestMailInput;
}>;


export type SendTestMailMutation = { __typename?: 'Mutation', sendTestMail: boolean };

export type GetEmailTemplatesQueryVariables = Exact<{
  portfolioId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetEmailTemplatesQuery = { __typename?: 'Query', getEmailTemplates: Array<{ __typename?: 'EmailTemplateObject', category: string, trigger: string, type: EmailTemplateType, appActive?: boolean | null, smsActive?: boolean | null, emailActive?: boolean | null, custom: boolean }> };

export type GetEmailTemplateQueryVariables = Exact<{
  portfolioId: Scalars['String'];
  type: EmailTemplateType;
}>;


export type GetEmailTemplateQuery = { __typename?: 'Query', getEmailTemplate: { __typename?: 'EmailTemplateObject', category: string, trigger: string, type: EmailTemplateType, appActive?: boolean | null, smsActive?: boolean | null, emailActive?: boolean | null, appBody?: string | null, smsBody?: string | null, emailBody?: string | null, subject?: string | null, bcc?: Array<string> | null, cc?: Array<string> | null, localParams?: Array<string> | null, globalParams: Array<string>, custom: boolean } };

export type FloorCoreFieldsFragment = { __typename?: 'FloorObject', id: string, title: string };

export type GlAccountCoreFieldsFragment = { __typename?: 'GLAccountObject', id: string, title: string };

export type GlAccountFieldsFragment = { __typename?: 'GLAccountObject', id: string, title: string, property?: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null };

export type CreateGlAccountMutationVariables = Exact<{
  title: Scalars['String'];
  portfolioId: Scalars['String'];
}>;


export type CreateGlAccountMutation = { __typename?: 'Mutation', createGLAccount: { __typename?: 'GLAccountObject', id: string } };

export type UpdateGlAccountMutationVariables = Exact<{
  id: Scalars['String'];
  title: Scalars['String'];
}>;


export type UpdateGlAccountMutation = { __typename?: 'Mutation', updateGLAccount: { __typename?: 'GLAccountObject', id: string, title: string, property?: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null } };

export type ToggleGlAccountMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ToggleGlAccountMutation = { __typename?: 'Mutation', toggleGLAccount: boolean };

export type RemoveGlAccountsMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveGlAccountsMutation = { __typename?: 'Mutation', removeGLAccounts: boolean };

export type GetGlAccountsTableQueryVariables = Exact<{
  portfolioId: Scalars['String'];
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  recordLevel?: InputMaybe<RecordLevel>;
  propertyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetGlAccountsTableQuery = { __typename?: 'Query', getGLAccounts: Array<{ __typename?: 'GLAccountObject', index: number, active: boolean, id: string, title: string, property?: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null }> };

export type GetGlAccountsDropdownQueryVariables = Exact<{
  portfolioId: Scalars['String'];
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  recordLevel?: InputMaybe<RecordLevel>;
  propertyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetGlAccountsDropdownQuery = { __typename?: 'Query', getGLAccounts: Array<{ __typename?: 'GLAccountObject', active: boolean, id: string, title: string }> };

export type GetGlAccountQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetGlAccountQuery = { __typename?: 'Query', getGLAccount: { __typename?: 'GLAccountObject', id: string, title: string, property?: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null } };

export type CategoryGroupCoreFieldsFragment = { __typename?: 'CategoryGroupObject', id: string, title: string };

export type CategoryGroupFieldsFragment = { __typename?: 'CategoryGroupObject', icon?: string | null, id: string, title: string, property?: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null };

export type CreateCategoryGroupMutationVariables = Exact<{
  portfolioId: Scalars['String'];
  recordType: CategoryRecordType;
  data: CategoryGroupInput;
}>;


export type CreateCategoryGroupMutation = { __typename?: 'Mutation', createCategoryGroup: { __typename?: 'CategoryGroupObject', id: string } };

export type UpdateCategoryGroupMutationVariables = Exact<{
  id: Scalars['String'];
  data: CategoryGroupInput;
}>;


export type UpdateCategoryGroupMutation = { __typename?: 'Mutation', updateCategoryGroup: { __typename?: 'CategoryGroupObject', icon?: string | null, id: string, title: string, property?: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null } };

export type ToggleCategoryGroupMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ToggleCategoryGroupMutation = { __typename?: 'Mutation', toggleCategoryGroup: boolean };

export type RemoveCategoryGroupsMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveCategoryGroupsMutation = { __typename?: 'Mutation', removeCategoryGroups: boolean };

export type GetCategoryGroupsTableQueryVariables = Exact<{
  portfolioId: Scalars['String'];
  recordType: CategoryRecordType;
  recordLevel?: InputMaybe<RecordLevel>;
  active?: InputMaybe<Scalars['Boolean']>;
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  propertyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetCategoryGroupsTableQuery = { __typename?: 'Query', getCategoryGroups: { __typename?: 'GetCategoryGroups', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'CategoryGroupObject', index: number, icon?: string | null, active: boolean, categoryCount: number, id: string, title: string, property?: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null }> } };

export type GetCategoryGroupsDropdownQueryVariables = Exact<{
  portfolioId: Scalars['String'];
  recordType: CategoryRecordType;
  recordLevel?: InputMaybe<RecordLevel>;
  active?: InputMaybe<Scalars['Boolean']>;
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  propertyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetCategoryGroupsDropdownQuery = { __typename?: 'Query', getCategoryGroups: { __typename?: 'GetCategoryGroups', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'CategoryGroupObject', icon?: string | null, active: boolean, id: string, title: string }> } };

export type GetCategoryGroupQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCategoryGroupQuery = { __typename?: 'Query', getCategoryGroup: { __typename?: 'CategoryGroupObject', icon?: string | null, id: string, title: string, property?: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null } };

export type CategoryCoreFieldsFragment = { __typename?: 'CategoryObject', id: string, title: string };

export type CategoryFieldsFragment = { __typename?: 'CategoryObject', description?: string | null, id: string, title: string, defaultPriority?: { __typename?: 'PriorityObject', color: string, id: string, title: string } | null, group?: { __typename?: 'CategoryGroupObject', id: string, title: string } | null, property?: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null };

export type CreateCategoryMutationVariables = Exact<{
  portfolioId: Scalars['String'];
  recordType: CategoryRecordType;
  data: CategoryInput;
}>;


export type CreateCategoryMutation = { __typename?: 'Mutation', createCategory: { __typename?: 'CategoryObject', id: string } };

export type UpdateCategoryMutationVariables = Exact<{
  id: Scalars['String'];
  data: CategoryInput;
}>;


export type UpdateCategoryMutation = { __typename?: 'Mutation', updateCategory: { __typename?: 'CategoryObject', description?: string | null, id: string, title: string, defaultPriority?: { __typename?: 'PriorityObject', color: string, id: string, title: string } | null, group?: { __typename?: 'CategoryGroupObject', id: string, title: string } | null, property?: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null } };

export type ToggleCategoryMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ToggleCategoryMutation = { __typename?: 'Mutation', toggleCategory: boolean };

export type RemoveCategoriesMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveCategoriesMutation = { __typename?: 'Mutation', removeCategories: boolean };

export type GetCategoriesTableQueryVariables = Exact<{
  portfolioId: Scalars['String'];
  recordType: CategoryRecordType;
  recordLevel?: InputMaybe<RecordLevel>;
  active?: InputMaybe<Scalars['Boolean']>;
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  propertyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetCategoriesTableQuery = { __typename?: 'Query', getCategories: { __typename?: 'GetCategories', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'CategoryObject', index: number, active: boolean, description?: string | null, id: string, title: string, defaultPriority?: { __typename?: 'PriorityObject', color: string, id: string, title: string } | null, group?: { __typename?: 'CategoryGroupObject', id: string, title: string } | null, property?: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null }> } };

export type GetCategoriesDropdownQueryVariables = Exact<{
  portfolioId: Scalars['String'];
  recordType: CategoryRecordType;
  recordLevel?: InputMaybe<RecordLevel>;
  active?: InputMaybe<Scalars['Boolean']>;
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  propertyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  includeGroup: Scalars['Boolean'];
  includeDescription: Scalars['Boolean'];
  includePriority: Scalars['Boolean'];
}>;


export type GetCategoriesDropdownQuery = { __typename?: 'Query', getCategories: { __typename?: 'GetCategories', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'CategoryObject', active: boolean, description?: string | null, id: string, title: string, group?: { __typename?: 'CategoryGroupObject', id: string, title: string } | null, defaultPriority?: { __typename?: 'PriorityObject', color: string, id: string, title: string } | null }> } };

export type GetCategoriesDropdownGroupedQueryVariables = Exact<{
  portfolioId: Scalars['String'];
  recordType: CategoryRecordType;
  recordLevel?: InputMaybe<RecordLevel>;
  active?: InputMaybe<Scalars['Boolean']>;
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  propertyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  includeDescription: Scalars['Boolean'];
  includePriority: Scalars['Boolean'];
}>;


export type GetCategoriesDropdownGroupedQuery = { __typename?: 'Query', getCategoriesGrouped: { __typename?: 'GetCategoriesGrouped', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'CategoryGroupObject', title: string, icon?: string | null, active: boolean, categories?: Array<{ __typename?: 'CategoryObject', active: boolean, description?: string | null, id: string, title: string, defaultPriority?: { __typename?: 'PriorityObject', color: string, id: string, title: string } | null }> | null }> } };

export type GetFilterableGroupedCategoriesQueryVariables = Exact<{
  portfolioId: Scalars['String'];
  location: FilterableCategoryLocationType;
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetFilterableGroupedCategoriesQuery = { __typename?: 'Query', getFilterableGroupedCategories: { __typename?: 'GetFilterableGroupedCategories', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'FilterableGroupedCategoryObject', id: string, title: string, icon?: string | null, active: boolean, isDeleted: boolean, categories: Array<{ __typename?: 'FilterableCategoryObject', id: string, title: string, active: boolean, isDeleted: boolean }> }> } };

export type GetCategoryQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCategoryQuery = { __typename?: 'Query', getCategory: { __typename?: 'CategoryObject', description?: string | null, id: string, title: string, defaultPriority?: { __typename?: 'PriorityObject', color: string, id: string, title: string } | null, group?: { __typename?: 'CategoryGroupObject', id: string, title: string } | null, property?: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null } };

export type LaborRateCoreFieldsFragment = { __typename?: 'LaborRateObject', id: string, title: string };

export type LaborRateFieldsFragment = { __typename?: 'LaborRateObject', rate: number, description?: string | null, id: string, title: string, markup?: { __typename?: 'MarkupObject', id: string, title: string } | null, property?: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, glAccount?: { __typename?: 'GLAccountObject', id: string, title: string } | null, arCode?: { __typename?: 'ARCodeObject', id: string, title: string } | null, chargeCode?: { __typename?: 'ChargeCodeObject', id: string, title: string } | null };

export type CreateLaborRateMutationVariables = Exact<{
  data: LaborRateInput;
  portfolioId: Scalars['String'];
}>;


export type CreateLaborRateMutation = { __typename?: 'Mutation', createLaborRate: { __typename?: 'LaborRateObject', id: string } };

export type UpdateLaborRateMutationVariables = Exact<{
  id: Scalars['String'];
  data: LaborRateInput;
}>;


export type UpdateLaborRateMutation = { __typename?: 'Mutation', updateLaborRate: { __typename?: 'LaborRateObject', rate: number, description?: string | null, id: string, title: string, markup?: { __typename?: 'MarkupObject', id: string, title: string } | null, property?: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, glAccount?: { __typename?: 'GLAccountObject', id: string, title: string } | null, arCode?: { __typename?: 'ARCodeObject', id: string, title: string } | null, chargeCode?: { __typename?: 'ChargeCodeObject', id: string, title: string } | null } };

export type ToggleLaborRateMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ToggleLaborRateMutation = { __typename?: 'Mutation', toggleLaborRate: boolean };

export type RemoveLaborRatesMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveLaborRatesMutation = { __typename?: 'Mutation', removeLaborRates: boolean };

export type GetLaborRatesTableQueryVariables = Exact<{
  portfolioId: Scalars['String'];
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  recordLevel?: InputMaybe<RecordLevel>;
  propertyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetLaborRatesTableQuery = { __typename?: 'Query', getLaborRates: Array<{ __typename?: 'LaborRateObject', index: number, active: boolean, rate: number, description?: string | null, id: string, title: string, markup?: { __typename?: 'MarkupObject', id: string, title: string } | null, property?: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, glAccount?: { __typename?: 'GLAccountObject', id: string, title: string } | null, arCode?: { __typename?: 'ARCodeObject', id: string, title: string } | null, chargeCode?: { __typename?: 'ChargeCodeObject', id: string, title: string } | null }> };

export type GetLaborRatesDropdownQueryVariables = Exact<{
  portfolioId: Scalars['String'];
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  recordLevel?: InputMaybe<RecordLevel>;
  propertyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  includeDescription: Scalars['Boolean'];
  includeMarkup: Scalars['Boolean'];
  includeGLAccount: Scalars['Boolean'];
  includeARCode: Scalars['Boolean'];
  includeChargeCode: Scalars['Boolean'];
}>;


export type GetLaborRatesDropdownQuery = { __typename?: 'Query', getLaborRates: Array<{ __typename?: 'LaborRateObject', active: boolean, rate: number, description?: string | null, id: string, title: string, markup?: { __typename?: 'MarkupObject', type: ValueUnit, amount: number, id: string, title: string } | null, glAccount?: { __typename?: 'GLAccountObject', id: string, title: string } | null, arCode?: { __typename?: 'ARCodeObject', id: string, title: string } | null, chargeCode?: { __typename?: 'ChargeCodeObject', id: string, title: string } | null }> };

export type GetLaborRateQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetLaborRateQuery = { __typename?: 'Query', getLaborRate: { __typename?: 'LaborRateObject', rate: number, description?: string | null, id: string, title: string, markup?: { __typename?: 'MarkupObject', id: string, title: string } | null, property?: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, glAccount?: { __typename?: 'GLAccountObject', id: string, title: string } | null, arCode?: { __typename?: 'ARCodeObject', id: string, title: string } | null, chargeCode?: { __typename?: 'ChargeCodeObject', id: string, title: string } | null } };

export type LeaseChargeTypeCoreFieldsFragment = { __typename?: 'LeaseChargeTypeObject', id: string, title: string };

export type LeaseChargeTypeFieldsFragment = { __typename?: 'LeaseChargeTypeObject', id: string, title: string, property?: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null };

export type CreateLeaseChargeTypeMutationVariables = Exact<{
  title: Scalars['String'];
  portfolioId: Scalars['String'];
}>;


export type CreateLeaseChargeTypeMutation = { __typename?: 'Mutation', createLeaseChargeType: { __typename?: 'LeaseChargeTypeObject', id: string } };

export type UpdateLeaseChargeTypeMutationVariables = Exact<{
  id: Scalars['String'];
  title: Scalars['String'];
}>;


export type UpdateLeaseChargeTypeMutation = { __typename?: 'Mutation', updateLeaseChargeType: { __typename?: 'LeaseChargeTypeObject', id: string, title: string, property?: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null } };

export type ReorderLeaseChargeTypesMutationVariables = Exact<{
  id: Scalars['String'];
  secondId: Scalars['String'];
}>;


export type ReorderLeaseChargeTypesMutation = { __typename?: 'Mutation', reorderLeaseChargeTypes: boolean };

export type ToggleLeaseChargeTypeMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ToggleLeaseChargeTypeMutation = { __typename?: 'Mutation', toggleLeaseChargeType: boolean };

export type RemoveLeaseChargeTypesMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveLeaseChargeTypesMutation = { __typename?: 'Mutation', removeLeaseChargeTypes: boolean };

export type GetLeaseChargeTypesTableQueryVariables = Exact<{
  portfolioId: Scalars['String'];
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  recordLevel?: InputMaybe<RecordLevel>;
  propertyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetLeaseChargeTypesTableQuery = { __typename?: 'Query', getLeaseChargeTypes: Array<{ __typename?: 'LeaseChargeTypeObject', index: number, active: boolean, id: string, title: string, property?: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null }> };

export type GetLeaseChargeTypeQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetLeaseChargeTypeQuery = { __typename?: 'Query', getLeaseChargeType: { __typename?: 'LeaseChargeTypeObject', id: string, title: string, property?: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null } };

export type MarkupCoreFieldsFragment = { __typename?: 'MarkupObject', id: string, title: string };

export type MarkupFieldsFragment = { __typename?: 'MarkupObject', type: ValueUnit, amount: number, description?: string | null, id: string, title: string, property?: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, glAccount?: { __typename?: 'GLAccountObject', id: string, title: string } | null, arCode?: { __typename?: 'ARCodeObject', id: string, title: string } | null, chargeCode?: { __typename?: 'ChargeCodeObject', id: string, title: string } | null };

export type CreateMarkupMutationVariables = Exact<{
  data: MarkUpInput;
  portfolioId: Scalars['String'];
}>;


export type CreateMarkupMutation = { __typename?: 'Mutation', createMarkup: { __typename?: 'MarkupObject', id: string } };

export type UpdateMarkupMutationVariables = Exact<{
  id: Scalars['String'];
  data: MarkUpInput;
}>;


export type UpdateMarkupMutation = { __typename?: 'Mutation', updateMarkup: { __typename?: 'MarkupObject', type: ValueUnit, amount: number, description?: string | null, id: string, title: string, property?: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, glAccount?: { __typename?: 'GLAccountObject', id: string, title: string } | null, arCode?: { __typename?: 'ARCodeObject', id: string, title: string } | null, chargeCode?: { __typename?: 'ChargeCodeObject', id: string, title: string } | null } };

export type ToggleMarkupMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ToggleMarkupMutation = { __typename?: 'Mutation', toggleMarkup: boolean };

export type RemoveMarkupsMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveMarkupsMutation = { __typename?: 'Mutation', removeMarkups: boolean };

export type GetMarkupsTableQueryVariables = Exact<{
  portfolioId: Scalars['String'];
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  recordLevel?: InputMaybe<RecordLevel>;
  propertyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetMarkupsTableQuery = { __typename?: 'Query', getMarkups: Array<{ __typename?: 'MarkupObject', index: number, active: boolean, type: ValueUnit, amount: number, description?: string | null, id: string, title: string, property?: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, glAccount?: { __typename?: 'GLAccountObject', id: string, title: string } | null, arCode?: { __typename?: 'ARCodeObject', id: string, title: string } | null, chargeCode?: { __typename?: 'ChargeCodeObject', id: string, title: string } | null }> };

export type GetMarkupsDropdownQueryVariables = Exact<{
  portfolioId: Scalars['String'];
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  recordLevel?: InputMaybe<RecordLevel>;
  propertyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  includeGLAccount: Scalars['Boolean'];
  includeARCode: Scalars['Boolean'];
  includeChargeCode: Scalars['Boolean'];
}>;


export type GetMarkupsDropdownQuery = { __typename?: 'Query', getMarkups: Array<{ __typename?: 'MarkupObject', active: boolean, type: ValueUnit, amount: number, id: string, title: string, glAccount?: { __typename?: 'GLAccountObject', id: string, title: string } | null, arCode?: { __typename?: 'ARCodeObject', id: string, title: string } | null, chargeCode?: { __typename?: 'ChargeCodeObject', id: string, title: string } | null }> };

export type GetMarkupQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetMarkupQuery = { __typename?: 'Query', getMarkup: { __typename?: 'MarkupObject', type: ValueUnit, amount: number, description?: string | null, id: string, title: string, property?: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, glAccount?: { __typename?: 'GLAccountObject', id: string, title: string } | null, arCode?: { __typename?: 'ARCodeObject', id: string, title: string } | null, chargeCode?: { __typename?: 'ChargeCodeObject', id: string, title: string } | null } };

export type MaterialGroupCoreFieldsFragment = { __typename?: 'MaterialGroupObject', id: string, title: string };

export type MaterialCoreFieldsFragment = { __typename?: 'MaterialObject', id: string, title: string };

export type PaginationFieldsFragment = { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number };

export type PortfolioCoreFieldsFragment = { __typename?: 'PortfolioModel', id: string, title: string, active: boolean, url: string, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null };

export type PortfolioFieldsFragment = { __typename?: 'PortfolioModel', id: string, title: string, active: boolean, url: string, translation: { __typename?: 'TranslationObject', id: string, title: string }, background?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null, stripeSettings: { __typename?: 'PortfolioStripeSettings', paymentACHFee?: number | null, paymentACHUnit?: ValueUnit | null, paymentACHCap?: number | null, paymentCardFee?: number | null, paymentCardUnit?: ValueUnit | null }, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null };

export type CreatePortfolioMutationVariables = Exact<{
  data: PortfolioInput;
}>;


export type CreatePortfolioMutation = { __typename?: 'Mutation', createPortfolio: { __typename?: 'PortfolioModel', id: string } };

export type UpdatePortfolioMutationVariables = Exact<{
  id: Scalars['String'];
  data: PortfolioUpdateInput;
}>;


export type UpdatePortfolioMutation = { __typename?: 'Mutation', updatePortfolio: { __typename?: 'PortfolioModel', id: string, title: string, active: boolean, url: string, translation: { __typename?: 'TranslationObject', id: string, title: string }, background?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null, stripeSettings: { __typename?: 'PortfolioStripeSettings', paymentACHFee?: number | null, paymentACHUnit?: ValueUnit | null, paymentACHCap?: number | null, paymentCardFee?: number | null, paymentCardUnit?: ValueUnit | null }, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } };

export type TogglePortfolioMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type TogglePortfolioMutation = { __typename?: 'Mutation', togglePortfolio: boolean };

export type RemovePortfoliosMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemovePortfoliosMutation = { __typename?: 'Mutation', removePortfolios: boolean };

export type GetPortfoliosTableQueryVariables = Exact<{
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetPortfoliosTableQuery = { __typename?: 'Query', getPortfolios: { __typename?: 'GetPortfolios', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'PortfolioModel', index: number, propertyCount: number, userCount: number, id: string, title: string, active: boolean, url: string, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> } };

export type GetPortfoliosDropdownQueryVariables = Exact<{
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetPortfoliosDropdownQuery = { __typename?: 'Query', getPortfolios: { __typename?: 'GetPortfolios', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'PortfolioModel', id: string, title: string, active: boolean, url: string, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> } };

export type GetPortfolioQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPortfolioQuery = { __typename?: 'Query', getPortfolio: { __typename?: 'PortfolioModel', id: string, title: string, active: boolean, url: string, translation: { __typename?: 'TranslationObject', id: string, title: string }, background?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null, stripeSettings: { __typename?: 'PortfolioStripeSettings', paymentACHFee?: number | null, paymentACHUnit?: ValueUnit | null, paymentACHCap?: number | null, paymentCardFee?: number | null, paymentCardUnit?: ValueUnit | null }, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } };

export type EquipmentCategoryCoreFieldsFragment = { __typename?: 'EquipmentCategoryModel', id: string, title: string };

export type EquipmentCoreFieldsFragment = { __typename?: 'EquipmentModel', id: string, title: string };

export type PriorityCoreFieldsFragment = { __typename?: 'PriorityObject', id: string, title: string };

export type PriorityFieldsFragment = { __typename?: 'PriorityObject', color: string, id: string, title: string, property?: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null };

export type CreatePriorityMutationVariables = Exact<{
  data: PriorityInput;
  portfolioId: Scalars['String'];
}>;


export type CreatePriorityMutation = { __typename?: 'Mutation', createPriority: { __typename?: 'PriorityObject', id: string } };

export type UpdatePriorityMutationVariables = Exact<{
  id: Scalars['String'];
  data: PriorityUpdateInput;
}>;


export type UpdatePriorityMutation = { __typename?: 'Mutation', updatePriority: { __typename?: 'PriorityObject', color: string, id: string, title: string, property?: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null } };

export type ReorderPrioritiesMutationVariables = Exact<{
  id: Scalars['String'];
  secondId: Scalars['String'];
}>;


export type ReorderPrioritiesMutation = { __typename?: 'Mutation', reorderPriorities: boolean };

export type TogglePriorityMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type TogglePriorityMutation = { __typename?: 'Mutation', togglePriority: boolean };

export type RemovePrioritiesMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemovePrioritiesMutation = { __typename?: 'Mutation', removePriorities: boolean };

export type GetPrioritiesTableQueryVariables = Exact<{
  portfolioId: Scalars['String'];
  recordType: PriorityRecordType;
  recordLevel?: InputMaybe<RecordLevel>;
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  propertyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetPrioritiesTableQuery = { __typename?: 'Query', getPriorities: Array<{ __typename?: 'PriorityObject', color: string, index: number, active: boolean, id: string, title: string, property?: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null }> };

export type GetPrioritiesDropdownQueryVariables = Exact<{
  portfolioId: Scalars['String'];
  recordType: PriorityRecordType;
  recordLevel?: InputMaybe<RecordLevel>;
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  propertyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetPrioritiesDropdownQuery = { __typename?: 'Query', getPriorities: Array<{ __typename?: 'PriorityObject', color: string, active: boolean, id: string, title: string }> };

export type GetFilterablePrioritiesQueryVariables = Exact<{
  portfolioId: Scalars['String'];
  location: FilterablePriorityLocationType;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetFilterablePrioritiesQuery = { __typename?: 'Query', getFilterablePriorities: Array<{ __typename?: 'FilterablePriorityObject', id: string, title: string, color?: string | null, active: boolean, isDeleted: boolean }> };

export type GetPriorityQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPriorityQuery = { __typename?: 'Query', getPriority: { __typename?: 'PriorityObject', color: string, id: string, title: string, property?: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null } };

export type PropertyCoreFieldsFragment = { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null };

export type PropertyFieldsFragment = { __typename?: 'PropertyObject', timezone: string, primaryColor?: string | null, id: string, title: string, active: boolean, bgImg?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null, favicon?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null };

export type CreatePropertyMutationVariables = Exact<{
  data: PropertyInput;
  portfolioId: Scalars['String'];
}>;


export type CreatePropertyMutation = { __typename?: 'Mutation', createProperty: { __typename?: 'PropertyObject', id: string } };

export type UpdatePropertyMutationVariables = Exact<{
  id: Scalars['String'];
  data: PropertyInput;
}>;


export type UpdatePropertyMutation = { __typename?: 'Mutation', updateProperty: { __typename?: 'PropertyObject', timezone: string, primaryColor?: string | null, id: string, title: string, active: boolean, bgImg?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null, favicon?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } };

export type TogglePropertyMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type TogglePropertyMutation = { __typename?: 'Mutation', toggleProperty: boolean };

export type ClonePropertyMutationVariables = Exact<{
  data: PropertyCloneInput;
}>;


export type ClonePropertyMutation = { __typename?: 'Mutation', cloneProperty: boolean };

export type RemovePropertiesMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemovePropertiesMutation = { __typename?: 'Mutation', removeProperties: boolean };

export type GetPropertiesTableQueryVariables = Exact<{
  portfolioId?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  includePortfolio: Scalars['Boolean'];
}>;


export type GetPropertiesTableQuery = { __typename?: 'Query', getProperties: { __typename?: 'GetProperties', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'PropertyObject', index: number, timezone: string, userCount: number, companyCount: number, id: string, title: string, active: boolean, portfolio?: { __typename?: 'PortfolioModel', id: string, title: string, active: boolean, url: string, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> } };

export type GetPropertiesDropdownQueryVariables = Exact<{
  portfolioId?: InputMaybe<Scalars['String']>;
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetPropertiesDropdownQuery = { __typename?: 'Query', getProperties: { __typename?: 'GetProperties', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> } };

export type GetPropertyQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPropertyQuery = { __typename?: 'Query', getProperty: { __typename?: 'PropertyObject', timezone: string, primaryColor?: string | null, id: string, title: string, active: boolean, bgImg?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null, favicon?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } };

export type AllRolePermissionsFragment = { __typename?: 'PermissionsObject', viewPropertyNewsFeedPost?: boolean | null, addNewsFeedPost?: boolean | null, editOtherUsersNewsFeedPost?: boolean | null, deleteOtherUsersNewsFeedPost?: boolean | null, addNewsFeedPostComment?: boolean | null, deleteOtherUsersNewsFeedComment?: boolean | null, addEventPost?: boolean | null, editOtherUsersEventPost?: boolean | null, deleteOtherUsersEventPost?: boolean | null, viewMyGuest?: boolean | null, viewCompanyGuest?: boolean | null, addMyGuest?: boolean | null, addCompanyGuest?: boolean | null, approveGuest?: boolean | null, updateMyGuest?: boolean | null, updateCompanyGuest?: boolean | null, checkInGuest?: boolean | null, printBadgeGuest?: boolean | null, viewMyVendorAccess?: boolean | null, viewCompanyVendorAccess?: boolean | null, addMyVendorAccess?: boolean | null, addCompanyVendorAccess?: boolean | null, approveVendorAccess?: boolean | null, updateMyVendorAccess?: boolean | null, updateCompanyVendorAccess?: boolean | null, checkInVendorAccess?: boolean | null, printBadgeVendorAccess?: boolean | null, viewMyWatchList?: boolean | null, viewCompanyWatchList?: boolean | null, addMyWatchList?: boolean | null, addCompanyWatchList?: boolean | null, updateMyWatchList?: boolean | null, updateCompanyWatchList?: boolean | null, deactivateMyWatchList?: boolean | null, deactivateCompanyWatchList?: boolean | null, deleteMyWatchList?: boolean | null, deleteCompanyWatchList?: boolean | null, viewMyRoomReservation?: boolean | null, viewCompanyRoomReservation?: boolean | null, addMyRoomReservation?: boolean | null, addCompanyRoomReservation?: boolean | null, updateMyRoomReservation?: boolean | null, updateCompanyRoomReservation?: boolean | null, manageCompanyRoomReservation?: boolean | null, viewMyIncident?: boolean | null, viewCompanyIncident?: boolean | null, addMyIncident?: boolean | null, addCompanyIncident?: boolean | null, updateMyIncident?: boolean | null, updateCompanyIncident?: boolean | null, deleteMyIncident?: boolean | null, deleteCompanyIncident?: boolean | null, viewMyWorkOrder?: boolean | null, viewCompanyWorkOrder?: boolean | null, addMyWorkOrder?: boolean | null, addCompanyWorkOrder?: boolean | null, updateMyWorkOrder?: boolean | null, updateCompanyWorkOrder?: boolean | null, updateWorkOrderStatus?: boolean | null, updateWorkOrderAssignee?: boolean | null, updateWorkOrderPriority?: boolean | null, canCloseWorkOrder?: boolean | null, deleteMyWorkOrder?: boolean | null, deleteCompanyWorkOrder?: boolean | null, viewWOCharges?: boolean | null, manageWOCharges?: boolean | null, viewMyWorkOrderTemplate?: boolean | null, viewCompanyWorkOrderTemplate?: boolean | null, addMyWorkOrderTemplate?: boolean | null, addCompanyWorkOrderTemplate?: boolean | null, updateMyWorkOrderTemplate?: boolean | null, updateCompanyWorkOrderTemplate?: boolean | null, updateWorkOrderAssigneeTemplate?: boolean | null, updateWorkOrderPriorityTemplate?: boolean | null, deleteMyWorkOrderTemplate?: boolean | null, deleteCompanyWorkOrderTemplate?: boolean | null, viewWOTCharges?: boolean | null, manageWOTCharges?: boolean | null, viewUser?: boolean | null, viewCompanyFullAccessUsers?: boolean | null, addUser?: boolean | null, updateUser?: boolean | null, deleteUser?: boolean | null, controlUserWallet?: boolean | null, viewCompanyPage?: boolean | null, addCompany?: boolean | null, updateCompany?: boolean | null, deleteCompany?: boolean | null, viewMySubscriptions?: boolean | null, viewCompanySubscriptions?: boolean | null, addCompanySubscriptions?: boolean | null, updateCompanySubscriptions?: boolean | null, cancelCompanySubscriptions?: boolean | null, refundSubscriptionCharges?: boolean | null, viewMessages?: boolean | null, addMessage?: boolean | null, viewGeneaCards?: boolean | null, updateGeneaCards?: boolean | null, viewGeneaDoors?: boolean | null, toggleGeneaDoor?: boolean | null, viewConciergeHub?: boolean | null, manageConciergeHub?: boolean | null, viewReports?: boolean | null, viewCoi?: boolean | null, addCoi?: boolean | null, updateCoi?: boolean | null, deleteCoi?: boolean | null, updateCoiStatus?: boolean | null, viewPreventiveMaintenance?: boolean | null, managePreventiveMaintenance?: boolean | null, viewMyTasks?: boolean | null, viewAllTasks?: boolean | null, manageMyTasks?: boolean | null, manageAllTasks?: boolean | null, viewTaskCharges?: boolean | null, manageTaskCharges?: boolean | null, viewLease?: boolean | null, manageLease?: boolean | null, viewAnalytics?: boolean | null, viewStackingPlan?: boolean | null, offlinePayments?: boolean | null, creditCardPayments?: boolean | null, propertyAdmin?: boolean | null, viewInternalNotes?: boolean | null, addInternalNotes?: boolean | null, viewFileManager?: boolean | null, manageFileManager?: boolean | null, accessFileManagerPrivate?: boolean | null, viewInvoices?: boolean | null, manageInvoices?: boolean | null, viewRecurringInvoices?: boolean | null, manageRecurringInvoices?: boolean | null, viewPackage?: boolean | null, managePackage?: boolean | null };

export type RoleCoreFieldsFragment = { __typename?: 'RoleObject', id: string, title: string };

export type RoleFieldsFragment = { __typename?: 'RoleObject', description?: string | null, id: string, title: string, permissions: { __typename?: 'PermissionsObject', viewPropertyNewsFeedPost?: boolean | null, addNewsFeedPost?: boolean | null, editOtherUsersNewsFeedPost?: boolean | null, deleteOtherUsersNewsFeedPost?: boolean | null, addNewsFeedPostComment?: boolean | null, deleteOtherUsersNewsFeedComment?: boolean | null, addEventPost?: boolean | null, editOtherUsersEventPost?: boolean | null, deleteOtherUsersEventPost?: boolean | null, viewMyGuest?: boolean | null, viewCompanyGuest?: boolean | null, addMyGuest?: boolean | null, addCompanyGuest?: boolean | null, approveGuest?: boolean | null, updateMyGuest?: boolean | null, updateCompanyGuest?: boolean | null, checkInGuest?: boolean | null, printBadgeGuest?: boolean | null, viewMyVendorAccess?: boolean | null, viewCompanyVendorAccess?: boolean | null, addMyVendorAccess?: boolean | null, addCompanyVendorAccess?: boolean | null, approveVendorAccess?: boolean | null, updateMyVendorAccess?: boolean | null, updateCompanyVendorAccess?: boolean | null, checkInVendorAccess?: boolean | null, printBadgeVendorAccess?: boolean | null, viewMyWatchList?: boolean | null, viewCompanyWatchList?: boolean | null, addMyWatchList?: boolean | null, addCompanyWatchList?: boolean | null, updateMyWatchList?: boolean | null, updateCompanyWatchList?: boolean | null, deactivateMyWatchList?: boolean | null, deactivateCompanyWatchList?: boolean | null, deleteMyWatchList?: boolean | null, deleteCompanyWatchList?: boolean | null, viewMyRoomReservation?: boolean | null, viewCompanyRoomReservation?: boolean | null, addMyRoomReservation?: boolean | null, addCompanyRoomReservation?: boolean | null, updateMyRoomReservation?: boolean | null, updateCompanyRoomReservation?: boolean | null, manageCompanyRoomReservation?: boolean | null, viewMyIncident?: boolean | null, viewCompanyIncident?: boolean | null, addMyIncident?: boolean | null, addCompanyIncident?: boolean | null, updateMyIncident?: boolean | null, updateCompanyIncident?: boolean | null, deleteMyIncident?: boolean | null, deleteCompanyIncident?: boolean | null, viewMyWorkOrder?: boolean | null, viewCompanyWorkOrder?: boolean | null, addMyWorkOrder?: boolean | null, addCompanyWorkOrder?: boolean | null, updateMyWorkOrder?: boolean | null, updateCompanyWorkOrder?: boolean | null, updateWorkOrderStatus?: boolean | null, updateWorkOrderAssignee?: boolean | null, updateWorkOrderPriority?: boolean | null, canCloseWorkOrder?: boolean | null, deleteMyWorkOrder?: boolean | null, deleteCompanyWorkOrder?: boolean | null, viewWOCharges?: boolean | null, manageWOCharges?: boolean | null, viewMyWorkOrderTemplate?: boolean | null, viewCompanyWorkOrderTemplate?: boolean | null, addMyWorkOrderTemplate?: boolean | null, addCompanyWorkOrderTemplate?: boolean | null, updateMyWorkOrderTemplate?: boolean | null, updateCompanyWorkOrderTemplate?: boolean | null, updateWorkOrderAssigneeTemplate?: boolean | null, updateWorkOrderPriorityTemplate?: boolean | null, deleteMyWorkOrderTemplate?: boolean | null, deleteCompanyWorkOrderTemplate?: boolean | null, viewWOTCharges?: boolean | null, manageWOTCharges?: boolean | null, viewUser?: boolean | null, viewCompanyFullAccessUsers?: boolean | null, addUser?: boolean | null, updateUser?: boolean | null, deleteUser?: boolean | null, controlUserWallet?: boolean | null, viewCompanyPage?: boolean | null, addCompany?: boolean | null, updateCompany?: boolean | null, deleteCompany?: boolean | null, viewMySubscriptions?: boolean | null, viewCompanySubscriptions?: boolean | null, addCompanySubscriptions?: boolean | null, updateCompanySubscriptions?: boolean | null, cancelCompanySubscriptions?: boolean | null, refundSubscriptionCharges?: boolean | null, viewMessages?: boolean | null, addMessage?: boolean | null, viewGeneaCards?: boolean | null, updateGeneaCards?: boolean | null, viewGeneaDoors?: boolean | null, toggleGeneaDoor?: boolean | null, viewConciergeHub?: boolean | null, manageConciergeHub?: boolean | null, viewReports?: boolean | null, viewCoi?: boolean | null, addCoi?: boolean | null, updateCoi?: boolean | null, deleteCoi?: boolean | null, updateCoiStatus?: boolean | null, viewPreventiveMaintenance?: boolean | null, managePreventiveMaintenance?: boolean | null, viewMyTasks?: boolean | null, viewAllTasks?: boolean | null, manageMyTasks?: boolean | null, manageAllTasks?: boolean | null, viewTaskCharges?: boolean | null, manageTaskCharges?: boolean | null, viewLease?: boolean | null, manageLease?: boolean | null, viewAnalytics?: boolean | null, viewStackingPlan?: boolean | null, offlinePayments?: boolean | null, creditCardPayments?: boolean | null, propertyAdmin?: boolean | null, viewInternalNotes?: boolean | null, addInternalNotes?: boolean | null, viewFileManager?: boolean | null, manageFileManager?: boolean | null, accessFileManagerPrivate?: boolean | null, viewInvoices?: boolean | null, manageInvoices?: boolean | null, viewRecurringInvoices?: boolean | null, manageRecurringInvoices?: boolean | null, viewPackage?: boolean | null, managePackage?: boolean | null }, rolesAssignable: Array<{ __typename?: 'RoleObject', id: string, title: string }> };

export type CreateRoleMutationVariables = Exact<{
  data: RoleInput;
  portfolioId: Scalars['String'];
}>;


export type CreateRoleMutation = { __typename?: 'Mutation', createRole: { __typename?: 'RoleObject', id: string } };

export type UpdateRoleMutationVariables = Exact<{
  id: Scalars['String'];
  data: RoleInput;
}>;


export type UpdateRoleMutation = { __typename?: 'Mutation', updateRole: { __typename?: 'RoleObject', description?: string | null, id: string, title: string, permissions: { __typename?: 'PermissionsObject', viewPropertyNewsFeedPost?: boolean | null, addNewsFeedPost?: boolean | null, editOtherUsersNewsFeedPost?: boolean | null, deleteOtherUsersNewsFeedPost?: boolean | null, addNewsFeedPostComment?: boolean | null, deleteOtherUsersNewsFeedComment?: boolean | null, addEventPost?: boolean | null, editOtherUsersEventPost?: boolean | null, deleteOtherUsersEventPost?: boolean | null, viewMyGuest?: boolean | null, viewCompanyGuest?: boolean | null, addMyGuest?: boolean | null, addCompanyGuest?: boolean | null, approveGuest?: boolean | null, updateMyGuest?: boolean | null, updateCompanyGuest?: boolean | null, checkInGuest?: boolean | null, printBadgeGuest?: boolean | null, viewMyVendorAccess?: boolean | null, viewCompanyVendorAccess?: boolean | null, addMyVendorAccess?: boolean | null, addCompanyVendorAccess?: boolean | null, approveVendorAccess?: boolean | null, updateMyVendorAccess?: boolean | null, updateCompanyVendorAccess?: boolean | null, checkInVendorAccess?: boolean | null, printBadgeVendorAccess?: boolean | null, viewMyWatchList?: boolean | null, viewCompanyWatchList?: boolean | null, addMyWatchList?: boolean | null, addCompanyWatchList?: boolean | null, updateMyWatchList?: boolean | null, updateCompanyWatchList?: boolean | null, deactivateMyWatchList?: boolean | null, deactivateCompanyWatchList?: boolean | null, deleteMyWatchList?: boolean | null, deleteCompanyWatchList?: boolean | null, viewMyRoomReservation?: boolean | null, viewCompanyRoomReservation?: boolean | null, addMyRoomReservation?: boolean | null, addCompanyRoomReservation?: boolean | null, updateMyRoomReservation?: boolean | null, updateCompanyRoomReservation?: boolean | null, manageCompanyRoomReservation?: boolean | null, viewMyIncident?: boolean | null, viewCompanyIncident?: boolean | null, addMyIncident?: boolean | null, addCompanyIncident?: boolean | null, updateMyIncident?: boolean | null, updateCompanyIncident?: boolean | null, deleteMyIncident?: boolean | null, deleteCompanyIncident?: boolean | null, viewMyWorkOrder?: boolean | null, viewCompanyWorkOrder?: boolean | null, addMyWorkOrder?: boolean | null, addCompanyWorkOrder?: boolean | null, updateMyWorkOrder?: boolean | null, updateCompanyWorkOrder?: boolean | null, updateWorkOrderStatus?: boolean | null, updateWorkOrderAssignee?: boolean | null, updateWorkOrderPriority?: boolean | null, canCloseWorkOrder?: boolean | null, deleteMyWorkOrder?: boolean | null, deleteCompanyWorkOrder?: boolean | null, viewWOCharges?: boolean | null, manageWOCharges?: boolean | null, viewMyWorkOrderTemplate?: boolean | null, viewCompanyWorkOrderTemplate?: boolean | null, addMyWorkOrderTemplate?: boolean | null, addCompanyWorkOrderTemplate?: boolean | null, updateMyWorkOrderTemplate?: boolean | null, updateCompanyWorkOrderTemplate?: boolean | null, updateWorkOrderAssigneeTemplate?: boolean | null, updateWorkOrderPriorityTemplate?: boolean | null, deleteMyWorkOrderTemplate?: boolean | null, deleteCompanyWorkOrderTemplate?: boolean | null, viewWOTCharges?: boolean | null, manageWOTCharges?: boolean | null, viewUser?: boolean | null, viewCompanyFullAccessUsers?: boolean | null, addUser?: boolean | null, updateUser?: boolean | null, deleteUser?: boolean | null, controlUserWallet?: boolean | null, viewCompanyPage?: boolean | null, addCompany?: boolean | null, updateCompany?: boolean | null, deleteCompany?: boolean | null, viewMySubscriptions?: boolean | null, viewCompanySubscriptions?: boolean | null, addCompanySubscriptions?: boolean | null, updateCompanySubscriptions?: boolean | null, cancelCompanySubscriptions?: boolean | null, refundSubscriptionCharges?: boolean | null, viewMessages?: boolean | null, addMessage?: boolean | null, viewGeneaCards?: boolean | null, updateGeneaCards?: boolean | null, viewGeneaDoors?: boolean | null, toggleGeneaDoor?: boolean | null, viewConciergeHub?: boolean | null, manageConciergeHub?: boolean | null, viewReports?: boolean | null, viewCoi?: boolean | null, addCoi?: boolean | null, updateCoi?: boolean | null, deleteCoi?: boolean | null, updateCoiStatus?: boolean | null, viewPreventiveMaintenance?: boolean | null, managePreventiveMaintenance?: boolean | null, viewMyTasks?: boolean | null, viewAllTasks?: boolean | null, manageMyTasks?: boolean | null, manageAllTasks?: boolean | null, viewTaskCharges?: boolean | null, manageTaskCharges?: boolean | null, viewLease?: boolean | null, manageLease?: boolean | null, viewAnalytics?: boolean | null, viewStackingPlan?: boolean | null, offlinePayments?: boolean | null, creditCardPayments?: boolean | null, propertyAdmin?: boolean | null, viewInternalNotes?: boolean | null, addInternalNotes?: boolean | null, viewFileManager?: boolean | null, manageFileManager?: boolean | null, accessFileManagerPrivate?: boolean | null, viewInvoices?: boolean | null, manageInvoices?: boolean | null, viewRecurringInvoices?: boolean | null, manageRecurringInvoices?: boolean | null, viewPackage?: boolean | null, managePackage?: boolean | null }, rolesAssignable: Array<{ __typename?: 'RoleObject', id: string, title: string }> } };

export type RemoveRolesMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveRolesMutation = { __typename?: 'Mutation', removeRoles: boolean };

export type ToggleRoleMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ToggleRoleMutation = { __typename?: 'Mutation', toggleRole: boolean };

export type GetRolesTableQueryVariables = Exact<{
  portfolioId: Scalars['String'];
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetRolesTableQuery = { __typename?: 'Query', getRoles: { __typename?: 'GetRolesObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'RoleObject', index: number, active: boolean, description?: string | null, createdAt?: any | null, userCount: number, id: string, title: string }> } };

export type GetRolesDropdownQueryVariables = Exact<{
  portfolioId: Scalars['String'];
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetRolesDropdownQuery = { __typename?: 'Query', getRoles: { __typename?: 'GetRolesObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'RoleObject', active: boolean, id: string, title: string }> } };

export type GetRoleQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetRoleQuery = { __typename?: 'Query', getRole: { __typename?: 'RoleObject', description?: string | null, id: string, title: string, permissions: { __typename?: 'PermissionsObject', viewPropertyNewsFeedPost?: boolean | null, addNewsFeedPost?: boolean | null, editOtherUsersNewsFeedPost?: boolean | null, deleteOtherUsersNewsFeedPost?: boolean | null, addNewsFeedPostComment?: boolean | null, deleteOtherUsersNewsFeedComment?: boolean | null, addEventPost?: boolean | null, editOtherUsersEventPost?: boolean | null, deleteOtherUsersEventPost?: boolean | null, viewMyGuest?: boolean | null, viewCompanyGuest?: boolean | null, addMyGuest?: boolean | null, addCompanyGuest?: boolean | null, approveGuest?: boolean | null, updateMyGuest?: boolean | null, updateCompanyGuest?: boolean | null, checkInGuest?: boolean | null, printBadgeGuest?: boolean | null, viewMyVendorAccess?: boolean | null, viewCompanyVendorAccess?: boolean | null, addMyVendorAccess?: boolean | null, addCompanyVendorAccess?: boolean | null, approveVendorAccess?: boolean | null, updateMyVendorAccess?: boolean | null, updateCompanyVendorAccess?: boolean | null, checkInVendorAccess?: boolean | null, printBadgeVendorAccess?: boolean | null, viewMyWatchList?: boolean | null, viewCompanyWatchList?: boolean | null, addMyWatchList?: boolean | null, addCompanyWatchList?: boolean | null, updateMyWatchList?: boolean | null, updateCompanyWatchList?: boolean | null, deactivateMyWatchList?: boolean | null, deactivateCompanyWatchList?: boolean | null, deleteMyWatchList?: boolean | null, deleteCompanyWatchList?: boolean | null, viewMyRoomReservation?: boolean | null, viewCompanyRoomReservation?: boolean | null, addMyRoomReservation?: boolean | null, addCompanyRoomReservation?: boolean | null, updateMyRoomReservation?: boolean | null, updateCompanyRoomReservation?: boolean | null, manageCompanyRoomReservation?: boolean | null, viewMyIncident?: boolean | null, viewCompanyIncident?: boolean | null, addMyIncident?: boolean | null, addCompanyIncident?: boolean | null, updateMyIncident?: boolean | null, updateCompanyIncident?: boolean | null, deleteMyIncident?: boolean | null, deleteCompanyIncident?: boolean | null, viewMyWorkOrder?: boolean | null, viewCompanyWorkOrder?: boolean | null, addMyWorkOrder?: boolean | null, addCompanyWorkOrder?: boolean | null, updateMyWorkOrder?: boolean | null, updateCompanyWorkOrder?: boolean | null, updateWorkOrderStatus?: boolean | null, updateWorkOrderAssignee?: boolean | null, updateWorkOrderPriority?: boolean | null, canCloseWorkOrder?: boolean | null, deleteMyWorkOrder?: boolean | null, deleteCompanyWorkOrder?: boolean | null, viewWOCharges?: boolean | null, manageWOCharges?: boolean | null, viewMyWorkOrderTemplate?: boolean | null, viewCompanyWorkOrderTemplate?: boolean | null, addMyWorkOrderTemplate?: boolean | null, addCompanyWorkOrderTemplate?: boolean | null, updateMyWorkOrderTemplate?: boolean | null, updateCompanyWorkOrderTemplate?: boolean | null, updateWorkOrderAssigneeTemplate?: boolean | null, updateWorkOrderPriorityTemplate?: boolean | null, deleteMyWorkOrderTemplate?: boolean | null, deleteCompanyWorkOrderTemplate?: boolean | null, viewWOTCharges?: boolean | null, manageWOTCharges?: boolean | null, viewUser?: boolean | null, viewCompanyFullAccessUsers?: boolean | null, addUser?: boolean | null, updateUser?: boolean | null, deleteUser?: boolean | null, controlUserWallet?: boolean | null, viewCompanyPage?: boolean | null, addCompany?: boolean | null, updateCompany?: boolean | null, deleteCompany?: boolean | null, viewMySubscriptions?: boolean | null, viewCompanySubscriptions?: boolean | null, addCompanySubscriptions?: boolean | null, updateCompanySubscriptions?: boolean | null, cancelCompanySubscriptions?: boolean | null, refundSubscriptionCharges?: boolean | null, viewMessages?: boolean | null, addMessage?: boolean | null, viewGeneaCards?: boolean | null, updateGeneaCards?: boolean | null, viewGeneaDoors?: boolean | null, toggleGeneaDoor?: boolean | null, viewConciergeHub?: boolean | null, manageConciergeHub?: boolean | null, viewReports?: boolean | null, viewCoi?: boolean | null, addCoi?: boolean | null, updateCoi?: boolean | null, deleteCoi?: boolean | null, updateCoiStatus?: boolean | null, viewPreventiveMaintenance?: boolean | null, managePreventiveMaintenance?: boolean | null, viewMyTasks?: boolean | null, viewAllTasks?: boolean | null, manageMyTasks?: boolean | null, manageAllTasks?: boolean | null, viewTaskCharges?: boolean | null, manageTaskCharges?: boolean | null, viewLease?: boolean | null, manageLease?: boolean | null, viewAnalytics?: boolean | null, viewStackingPlan?: boolean | null, offlinePayments?: boolean | null, creditCardPayments?: boolean | null, propertyAdmin?: boolean | null, viewInternalNotes?: boolean | null, addInternalNotes?: boolean | null, viewFileManager?: boolean | null, manageFileManager?: boolean | null, accessFileManagerPrivate?: boolean | null, viewInvoices?: boolean | null, manageInvoices?: boolean | null, viewRecurringInvoices?: boolean | null, manageRecurringInvoices?: boolean | null, viewPackage?: boolean | null, managePackage?: boolean | null }, rolesAssignable: Array<{ __typename?: 'RoleObject', id: string, title: string }> } };

export type GetRoleStructureQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRoleStructureQuery = { __typename?: 'Query', getRoleStructure: Array<{ __typename?: 'RoleStructureObject', title: string, description: string, sections: Array<{ __typename?: 'RoleSectionObject', title: string, notes?: string | null, permissions: Array<{ __typename?: 'RolePermissionObject', key: string, title: string, note?: string | null, dependencies?: Array<string> | null }> }> }> };

export type StatusCoreFieldsFragment = { __typename?: 'StatusObject', id: string, title: string };

export type StatusFieldsFragment = { __typename?: 'StatusObject', color: string, id: string, title: string, property?: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null };

export type WorkOrdersStatusSettingsFieldsFragment = { __typename?: 'WorkOrderStatusSettingObject', acknowledge?: { __typename?: 'StatusObject', color: string, id: string, title: string } | null, closed: Array<{ __typename?: 'StatusObject', color: string, id: string, title: string }>, default?: { __typename?: 'StatusObject', color: string, id: string, title: string } | null, rating: Array<{ __typename?: 'StatusObject', color: string, id: string, title: string }> };

export type IncidentsStatusSettingsFieldsFragment = { __typename?: 'IncidentStatusSettingObject', default?: { __typename?: 'StatusObject', color: string, id: string, title: string } | null };

export type CreateStatusMutationVariables = Exact<{
  data: StatusInput;
  portfolioId: Scalars['String'];
}>;


export type CreateStatusMutation = { __typename?: 'Mutation', createStatus: { __typename?: 'StatusObject', id: string } };

export type UpdateStatusMutationVariables = Exact<{
  id: Scalars['String'];
  data: StatusUpdateInput;
}>;


export type UpdateStatusMutation = { __typename?: 'Mutation', updateStatus: { __typename?: 'StatusObject', color: string, id: string, title: string, property?: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null } };

export type ReorderStatusesMutationVariables = Exact<{
  id: Scalars['String'];
  secondId: Scalars['String'];
}>;


export type ReorderStatusesMutation = { __typename?: 'Mutation', reorderStatuses: boolean };

export type ToggleStatusMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ToggleStatusMutation = { __typename?: 'Mutation', toggleStatus: boolean };

export type RemoveStatusesMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveStatusesMutation = { __typename?: 'Mutation', removeStatuses: boolean };

export type UpdateWorkOrderStatusSettingsMutationVariables = Exact<{
  portfolioId: Scalars['String'];
  data: WorkOrderStatusInput;
}>;


export type UpdateWorkOrderStatusSettingsMutation = { __typename?: 'Mutation', updateWorkOrderStatusSetting: { __typename?: 'WorkOrderStatusSettingObject', acknowledge?: { __typename?: 'StatusObject', color: string, id: string, title: string } | null, closed: Array<{ __typename?: 'StatusObject', color: string, id: string, title: string }>, default?: { __typename?: 'StatusObject', color: string, id: string, title: string } | null, rating: Array<{ __typename?: 'StatusObject', color: string, id: string, title: string }> } };

export type UpdateIncidentStatusSettingMutationVariables = Exact<{
  portfolioId: Scalars['String'];
  data: IncidentStatusInput;
}>;


export type UpdateIncidentStatusSettingMutation = { __typename?: 'Mutation', updateIncidentStatusSetting: { __typename?: 'IncidentStatusSettingObject', default?: { __typename?: 'StatusObject', color: string, id: string, title: string } | null } };

export type GetStatusesTableQueryVariables = Exact<{
  portfolioId: Scalars['String'];
  recordType: StatusRecordType;
  recordLevel?: InputMaybe<RecordLevel>;
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  propertyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetStatusesTableQuery = { __typename?: 'Query', getStatuses: Array<{ __typename?: 'StatusObject', color: string, index: number, active: boolean, id: string, title: string, property?: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null }> };

export type GetStatusesDropdownQueryVariables = Exact<{
  portfolioId: Scalars['String'];
  recordType: StatusRecordType;
  recordLevel?: InputMaybe<RecordLevel>;
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  propertyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetStatusesDropdownQuery = { __typename?: 'Query', getStatuses: Array<{ __typename?: 'StatusObject', color: string, active: boolean, id: string, title: string }> };

export type GetFilterableStatusesQueryVariables = Exact<{
  portfolioId: Scalars['String'];
  location: FilterableStatusLocationType;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetFilterableStatusesQuery = { __typename?: 'Query', getFilterableStatuses: Array<{ __typename?: 'FilterableStatusObject', id: string, title: string, color?: string | null, active: boolean, isDeleted: boolean }> };

export type GetStatusQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetStatusQuery = { __typename?: 'Query', getStatus: { __typename?: 'StatusObject', color: string, id: string, title: string, property?: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null } };

export type GetWorkOrderStatusSettingsQueryVariables = Exact<{
  portfolioId: Scalars['String'];
}>;


export type GetWorkOrderStatusSettingsQuery = { __typename?: 'Query', getWorkOrderStatusSetting: { __typename?: 'WorkOrderStatusSettingObject', acknowledge?: { __typename?: 'StatusObject', color: string, id: string, title: string } | null, closed: Array<{ __typename?: 'StatusObject', color: string, id: string, title: string }>, default?: { __typename?: 'StatusObject', color: string, id: string, title: string } | null, rating: Array<{ __typename?: 'StatusObject', color: string, id: string, title: string }> } };

export type GetIncidentStatusSettingQueryVariables = Exact<{
  portfolioId: Scalars['String'];
}>;


export type GetIncidentStatusSettingQuery = { __typename?: 'Query', getIncidentStatusSetting: { __typename?: 'IncidentStatusSettingObject', default?: { __typename?: 'StatusObject', color: string, id: string, title: string } | null } };

export type SuiteCoreFieldsFragment = { __typename?: 'SuiteObject', id: string, title: string };

export type TaxCoreFieldsFragment = { __typename?: 'TaxObject', id: string, title: string };

export type TaxFieldsFragment = { __typename?: 'TaxObject', amount: number, id: string, title: string, property?: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, glAccount?: { __typename?: 'GLAccountObject', id: string, title: string } | null, arCode?: { __typename?: 'ARCodeObject', id: string, title: string } | null, chargeCode?: { __typename?: 'ChargeCodeObject', id: string, title: string } | null };

export type CreateTaxMutationVariables = Exact<{
  data: TaxInput;
  portfolioId: Scalars['String'];
}>;


export type CreateTaxMutation = { __typename?: 'Mutation', createTax: { __typename?: 'TaxObject', id: string } };

export type UpdateTaxMutationVariables = Exact<{
  id: Scalars['String'];
  data: TaxInput;
}>;


export type UpdateTaxMutation = { __typename?: 'Mutation', updateTax: { __typename?: 'TaxObject', amount: number, id: string, title: string, property?: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, glAccount?: { __typename?: 'GLAccountObject', id: string, title: string } | null, arCode?: { __typename?: 'ARCodeObject', id: string, title: string } | null, chargeCode?: { __typename?: 'ChargeCodeObject', id: string, title: string } | null } };

export type ToggleTaxMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ToggleTaxMutation = { __typename?: 'Mutation', toggleTax: boolean };

export type RemoveTaxesMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveTaxesMutation = { __typename?: 'Mutation', removeTaxes: boolean };

export type GetTaxesTableQueryVariables = Exact<{
  portfolioId: Scalars['String'];
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  recordLevel?: InputMaybe<RecordLevel>;
  propertyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetTaxesTableQuery = { __typename?: 'Query', getTaxes: Array<{ __typename?: 'TaxObject', index: number, active: boolean, amount: number, id: string, title: string, property?: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, glAccount?: { __typename?: 'GLAccountObject', id: string, title: string } | null, arCode?: { __typename?: 'ARCodeObject', id: string, title: string } | null, chargeCode?: { __typename?: 'ChargeCodeObject', id: string, title: string } | null }> };

export type GetTaxesDropdownQueryVariables = Exact<{
  portfolioId: Scalars['String'];
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  recordLevel?: InputMaybe<RecordLevel>;
  propertyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  includeGLAccount: Scalars['Boolean'];
  includeARCode: Scalars['Boolean'];
  includeChargeCode: Scalars['Boolean'];
}>;


export type GetTaxesDropdownQuery = { __typename?: 'Query', getTaxes: Array<{ __typename?: 'TaxObject', active: boolean, amount: number, id: string, title: string, glAccount?: { __typename?: 'GLAccountObject', id: string, title: string } | null, arCode?: { __typename?: 'ARCodeObject', id: string, title: string } | null, chargeCode?: { __typename?: 'ChargeCodeObject', id: string, title: string } | null }> };

export type GetTaxQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetTaxQuery = { __typename?: 'Query', getTax: { __typename?: 'TaxObject', amount: number, id: string, title: string, property?: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, glAccount?: { __typename?: 'GLAccountObject', id: string, title: string } | null, arCode?: { __typename?: 'ARCodeObject', id: string, title: string } | null, chargeCode?: { __typename?: 'ChargeCodeObject', id: string, title: string } | null } };

export type GlobalTranslationCoreFieldsFragment = { __typename?: 'GlobalTranslationObject', id: string, title: string };

export type CreateGlobalTranslationMutationVariables = Exact<{
  data: GlobalTranslationInput;
}>;


export type CreateGlobalTranslationMutation = { __typename?: 'Mutation', createGlobalTranslation: { __typename?: 'GlobalTranslationObject', id: string } };

export type UpdateGlobalTranslationMutationVariables = Exact<{
  id: Scalars['String'];
  data: GlobalTranslationInput;
}>;


export type UpdateGlobalTranslationMutation = { __typename?: 'Mutation', updateGlobalTranslation: { __typename?: 'GlobalTranslationObject', countryCode: string, id: string, title: string } };

export type UpdateGlobalTranslationTextsMutationVariables = Exact<{
  id: Scalars['String'];
  key: Scalars['String'];
  sources?: InputMaybe<Scalars['TranslationKeysScalar']>;
  descriptions?: InputMaybe<Scalars['TranslationKeysScalar']>;
}>;


export type UpdateGlobalTranslationTextsMutation = { __typename?: 'Mutation', updateGlobalTranslationTexts: boolean };

export type ToggleGlobalTranslationMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ToggleGlobalTranslationMutation = { __typename?: 'Mutation', toggleGlobalTranslation: boolean };

export type ImportGlobalTranslationMutationVariables = Exact<{
  id: Scalars['String'];
  link: Scalars['String'];
}>;


export type ImportGlobalTranslationMutation = { __typename?: 'Mutation', importGlobalTranslation: boolean };

export type RemoveGlobalTranslationsMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveGlobalTranslationsMutation = { __typename?: 'Mutation', removeGlobalTranslations: boolean };

export type UploadTranslationMutationVariables = Exact<{
  data: GlobalBaseTranslationInput;
}>;


export type UploadTranslationMutation = { __typename?: 'Mutation', uploadTranslation: boolean };

export type GetGlobalTranslationsTableQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetGlobalTranslationsTableQuery = { __typename?: 'Query', getGlobalTranslations: Array<{ __typename?: 'GlobalTranslationObject', countryCode: string, active: boolean, id: string, title: string }> };

export type GetGlobalTranslationsDropdownQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetGlobalTranslationsDropdownQuery = { __typename?: 'Query', getGlobalTranslations: Array<{ __typename?: 'GlobalTranslationObject', active: boolean, id: string, title: string }> };

export type GetGlobalTranslationOverviewQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetGlobalTranslationOverviewQuery = { __typename?: 'Query', getGlobalTranslation: { __typename?: 'GlobalTranslationObject', active: boolean, id: string, title: string } };

export type GetGlobalTranslationQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetGlobalTranslationQuery = { __typename?: 'Query', getGlobalTranslation: { __typename?: 'GlobalTranslationObject', countryCode: string, id: string, title: string } };

export type GetGlobalTranslationFilteredTableQueryVariables = Exact<{
  id: Scalars['String'];
  key: Scalars['String'];
}>;


export type GetGlobalTranslationFilteredTableQuery = { __typename?: 'Query', getGlobalTranslationFiltered: { __typename?: 'GlobalTranslationFilteredObject', sources: any, descriptions: any } };

export type ExportGlobalTranslationQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ExportGlobalTranslationQuery = { __typename?: 'Query', exportGlobalTranslation: string };

export type TranslationCoreFieldsFragment = { __typename?: 'TranslationObject', id: string, title: string };

export type CreateTranslationMutationVariables = Exact<{
  portfolioId: Scalars['String'];
  data: TranslationInput;
}>;


export type CreateTranslationMutation = { __typename?: 'Mutation', createTranslation: { __typename?: 'TranslationObject', id: string } };

export type UpdateTranslationMutationVariables = Exact<{
  id: Scalars['String'];
  data: TranslationInput;
}>;


export type UpdateTranslationMutation = { __typename?: 'Mutation', updateTranslation: { __typename?: 'TranslationObject', countryCode: string, id: string, title: string } };

export type UpdateTranslationTranslationsMutationVariables = Exact<{
  id: Scalars['String'];
  key: Scalars['String'];
  translations: Scalars['TranslationKeysScalar'];
}>;


export type UpdateTranslationTranslationsMutation = { __typename?: 'Mutation', updateTranslationTranslations: boolean };

export type ResetTranslationMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ResetTranslationMutation = { __typename?: 'Mutation', resetTranslation: boolean };

export type ImportTranslationMutationVariables = Exact<{
  id: Scalars['String'];
  link: Scalars['String'];
}>;


export type ImportTranslationMutation = { __typename?: 'Mutation', importTranslation: boolean };

export type ToggleTranslationMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ToggleTranslationMutation = { __typename?: 'Mutation', toggleTranslation: boolean };

export type RemoveTranslationsMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveTranslationsMutation = { __typename?: 'Mutation', removeTranslations: boolean };

export type GetTranslationsTableQueryVariables = Exact<{
  portfolioId: Scalars['String'];
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetTranslationsTableQuery = { __typename?: 'Query', getTranslations: Array<{ __typename?: 'TranslationObject', countryCode: string, active: boolean, id: string, title: string }> };

export type GetTranslationsDropdownQueryVariables = Exact<{
  portfolioId: Scalars['String'];
  active?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetTranslationsDropdownQuery = { __typename?: 'Query', getTranslations: Array<{ __typename?: 'TranslationObject', active: boolean, id: string, title: string }> };

export type GetTranslationOverviewQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetTranslationOverviewQuery = { __typename?: 'Query', getTranslation: { __typename?: 'TranslationObject', active: boolean, translations?: any | null, id: string, title: string } };

export type GetTranslationQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetTranslationQuery = { __typename?: 'Query', getTranslation: { __typename?: 'TranslationObject', countryCode: string, id: string, title: string, globalTranslation: { __typename?: 'GlobalTranslationObject', id: string, title: string } } };

export type GetTranslationFilteredTableQueryVariables = Exact<{
  id: Scalars['String'];
  key: Scalars['String'];
}>;


export type GetTranslationFilteredTableQuery = { __typename?: 'Query', getTranslationFiltered: { __typename?: 'TranslationFilteredObject', sources: any, descriptions: any, translations?: any | null } };

export type ExportTranslationQueryVariables = Exact<{
  id: Scalars['String'];
  merge: Scalars['Boolean'];
}>;


export type ExportTranslationQuery = { __typename?: 'Query', exportTranslation: string };

export type FileFieldsFragment = { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string };

export type UploadFilesMutationVariables = Exact<{
  files: Array<Scalars['Upload']> | Scalars['Upload'];
  save?: InputMaybe<Scalars['Boolean']>;
}>;


export type UploadFilesMutation = { __typename?: 'Mutation', uploadFiles: Array<{ __typename?: 'UploadFileDTO', name: string, size: number, url: string }> };

export type GlobalUserFieldsFragment = { __typename?: 'GlobalUserObject', id: string, firstName: string, lastName: string, email: string, title?: string | null, phone?: string | null, addPortfolio: boolean, controlGlobalUsers: boolean, globalEmailAccess: boolean, viewPortfolioSettings: boolean, viewPortfolioDashboard: boolean, viewPortfolioWorkOrders: boolean, viewPortfolioCOIs: boolean, createdAt: any, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null, portfolios?: Array<{ __typename?: 'PortfolioModel', id: string, title: string, active: boolean, url: string, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> | null };

export type CreateGlobalUserMutationVariables = Exact<{
  data: CreateGlobalUserInput;
}>;


export type CreateGlobalUserMutation = { __typename?: 'Mutation', createGlobalUser: { __typename?: 'GlobalUserObject', id: string } };

export type UpdateGlobalUserMutationVariables = Exact<{
  id: Scalars['String'];
  data: UpdateGlobalUserInput;
}>;


export type UpdateGlobalUserMutation = { __typename?: 'Mutation', updateGlobalUser: { __typename?: 'GlobalUserObject', id: string, firstName: string, lastName: string, email: string, title?: string | null, phone?: string | null, addPortfolio: boolean, controlGlobalUsers: boolean, globalEmailAccess: boolean, viewPortfolioSettings: boolean, viewPortfolioDashboard: boolean, viewPortfolioWorkOrders: boolean, viewPortfolioCOIs: boolean, createdAt: any, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null, portfolios?: Array<{ __typename?: 'PortfolioModel', id: string, title: string, active: boolean, url: string, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> | null } };

export type RemoveGlobalUsersMutationVariables = Exact<{
  data: DeleteRecordsInput;
}>;


export type RemoveGlobalUsersMutation = { __typename?: 'Mutation', removeGlobalUsers: boolean };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'GlobalUserObject', id: string, firstName: string, lastName: string, email: string, title?: string | null, phone?: string | null, addPortfolio: boolean, controlGlobalUsers: boolean, globalEmailAccess: boolean, viewPortfolioSettings: boolean, viewPortfolioDashboard: boolean, viewPortfolioWorkOrders: boolean, viewPortfolioCOIs: boolean, createdAt: any, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null, portfolios?: Array<{ __typename?: 'PortfolioModel', id: string, title: string, active: boolean, url: string, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> | null } };

export type GetGlobalUsersTableQueryVariables = Exact<{
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetGlobalUsersTableQuery = { __typename?: 'Query', getGlobalUsers: { __typename?: 'GetGlobalUserList', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'GlobalUserObject', id: string, firstName: string, lastName: string, email: string, title?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> } };

export type GetGlobalUserQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetGlobalUserQuery = { __typename?: 'Query', getGlobalUser: { __typename?: 'GlobalUserObject', id: string, firstName: string, lastName: string, email: string, title?: string | null, phone?: string | null, addPortfolio: boolean, controlGlobalUsers: boolean, globalEmailAccess: boolean, viewPortfolioSettings: boolean, viewPortfolioDashboard: boolean, viewPortfolioWorkOrders: boolean, viewPortfolioCOIs: boolean, createdAt: any, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null, portfolios?: Array<{ __typename?: 'PortfolioModel', id: string, title: string, active: boolean, url: string, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> | null } };

export type UserCoreFieldsFragment = { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, active: boolean, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null };

export type UserFieldsFragment = { __typename?: 'UserObject', lastLoginAt?: any | null, id: string, email: string, firstName: string, lastName: string, active: boolean, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null };

export type CreateUserMutationVariables = Exact<{
  data: UserInput;
  portfolioId: Scalars['String'];
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'UserObject', id: string } };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['String'];
  data: UserUpdateInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UserObject', lastLoginAt?: any | null, id: string, email: string, firstName: string, lastName: string, active: boolean, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } };

export type UpdateUserPhotoMutationVariables = Exact<{
  id: Scalars['String'];
  photo?: InputMaybe<FileObjectInput>;
}>;


export type UpdateUserPhotoMutation = { __typename?: 'Mutation', updateUserPhoto: { __typename?: 'UserObject', id: string, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } };

export type ToggleUserMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ToggleUserMutation = { __typename?: 'Mutation', toggleUser: boolean };

export type AddUserPropertyMutationVariables = Exact<{
  id: Scalars['String'];
  data: UserPropertyInput;
}>;


export type AddUserPropertyMutation = { __typename?: 'Mutation', addUserProperty: boolean };

export type UpdateUserPropertyMutationVariables = Exact<{
  id: Scalars['String'];
  data: UserPropertyInput;
}>;


export type UpdateUserPropertyMutation = { __typename?: 'Mutation', updateUserProperty: boolean };

export type LoginAsUserMutationVariables = Exact<{
  id: Scalars['String'];
  portfolioId: Scalars['String'];
}>;


export type LoginAsUserMutation = { __typename?: 'Mutation', loginAsUser: string };

export type GetUsersTableQueryVariables = Exact<{
  portfolioId: Scalars['String'];
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  propertyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  roleIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetUsersTableQuery = { __typename?: 'Query', getUsers: { __typename?: 'GetUsersObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'UserObject', index: number, id: string, email: string, firstName: string, lastName: string, active: boolean, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> } };

export type GetUsersDropdownQueryVariables = Exact<{
  portfolioId: Scalars['String'];
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  propertyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  roleIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetUsersDropdownQuery = { __typename?: 'Query', getUsers: { __typename?: 'GetUsersObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, active: boolean, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> } };

export type GetUserQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetUserQuery = { __typename?: 'Query', getUser: { __typename?: 'UserObject', lastLoginAt?: any | null, id: string, email: string, firstName: string, lastName: string, active: boolean, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } };

export type GetUserPropertiesQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetUserPropertiesQuery = { __typename?: 'Query', getUserProperties: Array<{ __typename?: 'UserPropertyObject', title?: string | null, status: UserStatuses, property: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, role: { __typename?: 'RoleObject', active: boolean, id: string, title: string }, buildings: Array<{ __typename?: 'BuildingObject', id: string, title: string }>, companies: Array<{ __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }> }> };

export type GetWorkOrderStatusWidgetQueryVariables = Exact<{
  portfolioId: Scalars['String'];
  propertyId?: InputMaybe<Scalars['String']>;
  categoryIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  from: Scalars['DateTime'];
  to?: InputMaybe<Scalars['DateTime']>;
}>;


export type GetWorkOrderStatusWidgetQuery = { __typename?: 'Query', getWOStatusWidget: Array<{ __typename?: 'WOStatusWidget', name: string, count: number, percentage: number, color: string }> };

export type GetWorkOrderReviewsWidgetQueryVariables = Exact<{
  portfolioId: Scalars['String'];
  from: Scalars['DateTime'];
  to?: InputMaybe<Scalars['DateTime']>;
}>;


export type GetWorkOrderReviewsWidgetQuery = { __typename?: 'Query', getWOReviewsWidget: Array<{ __typename?: 'WOReviewWidget', name: string, count: number }> };

export type GetWorkOrderRevenueWidgetQueryVariables = Exact<{
  portfolioId: Scalars['String'];
  propertyId?: InputMaybe<Scalars['String']>;
  categoryIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  from: Scalars['DateTime'];
  to?: InputMaybe<Scalars['DateTime']>;
}>;


export type GetWorkOrderRevenueWidgetQuery = { __typename?: 'Query', getWORevenueWidget: Array<{ __typename?: 'WORevenueWidget', name: string, laborRevenue: number, markupRevenue: number, materialRevenue: number }> };

export type GetWorkOrderCategoryWidgetQueryVariables = Exact<{
  portfolioId: Scalars['String'];
  propertyId?: InputMaybe<Scalars['String']>;
  categoryIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  from: Scalars['DateTime'];
  to?: InputMaybe<Scalars['DateTime']>;
}>;


export type GetWorkOrderCategoryWidgetQuery = { __typename?: 'Query', getWOCategoryWidget: Array<{ __typename?: 'WOCategoryWidget', name: string, count: number }> };

export type GetCoiWidgetQueryVariables = Exact<{
  portfolioId: Scalars['String'];
  propertyId?: InputMaybe<Scalars['String']>;
}>;


export type GetCoiWidgetQuery = { __typename?: 'Query', getCOIWidget: Array<{ __typename?: 'COIWidget', name: CoiWidgetStatusEnum, count: number, percentage: number }> };

export type GetTaskOpenWidgetQueryVariables = Exact<{
  portfolioId: Scalars['String'];
  propertyId?: InputMaybe<Scalars['String']>;
}>;


export type GetTaskOpenWidgetQuery = { __typename?: 'Query', getTaskOpenWidget: { __typename?: 'TaskOpenWidget', count: number } };

export type GetTaskOverdueWidgetQueryVariables = Exact<{
  portfolioId: Scalars['String'];
  propertyId?: InputMaybe<Scalars['String']>;
}>;


export type GetTaskOverdueWidgetQuery = { __typename?: 'Query', getTaskOverdueWidget: { __typename?: 'TaskOverdueWidget', count: number } };

export type WorkOrderFieldsFragment = { __typename?: 'WorkOrderObject', id: string, index: number, description?: string | null, acknowledged?: boolean | null, createdAt: any, closedAt?: any | null, startDate: any, dueDate?: string | null, charges?: number | null, timezone: string, property: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, building: { __typename?: 'BuildingObject', active: boolean, id: string, title: string }, category: { __typename?: 'CategoryObject', id: string, title: string }, status: { __typename?: 'StatusObject', color: string, id: string, title: string }, priority?: { __typename?: 'PriorityObject', color: string, id: string, title: string } | null, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, requestedFor?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, active: boolean, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, assignedTo?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, active: boolean, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, active: boolean, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, createdByGuest?: { __typename?: 'WOGuestUserObject', firstName: string, lastName: string, email: string } | null, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null, watchers?: Array<{ __typename?: 'UserObject', id: string, firstName: string, lastName: string }> | null, review?: { __typename?: 'WOReviewObject', id: string, comment?: string | null, score: number } | null };

export type GetWorkOrdersQueryVariables = Exact<{
  portfolioId: Scalars['String'];
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  statusIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  from?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<Scalars['DateTime']>;
  propertyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  buildingIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  assigneeIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  categoryIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  priorityIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  requestedForIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  closedAtFrom?: InputMaybe<Scalars['DateTime']>;
  closedAtTo?: InputMaybe<Scalars['DateTime']>;
  archived?: ArchiveStatusEnum;
}>;


export type GetWorkOrdersQuery = { __typename?: 'Query', getWorkOrders: { __typename?: 'GetWorkOrdersObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'WorkOrderObject', id: string, index: number, isArchived: boolean, description?: string | null, createdAt: any, closedAt?: any | null, startDate: any, dueDate?: string | null, timezone: string, charges?: number | null, property: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, building: { __typename?: 'BuildingObject', active: boolean, id: string, title: string }, category: { __typename?: 'CategoryObject', id: string, title: string }, status: { __typename?: 'StatusObject', color: string, id: string, title: string }, priority?: { __typename?: 'PriorityObject', color: string, id: string, title: string } | null, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, requestedFor?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, active: boolean, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, assignedTo?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, active: boolean, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, active: boolean, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, createdByGuest?: { __typename?: 'WOGuestUserObject', firstName: string, lastName: string, email: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null, review?: { __typename?: 'WOReviewObject', id: string, comment?: string | null, score: number } | null }> } };

export type GetWorkOrderQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetWorkOrderQuery = { __typename?: 'Query', getWorkOrder: { __typename?: 'WorkOrderObject', id: string, index: number, description?: string | null, acknowledged?: boolean | null, createdAt: any, closedAt?: any | null, startDate: any, dueDate?: string | null, charges?: number | null, timezone: string, property: { __typename?: 'PropertyObject', id: string, title: string, active: boolean, logo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, building: { __typename?: 'BuildingObject', active: boolean, id: string, title: string }, category: { __typename?: 'CategoryObject', id: string, title: string }, status: { __typename?: 'StatusObject', color: string, id: string, title: string }, priority?: { __typename?: 'PriorityObject', color: string, id: string, title: string } | null, company: { __typename?: 'CompanyObject', id: string, title: string, active: boolean, type: CompanyTypeEnum, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, requestedFor?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, active: boolean, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, assignedTo?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, active: boolean, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, createdBy: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, active: boolean, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null }, createdByGuest?: { __typename?: 'WOGuestUserObject', firstName: string, lastName: string, email: string } | null, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null, attachments?: Array<{ __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string }> | null, watchers?: Array<{ __typename?: 'UserObject', id: string, firstName: string, lastName: string }> | null, review?: { __typename?: 'WOReviewObject', id: string, comment?: string | null, score: number } | null } };

export type GetWorkOrderChargesQueryVariables = Exact<{
  workOrderId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetWorkOrderChargesQuery = { __typename?: 'Query', getWorkOrderCharges: Array<{ __typename?: 'ChargeObject', id: string, type: ChargeEnum, date?: string | null, billable: boolean, hours?: number | null, notes?: string | null, price: number, quantity?: number | null, total: number, employeeUser?: { __typename?: 'UserObject', id: string, email: string, firstName: string, lastName: string, active: boolean, phone?: string | null, photo?: { __typename?: 'FileObject', id?: string | null, name: string, size: number, url: string } | null } | null, material?: { __typename?: 'MaterialObject', id: string, title: string } | null }> };

export type GetWorkOrderEquipmentQueryVariables = Exact<{
  workOrderId: Scalars['String'];
  take?: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetWorkOrderEquipmentQuery = { __typename?: 'Query', getWorkOrderEquipment: { __typename?: 'GetEquipmentsObject', pagination: { __typename?: 'CursorPagination', endCursor?: string | null, startCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, totalCount: number }, data: Array<{ __typename?: 'EquipmentModel', index: number, active: boolean, id: string, title: string, category: { __typename?: 'EquipmentCategoryModel', id: string, title: string }, floor?: { __typename?: 'FloorObject', id: string, title: string } | null, suite?: { __typename?: 'SuiteObject', id: string, title: string } | null }> } };

export const FileFieldsFragmentDoc = gql`
    fragment FileFields on FileObject {
  id
  name
  size
  url
}
    `;
export const ActivityLogCoreFieldsFragmentDoc = gql`
    fragment ActivityLogCoreFields on ActivityLogModel {
  id
  activityType
  internal
  author {
    id
    firstName
    lastName
    active
    photo {
      ...FileFields
    }
  }
  changeLog {
    action
    text
  }
  createdAt
}
    ${FileFieldsFragmentDoc}`;
export const ArCodeCoreFieldsFragmentDoc = gql`
    fragment ARCodeCoreFields on ARCodeObject {
  id
  title
}
    `;
export const PropertyCoreFieldsFragmentDoc = gql`
    fragment PropertyCoreFields on PropertyObject {
  id
  title
  active
  logo {
    ...FileFields
  }
}
    ${FileFieldsFragmentDoc}`;
export const ArCodeFieldsFragmentDoc = gql`
    fragment ARCodeFields on ARCodeObject {
  ...ARCodeCoreFields
  property {
    ...PropertyCoreFields
  }
}
    ${ArCodeCoreFieldsFragmentDoc}
${PropertyCoreFieldsFragmentDoc}`;
export const ChargeCodeCoreFieldsFragmentDoc = gql`
    fragment ChargeCodeCoreFields on ChargeCodeObject {
  id
  title
}
    `;
export const ChargeCodeFieldsFragmentDoc = gql`
    fragment ChargeCodeFields on ChargeCodeObject {
  ...ChargeCodeCoreFields
  property {
    ...PropertyCoreFields
  }
}
    ${ChargeCodeCoreFieldsFragmentDoc}
${PropertyCoreFieldsFragmentDoc}`;
export const CoiCoreFieldsFragmentDoc = gql`
    fragment CoiCoreFields on CoiObject {
  id
  title
}
    `;
export const CompanyCoreFieldsFragmentDoc = gql`
    fragment CompanyCoreFields on CompanyObject {
  id
  title
  active
  type
  photo {
    ...FileFields
  }
}
    ${FileFieldsFragmentDoc}`;
export const UserCoreFieldsFragmentDoc = gql`
    fragment UserCoreFields on UserObject {
  id
  email
  firstName
  lastName
  active
  phone
  photo {
    ...FileFields
  }
}
    ${FileFieldsFragmentDoc}`;
export const CoiFieldsFragmentDoc = gql`
    fragment CoiFields on CoiObject {
  ...CoiCoreFields
  property {
    ...PropertyCoreFields
  }
  note
  contactEmails
  status
  expiration
  validFrom
  validTo
  createdAt
  company {
    ...CompanyCoreFields
  }
  createdBy {
    ...UserCoreFields
  }
  attachment {
    ...FileFields
  }
}
    ${CoiCoreFieldsFragmentDoc}
${PropertyCoreFieldsFragmentDoc}
${CompanyCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}
${FileFieldsFragmentDoc}`;
export const AddressFieldsFragmentDoc = gql`
    fragment AddressFields on Address {
  address
  city
  country
  zip
  state
}
    `;
export const CompanyFieldsFragmentDoc = gql`
    fragment CompanyFields on CompanyObject {
  ...CompanyCoreFields
  taxCode
  vendorId
  phone
  address {
    ...AddressFields
  }
}
    ${CompanyCoreFieldsFragmentDoc}
${AddressFieldsFragmentDoc}`;
export const DefaultEmailTemplateFieldsFragmentDoc = gql`
    fragment DefaultEmailTemplateFields on DefaultEmailTemplateObject {
  category
  trigger
  type
  appBody
  smsBody
  emailBody
  subject
  localParams
  globalParams
}
    `;
export const EmailTemplateFieldsFragmentDoc = gql`
    fragment EmailTemplateFields on EmailTemplateObject {
  category
  trigger
  type
  appActive
  smsActive
  emailActive
  appBody
  smsBody
  emailBody
  subject
  bcc
  cc
  localParams
  globalParams
  custom
}
    `;
export const GlAccountCoreFieldsFragmentDoc = gql`
    fragment GLAccountCoreFields on GLAccountObject {
  id
  title
}
    `;
export const GlAccountFieldsFragmentDoc = gql`
    fragment GLAccountFields on GLAccountObject {
  ...GLAccountCoreFields
  property {
    ...PropertyCoreFields
  }
}
    ${GlAccountCoreFieldsFragmentDoc}
${PropertyCoreFieldsFragmentDoc}`;
export const CategoryGroupCoreFieldsFragmentDoc = gql`
    fragment CategoryGroupCoreFields on CategoryGroupObject {
  id
  title
}
    `;
export const CategoryGroupFieldsFragmentDoc = gql`
    fragment CategoryGroupFields on CategoryGroupObject {
  ...CategoryGroupCoreFields
  icon
  property {
    ...PropertyCoreFields
  }
}
    ${CategoryGroupCoreFieldsFragmentDoc}
${PropertyCoreFieldsFragmentDoc}`;
export const CategoryCoreFieldsFragmentDoc = gql`
    fragment CategoryCoreFields on CategoryObject {
  id
  title
}
    `;
export const PriorityCoreFieldsFragmentDoc = gql`
    fragment PriorityCoreFields on PriorityObject {
  id
  title
}
    `;
export const CategoryFieldsFragmentDoc = gql`
    fragment CategoryFields on CategoryObject {
  ...CategoryCoreFields
  description
  defaultPriority {
    ...PriorityCoreFields
    color
  }
  group {
    ...CategoryGroupCoreFields
  }
  property {
    ...PropertyCoreFields
  }
}
    ${CategoryCoreFieldsFragmentDoc}
${PriorityCoreFieldsFragmentDoc}
${CategoryGroupCoreFieldsFragmentDoc}
${PropertyCoreFieldsFragmentDoc}`;
export const LaborRateCoreFieldsFragmentDoc = gql`
    fragment LaborRateCoreFields on LaborRateObject {
  id
  title
}
    `;
export const MarkupCoreFieldsFragmentDoc = gql`
    fragment MarkupCoreFields on MarkupObject {
  id
  title
}
    `;
export const LaborRateFieldsFragmentDoc = gql`
    fragment LaborRateFields on LaborRateObject {
  ...LaborRateCoreFields
  rate
  description
  markup {
    ...MarkupCoreFields
  }
  property {
    ...PropertyCoreFields
  }
  glAccount {
    ...GLAccountCoreFields
  }
  arCode {
    ...ARCodeCoreFields
  }
  chargeCode {
    ...ChargeCodeCoreFields
  }
}
    ${LaborRateCoreFieldsFragmentDoc}
${MarkupCoreFieldsFragmentDoc}
${PropertyCoreFieldsFragmentDoc}
${GlAccountCoreFieldsFragmentDoc}
${ArCodeCoreFieldsFragmentDoc}
${ChargeCodeCoreFieldsFragmentDoc}`;
export const LeaseChargeTypeCoreFieldsFragmentDoc = gql`
    fragment LeaseChargeTypeCoreFields on LeaseChargeTypeObject {
  id
  title
}
    `;
export const LeaseChargeTypeFieldsFragmentDoc = gql`
    fragment LeaseChargeTypeFields on LeaseChargeTypeObject {
  ...LeaseChargeTypeCoreFields
  property {
    ...PropertyCoreFields
  }
}
    ${LeaseChargeTypeCoreFieldsFragmentDoc}
${PropertyCoreFieldsFragmentDoc}`;
export const MarkupFieldsFragmentDoc = gql`
    fragment MarkupFields on MarkupObject {
  ...MarkupCoreFields
  type
  amount
  description
  property {
    ...PropertyCoreFields
  }
  glAccount {
    ...GLAccountCoreFields
  }
  arCode {
    ...ARCodeCoreFields
  }
  chargeCode {
    ...ChargeCodeCoreFields
  }
}
    ${MarkupCoreFieldsFragmentDoc}
${PropertyCoreFieldsFragmentDoc}
${GlAccountCoreFieldsFragmentDoc}
${ArCodeCoreFieldsFragmentDoc}
${ChargeCodeCoreFieldsFragmentDoc}`;
export const MaterialGroupCoreFieldsFragmentDoc = gql`
    fragment MaterialGroupCoreFields on MaterialGroupObject {
  id
  title
}
    `;
export const MaterialCoreFieldsFragmentDoc = gql`
    fragment MaterialCoreFields on MaterialObject {
  id
  title
}
    `;
export const PaginationFieldsFragmentDoc = gql`
    fragment PaginationFields on CursorPagination {
  endCursor
  startCursor
  hasNextPage
  hasPreviousPage
  totalCount
}
    `;
export const PortfolioCoreFieldsFragmentDoc = gql`
    fragment PortfolioCoreFields on PortfolioModel {
  id
  title
  active
  url
  logo {
    ...FileFields
  }
}
    ${FileFieldsFragmentDoc}`;
export const TranslationCoreFieldsFragmentDoc = gql`
    fragment TranslationCoreFields on TranslationObject {
  id
  title
}
    `;
export const PortfolioFieldsFragmentDoc = gql`
    fragment PortfolioFields on PortfolioModel {
  ...PortfolioCoreFields
  translation {
    ...TranslationCoreFields
  }
  background {
    ...FileFields
  }
  stripeSettings {
    paymentACHFee
    paymentACHUnit
    paymentACHCap
    paymentCardFee
    paymentCardUnit
  }
}
    ${PortfolioCoreFieldsFragmentDoc}
${TranslationCoreFieldsFragmentDoc}
${FileFieldsFragmentDoc}`;
export const EquipmentCategoryCoreFieldsFragmentDoc = gql`
    fragment EquipmentCategoryCoreFields on EquipmentCategoryModel {
  id
  title
}
    `;
export const EquipmentCoreFieldsFragmentDoc = gql`
    fragment EquipmentCoreFields on EquipmentModel {
  id
  title
}
    `;
export const PriorityFieldsFragmentDoc = gql`
    fragment PriorityFields on PriorityObject {
  ...PriorityCoreFields
  color
  property {
    ...PropertyCoreFields
  }
}
    ${PriorityCoreFieldsFragmentDoc}
${PropertyCoreFieldsFragmentDoc}`;
export const PropertyFieldsFragmentDoc = gql`
    fragment PropertyFields on PropertyObject {
  ...PropertyCoreFields
  timezone
  bgImg {
    ...FileFields
  }
  favicon {
    ...FileFields
  }
  primaryColor
}
    ${PropertyCoreFieldsFragmentDoc}
${FileFieldsFragmentDoc}`;
export const RoleCoreFieldsFragmentDoc = gql`
    fragment RoleCoreFields on RoleObject {
  id
  title
}
    `;
export const AllRolePermissionsFragmentDoc = gql`
    fragment AllRolePermissions on PermissionsObject {
  viewPropertyNewsFeedPost
  addNewsFeedPost
  editOtherUsersNewsFeedPost
  deleteOtherUsersNewsFeedPost
  addNewsFeedPostComment
  deleteOtherUsersNewsFeedComment
  addEventPost
  editOtherUsersEventPost
  deleteOtherUsersEventPost
  viewMyGuest
  viewCompanyGuest
  addMyGuest
  addCompanyGuest
  approveGuest
  updateMyGuest
  updateCompanyGuest
  checkInGuest
  printBadgeGuest
  viewMyVendorAccess
  viewCompanyVendorAccess
  addMyVendorAccess
  addCompanyVendorAccess
  approveVendorAccess
  updateMyVendorAccess
  updateCompanyVendorAccess
  checkInVendorAccess
  printBadgeVendorAccess
  viewMyWatchList
  viewCompanyWatchList
  addMyWatchList
  addCompanyWatchList
  updateMyWatchList
  updateCompanyWatchList
  deactivateMyWatchList
  deactivateCompanyWatchList
  deleteMyWatchList
  deleteCompanyWatchList
  viewMyRoomReservation
  viewCompanyRoomReservation
  addMyRoomReservation
  addCompanyRoomReservation
  updateMyRoomReservation
  updateCompanyRoomReservation
  manageCompanyRoomReservation
  viewMyIncident
  viewCompanyIncident
  addMyIncident
  addCompanyIncident
  updateMyIncident
  updateCompanyIncident
  deleteMyIncident
  deleteCompanyIncident
  viewMyWorkOrder
  viewCompanyWorkOrder
  addMyWorkOrder
  addCompanyWorkOrder
  updateMyWorkOrder
  updateCompanyWorkOrder
  updateWorkOrderStatus
  updateWorkOrderAssignee
  updateWorkOrderPriority
  canCloseWorkOrder
  deleteMyWorkOrder
  deleteCompanyWorkOrder
  viewWOCharges
  manageWOCharges
  canCloseWorkOrder
  viewMyWorkOrderTemplate
  viewCompanyWorkOrderTemplate
  addMyWorkOrderTemplate
  addCompanyWorkOrderTemplate
  updateMyWorkOrderTemplate
  updateCompanyWorkOrderTemplate
  updateWorkOrderAssigneeTemplate
  updateWorkOrderPriorityTemplate
  deleteMyWorkOrderTemplate
  deleteCompanyWorkOrderTemplate
  viewWOTCharges
  manageWOTCharges
  viewUser
  viewCompanyFullAccessUsers
  addUser
  updateUser
  deleteUser
  controlUserWallet
  viewCompanyPage
  addCompany
  updateCompany
  deleteCompany
  viewMySubscriptions
  viewCompanySubscriptions
  addCompanySubscriptions
  updateCompanySubscriptions
  cancelCompanySubscriptions
  refundSubscriptionCharges
  viewMessages
  addMessage
  viewGeneaCards
  updateGeneaCards
  viewGeneaDoors
  toggleGeneaDoor
  viewConciergeHub
  manageConciergeHub
  viewReports
  viewCoi
  addCoi
  updateCoi
  deleteCoi
  updateCoiStatus
  viewPreventiveMaintenance
  managePreventiveMaintenance
  viewMyTasks
  viewAllTasks
  manageMyTasks
  manageAllTasks
  viewTaskCharges
  manageTaskCharges
  viewLease
  manageLease
  viewAnalytics
  viewStackingPlan
  offlinePayments
  creditCardPayments
  propertyAdmin
  viewInternalNotes
  addInternalNotes
  viewFileManager
  manageFileManager
  accessFileManagerPrivate
  viewInvoices
  manageInvoices
  viewRecurringInvoices
  manageRecurringInvoices
  viewPackage
  managePackage
}
    `;
export const RoleFieldsFragmentDoc = gql`
    fragment RoleFields on RoleObject {
  ...RoleCoreFields
  description
  permissions {
    ...AllRolePermissions
  }
  rolesAssignable {
    ...RoleCoreFields
  }
}
    ${RoleCoreFieldsFragmentDoc}
${AllRolePermissionsFragmentDoc}`;
export const StatusCoreFieldsFragmentDoc = gql`
    fragment StatusCoreFields on StatusObject {
  id
  title
}
    `;
export const StatusFieldsFragmentDoc = gql`
    fragment StatusFields on StatusObject {
  ...StatusCoreFields
  color
  property {
    ...PropertyCoreFields
  }
}
    ${StatusCoreFieldsFragmentDoc}
${PropertyCoreFieldsFragmentDoc}`;
export const WorkOrdersStatusSettingsFieldsFragmentDoc = gql`
    fragment WorkOrdersStatusSettingsFields on WorkOrderStatusSettingObject {
  acknowledge {
    ...StatusCoreFields
    color
  }
  closed {
    ...StatusCoreFields
    color
  }
  default {
    ...StatusCoreFields
    color
  }
  rating {
    ...StatusCoreFields
    color
  }
}
    ${StatusCoreFieldsFragmentDoc}`;
export const IncidentsStatusSettingsFieldsFragmentDoc = gql`
    fragment IncidentsStatusSettingsFields on IncidentStatusSettingObject {
  default {
    ...StatusCoreFields
    color
  }
}
    ${StatusCoreFieldsFragmentDoc}`;
export const TaxCoreFieldsFragmentDoc = gql`
    fragment TaxCoreFields on TaxObject {
  id
  title
}
    `;
export const TaxFieldsFragmentDoc = gql`
    fragment TaxFields on TaxObject {
  ...TaxCoreFields
  amount
  property {
    ...PropertyCoreFields
  }
  glAccount {
    ...GLAccountCoreFields
  }
  arCode {
    ...ARCodeCoreFields
  }
  chargeCode {
    ...ChargeCodeCoreFields
  }
}
    ${TaxCoreFieldsFragmentDoc}
${PropertyCoreFieldsFragmentDoc}
${GlAccountCoreFieldsFragmentDoc}
${ArCodeCoreFieldsFragmentDoc}
${ChargeCodeCoreFieldsFragmentDoc}`;
export const GlobalTranslationCoreFieldsFragmentDoc = gql`
    fragment GlobalTranslationCoreFields on GlobalTranslationObject {
  id
  title
}
    `;
export const GlobalUserFieldsFragmentDoc = gql`
    fragment GlobalUserFields on GlobalUserObject {
  id
  firstName
  lastName
  email
  title
  phone
  photo {
    ...FileFields
  }
  portfolios {
    ...PortfolioCoreFields
  }
  addPortfolio
  controlGlobalUsers
  globalEmailAccess
  viewPortfolioSettings
  viewPortfolioDashboard
  viewPortfolioWorkOrders
  viewPortfolioCOIs
  createdAt
}
    ${FileFieldsFragmentDoc}
${PortfolioCoreFieldsFragmentDoc}`;
export const UserFieldsFragmentDoc = gql`
    fragment UserFields on UserObject {
  ...UserCoreFields
  lastLoginAt
}
    ${UserCoreFieldsFragmentDoc}`;
export const BuildingCoreFieldsFragmentDoc = gql`
    fragment BuildingCoreFields on BuildingObject {
  id
  title
}
    `;
export const FloorCoreFieldsFragmentDoc = gql`
    fragment FloorCoreFields on FloorObject {
  id
  title
}
    `;
export const SuiteCoreFieldsFragmentDoc = gql`
    fragment SuiteCoreFields on SuiteObject {
  id
  title
}
    `;
export const WorkOrderFieldsFragmentDoc = gql`
    fragment WorkOrderFields on WorkOrderObject {
  id
  index
  property {
    ...PropertyCoreFields
  }
  building {
    ...BuildingCoreFields
    active
  }
  category {
    ...CategoryCoreFields
  }
  status {
    ...StatusCoreFields
    color
  }
  priority {
    ...PriorityCoreFields
    color
  }
  company {
    ...CompanyCoreFields
  }
  requestedFor {
    ...UserCoreFields
  }
  assignedTo {
    ...UserCoreFields
  }
  createdBy {
    ...UserCoreFields
  }
  createdByGuest {
    firstName
    lastName
    email
  }
  floor {
    ...FloorCoreFields
  }
  suite {
    ...SuiteCoreFields
  }
  description
  acknowledged
  createdAt
  closedAt
  startDate
  dueDate
  charges
  timezone
  attachments {
    ...FileFields
  }
  watchers {
    id
    firstName
    lastName
  }
  review {
    id
    comment
    score
  }
}
    ${PropertyCoreFieldsFragmentDoc}
${BuildingCoreFieldsFragmentDoc}
${CategoryCoreFieldsFragmentDoc}
${StatusCoreFieldsFragmentDoc}
${PriorityCoreFieldsFragmentDoc}
${CompanyCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}
${FloorCoreFieldsFragmentDoc}
${SuiteCoreFieldsFragmentDoc}
${FileFieldsFragmentDoc}`;
export const GetActivityLogDocument = gql`
    query getActivityLog($activityType: ActivityTypeEnum, $referType: ReferToType, $portfolioId: String!, $propertyIds: [String!], $take: Int! = 10, $after: String, $before: String, $search: String, $userIds: [String!], $from: DateTime, $to: DateTime, $sortBy: SortActivityFieldEnum! = CREATION, $sortByDir: SortDirectionEnum! = DESC) {
  getActivityLog(
    activityType: $activityType
    referType: $referType
    propertyIds: $propertyIds
    portfolioId: $portfolioId
    take: $take
    after: $after
    before: $before
    search: $search
    userIds: $userIds
    from: $from
    to: $to
    sortBy: $sortBy
    sortByDir: $sortByDir
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      ...ActivityLogCoreFields
      property {
        ...PropertyCoreFields
      }
      referToRecord {
        id
        index
        title
        type
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${ActivityLogCoreFieldsFragmentDoc}
${PropertyCoreFieldsFragmentDoc}`;

/**
 * __useGetActivityLogQuery__
 *
 * To run a query within a React component, call `useGetActivityLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityLogQuery({
 *   variables: {
 *      activityType: // value for 'activityType'
 *      referType: // value for 'referType'
 *      portfolioId: // value for 'portfolioId'
 *      propertyIds: // value for 'propertyIds'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      userIds: // value for 'userIds'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      sortBy: // value for 'sortBy'
 *      sortByDir: // value for 'sortByDir'
 *   },
 * });
 */
export function useGetActivityLogQuery(baseOptions: Apollo.QueryHookOptions<GetActivityLogQuery, GetActivityLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivityLogQuery, GetActivityLogQueryVariables>(GetActivityLogDocument, options);
      }
export function useGetActivityLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivityLogQuery, GetActivityLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivityLogQuery, GetActivityLogQueryVariables>(GetActivityLogDocument, options);
        }
export type GetActivityLogQueryHookResult = ReturnType<typeof useGetActivityLogQuery>;
export type GetActivityLogLazyQueryHookResult = ReturnType<typeof useGetActivityLogLazyQuery>;
export type GetActivityLogQueryResult = Apollo.QueryResult<GetActivityLogQuery, GetActivityLogQueryVariables>;
export const GetRecordActivityLogDocument = gql`
    query getRecordActivityLog($activityType: ActivityTypeEnum, $recordId: String!, $referType: ReferToType!, $take: Int! = 10, $after: String, $before: String, $sortBy: SortActivityFieldEnum! = CREATION, $sortByDir: SortDirectionEnum! = DESC) {
  getRecordActivityLog(
    activityType: $activityType
    recordId: $recordId
    referType: $referType
    take: $take
    after: $after
    before: $before
    sortBy: $sortBy
    sortByDir: $sortByDir
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      ...ActivityLogCoreFields
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${ActivityLogCoreFieldsFragmentDoc}`;

/**
 * __useGetRecordActivityLogQuery__
 *
 * To run a query within a React component, call `useGetRecordActivityLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecordActivityLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecordActivityLogQuery({
 *   variables: {
 *      activityType: // value for 'activityType'
 *      recordId: // value for 'recordId'
 *      referType: // value for 'referType'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      sortBy: // value for 'sortBy'
 *      sortByDir: // value for 'sortByDir'
 *   },
 * });
 */
export function useGetRecordActivityLogQuery(baseOptions: Apollo.QueryHookOptions<GetRecordActivityLogQuery, GetRecordActivityLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecordActivityLogQuery, GetRecordActivityLogQueryVariables>(GetRecordActivityLogDocument, options);
      }
export function useGetRecordActivityLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecordActivityLogQuery, GetRecordActivityLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecordActivityLogQuery, GetRecordActivityLogQueryVariables>(GetRecordActivityLogDocument, options);
        }
export type GetRecordActivityLogQueryHookResult = ReturnType<typeof useGetRecordActivityLogQuery>;
export type GetRecordActivityLogLazyQueryHookResult = ReturnType<typeof useGetRecordActivityLogLazyQuery>;
export type GetRecordActivityLogQueryResult = Apollo.QueryResult<GetRecordActivityLogQuery, GetRecordActivityLogQueryVariables>;
export const CreateArCodeDocument = gql`
    mutation createARCode($title: String!, $portfolioId: String!) {
  createARCode(title: $title, portfolioId: $portfolioId) {
    id
  }
}
    `;
export type CreateArCodeMutationFn = Apollo.MutationFunction<CreateArCodeMutation, CreateArCodeMutationVariables>;

/**
 * __useCreateArCodeMutation__
 *
 * To run a mutation, you first call `useCreateArCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateArCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createArCodeMutation, { data, loading, error }] = useCreateArCodeMutation({
 *   variables: {
 *      title: // value for 'title'
 *      portfolioId: // value for 'portfolioId'
 *   },
 * });
 */
export function useCreateArCodeMutation(baseOptions?: Apollo.MutationHookOptions<CreateArCodeMutation, CreateArCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateArCodeMutation, CreateArCodeMutationVariables>(CreateArCodeDocument, options);
      }
export type CreateArCodeMutationHookResult = ReturnType<typeof useCreateArCodeMutation>;
export type CreateArCodeMutationResult = Apollo.MutationResult<CreateArCodeMutation>;
export type CreateArCodeMutationOptions = Apollo.BaseMutationOptions<CreateArCodeMutation, CreateArCodeMutationVariables>;
export const UpdateArCodeDocument = gql`
    mutation updateARCode($id: String!, $title: String!) {
  updateARCode(id: $id, title: $title) {
    ...ARCodeFields
  }
}
    ${ArCodeFieldsFragmentDoc}`;
export type UpdateArCodeMutationFn = Apollo.MutationFunction<UpdateArCodeMutation, UpdateArCodeMutationVariables>;

/**
 * __useUpdateArCodeMutation__
 *
 * To run a mutation, you first call `useUpdateArCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateArCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateArCodeMutation, { data, loading, error }] = useUpdateArCodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useUpdateArCodeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateArCodeMutation, UpdateArCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateArCodeMutation, UpdateArCodeMutationVariables>(UpdateArCodeDocument, options);
      }
export type UpdateArCodeMutationHookResult = ReturnType<typeof useUpdateArCodeMutation>;
export type UpdateArCodeMutationResult = Apollo.MutationResult<UpdateArCodeMutation>;
export type UpdateArCodeMutationOptions = Apollo.BaseMutationOptions<UpdateArCodeMutation, UpdateArCodeMutationVariables>;
export const ToggleArCodeDocument = gql`
    mutation toggleARCode($id: String!) {
  toggleARCode(id: $id)
}
    `;
export type ToggleArCodeMutationFn = Apollo.MutationFunction<ToggleArCodeMutation, ToggleArCodeMutationVariables>;

/**
 * __useToggleArCodeMutation__
 *
 * To run a mutation, you first call `useToggleArCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleArCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleArCodeMutation, { data, loading, error }] = useToggleArCodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleArCodeMutation(baseOptions?: Apollo.MutationHookOptions<ToggleArCodeMutation, ToggleArCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleArCodeMutation, ToggleArCodeMutationVariables>(ToggleArCodeDocument, options);
      }
export type ToggleArCodeMutationHookResult = ReturnType<typeof useToggleArCodeMutation>;
export type ToggleArCodeMutationResult = Apollo.MutationResult<ToggleArCodeMutation>;
export type ToggleArCodeMutationOptions = Apollo.BaseMutationOptions<ToggleArCodeMutation, ToggleArCodeMutationVariables>;
export const RemoveArCodesDocument = gql`
    mutation removeARCodes($data: DeleteRecordsInput!) {
  removeARCodes(input: $data)
}
    `;
export type RemoveArCodesMutationFn = Apollo.MutationFunction<RemoveArCodesMutation, RemoveArCodesMutationVariables>;

/**
 * __useRemoveArCodesMutation__
 *
 * To run a mutation, you first call `useRemoveArCodesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveArCodesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeArCodesMutation, { data, loading, error }] = useRemoveArCodesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveArCodesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveArCodesMutation, RemoveArCodesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveArCodesMutation, RemoveArCodesMutationVariables>(RemoveArCodesDocument, options);
      }
export type RemoveArCodesMutationHookResult = ReturnType<typeof useRemoveArCodesMutation>;
export type RemoveArCodesMutationResult = Apollo.MutationResult<RemoveArCodesMutation>;
export type RemoveArCodesMutationOptions = Apollo.BaseMutationOptions<RemoveArCodesMutation, RemoveArCodesMutationVariables>;
export const GetArCodesTableDocument = gql`
    query getARCodesTable($portfolioId: String!, $active: Boolean, $search: String, $recordLevel: RecordLevel, $propertyIds: [String!]) {
  getARCodes(
    active: $active
    portfolioId: $portfolioId
    search: $search
    recordLevel: $recordLevel
    propertyIds: $propertyIds
  ) {
    ...ARCodeCoreFields
    index
    active
    property {
      ...PropertyCoreFields
    }
  }
}
    ${ArCodeCoreFieldsFragmentDoc}
${PropertyCoreFieldsFragmentDoc}`;

/**
 * __useGetArCodesTableQuery__
 *
 * To run a query within a React component, call `useGetArCodesTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArCodesTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArCodesTableQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      active: // value for 'active'
 *      search: // value for 'search'
 *      recordLevel: // value for 'recordLevel'
 *      propertyIds: // value for 'propertyIds'
 *   },
 * });
 */
export function useGetArCodesTableQuery(baseOptions: Apollo.QueryHookOptions<GetArCodesTableQuery, GetArCodesTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArCodesTableQuery, GetArCodesTableQueryVariables>(GetArCodesTableDocument, options);
      }
export function useGetArCodesTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArCodesTableQuery, GetArCodesTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArCodesTableQuery, GetArCodesTableQueryVariables>(GetArCodesTableDocument, options);
        }
export type GetArCodesTableQueryHookResult = ReturnType<typeof useGetArCodesTableQuery>;
export type GetArCodesTableLazyQueryHookResult = ReturnType<typeof useGetArCodesTableLazyQuery>;
export type GetArCodesTableQueryResult = Apollo.QueryResult<GetArCodesTableQuery, GetArCodesTableQueryVariables>;
export const GetArCodesDropdownDocument = gql`
    query getARCodesDropdown($portfolioId: String!, $active: Boolean, $search: String, $recordLevel: RecordLevel, $propertyIds: [String!]) {
  getARCodes(
    active: $active
    portfolioId: $portfolioId
    search: $search
    recordLevel: $recordLevel
    propertyIds: $propertyIds
  ) {
    ...ARCodeCoreFields
    active
  }
}
    ${ArCodeCoreFieldsFragmentDoc}`;

/**
 * __useGetArCodesDropdownQuery__
 *
 * To run a query within a React component, call `useGetArCodesDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArCodesDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArCodesDropdownQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      active: // value for 'active'
 *      search: // value for 'search'
 *      recordLevel: // value for 'recordLevel'
 *      propertyIds: // value for 'propertyIds'
 *   },
 * });
 */
export function useGetArCodesDropdownQuery(baseOptions: Apollo.QueryHookOptions<GetArCodesDropdownQuery, GetArCodesDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArCodesDropdownQuery, GetArCodesDropdownQueryVariables>(GetArCodesDropdownDocument, options);
      }
export function useGetArCodesDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArCodesDropdownQuery, GetArCodesDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArCodesDropdownQuery, GetArCodesDropdownQueryVariables>(GetArCodesDropdownDocument, options);
        }
export type GetArCodesDropdownQueryHookResult = ReturnType<typeof useGetArCodesDropdownQuery>;
export type GetArCodesDropdownLazyQueryHookResult = ReturnType<typeof useGetArCodesDropdownLazyQuery>;
export type GetArCodesDropdownQueryResult = Apollo.QueryResult<GetArCodesDropdownQuery, GetArCodesDropdownQueryVariables>;
export const GetArCodeDocument = gql`
    query getARCode($id: String!) {
  getARCode(id: $id) {
    ...ARCodeFields
  }
}
    ${ArCodeFieldsFragmentDoc}`;

/**
 * __useGetArCodeQuery__
 *
 * To run a query within a React component, call `useGetArCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArCodeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetArCodeQuery(baseOptions: Apollo.QueryHookOptions<GetArCodeQuery, GetArCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArCodeQuery, GetArCodeQueryVariables>(GetArCodeDocument, options);
      }
export function useGetArCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArCodeQuery, GetArCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArCodeQuery, GetArCodeQueryVariables>(GetArCodeDocument, options);
        }
export type GetArCodeQueryHookResult = ReturnType<typeof useGetArCodeQuery>;
export type GetArCodeLazyQueryHookResult = ReturnType<typeof useGetArCodeLazyQuery>;
export type GetArCodeQueryResult = Apollo.QueryResult<GetArCodeQuery, GetArCodeQueryVariables>;
export const LoginDocument = gql`
    mutation Login($data: LoginInput!) {
  login(input: $data) {
    token
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const SendMagicLoginDocument = gql`
    mutation SendMagicLogin($email: String!) {
  magicLogin(email: $email)
}
    `;
export type SendMagicLoginMutationFn = Apollo.MutationFunction<SendMagicLoginMutation, SendMagicLoginMutationVariables>;

/**
 * __useSendMagicLoginMutation__
 *
 * To run a mutation, you first call `useSendMagicLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMagicLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMagicLoginMutation, { data, loading, error }] = useSendMagicLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendMagicLoginMutation(baseOptions?: Apollo.MutationHookOptions<SendMagicLoginMutation, SendMagicLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendMagicLoginMutation, SendMagicLoginMutationVariables>(SendMagicLoginDocument, options);
      }
export type SendMagicLoginMutationHookResult = ReturnType<typeof useSendMagicLoginMutation>;
export type SendMagicLoginMutationResult = Apollo.MutationResult<SendMagicLoginMutation>;
export type SendMagicLoginMutationOptions = Apollo.BaseMutationOptions<SendMagicLoginMutation, SendMagicLoginMutationVariables>;
export const SendForgottenPasswordDocument = gql`
    mutation SendForgottenPassword($email: String!) {
  forgotPassword(email: $email)
}
    `;
export type SendForgottenPasswordMutationFn = Apollo.MutationFunction<SendForgottenPasswordMutation, SendForgottenPasswordMutationVariables>;

/**
 * __useSendForgottenPasswordMutation__
 *
 * To run a mutation, you first call `useSendForgottenPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendForgottenPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendForgottenPasswordMutation, { data, loading, error }] = useSendForgottenPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendForgottenPasswordMutation(baseOptions?: Apollo.MutationHookOptions<SendForgottenPasswordMutation, SendForgottenPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendForgottenPasswordMutation, SendForgottenPasswordMutationVariables>(SendForgottenPasswordDocument, options);
      }
export type SendForgottenPasswordMutationHookResult = ReturnType<typeof useSendForgottenPasswordMutation>;
export type SendForgottenPasswordMutationResult = Apollo.MutationResult<SendForgottenPasswordMutation>;
export type SendForgottenPasswordMutationOptions = Apollo.BaseMutationOptions<SendForgottenPasswordMutation, SendForgottenPasswordMutationVariables>;
export const SendResetPasswordDocument = gql`
    mutation SendResetPassword($data: ResetPasswordInput!) {
  resetPassword(input: $data)
}
    `;
export type SendResetPasswordMutationFn = Apollo.MutationFunction<SendResetPasswordMutation, SendResetPasswordMutationVariables>;

/**
 * __useSendResetPasswordMutation__
 *
 * To run a mutation, you first call `useSendResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendResetPasswordMutation, { data, loading, error }] = useSendResetPasswordMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSendResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<SendResetPasswordMutation, SendResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendResetPasswordMutation, SendResetPasswordMutationVariables>(SendResetPasswordDocument, options);
      }
export type SendResetPasswordMutationHookResult = ReturnType<typeof useSendResetPasswordMutation>;
export type SendResetPasswordMutationResult = Apollo.MutationResult<SendResetPasswordMutation>;
export type SendResetPasswordMutationOptions = Apollo.BaseMutationOptions<SendResetPasswordMutation, SendResetPasswordMutationVariables>;
export const CreateBuildingDocument = gql`
    mutation createBuilding($data: BuildingInput!) {
  createBuilding(input: $data) {
    id
  }
}
    `;
export type CreateBuildingMutationFn = Apollo.MutationFunction<CreateBuildingMutation, CreateBuildingMutationVariables>;

/**
 * __useCreateBuildingMutation__
 *
 * To run a mutation, you first call `useCreateBuildingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBuildingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBuildingMutation, { data, loading, error }] = useCreateBuildingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateBuildingMutation(baseOptions?: Apollo.MutationHookOptions<CreateBuildingMutation, CreateBuildingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBuildingMutation, CreateBuildingMutationVariables>(CreateBuildingDocument, options);
      }
export type CreateBuildingMutationHookResult = ReturnType<typeof useCreateBuildingMutation>;
export type CreateBuildingMutationResult = Apollo.MutationResult<CreateBuildingMutation>;
export type CreateBuildingMutationOptions = Apollo.BaseMutationOptions<CreateBuildingMutation, CreateBuildingMutationVariables>;
export const UpdateBuildingDocument = gql`
    mutation updateBuilding($id: String!, $title: String!) {
  updateBuilding(id: $id, title: $title) {
    ...BuildingCoreFields
  }
}
    ${BuildingCoreFieldsFragmentDoc}`;
export type UpdateBuildingMutationFn = Apollo.MutationFunction<UpdateBuildingMutation, UpdateBuildingMutationVariables>;

/**
 * __useUpdateBuildingMutation__
 *
 * To run a mutation, you first call `useUpdateBuildingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBuildingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBuildingMutation, { data, loading, error }] = useUpdateBuildingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useUpdateBuildingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBuildingMutation, UpdateBuildingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBuildingMutation, UpdateBuildingMutationVariables>(UpdateBuildingDocument, options);
      }
export type UpdateBuildingMutationHookResult = ReturnType<typeof useUpdateBuildingMutation>;
export type UpdateBuildingMutationResult = Apollo.MutationResult<UpdateBuildingMutation>;
export type UpdateBuildingMutationOptions = Apollo.BaseMutationOptions<UpdateBuildingMutation, UpdateBuildingMutationVariables>;
export const ToggleBuildingDocument = gql`
    mutation toggleBuilding($id: String!) {
  toggleBuilding(id: $id)
}
    `;
export type ToggleBuildingMutationFn = Apollo.MutationFunction<ToggleBuildingMutation, ToggleBuildingMutationVariables>;

/**
 * __useToggleBuildingMutation__
 *
 * To run a mutation, you first call `useToggleBuildingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleBuildingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleBuildingMutation, { data, loading, error }] = useToggleBuildingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleBuildingMutation(baseOptions?: Apollo.MutationHookOptions<ToggleBuildingMutation, ToggleBuildingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleBuildingMutation, ToggleBuildingMutationVariables>(ToggleBuildingDocument, options);
      }
export type ToggleBuildingMutationHookResult = ReturnType<typeof useToggleBuildingMutation>;
export type ToggleBuildingMutationResult = Apollo.MutationResult<ToggleBuildingMutation>;
export type ToggleBuildingMutationOptions = Apollo.BaseMutationOptions<ToggleBuildingMutation, ToggleBuildingMutationVariables>;
export const RemoveBuildingsDocument = gql`
    mutation removeBuildings($data: DeleteRecordsInput!) {
  removeBuildings(input: $data)
}
    `;
export type RemoveBuildingsMutationFn = Apollo.MutationFunction<RemoveBuildingsMutation, RemoveBuildingsMutationVariables>;

/**
 * __useRemoveBuildingsMutation__
 *
 * To run a mutation, you first call `useRemoveBuildingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveBuildingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeBuildingsMutation, { data, loading, error }] = useRemoveBuildingsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveBuildingsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveBuildingsMutation, RemoveBuildingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveBuildingsMutation, RemoveBuildingsMutationVariables>(RemoveBuildingsDocument, options);
      }
export type RemoveBuildingsMutationHookResult = ReturnType<typeof useRemoveBuildingsMutation>;
export type RemoveBuildingsMutationResult = Apollo.MutationResult<RemoveBuildingsMutation>;
export type RemoveBuildingsMutationOptions = Apollo.BaseMutationOptions<RemoveBuildingsMutation, RemoveBuildingsMutationVariables>;
export const GetBuildingsTableDocument = gql`
    query getBuildingsTable($portfolioId: String!, $propertyIds: [String!], $take: Int! = 10, $after: String, $before: String, $search: String, $active: Boolean, $sortBy: SortBuildingFieldEnum! = CREATION, $sortByDir: SortDirectionEnum! = DESC) {
  getBuildings(
    portfolioId: $portfolioId
    propertyIds: $propertyIds
    take: $take
    after: $after
    before: $before
    search: $search
    active: $active
    sortBy: $sortBy
    sortByDir: $sortByDir
  ) @connection(key: "getBuildingsTable") {
    pagination {
      ...PaginationFields
    }
    data {
      ...BuildingCoreFields
      index
      active
      userCount
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${BuildingCoreFieldsFragmentDoc}`;

/**
 * __useGetBuildingsTableQuery__
 *
 * To run a query within a React component, call `useGetBuildingsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBuildingsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBuildingsTableQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      propertyIds: // value for 'propertyIds'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      active: // value for 'active'
 *      sortBy: // value for 'sortBy'
 *      sortByDir: // value for 'sortByDir'
 *   },
 * });
 */
export function useGetBuildingsTableQuery(baseOptions: Apollo.QueryHookOptions<GetBuildingsTableQuery, GetBuildingsTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBuildingsTableQuery, GetBuildingsTableQueryVariables>(GetBuildingsTableDocument, options);
      }
export function useGetBuildingsTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBuildingsTableQuery, GetBuildingsTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBuildingsTableQuery, GetBuildingsTableQueryVariables>(GetBuildingsTableDocument, options);
        }
export type GetBuildingsTableQueryHookResult = ReturnType<typeof useGetBuildingsTableQuery>;
export type GetBuildingsTableLazyQueryHookResult = ReturnType<typeof useGetBuildingsTableLazyQuery>;
export type GetBuildingsTableQueryResult = Apollo.QueryResult<GetBuildingsTableQuery, GetBuildingsTableQueryVariables>;
export const GetBuildingsDropdownDocument = gql`
    query getBuildingsDropdown($portfolioId: String!, $propertyIds: [String!], $take: Int! = 10, $after: String, $before: String, $search: String, $active: Boolean, $sortBy: SortBuildingFieldEnum! = TITLE, $sortByDir: SortDirectionEnum! = ASC) {
  getBuildings(
    portfolioId: $portfolioId
    propertyIds: $propertyIds
    take: $take
    after: $after
    before: $before
    search: $search
    active: $active
  ) @connection(key: "getBuildingsDropdown") {
    pagination {
      ...PaginationFields
    }
    data {
      ...BuildingCoreFields
      active
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${BuildingCoreFieldsFragmentDoc}`;

/**
 * __useGetBuildingsDropdownQuery__
 *
 * To run a query within a React component, call `useGetBuildingsDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBuildingsDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBuildingsDropdownQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      propertyIds: // value for 'propertyIds'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      active: // value for 'active'
 *      sortBy: // value for 'sortBy'
 *      sortByDir: // value for 'sortByDir'
 *   },
 * });
 */
export function useGetBuildingsDropdownQuery(baseOptions: Apollo.QueryHookOptions<GetBuildingsDropdownQuery, GetBuildingsDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBuildingsDropdownQuery, GetBuildingsDropdownQueryVariables>(GetBuildingsDropdownDocument, options);
      }
export function useGetBuildingsDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBuildingsDropdownQuery, GetBuildingsDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBuildingsDropdownQuery, GetBuildingsDropdownQueryVariables>(GetBuildingsDropdownDocument, options);
        }
export type GetBuildingsDropdownQueryHookResult = ReturnType<typeof useGetBuildingsDropdownQuery>;
export type GetBuildingsDropdownLazyQueryHookResult = ReturnType<typeof useGetBuildingsDropdownLazyQuery>;
export type GetBuildingsDropdownQueryResult = Apollo.QueryResult<GetBuildingsDropdownQuery, GetBuildingsDropdownQueryVariables>;
export const GetBuildingDocument = gql`
    query getBuilding($id: String!) {
  getBuilding(id: $id) {
    ...BuildingCoreFields
    property {
      ...PropertyCoreFields
    }
  }
}
    ${BuildingCoreFieldsFragmentDoc}
${PropertyCoreFieldsFragmentDoc}`;

/**
 * __useGetBuildingQuery__
 *
 * To run a query within a React component, call `useGetBuildingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBuildingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBuildingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBuildingQuery(baseOptions: Apollo.QueryHookOptions<GetBuildingQuery, GetBuildingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBuildingQuery, GetBuildingQueryVariables>(GetBuildingDocument, options);
      }
export function useGetBuildingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBuildingQuery, GetBuildingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBuildingQuery, GetBuildingQueryVariables>(GetBuildingDocument, options);
        }
export type GetBuildingQueryHookResult = ReturnType<typeof useGetBuildingQuery>;
export type GetBuildingLazyQueryHookResult = ReturnType<typeof useGetBuildingLazyQuery>;
export type GetBuildingQueryResult = Apollo.QueryResult<GetBuildingQuery, GetBuildingQueryVariables>;
export const CreateChargeCodeDocument = gql`
    mutation createChargeCode($title: String!, $portfolioId: String!) {
  createChargeCode(title: $title, portfolioId: $portfolioId) {
    id
  }
}
    `;
export type CreateChargeCodeMutationFn = Apollo.MutationFunction<CreateChargeCodeMutation, CreateChargeCodeMutationVariables>;

/**
 * __useCreateChargeCodeMutation__
 *
 * To run a mutation, you first call `useCreateChargeCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChargeCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChargeCodeMutation, { data, loading, error }] = useCreateChargeCodeMutation({
 *   variables: {
 *      title: // value for 'title'
 *      portfolioId: // value for 'portfolioId'
 *   },
 * });
 */
export function useCreateChargeCodeMutation(baseOptions?: Apollo.MutationHookOptions<CreateChargeCodeMutation, CreateChargeCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChargeCodeMutation, CreateChargeCodeMutationVariables>(CreateChargeCodeDocument, options);
      }
export type CreateChargeCodeMutationHookResult = ReturnType<typeof useCreateChargeCodeMutation>;
export type CreateChargeCodeMutationResult = Apollo.MutationResult<CreateChargeCodeMutation>;
export type CreateChargeCodeMutationOptions = Apollo.BaseMutationOptions<CreateChargeCodeMutation, CreateChargeCodeMutationVariables>;
export const UpdateChargeCodeDocument = gql`
    mutation updateChargeCode($id: String!, $title: String!) {
  updateChargeCode(id: $id, title: $title) {
    ...ChargeCodeFields
  }
}
    ${ChargeCodeFieldsFragmentDoc}`;
export type UpdateChargeCodeMutationFn = Apollo.MutationFunction<UpdateChargeCodeMutation, UpdateChargeCodeMutationVariables>;

/**
 * __useUpdateChargeCodeMutation__
 *
 * To run a mutation, you first call `useUpdateChargeCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChargeCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChargeCodeMutation, { data, loading, error }] = useUpdateChargeCodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useUpdateChargeCodeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChargeCodeMutation, UpdateChargeCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChargeCodeMutation, UpdateChargeCodeMutationVariables>(UpdateChargeCodeDocument, options);
      }
export type UpdateChargeCodeMutationHookResult = ReturnType<typeof useUpdateChargeCodeMutation>;
export type UpdateChargeCodeMutationResult = Apollo.MutationResult<UpdateChargeCodeMutation>;
export type UpdateChargeCodeMutationOptions = Apollo.BaseMutationOptions<UpdateChargeCodeMutation, UpdateChargeCodeMutationVariables>;
export const ToggleChargeCodeDocument = gql`
    mutation toggleChargeCode($id: String!) {
  toggleChargeCode(id: $id)
}
    `;
export type ToggleChargeCodeMutationFn = Apollo.MutationFunction<ToggleChargeCodeMutation, ToggleChargeCodeMutationVariables>;

/**
 * __useToggleChargeCodeMutation__
 *
 * To run a mutation, you first call `useToggleChargeCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleChargeCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleChargeCodeMutation, { data, loading, error }] = useToggleChargeCodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleChargeCodeMutation(baseOptions?: Apollo.MutationHookOptions<ToggleChargeCodeMutation, ToggleChargeCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleChargeCodeMutation, ToggleChargeCodeMutationVariables>(ToggleChargeCodeDocument, options);
      }
export type ToggleChargeCodeMutationHookResult = ReturnType<typeof useToggleChargeCodeMutation>;
export type ToggleChargeCodeMutationResult = Apollo.MutationResult<ToggleChargeCodeMutation>;
export type ToggleChargeCodeMutationOptions = Apollo.BaseMutationOptions<ToggleChargeCodeMutation, ToggleChargeCodeMutationVariables>;
export const RemoveChargeCodesDocument = gql`
    mutation removeChargeCodes($data: DeleteRecordsInput!) {
  removeChargeCodes(input: $data)
}
    `;
export type RemoveChargeCodesMutationFn = Apollo.MutationFunction<RemoveChargeCodesMutation, RemoveChargeCodesMutationVariables>;

/**
 * __useRemoveChargeCodesMutation__
 *
 * To run a mutation, you first call `useRemoveChargeCodesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveChargeCodesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeChargeCodesMutation, { data, loading, error }] = useRemoveChargeCodesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveChargeCodesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveChargeCodesMutation, RemoveChargeCodesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveChargeCodesMutation, RemoveChargeCodesMutationVariables>(RemoveChargeCodesDocument, options);
      }
export type RemoveChargeCodesMutationHookResult = ReturnType<typeof useRemoveChargeCodesMutation>;
export type RemoveChargeCodesMutationResult = Apollo.MutationResult<RemoveChargeCodesMutation>;
export type RemoveChargeCodesMutationOptions = Apollo.BaseMutationOptions<RemoveChargeCodesMutation, RemoveChargeCodesMutationVariables>;
export const GetChargeCodesTableDocument = gql`
    query getChargeCodesTable($portfolioId: String!, $active: Boolean, $search: String, $recordLevel: RecordLevel, $propertyIds: [String!]) {
  getChargeCodes(
    active: $active
    portfolioId: $portfolioId
    search: $search
    recordLevel: $recordLevel
    propertyIds: $propertyIds
  ) {
    ...ChargeCodeCoreFields
    index
    active
    property {
      ...PropertyCoreFields
    }
  }
}
    ${ChargeCodeCoreFieldsFragmentDoc}
${PropertyCoreFieldsFragmentDoc}`;

/**
 * __useGetChargeCodesTableQuery__
 *
 * To run a query within a React component, call `useGetChargeCodesTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChargeCodesTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChargeCodesTableQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      active: // value for 'active'
 *      search: // value for 'search'
 *      recordLevel: // value for 'recordLevel'
 *      propertyIds: // value for 'propertyIds'
 *   },
 * });
 */
export function useGetChargeCodesTableQuery(baseOptions: Apollo.QueryHookOptions<GetChargeCodesTableQuery, GetChargeCodesTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChargeCodesTableQuery, GetChargeCodesTableQueryVariables>(GetChargeCodesTableDocument, options);
      }
export function useGetChargeCodesTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChargeCodesTableQuery, GetChargeCodesTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChargeCodesTableQuery, GetChargeCodesTableQueryVariables>(GetChargeCodesTableDocument, options);
        }
export type GetChargeCodesTableQueryHookResult = ReturnType<typeof useGetChargeCodesTableQuery>;
export type GetChargeCodesTableLazyQueryHookResult = ReturnType<typeof useGetChargeCodesTableLazyQuery>;
export type GetChargeCodesTableQueryResult = Apollo.QueryResult<GetChargeCodesTableQuery, GetChargeCodesTableQueryVariables>;
export const GetChargeCodesDropdownDocument = gql`
    query getChargeCodesDropdown($portfolioId: String!, $active: Boolean, $search: String, $recordLevel: RecordLevel, $propertyIds: [String!]) {
  getChargeCodes(
    active: $active
    portfolioId: $portfolioId
    search: $search
    recordLevel: $recordLevel
    propertyIds: $propertyIds
  ) {
    ...ChargeCodeCoreFields
    active
  }
}
    ${ChargeCodeCoreFieldsFragmentDoc}`;

/**
 * __useGetChargeCodesDropdownQuery__
 *
 * To run a query within a React component, call `useGetChargeCodesDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChargeCodesDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChargeCodesDropdownQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      active: // value for 'active'
 *      search: // value for 'search'
 *      recordLevel: // value for 'recordLevel'
 *      propertyIds: // value for 'propertyIds'
 *   },
 * });
 */
export function useGetChargeCodesDropdownQuery(baseOptions: Apollo.QueryHookOptions<GetChargeCodesDropdownQuery, GetChargeCodesDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChargeCodesDropdownQuery, GetChargeCodesDropdownQueryVariables>(GetChargeCodesDropdownDocument, options);
      }
export function useGetChargeCodesDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChargeCodesDropdownQuery, GetChargeCodesDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChargeCodesDropdownQuery, GetChargeCodesDropdownQueryVariables>(GetChargeCodesDropdownDocument, options);
        }
export type GetChargeCodesDropdownQueryHookResult = ReturnType<typeof useGetChargeCodesDropdownQuery>;
export type GetChargeCodesDropdownLazyQueryHookResult = ReturnType<typeof useGetChargeCodesDropdownLazyQuery>;
export type GetChargeCodesDropdownQueryResult = Apollo.QueryResult<GetChargeCodesDropdownQuery, GetChargeCodesDropdownQueryVariables>;
export const GetChargeCodeDocument = gql`
    query getChargeCode($id: String!) {
  getChargeCode(id: $id) {
    ...ChargeCodeFields
  }
}
    ${ChargeCodeFieldsFragmentDoc}`;

/**
 * __useGetChargeCodeQuery__
 *
 * To run a query within a React component, call `useGetChargeCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChargeCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChargeCodeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetChargeCodeQuery(baseOptions: Apollo.QueryHookOptions<GetChargeCodeQuery, GetChargeCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChargeCodeQuery, GetChargeCodeQueryVariables>(GetChargeCodeDocument, options);
      }
export function useGetChargeCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChargeCodeQuery, GetChargeCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChargeCodeQuery, GetChargeCodeQueryVariables>(GetChargeCodeDocument, options);
        }
export type GetChargeCodeQueryHookResult = ReturnType<typeof useGetChargeCodeQuery>;
export type GetChargeCodeLazyQueryHookResult = ReturnType<typeof useGetChargeCodeLazyQuery>;
export type GetChargeCodeQueryResult = Apollo.QueryResult<GetChargeCodeQuery, GetChargeCodeQueryVariables>;
export const GetCoisTableDocument = gql`
    query getCoisTable($portfolioId: String!, $take: Int! = 10, $after: String, $before: String, $statuses: [CoiStatusEnum!], $search: String, $to: DateTime, $from: DateTime, $propertyIds: [String!], $companyTypes: [CompanyTypeEnum!], $companyIds: [String!], $createdByIds: [String!], $archived: ArchiveStatusEnum! = NOT_ARCHIVED, $expiration: CoiExpirationEnum) {
  getCois(
    portfolioId: $portfolioId
    take: $take
    after: $after
    before: $before
    statuses: $statuses
    search: $search
    to: $to
    from: $from
    propertyIds: $propertyIds
    companyTypes: $companyTypes
    companyIds: $companyIds
    createdByIds: $createdByIds
    archived: $archived
    expiration: $expiration
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      ...CoiCoreFields
      property {
        ...PropertyCoreFields
      }
      isArchived
      status
      expiration
      note
      validFrom
      validTo
      createdAt
      company {
        ...CompanyCoreFields
      }
      createdBy {
        ...UserCoreFields
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${CoiCoreFieldsFragmentDoc}
${PropertyCoreFieldsFragmentDoc}
${CompanyCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}`;

/**
 * __useGetCoisTableQuery__
 *
 * To run a query within a React component, call `useGetCoisTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoisTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoisTableQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      statuses: // value for 'statuses'
 *      search: // value for 'search'
 *      to: // value for 'to'
 *      from: // value for 'from'
 *      propertyIds: // value for 'propertyIds'
 *      companyTypes: // value for 'companyTypes'
 *      companyIds: // value for 'companyIds'
 *      createdByIds: // value for 'createdByIds'
 *      archived: // value for 'archived'
 *      expiration: // value for 'expiration'
 *   },
 * });
 */
export function useGetCoisTableQuery(baseOptions: Apollo.QueryHookOptions<GetCoisTableQuery, GetCoisTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoisTableQuery, GetCoisTableQueryVariables>(GetCoisTableDocument, options);
      }
export function useGetCoisTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoisTableQuery, GetCoisTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoisTableQuery, GetCoisTableQueryVariables>(GetCoisTableDocument, options);
        }
export type GetCoisTableQueryHookResult = ReturnType<typeof useGetCoisTableQuery>;
export type GetCoisTableLazyQueryHookResult = ReturnType<typeof useGetCoisTableLazyQuery>;
export type GetCoisTableQueryResult = Apollo.QueryResult<GetCoisTableQuery, GetCoisTableQueryVariables>;
export const GetCoiDocument = gql`
    query getCoi($id: String!) {
  getCoi(coiId: $id) {
    ...CoiFields
  }
}
    ${CoiFieldsFragmentDoc}`;

/**
 * __useGetCoiQuery__
 *
 * To run a query within a React component, call `useGetCoiQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoiQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCoiQuery(baseOptions: Apollo.QueryHookOptions<GetCoiQuery, GetCoiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoiQuery, GetCoiQueryVariables>(GetCoiDocument, options);
      }
export function useGetCoiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoiQuery, GetCoiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoiQuery, GetCoiQueryVariables>(GetCoiDocument, options);
        }
export type GetCoiQueryHookResult = ReturnType<typeof useGetCoiQuery>;
export type GetCoiLazyQueryHookResult = ReturnType<typeof useGetCoiLazyQuery>;
export type GetCoiQueryResult = Apollo.QueryResult<GetCoiQuery, GetCoiQueryVariables>;
export const CreateCompanyDocument = gql`
    mutation createCompany($data: CompanyInput!, $portfolioId: String!) {
  createCompany(input: $data, portfolioId: $portfolioId) {
    id
  }
}
    `;
export type CreateCompanyMutationFn = Apollo.MutationFunction<CreateCompanyMutation, CreateCompanyMutationVariables>;

/**
 * __useCreateCompanyMutation__
 *
 * To run a mutation, you first call `useCreateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyMutation, { data, loading, error }] = useCreateCompanyMutation({
 *   variables: {
 *      data: // value for 'data'
 *      portfolioId: // value for 'portfolioId'
 *   },
 * });
 */
export function useCreateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompanyMutation, CreateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompanyMutation, CreateCompanyMutationVariables>(CreateCompanyDocument, options);
      }
export type CreateCompanyMutationHookResult = ReturnType<typeof useCreateCompanyMutation>;
export type CreateCompanyMutationResult = Apollo.MutationResult<CreateCompanyMutation>;
export type CreateCompanyMutationOptions = Apollo.BaseMutationOptions<CreateCompanyMutation, CreateCompanyMutationVariables>;
export const UpdateCompanyDocument = gql`
    mutation updateCompany($id: String!, $data: CompanyUpdateInput!) {
  updateCompany(id: $id, input: $data) {
    ...CompanyFields
  }
}
    ${CompanyFieldsFragmentDoc}`;
export type UpdateCompanyMutationFn = Apollo.MutationFunction<UpdateCompanyMutation, UpdateCompanyMutationVariables>;

/**
 * __useUpdateCompanyMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyMutation, { data, loading, error }] = useUpdateCompanyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyMutation, UpdateCompanyMutationVariables>(UpdateCompanyDocument, options);
      }
export type UpdateCompanyMutationHookResult = ReturnType<typeof useUpdateCompanyMutation>;
export type UpdateCompanyMutationResult = Apollo.MutationResult<UpdateCompanyMutation>;
export type UpdateCompanyMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>;
export const UpdateCompanyPhotoDocument = gql`
    mutation updateCompanyPhoto($id: String!, $photo: FileObjectInput) {
  updateCompanyPhoto(companyId: $id, photo: $photo) {
    id
    photo {
      ...FileFields
    }
  }
}
    ${FileFieldsFragmentDoc}`;
export type UpdateCompanyPhotoMutationFn = Apollo.MutationFunction<UpdateCompanyPhotoMutation, UpdateCompanyPhotoMutationVariables>;

/**
 * __useUpdateCompanyPhotoMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyPhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyPhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyPhotoMutation, { data, loading, error }] = useUpdateCompanyPhotoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      photo: // value for 'photo'
 *   },
 * });
 */
export function useUpdateCompanyPhotoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyPhotoMutation, UpdateCompanyPhotoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyPhotoMutation, UpdateCompanyPhotoMutationVariables>(UpdateCompanyPhotoDocument, options);
      }
export type UpdateCompanyPhotoMutationHookResult = ReturnType<typeof useUpdateCompanyPhotoMutation>;
export type UpdateCompanyPhotoMutationResult = Apollo.MutationResult<UpdateCompanyPhotoMutation>;
export type UpdateCompanyPhotoMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyPhotoMutation, UpdateCompanyPhotoMutationVariables>;
export const UpdateCompanyAddressDocument = gql`
    mutation updateCompanyAddress($id: String!, $address: AddressInput!) {
  updateCompanyAddress(companyId: $id, address: $address) {
    id
    address {
      ...AddressFields
    }
  }
}
    ${AddressFieldsFragmentDoc}`;
export type UpdateCompanyAddressMutationFn = Apollo.MutationFunction<UpdateCompanyAddressMutation, UpdateCompanyAddressMutationVariables>;

/**
 * __useUpdateCompanyAddressMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyAddressMutation, { data, loading, error }] = useUpdateCompanyAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *      address: // value for 'address'
 *   },
 * });
 */
export function useUpdateCompanyAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyAddressMutation, UpdateCompanyAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyAddressMutation, UpdateCompanyAddressMutationVariables>(UpdateCompanyAddressDocument, options);
      }
export type UpdateCompanyAddressMutationHookResult = ReturnType<typeof useUpdateCompanyAddressMutation>;
export type UpdateCompanyAddressMutationResult = Apollo.MutationResult<UpdateCompanyAddressMutation>;
export type UpdateCompanyAddressMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyAddressMutation, UpdateCompanyAddressMutationVariables>;
export const AddCompanyPropertyDocument = gql`
    mutation addCompanyProperty($id: String!, $propertyId: String!) {
  addCompanyProperty(companyId: $id, propertyId: $propertyId)
}
    `;
export type AddCompanyPropertyMutationFn = Apollo.MutationFunction<AddCompanyPropertyMutation, AddCompanyPropertyMutationVariables>;

/**
 * __useAddCompanyPropertyMutation__
 *
 * To run a mutation, you first call `useAddCompanyPropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCompanyPropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCompanyPropertyMutation, { data, loading, error }] = useAddCompanyPropertyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useAddCompanyPropertyMutation(baseOptions?: Apollo.MutationHookOptions<AddCompanyPropertyMutation, AddCompanyPropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCompanyPropertyMutation, AddCompanyPropertyMutationVariables>(AddCompanyPropertyDocument, options);
      }
export type AddCompanyPropertyMutationHookResult = ReturnType<typeof useAddCompanyPropertyMutation>;
export type AddCompanyPropertyMutationResult = Apollo.MutationResult<AddCompanyPropertyMutation>;
export type AddCompanyPropertyMutationOptions = Apollo.BaseMutationOptions<AddCompanyPropertyMutation, AddCompanyPropertyMutationVariables>;
export const ToggleCompanyPropertyDocument = gql`
    mutation toggleCompanyProperty($id: String!, $propertyId: String!) {
  toggleCompanyProperty(companyId: $id, propertyId: $propertyId)
}
    `;
export type ToggleCompanyPropertyMutationFn = Apollo.MutationFunction<ToggleCompanyPropertyMutation, ToggleCompanyPropertyMutationVariables>;

/**
 * __useToggleCompanyPropertyMutation__
 *
 * To run a mutation, you first call `useToggleCompanyPropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleCompanyPropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleCompanyPropertyMutation, { data, loading, error }] = useToggleCompanyPropertyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useToggleCompanyPropertyMutation(baseOptions?: Apollo.MutationHookOptions<ToggleCompanyPropertyMutation, ToggleCompanyPropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleCompanyPropertyMutation, ToggleCompanyPropertyMutationVariables>(ToggleCompanyPropertyDocument, options);
      }
export type ToggleCompanyPropertyMutationHookResult = ReturnType<typeof useToggleCompanyPropertyMutation>;
export type ToggleCompanyPropertyMutationResult = Apollo.MutationResult<ToggleCompanyPropertyMutation>;
export type ToggleCompanyPropertyMutationOptions = Apollo.BaseMutationOptions<ToggleCompanyPropertyMutation, ToggleCompanyPropertyMutationVariables>;
export const RemoveCompaniesDocument = gql`
    mutation removeCompanies($data: DeleteRecordsInput!) {
  removeCompanies(input: $data)
}
    `;
export type RemoveCompaniesMutationFn = Apollo.MutationFunction<RemoveCompaniesMutation, RemoveCompaniesMutationVariables>;

/**
 * __useRemoveCompaniesMutation__
 *
 * To run a mutation, you first call `useRemoveCompaniesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCompaniesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCompaniesMutation, { data, loading, error }] = useRemoveCompaniesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveCompaniesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCompaniesMutation, RemoveCompaniesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCompaniesMutation, RemoveCompaniesMutationVariables>(RemoveCompaniesDocument, options);
      }
export type RemoveCompaniesMutationHookResult = ReturnType<typeof useRemoveCompaniesMutation>;
export type RemoveCompaniesMutationResult = Apollo.MutationResult<RemoveCompaniesMutation>;
export type RemoveCompaniesMutationOptions = Apollo.BaseMutationOptions<RemoveCompaniesMutation, RemoveCompaniesMutationVariables>;
export const ToggleCompanyDocument = gql`
    mutation toggleCompany($id: String!) {
  toggleCompany(id: $id)
}
    `;
export type ToggleCompanyMutationFn = Apollo.MutationFunction<ToggleCompanyMutation, ToggleCompanyMutationVariables>;

/**
 * __useToggleCompanyMutation__
 *
 * To run a mutation, you first call `useToggleCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleCompanyMutation, { data, loading, error }] = useToggleCompanyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleCompanyMutation(baseOptions?: Apollo.MutationHookOptions<ToggleCompanyMutation, ToggleCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleCompanyMutation, ToggleCompanyMutationVariables>(ToggleCompanyDocument, options);
      }
export type ToggleCompanyMutationHookResult = ReturnType<typeof useToggleCompanyMutation>;
export type ToggleCompanyMutationResult = Apollo.MutationResult<ToggleCompanyMutation>;
export type ToggleCompanyMutationOptions = Apollo.BaseMutationOptions<ToggleCompanyMutation, ToggleCompanyMutationVariables>;
export const GetCompaniesTableDocument = gql`
    query getCompaniesTable($portfolioId: String!, $take: Int! = 10, $after: String, $before: String, $search: String, $companyTypes: [CompanyTypeEnum!], $propertyIds: [String!], $active: Boolean) {
  getCompanies(
    take: $take
    after: $after
    before: $before
    search: $search
    portfolioId: $portfolioId
    companyTypes: $companyTypes
    propertyIds: $propertyIds
    active: $active
  ) @connection(key: "getCompaniesTable") {
    pagination {
      ...PaginationFields
    }
    data {
      ...CompanyCoreFields
      index
      taxCode
      vendorId
      createdAt
      userCount
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${CompanyCoreFieldsFragmentDoc}`;

/**
 * __useGetCompaniesTableQuery__
 *
 * To run a query within a React component, call `useGetCompaniesTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompaniesTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompaniesTableQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      companyTypes: // value for 'companyTypes'
 *      propertyIds: // value for 'propertyIds'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useGetCompaniesTableQuery(baseOptions: Apollo.QueryHookOptions<GetCompaniesTableQuery, GetCompaniesTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompaniesTableQuery, GetCompaniesTableQueryVariables>(GetCompaniesTableDocument, options);
      }
export function useGetCompaniesTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompaniesTableQuery, GetCompaniesTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompaniesTableQuery, GetCompaniesTableQueryVariables>(GetCompaniesTableDocument, options);
        }
export type GetCompaniesTableQueryHookResult = ReturnType<typeof useGetCompaniesTableQuery>;
export type GetCompaniesTableLazyQueryHookResult = ReturnType<typeof useGetCompaniesTableLazyQuery>;
export type GetCompaniesTableQueryResult = Apollo.QueryResult<GetCompaniesTableQuery, GetCompaniesTableQueryVariables>;
export const GetCompaniesDropdownDocument = gql`
    query getCompaniesDropdown($take: Int! = 10, $after: String, $before: String, $search: String, $portfolioId: String!, $companyTypes: [CompanyTypeEnum!], $propertyIds: [String!], $active: Boolean) {
  getCompanies(
    take: $take
    after: $after
    before: $before
    search: $search
    portfolioId: $portfolioId
    companyTypes: $companyTypes
    propertyIds: $propertyIds
    active: $active
  ) @connection(key: "getCompaniesDropdown") {
    pagination {
      ...PaginationFields
    }
    data {
      ...CompanyCoreFields
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${CompanyCoreFieldsFragmentDoc}`;

/**
 * __useGetCompaniesDropdownQuery__
 *
 * To run a query within a React component, call `useGetCompaniesDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompaniesDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompaniesDropdownQuery({
 *   variables: {
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      portfolioId: // value for 'portfolioId'
 *      companyTypes: // value for 'companyTypes'
 *      propertyIds: // value for 'propertyIds'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useGetCompaniesDropdownQuery(baseOptions: Apollo.QueryHookOptions<GetCompaniesDropdownQuery, GetCompaniesDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompaniesDropdownQuery, GetCompaniesDropdownQueryVariables>(GetCompaniesDropdownDocument, options);
      }
export function useGetCompaniesDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompaniesDropdownQuery, GetCompaniesDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompaniesDropdownQuery, GetCompaniesDropdownQueryVariables>(GetCompaniesDropdownDocument, options);
        }
export type GetCompaniesDropdownQueryHookResult = ReturnType<typeof useGetCompaniesDropdownQuery>;
export type GetCompaniesDropdownLazyQueryHookResult = ReturnType<typeof useGetCompaniesDropdownLazyQuery>;
export type GetCompaniesDropdownQueryResult = Apollo.QueryResult<GetCompaniesDropdownQuery, GetCompaniesDropdownQueryVariables>;
export const GetCompanyDocument = gql`
    query getCompany($id: String!) {
  getCompany(id: $id) {
    ...CompanyFields
  }
}
    ${CompanyFieldsFragmentDoc}`;

/**
 * __useGetCompanyQuery__
 *
 * To run a query within a React component, call `useGetCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCompanyQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, options);
      }
export function useGetCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, options);
        }
export type GetCompanyQueryHookResult = ReturnType<typeof useGetCompanyQuery>;
export type GetCompanyLazyQueryHookResult = ReturnType<typeof useGetCompanyLazyQuery>;
export type GetCompanyQueryResult = Apollo.QueryResult<GetCompanyQuery, GetCompanyQueryVariables>;
export const GetCompanyPropertiesDocument = gql`
    query getCompanyProperties($id: String!) {
  getCompanyProperties(id: $id) {
    active
    property {
      id
      title
    }
  }
}
    `;

/**
 * __useGetCompanyPropertiesQuery__
 *
 * To run a query within a React component, call `useGetCompanyPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyPropertiesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCompanyPropertiesQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyPropertiesQuery, GetCompanyPropertiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyPropertiesQuery, GetCompanyPropertiesQueryVariables>(GetCompanyPropertiesDocument, options);
      }
export function useGetCompanyPropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyPropertiesQuery, GetCompanyPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyPropertiesQuery, GetCompanyPropertiesQueryVariables>(GetCompanyPropertiesDocument, options);
        }
export type GetCompanyPropertiesQueryHookResult = ReturnType<typeof useGetCompanyPropertiesQuery>;
export type GetCompanyPropertiesLazyQueryHookResult = ReturnType<typeof useGetCompanyPropertiesLazyQuery>;
export type GetCompanyPropertiesQueryResult = Apollo.QueryResult<GetCompanyPropertiesQuery, GetCompanyPropertiesQueryVariables>;
export const UpdateDefaultEmailTemplateDocument = gql`
    mutation updateDefaultEmailTemplate($data: UpdateDefaultEmailTemplateInput!, $type: EmailTemplateType!) {
  updateDefaultEmailTemplate(input: $data, type: $type)
}
    `;
export type UpdateDefaultEmailTemplateMutationFn = Apollo.MutationFunction<UpdateDefaultEmailTemplateMutation, UpdateDefaultEmailTemplateMutationVariables>;

/**
 * __useUpdateDefaultEmailTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateDefaultEmailTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDefaultEmailTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDefaultEmailTemplateMutation, { data, loading, error }] = useUpdateDefaultEmailTemplateMutation({
 *   variables: {
 *      data: // value for 'data'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useUpdateDefaultEmailTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDefaultEmailTemplateMutation, UpdateDefaultEmailTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDefaultEmailTemplateMutation, UpdateDefaultEmailTemplateMutationVariables>(UpdateDefaultEmailTemplateDocument, options);
      }
export type UpdateDefaultEmailTemplateMutationHookResult = ReturnType<typeof useUpdateDefaultEmailTemplateMutation>;
export type UpdateDefaultEmailTemplateMutationResult = Apollo.MutationResult<UpdateDefaultEmailTemplateMutation>;
export type UpdateDefaultEmailTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateDefaultEmailTemplateMutation, UpdateDefaultEmailTemplateMutationVariables>;
export const GetDefaultEmailTemplatesDocument = gql`
    query getDefaultEmailTemplates($search: String) {
  getDefaultEmailTemplates(search: $search) {
    category
    trigger
    type
  }
}
    `;

/**
 * __useGetDefaultEmailTemplatesQuery__
 *
 * To run a query within a React component, call `useGetDefaultEmailTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDefaultEmailTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDefaultEmailTemplatesQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetDefaultEmailTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetDefaultEmailTemplatesQuery, GetDefaultEmailTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDefaultEmailTemplatesQuery, GetDefaultEmailTemplatesQueryVariables>(GetDefaultEmailTemplatesDocument, options);
      }
export function useGetDefaultEmailTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDefaultEmailTemplatesQuery, GetDefaultEmailTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDefaultEmailTemplatesQuery, GetDefaultEmailTemplatesQueryVariables>(GetDefaultEmailTemplatesDocument, options);
        }
export type GetDefaultEmailTemplatesQueryHookResult = ReturnType<typeof useGetDefaultEmailTemplatesQuery>;
export type GetDefaultEmailTemplatesLazyQueryHookResult = ReturnType<typeof useGetDefaultEmailTemplatesLazyQuery>;
export type GetDefaultEmailTemplatesQueryResult = Apollo.QueryResult<GetDefaultEmailTemplatesQuery, GetDefaultEmailTemplatesQueryVariables>;
export const GetDefaultEmailTemplateDocument = gql`
    query getDefaultEmailTemplate($type: EmailTemplateType!) {
  getDefaultEmailTemplate(type: $type) {
    ...DefaultEmailTemplateFields
  }
}
    ${DefaultEmailTemplateFieldsFragmentDoc}`;

/**
 * __useGetDefaultEmailTemplateQuery__
 *
 * To run a query within a React component, call `useGetDefaultEmailTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDefaultEmailTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDefaultEmailTemplateQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetDefaultEmailTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetDefaultEmailTemplateQuery, GetDefaultEmailTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDefaultEmailTemplateQuery, GetDefaultEmailTemplateQueryVariables>(GetDefaultEmailTemplateDocument, options);
      }
export function useGetDefaultEmailTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDefaultEmailTemplateQuery, GetDefaultEmailTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDefaultEmailTemplateQuery, GetDefaultEmailTemplateQueryVariables>(GetDefaultEmailTemplateDocument, options);
        }
export type GetDefaultEmailTemplateQueryHookResult = ReturnType<typeof useGetDefaultEmailTemplateQuery>;
export type GetDefaultEmailTemplateLazyQueryHookResult = ReturnType<typeof useGetDefaultEmailTemplateLazyQuery>;
export type GetDefaultEmailTemplateQueryResult = Apollo.QueryResult<GetDefaultEmailTemplateQuery, GetDefaultEmailTemplateQueryVariables>;
export const UpdateEmailTemplateDocument = gql`
    mutation updateEmailTemplate($portfolioId: String!, $data: UpdateEmailTemplateInput!, $type: EmailTemplateType!) {
  updateEmailTemplate(portfolioId: $portfolioId, input: $data, type: $type)
}
    `;
export type UpdateEmailTemplateMutationFn = Apollo.MutationFunction<UpdateEmailTemplateMutation, UpdateEmailTemplateMutationVariables>;

/**
 * __useUpdateEmailTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateEmailTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmailTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmailTemplateMutation, { data, loading, error }] = useUpdateEmailTemplateMutation({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      data: // value for 'data'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useUpdateEmailTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmailTemplateMutation, UpdateEmailTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmailTemplateMutation, UpdateEmailTemplateMutationVariables>(UpdateEmailTemplateDocument, options);
      }
export type UpdateEmailTemplateMutationHookResult = ReturnType<typeof useUpdateEmailTemplateMutation>;
export type UpdateEmailTemplateMutationResult = Apollo.MutationResult<UpdateEmailTemplateMutation>;
export type UpdateEmailTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateEmailTemplateMutation, UpdateEmailTemplateMutationVariables>;
export const ToggleEmailTemplateDocument = gql`
    mutation toggleEmailTemplate($data: ToggleEmailTemplateInput!) {
  toggleEmailTemplate(input: $data)
}
    `;
export type ToggleEmailTemplateMutationFn = Apollo.MutationFunction<ToggleEmailTemplateMutation, ToggleEmailTemplateMutationVariables>;

/**
 * __useToggleEmailTemplateMutation__
 *
 * To run a mutation, you first call `useToggleEmailTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleEmailTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleEmailTemplateMutation, { data, loading, error }] = useToggleEmailTemplateMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useToggleEmailTemplateMutation(baseOptions?: Apollo.MutationHookOptions<ToggleEmailTemplateMutation, ToggleEmailTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleEmailTemplateMutation, ToggleEmailTemplateMutationVariables>(ToggleEmailTemplateDocument, options);
      }
export type ToggleEmailTemplateMutationHookResult = ReturnType<typeof useToggleEmailTemplateMutation>;
export type ToggleEmailTemplateMutationResult = Apollo.MutationResult<ToggleEmailTemplateMutation>;
export type ToggleEmailTemplateMutationOptions = Apollo.BaseMutationOptions<ToggleEmailTemplateMutation, ToggleEmailTemplateMutationVariables>;
export const ToggleCustomTemplateDocument = gql`
    mutation toggleCustomTemplate($portfolioId: String!, $type: EmailTemplateType!) {
  toggleCustomTemplate(portfolioId: $portfolioId, type: $type) {
    ...EmailTemplateFields
  }
}
    ${EmailTemplateFieldsFragmentDoc}`;
export type ToggleCustomTemplateMutationFn = Apollo.MutationFunction<ToggleCustomTemplateMutation, ToggleCustomTemplateMutationVariables>;

/**
 * __useToggleCustomTemplateMutation__
 *
 * To run a mutation, you first call `useToggleCustomTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleCustomTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleCustomTemplateMutation, { data, loading, error }] = useToggleCustomTemplateMutation({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useToggleCustomTemplateMutation(baseOptions?: Apollo.MutationHookOptions<ToggleCustomTemplateMutation, ToggleCustomTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleCustomTemplateMutation, ToggleCustomTemplateMutationVariables>(ToggleCustomTemplateDocument, options);
      }
export type ToggleCustomTemplateMutationHookResult = ReturnType<typeof useToggleCustomTemplateMutation>;
export type ToggleCustomTemplateMutationResult = Apollo.MutationResult<ToggleCustomTemplateMutation>;
export type ToggleCustomTemplateMutationOptions = Apollo.BaseMutationOptions<ToggleCustomTemplateMutation, ToggleCustomTemplateMutationVariables>;
export const SendTestMailDocument = gql`
    mutation sendTestMail($data: SendTestMailInput!) {
  sendTestMail(input: $data)
}
    `;
export type SendTestMailMutationFn = Apollo.MutationFunction<SendTestMailMutation, SendTestMailMutationVariables>;

/**
 * __useSendTestMailMutation__
 *
 * To run a mutation, you first call `useSendTestMailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTestMailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTestMailMutation, { data, loading, error }] = useSendTestMailMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSendTestMailMutation(baseOptions?: Apollo.MutationHookOptions<SendTestMailMutation, SendTestMailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendTestMailMutation, SendTestMailMutationVariables>(SendTestMailDocument, options);
      }
export type SendTestMailMutationHookResult = ReturnType<typeof useSendTestMailMutation>;
export type SendTestMailMutationResult = Apollo.MutationResult<SendTestMailMutation>;
export type SendTestMailMutationOptions = Apollo.BaseMutationOptions<SendTestMailMutation, SendTestMailMutationVariables>;
export const GetEmailTemplatesDocument = gql`
    query getEmailTemplates($portfolioId: String!, $search: String) {
  getEmailTemplates(portfolioId: $portfolioId, search: $search) {
    category
    trigger
    type
    appActive
    smsActive
    emailActive
    custom
  }
}
    `;

/**
 * __useGetEmailTemplatesQuery__
 *
 * To run a query within a React component, call `useGetEmailTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailTemplatesQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetEmailTemplatesQuery(baseOptions: Apollo.QueryHookOptions<GetEmailTemplatesQuery, GetEmailTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmailTemplatesQuery, GetEmailTemplatesQueryVariables>(GetEmailTemplatesDocument, options);
      }
export function useGetEmailTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmailTemplatesQuery, GetEmailTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmailTemplatesQuery, GetEmailTemplatesQueryVariables>(GetEmailTemplatesDocument, options);
        }
export type GetEmailTemplatesQueryHookResult = ReturnType<typeof useGetEmailTemplatesQuery>;
export type GetEmailTemplatesLazyQueryHookResult = ReturnType<typeof useGetEmailTemplatesLazyQuery>;
export type GetEmailTemplatesQueryResult = Apollo.QueryResult<GetEmailTemplatesQuery, GetEmailTemplatesQueryVariables>;
export const GetEmailTemplateDocument = gql`
    query getEmailTemplate($portfolioId: String!, $type: EmailTemplateType!) {
  getEmailTemplate(portfolioId: $portfolioId, type: $type) {
    ...EmailTemplateFields
  }
}
    ${EmailTemplateFieldsFragmentDoc}`;

/**
 * __useGetEmailTemplateQuery__
 *
 * To run a query within a React component, call `useGetEmailTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailTemplateQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetEmailTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetEmailTemplateQuery, GetEmailTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmailTemplateQuery, GetEmailTemplateQueryVariables>(GetEmailTemplateDocument, options);
      }
export function useGetEmailTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmailTemplateQuery, GetEmailTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmailTemplateQuery, GetEmailTemplateQueryVariables>(GetEmailTemplateDocument, options);
        }
export type GetEmailTemplateQueryHookResult = ReturnType<typeof useGetEmailTemplateQuery>;
export type GetEmailTemplateLazyQueryHookResult = ReturnType<typeof useGetEmailTemplateLazyQuery>;
export type GetEmailTemplateQueryResult = Apollo.QueryResult<GetEmailTemplateQuery, GetEmailTemplateQueryVariables>;
export const CreateGlAccountDocument = gql`
    mutation createGLAccount($title: String!, $portfolioId: String!) {
  createGLAccount(title: $title, portfolioId: $portfolioId) {
    id
  }
}
    `;
export type CreateGlAccountMutationFn = Apollo.MutationFunction<CreateGlAccountMutation, CreateGlAccountMutationVariables>;

/**
 * __useCreateGlAccountMutation__
 *
 * To run a mutation, you first call `useCreateGlAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGlAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGlAccountMutation, { data, loading, error }] = useCreateGlAccountMutation({
 *   variables: {
 *      title: // value for 'title'
 *      portfolioId: // value for 'portfolioId'
 *   },
 * });
 */
export function useCreateGlAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateGlAccountMutation, CreateGlAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGlAccountMutation, CreateGlAccountMutationVariables>(CreateGlAccountDocument, options);
      }
export type CreateGlAccountMutationHookResult = ReturnType<typeof useCreateGlAccountMutation>;
export type CreateGlAccountMutationResult = Apollo.MutationResult<CreateGlAccountMutation>;
export type CreateGlAccountMutationOptions = Apollo.BaseMutationOptions<CreateGlAccountMutation, CreateGlAccountMutationVariables>;
export const UpdateGlAccountDocument = gql`
    mutation updateGLAccount($id: String!, $title: String!) {
  updateGLAccount(id: $id, title: $title) {
    ...GLAccountFields
  }
}
    ${GlAccountFieldsFragmentDoc}`;
export type UpdateGlAccountMutationFn = Apollo.MutationFunction<UpdateGlAccountMutation, UpdateGlAccountMutationVariables>;

/**
 * __useUpdateGlAccountMutation__
 *
 * To run a mutation, you first call `useUpdateGlAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGlAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGlAccountMutation, { data, loading, error }] = useUpdateGlAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useUpdateGlAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGlAccountMutation, UpdateGlAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGlAccountMutation, UpdateGlAccountMutationVariables>(UpdateGlAccountDocument, options);
      }
export type UpdateGlAccountMutationHookResult = ReturnType<typeof useUpdateGlAccountMutation>;
export type UpdateGlAccountMutationResult = Apollo.MutationResult<UpdateGlAccountMutation>;
export type UpdateGlAccountMutationOptions = Apollo.BaseMutationOptions<UpdateGlAccountMutation, UpdateGlAccountMutationVariables>;
export const ToggleGlAccountDocument = gql`
    mutation toggleGLAccount($id: String!) {
  toggleGLAccount(id: $id)
}
    `;
export type ToggleGlAccountMutationFn = Apollo.MutationFunction<ToggleGlAccountMutation, ToggleGlAccountMutationVariables>;

/**
 * __useToggleGlAccountMutation__
 *
 * To run a mutation, you first call `useToggleGlAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleGlAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleGlAccountMutation, { data, loading, error }] = useToggleGlAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleGlAccountMutation(baseOptions?: Apollo.MutationHookOptions<ToggleGlAccountMutation, ToggleGlAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleGlAccountMutation, ToggleGlAccountMutationVariables>(ToggleGlAccountDocument, options);
      }
export type ToggleGlAccountMutationHookResult = ReturnType<typeof useToggleGlAccountMutation>;
export type ToggleGlAccountMutationResult = Apollo.MutationResult<ToggleGlAccountMutation>;
export type ToggleGlAccountMutationOptions = Apollo.BaseMutationOptions<ToggleGlAccountMutation, ToggleGlAccountMutationVariables>;
export const RemoveGlAccountsDocument = gql`
    mutation removeGLAccounts($data: DeleteRecordsInput!) {
  removeGLAccounts(input: $data)
}
    `;
export type RemoveGlAccountsMutationFn = Apollo.MutationFunction<RemoveGlAccountsMutation, RemoveGlAccountsMutationVariables>;

/**
 * __useRemoveGlAccountsMutation__
 *
 * To run a mutation, you first call `useRemoveGlAccountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveGlAccountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeGlAccountsMutation, { data, loading, error }] = useRemoveGlAccountsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveGlAccountsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveGlAccountsMutation, RemoveGlAccountsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveGlAccountsMutation, RemoveGlAccountsMutationVariables>(RemoveGlAccountsDocument, options);
      }
export type RemoveGlAccountsMutationHookResult = ReturnType<typeof useRemoveGlAccountsMutation>;
export type RemoveGlAccountsMutationResult = Apollo.MutationResult<RemoveGlAccountsMutation>;
export type RemoveGlAccountsMutationOptions = Apollo.BaseMutationOptions<RemoveGlAccountsMutation, RemoveGlAccountsMutationVariables>;
export const GetGlAccountsTableDocument = gql`
    query getGLAccountsTable($portfolioId: String!, $active: Boolean, $search: String, $recordLevel: RecordLevel, $propertyIds: [String!]) {
  getGLAccounts(
    active: $active
    portfolioId: $portfolioId
    search: $search
    recordLevel: $recordLevel
    propertyIds: $propertyIds
  ) {
    ...GLAccountCoreFields
    index
    active
    property {
      ...PropertyCoreFields
    }
  }
}
    ${GlAccountCoreFieldsFragmentDoc}
${PropertyCoreFieldsFragmentDoc}`;

/**
 * __useGetGlAccountsTableQuery__
 *
 * To run a query within a React component, call `useGetGlAccountsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGlAccountsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGlAccountsTableQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      active: // value for 'active'
 *      search: // value for 'search'
 *      recordLevel: // value for 'recordLevel'
 *      propertyIds: // value for 'propertyIds'
 *   },
 * });
 */
export function useGetGlAccountsTableQuery(baseOptions: Apollo.QueryHookOptions<GetGlAccountsTableQuery, GetGlAccountsTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGlAccountsTableQuery, GetGlAccountsTableQueryVariables>(GetGlAccountsTableDocument, options);
      }
export function useGetGlAccountsTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGlAccountsTableQuery, GetGlAccountsTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGlAccountsTableQuery, GetGlAccountsTableQueryVariables>(GetGlAccountsTableDocument, options);
        }
export type GetGlAccountsTableQueryHookResult = ReturnType<typeof useGetGlAccountsTableQuery>;
export type GetGlAccountsTableLazyQueryHookResult = ReturnType<typeof useGetGlAccountsTableLazyQuery>;
export type GetGlAccountsTableQueryResult = Apollo.QueryResult<GetGlAccountsTableQuery, GetGlAccountsTableQueryVariables>;
export const GetGlAccountsDropdownDocument = gql`
    query getGLAccountsDropdown($portfolioId: String!, $active: Boolean, $search: String, $recordLevel: RecordLevel, $propertyIds: [String!]) {
  getGLAccounts(
    active: $active
    portfolioId: $portfolioId
    search: $search
    recordLevel: $recordLevel
    propertyIds: $propertyIds
  ) {
    ...GLAccountCoreFields
    active
  }
}
    ${GlAccountCoreFieldsFragmentDoc}`;

/**
 * __useGetGlAccountsDropdownQuery__
 *
 * To run a query within a React component, call `useGetGlAccountsDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGlAccountsDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGlAccountsDropdownQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      active: // value for 'active'
 *      search: // value for 'search'
 *      recordLevel: // value for 'recordLevel'
 *      propertyIds: // value for 'propertyIds'
 *   },
 * });
 */
export function useGetGlAccountsDropdownQuery(baseOptions: Apollo.QueryHookOptions<GetGlAccountsDropdownQuery, GetGlAccountsDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGlAccountsDropdownQuery, GetGlAccountsDropdownQueryVariables>(GetGlAccountsDropdownDocument, options);
      }
export function useGetGlAccountsDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGlAccountsDropdownQuery, GetGlAccountsDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGlAccountsDropdownQuery, GetGlAccountsDropdownQueryVariables>(GetGlAccountsDropdownDocument, options);
        }
export type GetGlAccountsDropdownQueryHookResult = ReturnType<typeof useGetGlAccountsDropdownQuery>;
export type GetGlAccountsDropdownLazyQueryHookResult = ReturnType<typeof useGetGlAccountsDropdownLazyQuery>;
export type GetGlAccountsDropdownQueryResult = Apollo.QueryResult<GetGlAccountsDropdownQuery, GetGlAccountsDropdownQueryVariables>;
export const GetGlAccountDocument = gql`
    query getGLAccount($id: String!) {
  getGLAccount(id: $id) {
    ...GLAccountFields
  }
}
    ${GlAccountFieldsFragmentDoc}`;

/**
 * __useGetGlAccountQuery__
 *
 * To run a query within a React component, call `useGetGlAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGlAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGlAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGlAccountQuery(baseOptions: Apollo.QueryHookOptions<GetGlAccountQuery, GetGlAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGlAccountQuery, GetGlAccountQueryVariables>(GetGlAccountDocument, options);
      }
export function useGetGlAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGlAccountQuery, GetGlAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGlAccountQuery, GetGlAccountQueryVariables>(GetGlAccountDocument, options);
        }
export type GetGlAccountQueryHookResult = ReturnType<typeof useGetGlAccountQuery>;
export type GetGlAccountLazyQueryHookResult = ReturnType<typeof useGetGlAccountLazyQuery>;
export type GetGlAccountQueryResult = Apollo.QueryResult<GetGlAccountQuery, GetGlAccountQueryVariables>;
export const CreateCategoryGroupDocument = gql`
    mutation createCategoryGroup($portfolioId: String!, $recordType: CategoryRecordType!, $data: CategoryGroupInput!) {
  createCategoryGroup(
    portfolioId: $portfolioId
    recordType: $recordType
    input: $data
  ) {
    id
  }
}
    `;
export type CreateCategoryGroupMutationFn = Apollo.MutationFunction<CreateCategoryGroupMutation, CreateCategoryGroupMutationVariables>;

/**
 * __useCreateCategoryGroupMutation__
 *
 * To run a mutation, you first call `useCreateCategoryGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCategoryGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCategoryGroupMutation, { data, loading, error }] = useCreateCategoryGroupMutation({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      recordType: // value for 'recordType'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCategoryGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateCategoryGroupMutation, CreateCategoryGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCategoryGroupMutation, CreateCategoryGroupMutationVariables>(CreateCategoryGroupDocument, options);
      }
export type CreateCategoryGroupMutationHookResult = ReturnType<typeof useCreateCategoryGroupMutation>;
export type CreateCategoryGroupMutationResult = Apollo.MutationResult<CreateCategoryGroupMutation>;
export type CreateCategoryGroupMutationOptions = Apollo.BaseMutationOptions<CreateCategoryGroupMutation, CreateCategoryGroupMutationVariables>;
export const UpdateCategoryGroupDocument = gql`
    mutation updateCategoryGroup($id: String!, $data: CategoryGroupInput!) {
  updateCategoryGroup(id: $id, input: $data) {
    ...CategoryGroupFields
  }
}
    ${CategoryGroupFieldsFragmentDoc}`;
export type UpdateCategoryGroupMutationFn = Apollo.MutationFunction<UpdateCategoryGroupMutation, UpdateCategoryGroupMutationVariables>;

/**
 * __useUpdateCategoryGroupMutation__
 *
 * To run a mutation, you first call `useUpdateCategoryGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCategoryGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCategoryGroupMutation, { data, loading, error }] = useUpdateCategoryGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCategoryGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCategoryGroupMutation, UpdateCategoryGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCategoryGroupMutation, UpdateCategoryGroupMutationVariables>(UpdateCategoryGroupDocument, options);
      }
export type UpdateCategoryGroupMutationHookResult = ReturnType<typeof useUpdateCategoryGroupMutation>;
export type UpdateCategoryGroupMutationResult = Apollo.MutationResult<UpdateCategoryGroupMutation>;
export type UpdateCategoryGroupMutationOptions = Apollo.BaseMutationOptions<UpdateCategoryGroupMutation, UpdateCategoryGroupMutationVariables>;
export const ToggleCategoryGroupDocument = gql`
    mutation toggleCategoryGroup($id: String!) {
  toggleCategoryGroup(id: $id)
}
    `;
export type ToggleCategoryGroupMutationFn = Apollo.MutationFunction<ToggleCategoryGroupMutation, ToggleCategoryGroupMutationVariables>;

/**
 * __useToggleCategoryGroupMutation__
 *
 * To run a mutation, you first call `useToggleCategoryGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleCategoryGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleCategoryGroupMutation, { data, loading, error }] = useToggleCategoryGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleCategoryGroupMutation(baseOptions?: Apollo.MutationHookOptions<ToggleCategoryGroupMutation, ToggleCategoryGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleCategoryGroupMutation, ToggleCategoryGroupMutationVariables>(ToggleCategoryGroupDocument, options);
      }
export type ToggleCategoryGroupMutationHookResult = ReturnType<typeof useToggleCategoryGroupMutation>;
export type ToggleCategoryGroupMutationResult = Apollo.MutationResult<ToggleCategoryGroupMutation>;
export type ToggleCategoryGroupMutationOptions = Apollo.BaseMutationOptions<ToggleCategoryGroupMutation, ToggleCategoryGroupMutationVariables>;
export const RemoveCategoryGroupsDocument = gql`
    mutation removeCategoryGroups($data: DeleteRecordsInput!) {
  removeCategoryGroups(input: $data)
}
    `;
export type RemoveCategoryGroupsMutationFn = Apollo.MutationFunction<RemoveCategoryGroupsMutation, RemoveCategoryGroupsMutationVariables>;

/**
 * __useRemoveCategoryGroupsMutation__
 *
 * To run a mutation, you first call `useRemoveCategoryGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCategoryGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCategoryGroupsMutation, { data, loading, error }] = useRemoveCategoryGroupsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveCategoryGroupsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCategoryGroupsMutation, RemoveCategoryGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCategoryGroupsMutation, RemoveCategoryGroupsMutationVariables>(RemoveCategoryGroupsDocument, options);
      }
export type RemoveCategoryGroupsMutationHookResult = ReturnType<typeof useRemoveCategoryGroupsMutation>;
export type RemoveCategoryGroupsMutationResult = Apollo.MutationResult<RemoveCategoryGroupsMutation>;
export type RemoveCategoryGroupsMutationOptions = Apollo.BaseMutationOptions<RemoveCategoryGroupsMutation, RemoveCategoryGroupsMutationVariables>;
export const GetCategoryGroupsTableDocument = gql`
    query getCategoryGroupsTable($portfolioId: String!, $recordType: CategoryRecordType!, $recordLevel: RecordLevel, $active: Boolean, $take: Int! = 10, $after: String, $before: String, $search: String, $propertyIds: [String!]) {
  getCategoryGroups(
    portfolioId: $portfolioId
    recordType: $recordType
    recordLevel: $recordLevel
    active: $active
    take: $take
    after: $after
    before: $before
    search: $search
    propertyIds: $propertyIds
  ) @connection(key: "getCategoryGroupsTable") {
    pagination {
      ...PaginationFields
    }
    data {
      ...CategoryGroupCoreFields
      index
      icon
      active
      categoryCount
      property {
        ...PropertyCoreFields
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${CategoryGroupCoreFieldsFragmentDoc}
${PropertyCoreFieldsFragmentDoc}`;

/**
 * __useGetCategoryGroupsTableQuery__
 *
 * To run a query within a React component, call `useGetCategoryGroupsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoryGroupsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoryGroupsTableQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      recordType: // value for 'recordType'
 *      recordLevel: // value for 'recordLevel'
 *      active: // value for 'active'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      propertyIds: // value for 'propertyIds'
 *   },
 * });
 */
export function useGetCategoryGroupsTableQuery(baseOptions: Apollo.QueryHookOptions<GetCategoryGroupsTableQuery, GetCategoryGroupsTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoryGroupsTableQuery, GetCategoryGroupsTableQueryVariables>(GetCategoryGroupsTableDocument, options);
      }
export function useGetCategoryGroupsTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoryGroupsTableQuery, GetCategoryGroupsTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoryGroupsTableQuery, GetCategoryGroupsTableQueryVariables>(GetCategoryGroupsTableDocument, options);
        }
export type GetCategoryGroupsTableQueryHookResult = ReturnType<typeof useGetCategoryGroupsTableQuery>;
export type GetCategoryGroupsTableLazyQueryHookResult = ReturnType<typeof useGetCategoryGroupsTableLazyQuery>;
export type GetCategoryGroupsTableQueryResult = Apollo.QueryResult<GetCategoryGroupsTableQuery, GetCategoryGroupsTableQueryVariables>;
export const GetCategoryGroupsDropdownDocument = gql`
    query getCategoryGroupsDropdown($portfolioId: String!, $recordType: CategoryRecordType!, $recordLevel: RecordLevel, $active: Boolean, $take: Int! = 10, $after: String, $before: String, $search: String, $propertyIds: [String!]) {
  getCategoryGroups(
    portfolioId: $portfolioId
    recordType: $recordType
    recordLevel: $recordLevel
    active: $active
    take: $take
    after: $after
    before: $before
    search: $search
    propertyIds: $propertyIds
  ) @connection(key: "getCategoryGroupsDropdown") {
    pagination {
      ...PaginationFields
    }
    data {
      ...CategoryGroupCoreFields
      icon
      active
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${CategoryGroupCoreFieldsFragmentDoc}`;

/**
 * __useGetCategoryGroupsDropdownQuery__
 *
 * To run a query within a React component, call `useGetCategoryGroupsDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoryGroupsDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoryGroupsDropdownQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      recordType: // value for 'recordType'
 *      recordLevel: // value for 'recordLevel'
 *      active: // value for 'active'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      propertyIds: // value for 'propertyIds'
 *   },
 * });
 */
export function useGetCategoryGroupsDropdownQuery(baseOptions: Apollo.QueryHookOptions<GetCategoryGroupsDropdownQuery, GetCategoryGroupsDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoryGroupsDropdownQuery, GetCategoryGroupsDropdownQueryVariables>(GetCategoryGroupsDropdownDocument, options);
      }
export function useGetCategoryGroupsDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoryGroupsDropdownQuery, GetCategoryGroupsDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoryGroupsDropdownQuery, GetCategoryGroupsDropdownQueryVariables>(GetCategoryGroupsDropdownDocument, options);
        }
export type GetCategoryGroupsDropdownQueryHookResult = ReturnType<typeof useGetCategoryGroupsDropdownQuery>;
export type GetCategoryGroupsDropdownLazyQueryHookResult = ReturnType<typeof useGetCategoryGroupsDropdownLazyQuery>;
export type GetCategoryGroupsDropdownQueryResult = Apollo.QueryResult<GetCategoryGroupsDropdownQuery, GetCategoryGroupsDropdownQueryVariables>;
export const GetCategoryGroupDocument = gql`
    query getCategoryGroup($id: String!) {
  getCategoryGroup(id: $id) {
    ...CategoryGroupFields
  }
}
    ${CategoryGroupFieldsFragmentDoc}`;

/**
 * __useGetCategoryGroupQuery__
 *
 * To run a query within a React component, call `useGetCategoryGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoryGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoryGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCategoryGroupQuery(baseOptions: Apollo.QueryHookOptions<GetCategoryGroupQuery, GetCategoryGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoryGroupQuery, GetCategoryGroupQueryVariables>(GetCategoryGroupDocument, options);
      }
export function useGetCategoryGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoryGroupQuery, GetCategoryGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoryGroupQuery, GetCategoryGroupQueryVariables>(GetCategoryGroupDocument, options);
        }
export type GetCategoryGroupQueryHookResult = ReturnType<typeof useGetCategoryGroupQuery>;
export type GetCategoryGroupLazyQueryHookResult = ReturnType<typeof useGetCategoryGroupLazyQuery>;
export type GetCategoryGroupQueryResult = Apollo.QueryResult<GetCategoryGroupQuery, GetCategoryGroupQueryVariables>;
export const CreateCategoryDocument = gql`
    mutation createCategory($portfolioId: String!, $recordType: CategoryRecordType!, $data: CategoryInput!) {
  createCategory(portfolioId: $portfolioId, recordType: $recordType, input: $data) {
    id
  }
}
    `;
export type CreateCategoryMutationFn = Apollo.MutationFunction<CreateCategoryMutation, CreateCategoryMutationVariables>;

/**
 * __useCreateCategoryMutation__
 *
 * To run a mutation, you first call `useCreateCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCategoryMutation, { data, loading, error }] = useCreateCategoryMutation({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      recordType: // value for 'recordType'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateCategoryMutation, CreateCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCategoryMutation, CreateCategoryMutationVariables>(CreateCategoryDocument, options);
      }
export type CreateCategoryMutationHookResult = ReturnType<typeof useCreateCategoryMutation>;
export type CreateCategoryMutationResult = Apollo.MutationResult<CreateCategoryMutation>;
export type CreateCategoryMutationOptions = Apollo.BaseMutationOptions<CreateCategoryMutation, CreateCategoryMutationVariables>;
export const UpdateCategoryDocument = gql`
    mutation updateCategory($id: String!, $data: CategoryInput!) {
  updateCategory(id: $id, input: $data) {
    ...CategoryFields
  }
}
    ${CategoryFieldsFragmentDoc}`;
export type UpdateCategoryMutationFn = Apollo.MutationFunction<UpdateCategoryMutation, UpdateCategoryMutationVariables>;

/**
 * __useUpdateCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCategoryMutation, { data, loading, error }] = useUpdateCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCategoryMutation, UpdateCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCategoryMutation, UpdateCategoryMutationVariables>(UpdateCategoryDocument, options);
      }
export type UpdateCategoryMutationHookResult = ReturnType<typeof useUpdateCategoryMutation>;
export type UpdateCategoryMutationResult = Apollo.MutationResult<UpdateCategoryMutation>;
export type UpdateCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateCategoryMutation, UpdateCategoryMutationVariables>;
export const ToggleCategoryDocument = gql`
    mutation toggleCategory($id: String!) {
  toggleCategory(id: $id)
}
    `;
export type ToggleCategoryMutationFn = Apollo.MutationFunction<ToggleCategoryMutation, ToggleCategoryMutationVariables>;

/**
 * __useToggleCategoryMutation__
 *
 * To run a mutation, you first call `useToggleCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleCategoryMutation, { data, loading, error }] = useToggleCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleCategoryMutation(baseOptions?: Apollo.MutationHookOptions<ToggleCategoryMutation, ToggleCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleCategoryMutation, ToggleCategoryMutationVariables>(ToggleCategoryDocument, options);
      }
export type ToggleCategoryMutationHookResult = ReturnType<typeof useToggleCategoryMutation>;
export type ToggleCategoryMutationResult = Apollo.MutationResult<ToggleCategoryMutation>;
export type ToggleCategoryMutationOptions = Apollo.BaseMutationOptions<ToggleCategoryMutation, ToggleCategoryMutationVariables>;
export const RemoveCategoriesDocument = gql`
    mutation removeCategories($data: DeleteRecordsInput!) {
  removeCategories(input: $data)
}
    `;
export type RemoveCategoriesMutationFn = Apollo.MutationFunction<RemoveCategoriesMutation, RemoveCategoriesMutationVariables>;

/**
 * __useRemoveCategoriesMutation__
 *
 * To run a mutation, you first call `useRemoveCategoriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCategoriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCategoriesMutation, { data, loading, error }] = useRemoveCategoriesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveCategoriesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCategoriesMutation, RemoveCategoriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCategoriesMutation, RemoveCategoriesMutationVariables>(RemoveCategoriesDocument, options);
      }
export type RemoveCategoriesMutationHookResult = ReturnType<typeof useRemoveCategoriesMutation>;
export type RemoveCategoriesMutationResult = Apollo.MutationResult<RemoveCategoriesMutation>;
export type RemoveCategoriesMutationOptions = Apollo.BaseMutationOptions<RemoveCategoriesMutation, RemoveCategoriesMutationVariables>;
export const GetCategoriesTableDocument = gql`
    query getCategoriesTable($portfolioId: String!, $recordType: CategoryRecordType!, $recordLevel: RecordLevel, $active: Boolean, $take: Int! = 10, $after: String, $before: String, $search: String, $propertyIds: [String!]) {
  getCategories(
    portfolioId: $portfolioId
    recordType: $recordType
    recordLevel: $recordLevel
    active: $active
    take: $take
    after: $after
    before: $before
    search: $search
    propertyIds: $propertyIds
  ) @connection(key: "getCategoriesTable") {
    pagination {
      ...PaginationFields
    }
    data {
      ...CategoryCoreFields
      index
      active
      description
      defaultPriority {
        ...PriorityCoreFields
        color
      }
      group {
        ...CategoryGroupCoreFields
      }
      property {
        ...PropertyCoreFields
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${CategoryCoreFieldsFragmentDoc}
${PriorityCoreFieldsFragmentDoc}
${CategoryGroupCoreFieldsFragmentDoc}
${PropertyCoreFieldsFragmentDoc}`;

/**
 * __useGetCategoriesTableQuery__
 *
 * To run a query within a React component, call `useGetCategoriesTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesTableQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      recordType: // value for 'recordType'
 *      recordLevel: // value for 'recordLevel'
 *      active: // value for 'active'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      propertyIds: // value for 'propertyIds'
 *   },
 * });
 */
export function useGetCategoriesTableQuery(baseOptions: Apollo.QueryHookOptions<GetCategoriesTableQuery, GetCategoriesTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoriesTableQuery, GetCategoriesTableQueryVariables>(GetCategoriesTableDocument, options);
      }
export function useGetCategoriesTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoriesTableQuery, GetCategoriesTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoriesTableQuery, GetCategoriesTableQueryVariables>(GetCategoriesTableDocument, options);
        }
export type GetCategoriesTableQueryHookResult = ReturnType<typeof useGetCategoriesTableQuery>;
export type GetCategoriesTableLazyQueryHookResult = ReturnType<typeof useGetCategoriesTableLazyQuery>;
export type GetCategoriesTableQueryResult = Apollo.QueryResult<GetCategoriesTableQuery, GetCategoriesTableQueryVariables>;
export const GetCategoriesDropdownDocument = gql`
    query getCategoriesDropdown($portfolioId: String!, $recordType: CategoryRecordType!, $recordLevel: RecordLevel, $active: Boolean, $take: Int! = 10, $after: String, $before: String, $search: String, $propertyIds: [String!], $includeGroup: Boolean!, $includeDescription: Boolean!, $includePriority: Boolean!) {
  getCategories(
    portfolioId: $portfolioId
    recordType: $recordType
    recordLevel: $recordLevel
    active: $active
    take: $take
    after: $after
    before: $before
    search: $search
    propertyIds: $propertyIds
  ) @connection(key: "getCategoriesDropdown") {
    pagination {
      ...PaginationFields
    }
    data {
      ...CategoryCoreFields
      active
      description @include(if: $includeDescription)
      group @include(if: $includeGroup) {
        ...CategoryGroupCoreFields
      }
      defaultPriority @include(if: $includePriority) {
        ...PriorityCoreFields
        color
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${CategoryCoreFieldsFragmentDoc}
${CategoryGroupCoreFieldsFragmentDoc}
${PriorityCoreFieldsFragmentDoc}`;

/**
 * __useGetCategoriesDropdownQuery__
 *
 * To run a query within a React component, call `useGetCategoriesDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesDropdownQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      recordType: // value for 'recordType'
 *      recordLevel: // value for 'recordLevel'
 *      active: // value for 'active'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      propertyIds: // value for 'propertyIds'
 *      includeGroup: // value for 'includeGroup'
 *      includeDescription: // value for 'includeDescription'
 *      includePriority: // value for 'includePriority'
 *   },
 * });
 */
export function useGetCategoriesDropdownQuery(baseOptions: Apollo.QueryHookOptions<GetCategoriesDropdownQuery, GetCategoriesDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoriesDropdownQuery, GetCategoriesDropdownQueryVariables>(GetCategoriesDropdownDocument, options);
      }
export function useGetCategoriesDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoriesDropdownQuery, GetCategoriesDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoriesDropdownQuery, GetCategoriesDropdownQueryVariables>(GetCategoriesDropdownDocument, options);
        }
export type GetCategoriesDropdownQueryHookResult = ReturnType<typeof useGetCategoriesDropdownQuery>;
export type GetCategoriesDropdownLazyQueryHookResult = ReturnType<typeof useGetCategoriesDropdownLazyQuery>;
export type GetCategoriesDropdownQueryResult = Apollo.QueryResult<GetCategoriesDropdownQuery, GetCategoriesDropdownQueryVariables>;
export const GetCategoriesDropdownGroupedDocument = gql`
    query getCategoriesDropdownGrouped($portfolioId: String!, $recordType: CategoryRecordType!, $recordLevel: RecordLevel, $active: Boolean, $take: Int! = 10, $after: String, $before: String, $search: String, $propertyIds: [String!], $includeDescription: Boolean!, $includePriority: Boolean!) {
  getCategoriesGrouped(
    portfolioId: $portfolioId
    recordType: $recordType
    recordLevel: $recordLevel
    active: $active
    take: $take
    after: $after
    before: $before
    search: $search
    propertyIds: $propertyIds
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      title
      icon
      active
      categories {
        ...CategoryCoreFields
        active
        description @include(if: $includeDescription)
        defaultPriority @include(if: $includePriority) {
          ...PriorityCoreFields
          color
        }
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${CategoryCoreFieldsFragmentDoc}
${PriorityCoreFieldsFragmentDoc}`;

/**
 * __useGetCategoriesDropdownGroupedQuery__
 *
 * To run a query within a React component, call `useGetCategoriesDropdownGroupedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesDropdownGroupedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesDropdownGroupedQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      recordType: // value for 'recordType'
 *      recordLevel: // value for 'recordLevel'
 *      active: // value for 'active'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      propertyIds: // value for 'propertyIds'
 *      includeDescription: // value for 'includeDescription'
 *      includePriority: // value for 'includePriority'
 *   },
 * });
 */
export function useGetCategoriesDropdownGroupedQuery(baseOptions: Apollo.QueryHookOptions<GetCategoriesDropdownGroupedQuery, GetCategoriesDropdownGroupedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoriesDropdownGroupedQuery, GetCategoriesDropdownGroupedQueryVariables>(GetCategoriesDropdownGroupedDocument, options);
      }
export function useGetCategoriesDropdownGroupedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoriesDropdownGroupedQuery, GetCategoriesDropdownGroupedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoriesDropdownGroupedQuery, GetCategoriesDropdownGroupedQueryVariables>(GetCategoriesDropdownGroupedDocument, options);
        }
export type GetCategoriesDropdownGroupedQueryHookResult = ReturnType<typeof useGetCategoriesDropdownGroupedQuery>;
export type GetCategoriesDropdownGroupedLazyQueryHookResult = ReturnType<typeof useGetCategoriesDropdownGroupedLazyQuery>;
export type GetCategoriesDropdownGroupedQueryResult = Apollo.QueryResult<GetCategoriesDropdownGroupedQuery, GetCategoriesDropdownGroupedQueryVariables>;
export const GetFilterableGroupedCategoriesDocument = gql`
    query getFilterableGroupedCategories($portfolioId: String!, $location: FilterableCategoryLocationType!, $take: Int! = 10, $after: String, $before: String, $search: String) {
  getFilterableGroupedCategories(
    portfolioId: $portfolioId
    location: $location
    take: $take
    after: $after
    before: $before
    search: $search
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      id
      title
      icon
      active
      isDeleted
      categories {
        id
        title
        active
        isDeleted
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}`;

/**
 * __useGetFilterableGroupedCategoriesQuery__
 *
 * To run a query within a React component, call `useGetFilterableGroupedCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilterableGroupedCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilterableGroupedCategoriesQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      location: // value for 'location'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetFilterableGroupedCategoriesQuery(baseOptions: Apollo.QueryHookOptions<GetFilterableGroupedCategoriesQuery, GetFilterableGroupedCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilterableGroupedCategoriesQuery, GetFilterableGroupedCategoriesQueryVariables>(GetFilterableGroupedCategoriesDocument, options);
      }
export function useGetFilterableGroupedCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilterableGroupedCategoriesQuery, GetFilterableGroupedCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilterableGroupedCategoriesQuery, GetFilterableGroupedCategoriesQueryVariables>(GetFilterableGroupedCategoriesDocument, options);
        }
export type GetFilterableGroupedCategoriesQueryHookResult = ReturnType<typeof useGetFilterableGroupedCategoriesQuery>;
export type GetFilterableGroupedCategoriesLazyQueryHookResult = ReturnType<typeof useGetFilterableGroupedCategoriesLazyQuery>;
export type GetFilterableGroupedCategoriesQueryResult = Apollo.QueryResult<GetFilterableGroupedCategoriesQuery, GetFilterableGroupedCategoriesQueryVariables>;
export const GetCategoryDocument = gql`
    query getCategory($id: String!) {
  getCategory(id: $id) {
    ...CategoryFields
  }
}
    ${CategoryFieldsFragmentDoc}`;

/**
 * __useGetCategoryQuery__
 *
 * To run a query within a React component, call `useGetCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCategoryQuery(baseOptions: Apollo.QueryHookOptions<GetCategoryQuery, GetCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoryQuery, GetCategoryQueryVariables>(GetCategoryDocument, options);
      }
export function useGetCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoryQuery, GetCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoryQuery, GetCategoryQueryVariables>(GetCategoryDocument, options);
        }
export type GetCategoryQueryHookResult = ReturnType<typeof useGetCategoryQuery>;
export type GetCategoryLazyQueryHookResult = ReturnType<typeof useGetCategoryLazyQuery>;
export type GetCategoryQueryResult = Apollo.QueryResult<GetCategoryQuery, GetCategoryQueryVariables>;
export const CreateLaborRateDocument = gql`
    mutation createLaborRate($data: LaborRateInput!, $portfolioId: String!) {
  createLaborRate(input: $data, portfolioId: $portfolioId) {
    id
  }
}
    `;
export type CreateLaborRateMutationFn = Apollo.MutationFunction<CreateLaborRateMutation, CreateLaborRateMutationVariables>;

/**
 * __useCreateLaborRateMutation__
 *
 * To run a mutation, you first call `useCreateLaborRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLaborRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLaborRateMutation, { data, loading, error }] = useCreateLaborRateMutation({
 *   variables: {
 *      data: // value for 'data'
 *      portfolioId: // value for 'portfolioId'
 *   },
 * });
 */
export function useCreateLaborRateMutation(baseOptions?: Apollo.MutationHookOptions<CreateLaborRateMutation, CreateLaborRateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLaborRateMutation, CreateLaborRateMutationVariables>(CreateLaborRateDocument, options);
      }
export type CreateLaborRateMutationHookResult = ReturnType<typeof useCreateLaborRateMutation>;
export type CreateLaborRateMutationResult = Apollo.MutationResult<CreateLaborRateMutation>;
export type CreateLaborRateMutationOptions = Apollo.BaseMutationOptions<CreateLaborRateMutation, CreateLaborRateMutationVariables>;
export const UpdateLaborRateDocument = gql`
    mutation updateLaborRate($id: String!, $data: LaborRateInput!) {
  updateLaborRate(id: $id, input: $data) {
    ...LaborRateFields
  }
}
    ${LaborRateFieldsFragmentDoc}`;
export type UpdateLaborRateMutationFn = Apollo.MutationFunction<UpdateLaborRateMutation, UpdateLaborRateMutationVariables>;

/**
 * __useUpdateLaborRateMutation__
 *
 * To run a mutation, you first call `useUpdateLaborRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLaborRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLaborRateMutation, { data, loading, error }] = useUpdateLaborRateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateLaborRateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLaborRateMutation, UpdateLaborRateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLaborRateMutation, UpdateLaborRateMutationVariables>(UpdateLaborRateDocument, options);
      }
export type UpdateLaborRateMutationHookResult = ReturnType<typeof useUpdateLaborRateMutation>;
export type UpdateLaborRateMutationResult = Apollo.MutationResult<UpdateLaborRateMutation>;
export type UpdateLaborRateMutationOptions = Apollo.BaseMutationOptions<UpdateLaborRateMutation, UpdateLaborRateMutationVariables>;
export const ToggleLaborRateDocument = gql`
    mutation toggleLaborRate($id: String!) {
  toggleLaborRate(id: $id)
}
    `;
export type ToggleLaborRateMutationFn = Apollo.MutationFunction<ToggleLaborRateMutation, ToggleLaborRateMutationVariables>;

/**
 * __useToggleLaborRateMutation__
 *
 * To run a mutation, you first call `useToggleLaborRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleLaborRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleLaborRateMutation, { data, loading, error }] = useToggleLaborRateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleLaborRateMutation(baseOptions?: Apollo.MutationHookOptions<ToggleLaborRateMutation, ToggleLaborRateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleLaborRateMutation, ToggleLaborRateMutationVariables>(ToggleLaborRateDocument, options);
      }
export type ToggleLaborRateMutationHookResult = ReturnType<typeof useToggleLaborRateMutation>;
export type ToggleLaborRateMutationResult = Apollo.MutationResult<ToggleLaborRateMutation>;
export type ToggleLaborRateMutationOptions = Apollo.BaseMutationOptions<ToggleLaborRateMutation, ToggleLaborRateMutationVariables>;
export const RemoveLaborRatesDocument = gql`
    mutation removeLaborRates($data: DeleteRecordsInput!) {
  removeLaborRates(input: $data)
}
    `;
export type RemoveLaborRatesMutationFn = Apollo.MutationFunction<RemoveLaborRatesMutation, RemoveLaborRatesMutationVariables>;

/**
 * __useRemoveLaborRatesMutation__
 *
 * To run a mutation, you first call `useRemoveLaborRatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveLaborRatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeLaborRatesMutation, { data, loading, error }] = useRemoveLaborRatesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveLaborRatesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveLaborRatesMutation, RemoveLaborRatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveLaborRatesMutation, RemoveLaborRatesMutationVariables>(RemoveLaborRatesDocument, options);
      }
export type RemoveLaborRatesMutationHookResult = ReturnType<typeof useRemoveLaborRatesMutation>;
export type RemoveLaborRatesMutationResult = Apollo.MutationResult<RemoveLaborRatesMutation>;
export type RemoveLaborRatesMutationOptions = Apollo.BaseMutationOptions<RemoveLaborRatesMutation, RemoveLaborRatesMutationVariables>;
export const GetLaborRatesTableDocument = gql`
    query getLaborRatesTable($portfolioId: String!, $active: Boolean, $search: String, $recordLevel: RecordLevel, $propertyIds: [String!]) {
  getLaborRates(
    active: $active
    portfolioId: $portfolioId
    search: $search
    recordLevel: $recordLevel
    propertyIds: $propertyIds
  ) {
    ...LaborRateCoreFields
    index
    active
    rate
    description
    markup {
      ...MarkupCoreFields
    }
    property {
      ...PropertyCoreFields
    }
    glAccount {
      ...GLAccountCoreFields
    }
    arCode {
      ...ARCodeCoreFields
    }
    chargeCode {
      ...ChargeCodeCoreFields
    }
  }
}
    ${LaborRateCoreFieldsFragmentDoc}
${MarkupCoreFieldsFragmentDoc}
${PropertyCoreFieldsFragmentDoc}
${GlAccountCoreFieldsFragmentDoc}
${ArCodeCoreFieldsFragmentDoc}
${ChargeCodeCoreFieldsFragmentDoc}`;

/**
 * __useGetLaborRatesTableQuery__
 *
 * To run a query within a React component, call `useGetLaborRatesTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLaborRatesTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLaborRatesTableQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      active: // value for 'active'
 *      search: // value for 'search'
 *      recordLevel: // value for 'recordLevel'
 *      propertyIds: // value for 'propertyIds'
 *   },
 * });
 */
export function useGetLaborRatesTableQuery(baseOptions: Apollo.QueryHookOptions<GetLaborRatesTableQuery, GetLaborRatesTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLaborRatesTableQuery, GetLaborRatesTableQueryVariables>(GetLaborRatesTableDocument, options);
      }
export function useGetLaborRatesTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLaborRatesTableQuery, GetLaborRatesTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLaborRatesTableQuery, GetLaborRatesTableQueryVariables>(GetLaborRatesTableDocument, options);
        }
export type GetLaborRatesTableQueryHookResult = ReturnType<typeof useGetLaborRatesTableQuery>;
export type GetLaborRatesTableLazyQueryHookResult = ReturnType<typeof useGetLaborRatesTableLazyQuery>;
export type GetLaborRatesTableQueryResult = Apollo.QueryResult<GetLaborRatesTableQuery, GetLaborRatesTableQueryVariables>;
export const GetLaborRatesDropdownDocument = gql`
    query getLaborRatesDropdown($portfolioId: String!, $active: Boolean, $search: String, $recordLevel: RecordLevel, $propertyIds: [String!], $includeDescription: Boolean!, $includeMarkup: Boolean!, $includeGLAccount: Boolean!, $includeARCode: Boolean!, $includeChargeCode: Boolean!) {
  getLaborRates(
    active: $active
    portfolioId: $portfolioId
    search: $search
    recordLevel: $recordLevel
    propertyIds: $propertyIds
  ) {
    ...LaborRateCoreFields
    active
    rate
    description @include(if: $includeDescription)
    markup @include(if: $includeMarkup) {
      ...MarkupCoreFields
      type
      amount
    }
    glAccount @include(if: $includeGLAccount) {
      ...GLAccountCoreFields
    }
    arCode @include(if: $includeARCode) {
      ...ARCodeCoreFields
    }
    chargeCode @include(if: $includeChargeCode) {
      ...ChargeCodeCoreFields
    }
  }
}
    ${LaborRateCoreFieldsFragmentDoc}
${MarkupCoreFieldsFragmentDoc}
${GlAccountCoreFieldsFragmentDoc}
${ArCodeCoreFieldsFragmentDoc}
${ChargeCodeCoreFieldsFragmentDoc}`;

/**
 * __useGetLaborRatesDropdownQuery__
 *
 * To run a query within a React component, call `useGetLaborRatesDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLaborRatesDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLaborRatesDropdownQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      active: // value for 'active'
 *      search: // value for 'search'
 *      recordLevel: // value for 'recordLevel'
 *      propertyIds: // value for 'propertyIds'
 *      includeDescription: // value for 'includeDescription'
 *      includeMarkup: // value for 'includeMarkup'
 *      includeGLAccount: // value for 'includeGLAccount'
 *      includeARCode: // value for 'includeARCode'
 *      includeChargeCode: // value for 'includeChargeCode'
 *   },
 * });
 */
export function useGetLaborRatesDropdownQuery(baseOptions: Apollo.QueryHookOptions<GetLaborRatesDropdownQuery, GetLaborRatesDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLaborRatesDropdownQuery, GetLaborRatesDropdownQueryVariables>(GetLaborRatesDropdownDocument, options);
      }
export function useGetLaborRatesDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLaborRatesDropdownQuery, GetLaborRatesDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLaborRatesDropdownQuery, GetLaborRatesDropdownQueryVariables>(GetLaborRatesDropdownDocument, options);
        }
export type GetLaborRatesDropdownQueryHookResult = ReturnType<typeof useGetLaborRatesDropdownQuery>;
export type GetLaborRatesDropdownLazyQueryHookResult = ReturnType<typeof useGetLaborRatesDropdownLazyQuery>;
export type GetLaborRatesDropdownQueryResult = Apollo.QueryResult<GetLaborRatesDropdownQuery, GetLaborRatesDropdownQueryVariables>;
export const GetLaborRateDocument = gql`
    query getLaborRate($id: String!) {
  getLaborRate(id: $id) {
    ...LaborRateFields
  }
}
    ${LaborRateFieldsFragmentDoc}`;

/**
 * __useGetLaborRateQuery__
 *
 * To run a query within a React component, call `useGetLaborRateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLaborRateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLaborRateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLaborRateQuery(baseOptions: Apollo.QueryHookOptions<GetLaborRateQuery, GetLaborRateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLaborRateQuery, GetLaborRateQueryVariables>(GetLaborRateDocument, options);
      }
export function useGetLaborRateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLaborRateQuery, GetLaborRateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLaborRateQuery, GetLaborRateQueryVariables>(GetLaborRateDocument, options);
        }
export type GetLaborRateQueryHookResult = ReturnType<typeof useGetLaborRateQuery>;
export type GetLaborRateLazyQueryHookResult = ReturnType<typeof useGetLaborRateLazyQuery>;
export type GetLaborRateQueryResult = Apollo.QueryResult<GetLaborRateQuery, GetLaborRateQueryVariables>;
export const CreateLeaseChargeTypeDocument = gql`
    mutation createLeaseChargeType($title: String!, $portfolioId: String!) {
  createLeaseChargeType(title: $title, portfolioId: $portfolioId) {
    id
  }
}
    `;
export type CreateLeaseChargeTypeMutationFn = Apollo.MutationFunction<CreateLeaseChargeTypeMutation, CreateLeaseChargeTypeMutationVariables>;

/**
 * __useCreateLeaseChargeTypeMutation__
 *
 * To run a mutation, you first call `useCreateLeaseChargeTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLeaseChargeTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLeaseChargeTypeMutation, { data, loading, error }] = useCreateLeaseChargeTypeMutation({
 *   variables: {
 *      title: // value for 'title'
 *      portfolioId: // value for 'portfolioId'
 *   },
 * });
 */
export function useCreateLeaseChargeTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateLeaseChargeTypeMutation, CreateLeaseChargeTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLeaseChargeTypeMutation, CreateLeaseChargeTypeMutationVariables>(CreateLeaseChargeTypeDocument, options);
      }
export type CreateLeaseChargeTypeMutationHookResult = ReturnType<typeof useCreateLeaseChargeTypeMutation>;
export type CreateLeaseChargeTypeMutationResult = Apollo.MutationResult<CreateLeaseChargeTypeMutation>;
export type CreateLeaseChargeTypeMutationOptions = Apollo.BaseMutationOptions<CreateLeaseChargeTypeMutation, CreateLeaseChargeTypeMutationVariables>;
export const UpdateLeaseChargeTypeDocument = gql`
    mutation updateLeaseChargeType($id: String!, $title: String!) {
  updateLeaseChargeType(id: $id, title: $title) {
    ...LeaseChargeTypeFields
  }
}
    ${LeaseChargeTypeFieldsFragmentDoc}`;
export type UpdateLeaseChargeTypeMutationFn = Apollo.MutationFunction<UpdateLeaseChargeTypeMutation, UpdateLeaseChargeTypeMutationVariables>;

/**
 * __useUpdateLeaseChargeTypeMutation__
 *
 * To run a mutation, you first call `useUpdateLeaseChargeTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLeaseChargeTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLeaseChargeTypeMutation, { data, loading, error }] = useUpdateLeaseChargeTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useUpdateLeaseChargeTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLeaseChargeTypeMutation, UpdateLeaseChargeTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLeaseChargeTypeMutation, UpdateLeaseChargeTypeMutationVariables>(UpdateLeaseChargeTypeDocument, options);
      }
export type UpdateLeaseChargeTypeMutationHookResult = ReturnType<typeof useUpdateLeaseChargeTypeMutation>;
export type UpdateLeaseChargeTypeMutationResult = Apollo.MutationResult<UpdateLeaseChargeTypeMutation>;
export type UpdateLeaseChargeTypeMutationOptions = Apollo.BaseMutationOptions<UpdateLeaseChargeTypeMutation, UpdateLeaseChargeTypeMutationVariables>;
export const ReorderLeaseChargeTypesDocument = gql`
    mutation reorderLeaseChargeTypes($id: String!, $secondId: String!) {
  reorderLeaseChargeTypes(id: $id, secondId: $secondId)
}
    `;
export type ReorderLeaseChargeTypesMutationFn = Apollo.MutationFunction<ReorderLeaseChargeTypesMutation, ReorderLeaseChargeTypesMutationVariables>;

/**
 * __useReorderLeaseChargeTypesMutation__
 *
 * To run a mutation, you first call `useReorderLeaseChargeTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderLeaseChargeTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderLeaseChargeTypesMutation, { data, loading, error }] = useReorderLeaseChargeTypesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      secondId: // value for 'secondId'
 *   },
 * });
 */
export function useReorderLeaseChargeTypesMutation(baseOptions?: Apollo.MutationHookOptions<ReorderLeaseChargeTypesMutation, ReorderLeaseChargeTypesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderLeaseChargeTypesMutation, ReorderLeaseChargeTypesMutationVariables>(ReorderLeaseChargeTypesDocument, options);
      }
export type ReorderLeaseChargeTypesMutationHookResult = ReturnType<typeof useReorderLeaseChargeTypesMutation>;
export type ReorderLeaseChargeTypesMutationResult = Apollo.MutationResult<ReorderLeaseChargeTypesMutation>;
export type ReorderLeaseChargeTypesMutationOptions = Apollo.BaseMutationOptions<ReorderLeaseChargeTypesMutation, ReorderLeaseChargeTypesMutationVariables>;
export const ToggleLeaseChargeTypeDocument = gql`
    mutation toggleLeaseChargeType($id: String!) {
  toggleLeaseChargeType(id: $id)
}
    `;
export type ToggleLeaseChargeTypeMutationFn = Apollo.MutationFunction<ToggleLeaseChargeTypeMutation, ToggleLeaseChargeTypeMutationVariables>;

/**
 * __useToggleLeaseChargeTypeMutation__
 *
 * To run a mutation, you first call `useToggleLeaseChargeTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleLeaseChargeTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleLeaseChargeTypeMutation, { data, loading, error }] = useToggleLeaseChargeTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleLeaseChargeTypeMutation(baseOptions?: Apollo.MutationHookOptions<ToggleLeaseChargeTypeMutation, ToggleLeaseChargeTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleLeaseChargeTypeMutation, ToggleLeaseChargeTypeMutationVariables>(ToggleLeaseChargeTypeDocument, options);
      }
export type ToggleLeaseChargeTypeMutationHookResult = ReturnType<typeof useToggleLeaseChargeTypeMutation>;
export type ToggleLeaseChargeTypeMutationResult = Apollo.MutationResult<ToggleLeaseChargeTypeMutation>;
export type ToggleLeaseChargeTypeMutationOptions = Apollo.BaseMutationOptions<ToggleLeaseChargeTypeMutation, ToggleLeaseChargeTypeMutationVariables>;
export const RemoveLeaseChargeTypesDocument = gql`
    mutation removeLeaseChargeTypes($data: DeleteRecordsInput!) {
  removeLeaseChargeTypes(input: $data)
}
    `;
export type RemoveLeaseChargeTypesMutationFn = Apollo.MutationFunction<RemoveLeaseChargeTypesMutation, RemoveLeaseChargeTypesMutationVariables>;

/**
 * __useRemoveLeaseChargeTypesMutation__
 *
 * To run a mutation, you first call `useRemoveLeaseChargeTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveLeaseChargeTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeLeaseChargeTypesMutation, { data, loading, error }] = useRemoveLeaseChargeTypesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveLeaseChargeTypesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveLeaseChargeTypesMutation, RemoveLeaseChargeTypesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveLeaseChargeTypesMutation, RemoveLeaseChargeTypesMutationVariables>(RemoveLeaseChargeTypesDocument, options);
      }
export type RemoveLeaseChargeTypesMutationHookResult = ReturnType<typeof useRemoveLeaseChargeTypesMutation>;
export type RemoveLeaseChargeTypesMutationResult = Apollo.MutationResult<RemoveLeaseChargeTypesMutation>;
export type RemoveLeaseChargeTypesMutationOptions = Apollo.BaseMutationOptions<RemoveLeaseChargeTypesMutation, RemoveLeaseChargeTypesMutationVariables>;
export const GetLeaseChargeTypesTableDocument = gql`
    query getLeaseChargeTypesTable($portfolioId: String!, $active: Boolean, $search: String, $recordLevel: RecordLevel, $propertyIds: [String!]) {
  getLeaseChargeTypes(
    portfolioId: $portfolioId
    active: $active
    search: $search
    recordLevel: $recordLevel
    propertyIds: $propertyIds
  ) {
    ...LeaseChargeTypeCoreFields
    index
    active
    property {
      ...PropertyCoreFields
    }
  }
}
    ${LeaseChargeTypeCoreFieldsFragmentDoc}
${PropertyCoreFieldsFragmentDoc}`;

/**
 * __useGetLeaseChargeTypesTableQuery__
 *
 * To run a query within a React component, call `useGetLeaseChargeTypesTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeaseChargeTypesTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeaseChargeTypesTableQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      active: // value for 'active'
 *      search: // value for 'search'
 *      recordLevel: // value for 'recordLevel'
 *      propertyIds: // value for 'propertyIds'
 *   },
 * });
 */
export function useGetLeaseChargeTypesTableQuery(baseOptions: Apollo.QueryHookOptions<GetLeaseChargeTypesTableQuery, GetLeaseChargeTypesTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeaseChargeTypesTableQuery, GetLeaseChargeTypesTableQueryVariables>(GetLeaseChargeTypesTableDocument, options);
      }
export function useGetLeaseChargeTypesTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeaseChargeTypesTableQuery, GetLeaseChargeTypesTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeaseChargeTypesTableQuery, GetLeaseChargeTypesTableQueryVariables>(GetLeaseChargeTypesTableDocument, options);
        }
export type GetLeaseChargeTypesTableQueryHookResult = ReturnType<typeof useGetLeaseChargeTypesTableQuery>;
export type GetLeaseChargeTypesTableLazyQueryHookResult = ReturnType<typeof useGetLeaseChargeTypesTableLazyQuery>;
export type GetLeaseChargeTypesTableQueryResult = Apollo.QueryResult<GetLeaseChargeTypesTableQuery, GetLeaseChargeTypesTableQueryVariables>;
export const GetLeaseChargeTypeDocument = gql`
    query getLeaseChargeType($id: String!) {
  getLeaseChargeType(id: $id) {
    ...LeaseChargeTypeFields
  }
}
    ${LeaseChargeTypeFieldsFragmentDoc}`;

/**
 * __useGetLeaseChargeTypeQuery__
 *
 * To run a query within a React component, call `useGetLeaseChargeTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeaseChargeTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeaseChargeTypeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLeaseChargeTypeQuery(baseOptions: Apollo.QueryHookOptions<GetLeaseChargeTypeQuery, GetLeaseChargeTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeaseChargeTypeQuery, GetLeaseChargeTypeQueryVariables>(GetLeaseChargeTypeDocument, options);
      }
export function useGetLeaseChargeTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeaseChargeTypeQuery, GetLeaseChargeTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeaseChargeTypeQuery, GetLeaseChargeTypeQueryVariables>(GetLeaseChargeTypeDocument, options);
        }
export type GetLeaseChargeTypeQueryHookResult = ReturnType<typeof useGetLeaseChargeTypeQuery>;
export type GetLeaseChargeTypeLazyQueryHookResult = ReturnType<typeof useGetLeaseChargeTypeLazyQuery>;
export type GetLeaseChargeTypeQueryResult = Apollo.QueryResult<GetLeaseChargeTypeQuery, GetLeaseChargeTypeQueryVariables>;
export const CreateMarkupDocument = gql`
    mutation createMarkup($data: MarkUpInput!, $portfolioId: String!) {
  createMarkup(input: $data, portfolioId: $portfolioId) {
    id
  }
}
    `;
export type CreateMarkupMutationFn = Apollo.MutationFunction<CreateMarkupMutation, CreateMarkupMutationVariables>;

/**
 * __useCreateMarkupMutation__
 *
 * To run a mutation, you first call `useCreateMarkupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMarkupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMarkupMutation, { data, loading, error }] = useCreateMarkupMutation({
 *   variables: {
 *      data: // value for 'data'
 *      portfolioId: // value for 'portfolioId'
 *   },
 * });
 */
export function useCreateMarkupMutation(baseOptions?: Apollo.MutationHookOptions<CreateMarkupMutation, CreateMarkupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMarkupMutation, CreateMarkupMutationVariables>(CreateMarkupDocument, options);
      }
export type CreateMarkupMutationHookResult = ReturnType<typeof useCreateMarkupMutation>;
export type CreateMarkupMutationResult = Apollo.MutationResult<CreateMarkupMutation>;
export type CreateMarkupMutationOptions = Apollo.BaseMutationOptions<CreateMarkupMutation, CreateMarkupMutationVariables>;
export const UpdateMarkupDocument = gql`
    mutation updateMarkup($id: String!, $data: MarkUpInput!) {
  updateMarkup(id: $id, input: $data) {
    ...MarkupFields
  }
}
    ${MarkupFieldsFragmentDoc}`;
export type UpdateMarkupMutationFn = Apollo.MutationFunction<UpdateMarkupMutation, UpdateMarkupMutationVariables>;

/**
 * __useUpdateMarkupMutation__
 *
 * To run a mutation, you first call `useUpdateMarkupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMarkupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMarkupMutation, { data, loading, error }] = useUpdateMarkupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateMarkupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMarkupMutation, UpdateMarkupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMarkupMutation, UpdateMarkupMutationVariables>(UpdateMarkupDocument, options);
      }
export type UpdateMarkupMutationHookResult = ReturnType<typeof useUpdateMarkupMutation>;
export type UpdateMarkupMutationResult = Apollo.MutationResult<UpdateMarkupMutation>;
export type UpdateMarkupMutationOptions = Apollo.BaseMutationOptions<UpdateMarkupMutation, UpdateMarkupMutationVariables>;
export const ToggleMarkupDocument = gql`
    mutation toggleMarkup($id: String!) {
  toggleMarkup(id: $id)
}
    `;
export type ToggleMarkupMutationFn = Apollo.MutationFunction<ToggleMarkupMutation, ToggleMarkupMutationVariables>;

/**
 * __useToggleMarkupMutation__
 *
 * To run a mutation, you first call `useToggleMarkupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleMarkupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleMarkupMutation, { data, loading, error }] = useToggleMarkupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleMarkupMutation(baseOptions?: Apollo.MutationHookOptions<ToggleMarkupMutation, ToggleMarkupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleMarkupMutation, ToggleMarkupMutationVariables>(ToggleMarkupDocument, options);
      }
export type ToggleMarkupMutationHookResult = ReturnType<typeof useToggleMarkupMutation>;
export type ToggleMarkupMutationResult = Apollo.MutationResult<ToggleMarkupMutation>;
export type ToggleMarkupMutationOptions = Apollo.BaseMutationOptions<ToggleMarkupMutation, ToggleMarkupMutationVariables>;
export const RemoveMarkupsDocument = gql`
    mutation removeMarkups($data: DeleteRecordsInput!) {
  removeMarkups(input: $data)
}
    `;
export type RemoveMarkupsMutationFn = Apollo.MutationFunction<RemoveMarkupsMutation, RemoveMarkupsMutationVariables>;

/**
 * __useRemoveMarkupsMutation__
 *
 * To run a mutation, you first call `useRemoveMarkupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMarkupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMarkupsMutation, { data, loading, error }] = useRemoveMarkupsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveMarkupsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMarkupsMutation, RemoveMarkupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMarkupsMutation, RemoveMarkupsMutationVariables>(RemoveMarkupsDocument, options);
      }
export type RemoveMarkupsMutationHookResult = ReturnType<typeof useRemoveMarkupsMutation>;
export type RemoveMarkupsMutationResult = Apollo.MutationResult<RemoveMarkupsMutation>;
export type RemoveMarkupsMutationOptions = Apollo.BaseMutationOptions<RemoveMarkupsMutation, RemoveMarkupsMutationVariables>;
export const GetMarkupsTableDocument = gql`
    query getMarkupsTable($portfolioId: String!, $active: Boolean, $search: String, $recordLevel: RecordLevel, $propertyIds: [String!]) {
  getMarkups(
    active: $active
    portfolioId: $portfolioId
    search: $search
    recordLevel: $recordLevel
    propertyIds: $propertyIds
  ) {
    ...MarkupCoreFields
    index
    active
    type
    amount
    description
    property {
      ...PropertyCoreFields
    }
    glAccount {
      ...GLAccountCoreFields
    }
    arCode {
      ...ARCodeCoreFields
    }
    chargeCode {
      ...ChargeCodeCoreFields
    }
  }
}
    ${MarkupCoreFieldsFragmentDoc}
${PropertyCoreFieldsFragmentDoc}
${GlAccountCoreFieldsFragmentDoc}
${ArCodeCoreFieldsFragmentDoc}
${ChargeCodeCoreFieldsFragmentDoc}`;

/**
 * __useGetMarkupsTableQuery__
 *
 * To run a query within a React component, call `useGetMarkupsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarkupsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarkupsTableQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      active: // value for 'active'
 *      search: // value for 'search'
 *      recordLevel: // value for 'recordLevel'
 *      propertyIds: // value for 'propertyIds'
 *   },
 * });
 */
export function useGetMarkupsTableQuery(baseOptions: Apollo.QueryHookOptions<GetMarkupsTableQuery, GetMarkupsTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMarkupsTableQuery, GetMarkupsTableQueryVariables>(GetMarkupsTableDocument, options);
      }
export function useGetMarkupsTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMarkupsTableQuery, GetMarkupsTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMarkupsTableQuery, GetMarkupsTableQueryVariables>(GetMarkupsTableDocument, options);
        }
export type GetMarkupsTableQueryHookResult = ReturnType<typeof useGetMarkupsTableQuery>;
export type GetMarkupsTableLazyQueryHookResult = ReturnType<typeof useGetMarkupsTableLazyQuery>;
export type GetMarkupsTableQueryResult = Apollo.QueryResult<GetMarkupsTableQuery, GetMarkupsTableQueryVariables>;
export const GetMarkupsDropdownDocument = gql`
    query getMarkupsDropdown($portfolioId: String!, $active: Boolean, $search: String, $recordLevel: RecordLevel, $propertyIds: [String!], $includeGLAccount: Boolean!, $includeARCode: Boolean!, $includeChargeCode: Boolean!) {
  getMarkups(
    active: $active
    portfolioId: $portfolioId
    search: $search
    recordLevel: $recordLevel
    propertyIds: $propertyIds
  ) {
    ...MarkupCoreFields
    active
    type
    amount
    glAccount @include(if: $includeGLAccount) {
      ...GLAccountCoreFields
    }
    arCode @include(if: $includeARCode) {
      ...ARCodeCoreFields
    }
    chargeCode @include(if: $includeChargeCode) {
      ...ChargeCodeCoreFields
    }
  }
}
    ${MarkupCoreFieldsFragmentDoc}
${GlAccountCoreFieldsFragmentDoc}
${ArCodeCoreFieldsFragmentDoc}
${ChargeCodeCoreFieldsFragmentDoc}`;

/**
 * __useGetMarkupsDropdownQuery__
 *
 * To run a query within a React component, call `useGetMarkupsDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarkupsDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarkupsDropdownQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      active: // value for 'active'
 *      search: // value for 'search'
 *      recordLevel: // value for 'recordLevel'
 *      propertyIds: // value for 'propertyIds'
 *      includeGLAccount: // value for 'includeGLAccount'
 *      includeARCode: // value for 'includeARCode'
 *      includeChargeCode: // value for 'includeChargeCode'
 *   },
 * });
 */
export function useGetMarkupsDropdownQuery(baseOptions: Apollo.QueryHookOptions<GetMarkupsDropdownQuery, GetMarkupsDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMarkupsDropdownQuery, GetMarkupsDropdownQueryVariables>(GetMarkupsDropdownDocument, options);
      }
export function useGetMarkupsDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMarkupsDropdownQuery, GetMarkupsDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMarkupsDropdownQuery, GetMarkupsDropdownQueryVariables>(GetMarkupsDropdownDocument, options);
        }
export type GetMarkupsDropdownQueryHookResult = ReturnType<typeof useGetMarkupsDropdownQuery>;
export type GetMarkupsDropdownLazyQueryHookResult = ReturnType<typeof useGetMarkupsDropdownLazyQuery>;
export type GetMarkupsDropdownQueryResult = Apollo.QueryResult<GetMarkupsDropdownQuery, GetMarkupsDropdownQueryVariables>;
export const GetMarkupDocument = gql`
    query getMarkup($id: String!) {
  getMarkup(id: $id) {
    ...MarkupFields
  }
}
    ${MarkupFieldsFragmentDoc}`;

/**
 * __useGetMarkupQuery__
 *
 * To run a query within a React component, call `useGetMarkupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarkupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarkupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMarkupQuery(baseOptions: Apollo.QueryHookOptions<GetMarkupQuery, GetMarkupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMarkupQuery, GetMarkupQueryVariables>(GetMarkupDocument, options);
      }
export function useGetMarkupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMarkupQuery, GetMarkupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMarkupQuery, GetMarkupQueryVariables>(GetMarkupDocument, options);
        }
export type GetMarkupQueryHookResult = ReturnType<typeof useGetMarkupQuery>;
export type GetMarkupLazyQueryHookResult = ReturnType<typeof useGetMarkupLazyQuery>;
export type GetMarkupQueryResult = Apollo.QueryResult<GetMarkupQuery, GetMarkupQueryVariables>;
export const CreatePortfolioDocument = gql`
    mutation createPortfolio($data: PortfolioInput!) {
  createPortfolio(input: $data) {
    id
  }
}
    `;
export type CreatePortfolioMutationFn = Apollo.MutationFunction<CreatePortfolioMutation, CreatePortfolioMutationVariables>;

/**
 * __useCreatePortfolioMutation__
 *
 * To run a mutation, you first call `useCreatePortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPortfolioMutation, { data, loading, error }] = useCreatePortfolioMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePortfolioMutation(baseOptions?: Apollo.MutationHookOptions<CreatePortfolioMutation, CreatePortfolioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePortfolioMutation, CreatePortfolioMutationVariables>(CreatePortfolioDocument, options);
      }
export type CreatePortfolioMutationHookResult = ReturnType<typeof useCreatePortfolioMutation>;
export type CreatePortfolioMutationResult = Apollo.MutationResult<CreatePortfolioMutation>;
export type CreatePortfolioMutationOptions = Apollo.BaseMutationOptions<CreatePortfolioMutation, CreatePortfolioMutationVariables>;
export const UpdatePortfolioDocument = gql`
    mutation updatePortfolio($id: String!, $data: PortfolioUpdateInput!) {
  updatePortfolio(id: $id, input: $data) {
    ...PortfolioFields
  }
}
    ${PortfolioFieldsFragmentDoc}`;
export type UpdatePortfolioMutationFn = Apollo.MutationFunction<UpdatePortfolioMutation, UpdatePortfolioMutationVariables>;

/**
 * __useUpdatePortfolioMutation__
 *
 * To run a mutation, you first call `useUpdatePortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePortfolioMutation, { data, loading, error }] = useUpdatePortfolioMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePortfolioMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePortfolioMutation, UpdatePortfolioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePortfolioMutation, UpdatePortfolioMutationVariables>(UpdatePortfolioDocument, options);
      }
export type UpdatePortfolioMutationHookResult = ReturnType<typeof useUpdatePortfolioMutation>;
export type UpdatePortfolioMutationResult = Apollo.MutationResult<UpdatePortfolioMutation>;
export type UpdatePortfolioMutationOptions = Apollo.BaseMutationOptions<UpdatePortfolioMutation, UpdatePortfolioMutationVariables>;
export const TogglePortfolioDocument = gql`
    mutation togglePortfolio($id: String!) {
  togglePortfolio(id: $id)
}
    `;
export type TogglePortfolioMutationFn = Apollo.MutationFunction<TogglePortfolioMutation, TogglePortfolioMutationVariables>;

/**
 * __useTogglePortfolioMutation__
 *
 * To run a mutation, you first call `useTogglePortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTogglePortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [togglePortfolioMutation, { data, loading, error }] = useTogglePortfolioMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTogglePortfolioMutation(baseOptions?: Apollo.MutationHookOptions<TogglePortfolioMutation, TogglePortfolioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TogglePortfolioMutation, TogglePortfolioMutationVariables>(TogglePortfolioDocument, options);
      }
export type TogglePortfolioMutationHookResult = ReturnType<typeof useTogglePortfolioMutation>;
export type TogglePortfolioMutationResult = Apollo.MutationResult<TogglePortfolioMutation>;
export type TogglePortfolioMutationOptions = Apollo.BaseMutationOptions<TogglePortfolioMutation, TogglePortfolioMutationVariables>;
export const RemovePortfoliosDocument = gql`
    mutation removePortfolios($data: DeleteRecordsInput!) {
  removePortfolios(input: $data)
}
    `;
export type RemovePortfoliosMutationFn = Apollo.MutationFunction<RemovePortfoliosMutation, RemovePortfoliosMutationVariables>;

/**
 * __useRemovePortfoliosMutation__
 *
 * To run a mutation, you first call `useRemovePortfoliosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePortfoliosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePortfoliosMutation, { data, loading, error }] = useRemovePortfoliosMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemovePortfoliosMutation(baseOptions?: Apollo.MutationHookOptions<RemovePortfoliosMutation, RemovePortfoliosMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePortfoliosMutation, RemovePortfoliosMutationVariables>(RemovePortfoliosDocument, options);
      }
export type RemovePortfoliosMutationHookResult = ReturnType<typeof useRemovePortfoliosMutation>;
export type RemovePortfoliosMutationResult = Apollo.MutationResult<RemovePortfoliosMutation>;
export type RemovePortfoliosMutationOptions = Apollo.BaseMutationOptions<RemovePortfoliosMutation, RemovePortfoliosMutationVariables>;
export const GetPortfoliosTableDocument = gql`
    query getPortfoliosTable($take: Int! = 10, $after: String, $before: String, $search: String, $active: Boolean) {
  getPortfolios(
    take: $take
    after: $after
    before: $before
    search: $search
    active: $active
  ) @connection(key: "getPortfoliosTable") {
    pagination {
      ...PaginationFields
    }
    data {
      ...PortfolioCoreFields
      index
      propertyCount
      userCount
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${PortfolioCoreFieldsFragmentDoc}`;

/**
 * __useGetPortfoliosTableQuery__
 *
 * To run a query within a React component, call `useGetPortfoliosTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortfoliosTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortfoliosTableQuery({
 *   variables: {
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useGetPortfoliosTableQuery(baseOptions?: Apollo.QueryHookOptions<GetPortfoliosTableQuery, GetPortfoliosTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPortfoliosTableQuery, GetPortfoliosTableQueryVariables>(GetPortfoliosTableDocument, options);
      }
export function useGetPortfoliosTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPortfoliosTableQuery, GetPortfoliosTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPortfoliosTableQuery, GetPortfoliosTableQueryVariables>(GetPortfoliosTableDocument, options);
        }
export type GetPortfoliosTableQueryHookResult = ReturnType<typeof useGetPortfoliosTableQuery>;
export type GetPortfoliosTableLazyQueryHookResult = ReturnType<typeof useGetPortfoliosTableLazyQuery>;
export type GetPortfoliosTableQueryResult = Apollo.QueryResult<GetPortfoliosTableQuery, GetPortfoliosTableQueryVariables>;
export const GetPortfoliosDropdownDocument = gql`
    query getPortfoliosDropdown($take: Int! = 10, $after: String, $before: String, $search: String, $active: Boolean) {
  getPortfolios(
    take: $take
    after: $after
    before: $before
    search: $search
    active: $active
  ) @connection(key: "getPortfoliosDropdown") {
    pagination {
      ...PaginationFields
    }
    data {
      ...PortfolioCoreFields
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${PortfolioCoreFieldsFragmentDoc}`;

/**
 * __useGetPortfoliosDropdownQuery__
 *
 * To run a query within a React component, call `useGetPortfoliosDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortfoliosDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortfoliosDropdownQuery({
 *   variables: {
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useGetPortfoliosDropdownQuery(baseOptions?: Apollo.QueryHookOptions<GetPortfoliosDropdownQuery, GetPortfoliosDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPortfoliosDropdownQuery, GetPortfoliosDropdownQueryVariables>(GetPortfoliosDropdownDocument, options);
      }
export function useGetPortfoliosDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPortfoliosDropdownQuery, GetPortfoliosDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPortfoliosDropdownQuery, GetPortfoliosDropdownQueryVariables>(GetPortfoliosDropdownDocument, options);
        }
export type GetPortfoliosDropdownQueryHookResult = ReturnType<typeof useGetPortfoliosDropdownQuery>;
export type GetPortfoliosDropdownLazyQueryHookResult = ReturnType<typeof useGetPortfoliosDropdownLazyQuery>;
export type GetPortfoliosDropdownQueryResult = Apollo.QueryResult<GetPortfoliosDropdownQuery, GetPortfoliosDropdownQueryVariables>;
export const GetPortfolioDocument = gql`
    query getPortfolio($id: String!) {
  getPortfolio(id: $id) {
    ...PortfolioFields
  }
}
    ${PortfolioFieldsFragmentDoc}`;

/**
 * __useGetPortfolioQuery__
 *
 * To run a query within a React component, call `useGetPortfolioQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortfolioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortfolioQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPortfolioQuery(baseOptions: Apollo.QueryHookOptions<GetPortfolioQuery, GetPortfolioQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPortfolioQuery, GetPortfolioQueryVariables>(GetPortfolioDocument, options);
      }
export function useGetPortfolioLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPortfolioQuery, GetPortfolioQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPortfolioQuery, GetPortfolioQueryVariables>(GetPortfolioDocument, options);
        }
export type GetPortfolioQueryHookResult = ReturnType<typeof useGetPortfolioQuery>;
export type GetPortfolioLazyQueryHookResult = ReturnType<typeof useGetPortfolioLazyQuery>;
export type GetPortfolioQueryResult = Apollo.QueryResult<GetPortfolioQuery, GetPortfolioQueryVariables>;
export const CreatePriorityDocument = gql`
    mutation createPriority($data: PriorityInput!, $portfolioId: String!) {
  createPriority(input: $data, portfolioId: $portfolioId) {
    id
  }
}
    `;
export type CreatePriorityMutationFn = Apollo.MutationFunction<CreatePriorityMutation, CreatePriorityMutationVariables>;

/**
 * __useCreatePriorityMutation__
 *
 * To run a mutation, you first call `useCreatePriorityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePriorityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPriorityMutation, { data, loading, error }] = useCreatePriorityMutation({
 *   variables: {
 *      data: // value for 'data'
 *      portfolioId: // value for 'portfolioId'
 *   },
 * });
 */
export function useCreatePriorityMutation(baseOptions?: Apollo.MutationHookOptions<CreatePriorityMutation, CreatePriorityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePriorityMutation, CreatePriorityMutationVariables>(CreatePriorityDocument, options);
      }
export type CreatePriorityMutationHookResult = ReturnType<typeof useCreatePriorityMutation>;
export type CreatePriorityMutationResult = Apollo.MutationResult<CreatePriorityMutation>;
export type CreatePriorityMutationOptions = Apollo.BaseMutationOptions<CreatePriorityMutation, CreatePriorityMutationVariables>;
export const UpdatePriorityDocument = gql`
    mutation updatePriority($id: String!, $data: PriorityUpdateInput!) {
  updatePriority(id: $id, input: $data) {
    ...PriorityFields
  }
}
    ${PriorityFieldsFragmentDoc}`;
export type UpdatePriorityMutationFn = Apollo.MutationFunction<UpdatePriorityMutation, UpdatePriorityMutationVariables>;

/**
 * __useUpdatePriorityMutation__
 *
 * To run a mutation, you first call `useUpdatePriorityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePriorityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePriorityMutation, { data, loading, error }] = useUpdatePriorityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePriorityMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePriorityMutation, UpdatePriorityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePriorityMutation, UpdatePriorityMutationVariables>(UpdatePriorityDocument, options);
      }
export type UpdatePriorityMutationHookResult = ReturnType<typeof useUpdatePriorityMutation>;
export type UpdatePriorityMutationResult = Apollo.MutationResult<UpdatePriorityMutation>;
export type UpdatePriorityMutationOptions = Apollo.BaseMutationOptions<UpdatePriorityMutation, UpdatePriorityMutationVariables>;
export const ReorderPrioritiesDocument = gql`
    mutation reorderPriorities($id: String!, $secondId: String!) {
  reorderPriorities(id: $id, secondId: $secondId)
}
    `;
export type ReorderPrioritiesMutationFn = Apollo.MutationFunction<ReorderPrioritiesMutation, ReorderPrioritiesMutationVariables>;

/**
 * __useReorderPrioritiesMutation__
 *
 * To run a mutation, you first call `useReorderPrioritiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderPrioritiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderPrioritiesMutation, { data, loading, error }] = useReorderPrioritiesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      secondId: // value for 'secondId'
 *   },
 * });
 */
export function useReorderPrioritiesMutation(baseOptions?: Apollo.MutationHookOptions<ReorderPrioritiesMutation, ReorderPrioritiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderPrioritiesMutation, ReorderPrioritiesMutationVariables>(ReorderPrioritiesDocument, options);
      }
export type ReorderPrioritiesMutationHookResult = ReturnType<typeof useReorderPrioritiesMutation>;
export type ReorderPrioritiesMutationResult = Apollo.MutationResult<ReorderPrioritiesMutation>;
export type ReorderPrioritiesMutationOptions = Apollo.BaseMutationOptions<ReorderPrioritiesMutation, ReorderPrioritiesMutationVariables>;
export const TogglePriorityDocument = gql`
    mutation togglePriority($id: String!) {
  togglePriority(id: $id)
}
    `;
export type TogglePriorityMutationFn = Apollo.MutationFunction<TogglePriorityMutation, TogglePriorityMutationVariables>;

/**
 * __useTogglePriorityMutation__
 *
 * To run a mutation, you first call `useTogglePriorityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTogglePriorityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [togglePriorityMutation, { data, loading, error }] = useTogglePriorityMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTogglePriorityMutation(baseOptions?: Apollo.MutationHookOptions<TogglePriorityMutation, TogglePriorityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TogglePriorityMutation, TogglePriorityMutationVariables>(TogglePriorityDocument, options);
      }
export type TogglePriorityMutationHookResult = ReturnType<typeof useTogglePriorityMutation>;
export type TogglePriorityMutationResult = Apollo.MutationResult<TogglePriorityMutation>;
export type TogglePriorityMutationOptions = Apollo.BaseMutationOptions<TogglePriorityMutation, TogglePriorityMutationVariables>;
export const RemovePrioritiesDocument = gql`
    mutation removePriorities($data: DeleteRecordsInput!) {
  removePriorities(input: $data)
}
    `;
export type RemovePrioritiesMutationFn = Apollo.MutationFunction<RemovePrioritiesMutation, RemovePrioritiesMutationVariables>;

/**
 * __useRemovePrioritiesMutation__
 *
 * To run a mutation, you first call `useRemovePrioritiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePrioritiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePrioritiesMutation, { data, loading, error }] = useRemovePrioritiesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemovePrioritiesMutation(baseOptions?: Apollo.MutationHookOptions<RemovePrioritiesMutation, RemovePrioritiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePrioritiesMutation, RemovePrioritiesMutationVariables>(RemovePrioritiesDocument, options);
      }
export type RemovePrioritiesMutationHookResult = ReturnType<typeof useRemovePrioritiesMutation>;
export type RemovePrioritiesMutationResult = Apollo.MutationResult<RemovePrioritiesMutation>;
export type RemovePrioritiesMutationOptions = Apollo.BaseMutationOptions<RemovePrioritiesMutation, RemovePrioritiesMutationVariables>;
export const GetPrioritiesTableDocument = gql`
    query getPrioritiesTable($portfolioId: String!, $recordType: PriorityRecordType!, $recordLevel: RecordLevel, $active: Boolean, $search: String, $propertyIds: [String!]) {
  getPriorities(
    portfolioId: $portfolioId
    recordType: $recordType
    recordLevel: $recordLevel
    active: $active
    search: $search
    propertyIds: $propertyIds
  ) {
    ...PriorityCoreFields
    color
    index
    active
    property {
      ...PropertyCoreFields
    }
  }
}
    ${PriorityCoreFieldsFragmentDoc}
${PropertyCoreFieldsFragmentDoc}`;

/**
 * __useGetPrioritiesTableQuery__
 *
 * To run a query within a React component, call `useGetPrioritiesTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrioritiesTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrioritiesTableQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      recordType: // value for 'recordType'
 *      recordLevel: // value for 'recordLevel'
 *      active: // value for 'active'
 *      search: // value for 'search'
 *      propertyIds: // value for 'propertyIds'
 *   },
 * });
 */
export function useGetPrioritiesTableQuery(baseOptions: Apollo.QueryHookOptions<GetPrioritiesTableQuery, GetPrioritiesTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrioritiesTableQuery, GetPrioritiesTableQueryVariables>(GetPrioritiesTableDocument, options);
      }
export function useGetPrioritiesTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPrioritiesTableQuery, GetPrioritiesTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrioritiesTableQuery, GetPrioritiesTableQueryVariables>(GetPrioritiesTableDocument, options);
        }
export type GetPrioritiesTableQueryHookResult = ReturnType<typeof useGetPrioritiesTableQuery>;
export type GetPrioritiesTableLazyQueryHookResult = ReturnType<typeof useGetPrioritiesTableLazyQuery>;
export type GetPrioritiesTableQueryResult = Apollo.QueryResult<GetPrioritiesTableQuery, GetPrioritiesTableQueryVariables>;
export const GetPrioritiesDropdownDocument = gql`
    query getPrioritiesDropdown($portfolioId: String!, $recordType: PriorityRecordType!, $recordLevel: RecordLevel, $active: Boolean, $search: String, $propertyIds: [String!]) {
  getPriorities(
    portfolioId: $portfolioId
    recordType: $recordType
    recordLevel: $recordLevel
    active: $active
    search: $search
    propertyIds: $propertyIds
  ) {
    ...PriorityCoreFields
    color
    active
  }
}
    ${PriorityCoreFieldsFragmentDoc}`;

/**
 * __useGetPrioritiesDropdownQuery__
 *
 * To run a query within a React component, call `useGetPrioritiesDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrioritiesDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrioritiesDropdownQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      recordType: // value for 'recordType'
 *      recordLevel: // value for 'recordLevel'
 *      active: // value for 'active'
 *      search: // value for 'search'
 *      propertyIds: // value for 'propertyIds'
 *   },
 * });
 */
export function useGetPrioritiesDropdownQuery(baseOptions: Apollo.QueryHookOptions<GetPrioritiesDropdownQuery, GetPrioritiesDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrioritiesDropdownQuery, GetPrioritiesDropdownQueryVariables>(GetPrioritiesDropdownDocument, options);
      }
export function useGetPrioritiesDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPrioritiesDropdownQuery, GetPrioritiesDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrioritiesDropdownQuery, GetPrioritiesDropdownQueryVariables>(GetPrioritiesDropdownDocument, options);
        }
export type GetPrioritiesDropdownQueryHookResult = ReturnType<typeof useGetPrioritiesDropdownQuery>;
export type GetPrioritiesDropdownLazyQueryHookResult = ReturnType<typeof useGetPrioritiesDropdownLazyQuery>;
export type GetPrioritiesDropdownQueryResult = Apollo.QueryResult<GetPrioritiesDropdownQuery, GetPrioritiesDropdownQueryVariables>;
export const GetFilterablePrioritiesDocument = gql`
    query getFilterablePriorities($portfolioId: String!, $location: FilterablePriorityLocationType!, $search: String) {
  getFilterablePriorities(
    portfolioId: $portfolioId
    location: $location
    search: $search
  ) {
    id
    title
    color
    active
    isDeleted
  }
}
    `;

/**
 * __useGetFilterablePrioritiesQuery__
 *
 * To run a query within a React component, call `useGetFilterablePrioritiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilterablePrioritiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilterablePrioritiesQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      location: // value for 'location'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetFilterablePrioritiesQuery(baseOptions: Apollo.QueryHookOptions<GetFilterablePrioritiesQuery, GetFilterablePrioritiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilterablePrioritiesQuery, GetFilterablePrioritiesQueryVariables>(GetFilterablePrioritiesDocument, options);
      }
export function useGetFilterablePrioritiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilterablePrioritiesQuery, GetFilterablePrioritiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilterablePrioritiesQuery, GetFilterablePrioritiesQueryVariables>(GetFilterablePrioritiesDocument, options);
        }
export type GetFilterablePrioritiesQueryHookResult = ReturnType<typeof useGetFilterablePrioritiesQuery>;
export type GetFilterablePrioritiesLazyQueryHookResult = ReturnType<typeof useGetFilterablePrioritiesLazyQuery>;
export type GetFilterablePrioritiesQueryResult = Apollo.QueryResult<GetFilterablePrioritiesQuery, GetFilterablePrioritiesQueryVariables>;
export const GetPriorityDocument = gql`
    query getPriority($id: String!) {
  getPriority(id: $id) {
    ...PriorityFields
  }
}
    ${PriorityFieldsFragmentDoc}`;

/**
 * __useGetPriorityQuery__
 *
 * To run a query within a React component, call `useGetPriorityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPriorityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPriorityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPriorityQuery(baseOptions: Apollo.QueryHookOptions<GetPriorityQuery, GetPriorityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPriorityQuery, GetPriorityQueryVariables>(GetPriorityDocument, options);
      }
export function useGetPriorityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPriorityQuery, GetPriorityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPriorityQuery, GetPriorityQueryVariables>(GetPriorityDocument, options);
        }
export type GetPriorityQueryHookResult = ReturnType<typeof useGetPriorityQuery>;
export type GetPriorityLazyQueryHookResult = ReturnType<typeof useGetPriorityLazyQuery>;
export type GetPriorityQueryResult = Apollo.QueryResult<GetPriorityQuery, GetPriorityQueryVariables>;
export const CreatePropertyDocument = gql`
    mutation createProperty($data: PropertyInput!, $portfolioId: String!) {
  createProperty(input: $data, portfolioId: $portfolioId) {
    id
  }
}
    `;
export type CreatePropertyMutationFn = Apollo.MutationFunction<CreatePropertyMutation, CreatePropertyMutationVariables>;

/**
 * __useCreatePropertyMutation__
 *
 * To run a mutation, you first call `useCreatePropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPropertyMutation, { data, loading, error }] = useCreatePropertyMutation({
 *   variables: {
 *      data: // value for 'data'
 *      portfolioId: // value for 'portfolioId'
 *   },
 * });
 */
export function useCreatePropertyMutation(baseOptions?: Apollo.MutationHookOptions<CreatePropertyMutation, CreatePropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePropertyMutation, CreatePropertyMutationVariables>(CreatePropertyDocument, options);
      }
export type CreatePropertyMutationHookResult = ReturnType<typeof useCreatePropertyMutation>;
export type CreatePropertyMutationResult = Apollo.MutationResult<CreatePropertyMutation>;
export type CreatePropertyMutationOptions = Apollo.BaseMutationOptions<CreatePropertyMutation, CreatePropertyMutationVariables>;
export const UpdatePropertyDocument = gql`
    mutation updateProperty($id: String!, $data: PropertyInput!) {
  updateProperty(id: $id, input: $data) {
    ...PropertyFields
  }
}
    ${PropertyFieldsFragmentDoc}`;
export type UpdatePropertyMutationFn = Apollo.MutationFunction<UpdatePropertyMutation, UpdatePropertyMutationVariables>;

/**
 * __useUpdatePropertyMutation__
 *
 * To run a mutation, you first call `useUpdatePropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePropertyMutation, { data, loading, error }] = useUpdatePropertyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePropertyMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePropertyMutation, UpdatePropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePropertyMutation, UpdatePropertyMutationVariables>(UpdatePropertyDocument, options);
      }
export type UpdatePropertyMutationHookResult = ReturnType<typeof useUpdatePropertyMutation>;
export type UpdatePropertyMutationResult = Apollo.MutationResult<UpdatePropertyMutation>;
export type UpdatePropertyMutationOptions = Apollo.BaseMutationOptions<UpdatePropertyMutation, UpdatePropertyMutationVariables>;
export const TogglePropertyDocument = gql`
    mutation toggleProperty($id: String!) {
  toggleProperty(id: $id)
}
    `;
export type TogglePropertyMutationFn = Apollo.MutationFunction<TogglePropertyMutation, TogglePropertyMutationVariables>;

/**
 * __useTogglePropertyMutation__
 *
 * To run a mutation, you first call `useTogglePropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTogglePropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [togglePropertyMutation, { data, loading, error }] = useTogglePropertyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTogglePropertyMutation(baseOptions?: Apollo.MutationHookOptions<TogglePropertyMutation, TogglePropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TogglePropertyMutation, TogglePropertyMutationVariables>(TogglePropertyDocument, options);
      }
export type TogglePropertyMutationHookResult = ReturnType<typeof useTogglePropertyMutation>;
export type TogglePropertyMutationResult = Apollo.MutationResult<TogglePropertyMutation>;
export type TogglePropertyMutationOptions = Apollo.BaseMutationOptions<TogglePropertyMutation, TogglePropertyMutationVariables>;
export const ClonePropertyDocument = gql`
    mutation cloneProperty($data: PropertyCloneInput!) {
  cloneProperty(input: $data)
}
    `;
export type ClonePropertyMutationFn = Apollo.MutationFunction<ClonePropertyMutation, ClonePropertyMutationVariables>;

/**
 * __useClonePropertyMutation__
 *
 * To run a mutation, you first call `useClonePropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClonePropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clonePropertyMutation, { data, loading, error }] = useClonePropertyMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useClonePropertyMutation(baseOptions?: Apollo.MutationHookOptions<ClonePropertyMutation, ClonePropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClonePropertyMutation, ClonePropertyMutationVariables>(ClonePropertyDocument, options);
      }
export type ClonePropertyMutationHookResult = ReturnType<typeof useClonePropertyMutation>;
export type ClonePropertyMutationResult = Apollo.MutationResult<ClonePropertyMutation>;
export type ClonePropertyMutationOptions = Apollo.BaseMutationOptions<ClonePropertyMutation, ClonePropertyMutationVariables>;
export const RemovePropertiesDocument = gql`
    mutation removeProperties($data: DeleteRecordsInput!) {
  removeProperties(input: $data)
}
    `;
export type RemovePropertiesMutationFn = Apollo.MutationFunction<RemovePropertiesMutation, RemovePropertiesMutationVariables>;

/**
 * __useRemovePropertiesMutation__
 *
 * To run a mutation, you first call `useRemovePropertiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePropertiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePropertiesMutation, { data, loading, error }] = useRemovePropertiesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemovePropertiesMutation(baseOptions?: Apollo.MutationHookOptions<RemovePropertiesMutation, RemovePropertiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePropertiesMutation, RemovePropertiesMutationVariables>(RemovePropertiesDocument, options);
      }
export type RemovePropertiesMutationHookResult = ReturnType<typeof useRemovePropertiesMutation>;
export type RemovePropertiesMutationResult = Apollo.MutationResult<RemovePropertiesMutation>;
export type RemovePropertiesMutationOptions = Apollo.BaseMutationOptions<RemovePropertiesMutation, RemovePropertiesMutationVariables>;
export const GetPropertiesTableDocument = gql`
    query getPropertiesTable($portfolioId: String, $take: Int! = 10, $after: String, $before: String, $search: String, $active: Boolean, $includePortfolio: Boolean!) {
  getProperties(
    portfolioId: $portfolioId
    take: $take
    after: $after
    before: $before
    search: $search
    active: $active
  ) @connection(key: "getPropertiesTable") {
    pagination {
      ...PaginationFields
    }
    data {
      ...PropertyCoreFields
      index
      timezone
      userCount
      companyCount
      portfolio @include(if: $includePortfolio) {
        ...PortfolioCoreFields
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${PropertyCoreFieldsFragmentDoc}
${PortfolioCoreFieldsFragmentDoc}`;

/**
 * __useGetPropertiesTableQuery__
 *
 * To run a query within a React component, call `useGetPropertiesTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertiesTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertiesTableQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      active: // value for 'active'
 *      includePortfolio: // value for 'includePortfolio'
 *   },
 * });
 */
export function useGetPropertiesTableQuery(baseOptions: Apollo.QueryHookOptions<GetPropertiesTableQuery, GetPropertiesTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertiesTableQuery, GetPropertiesTableQueryVariables>(GetPropertiesTableDocument, options);
      }
export function useGetPropertiesTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertiesTableQuery, GetPropertiesTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertiesTableQuery, GetPropertiesTableQueryVariables>(GetPropertiesTableDocument, options);
        }
export type GetPropertiesTableQueryHookResult = ReturnType<typeof useGetPropertiesTableQuery>;
export type GetPropertiesTableLazyQueryHookResult = ReturnType<typeof useGetPropertiesTableLazyQuery>;
export type GetPropertiesTableQueryResult = Apollo.QueryResult<GetPropertiesTableQuery, GetPropertiesTableQueryVariables>;
export const GetPropertiesDropdownDocument = gql`
    query getPropertiesDropdown($portfolioId: String, $take: Int! = 10, $after: String, $before: String, $search: String, $active: Boolean) {
  getProperties(
    portfolioId: $portfolioId
    take: $take
    after: $after
    before: $before
    search: $search
    active: $active
  ) @connection(key: "getPropertiesDropdown") {
    pagination {
      ...PaginationFields
    }
    data {
      ...PropertyCoreFields
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${PropertyCoreFieldsFragmentDoc}`;

/**
 * __useGetPropertiesDropdownQuery__
 *
 * To run a query within a React component, call `useGetPropertiesDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertiesDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertiesDropdownQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useGetPropertiesDropdownQuery(baseOptions?: Apollo.QueryHookOptions<GetPropertiesDropdownQuery, GetPropertiesDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertiesDropdownQuery, GetPropertiesDropdownQueryVariables>(GetPropertiesDropdownDocument, options);
      }
export function useGetPropertiesDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertiesDropdownQuery, GetPropertiesDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertiesDropdownQuery, GetPropertiesDropdownQueryVariables>(GetPropertiesDropdownDocument, options);
        }
export type GetPropertiesDropdownQueryHookResult = ReturnType<typeof useGetPropertiesDropdownQuery>;
export type GetPropertiesDropdownLazyQueryHookResult = ReturnType<typeof useGetPropertiesDropdownLazyQuery>;
export type GetPropertiesDropdownQueryResult = Apollo.QueryResult<GetPropertiesDropdownQuery, GetPropertiesDropdownQueryVariables>;
export const GetPropertyDocument = gql`
    query getProperty($id: String!) {
  getProperty(id: $id) {
    ...PropertyFields
  }
}
    ${PropertyFieldsFragmentDoc}`;

/**
 * __useGetPropertyQuery__
 *
 * To run a query within a React component, call `useGetPropertyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPropertyQuery(baseOptions: Apollo.QueryHookOptions<GetPropertyQuery, GetPropertyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertyQuery, GetPropertyQueryVariables>(GetPropertyDocument, options);
      }
export function useGetPropertyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertyQuery, GetPropertyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertyQuery, GetPropertyQueryVariables>(GetPropertyDocument, options);
        }
export type GetPropertyQueryHookResult = ReturnType<typeof useGetPropertyQuery>;
export type GetPropertyLazyQueryHookResult = ReturnType<typeof useGetPropertyLazyQuery>;
export type GetPropertyQueryResult = Apollo.QueryResult<GetPropertyQuery, GetPropertyQueryVariables>;
export const CreateRoleDocument = gql`
    mutation createRole($data: RoleInput!, $portfolioId: String!) {
  createRole(input: $data, portfolioId: $portfolioId) {
    id
  }
}
    `;
export type CreateRoleMutationFn = Apollo.MutationFunction<CreateRoleMutation, CreateRoleMutationVariables>;

/**
 * __useCreateRoleMutation__
 *
 * To run a mutation, you first call `useCreateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoleMutation, { data, loading, error }] = useCreateRoleMutation({
 *   variables: {
 *      data: // value for 'data'
 *      portfolioId: // value for 'portfolioId'
 *   },
 * });
 */
export function useCreateRoleMutation(baseOptions?: Apollo.MutationHookOptions<CreateRoleMutation, CreateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRoleMutation, CreateRoleMutationVariables>(CreateRoleDocument, options);
      }
export type CreateRoleMutationHookResult = ReturnType<typeof useCreateRoleMutation>;
export type CreateRoleMutationResult = Apollo.MutationResult<CreateRoleMutation>;
export type CreateRoleMutationOptions = Apollo.BaseMutationOptions<CreateRoleMutation, CreateRoleMutationVariables>;
export const UpdateRoleDocument = gql`
    mutation updateRole($id: String!, $data: RoleInput!) {
  updateRole(id: $id, input: $data) {
    ...RoleFields
  }
}
    ${RoleFieldsFragmentDoc}`;
export type UpdateRoleMutationFn = Apollo.MutationFunction<UpdateRoleMutation, UpdateRoleMutationVariables>;

/**
 * __useUpdateRoleMutation__
 *
 * To run a mutation, you first call `useUpdateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoleMutation, { data, loading, error }] = useUpdateRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRoleMutation, UpdateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRoleMutation, UpdateRoleMutationVariables>(UpdateRoleDocument, options);
      }
export type UpdateRoleMutationHookResult = ReturnType<typeof useUpdateRoleMutation>;
export type UpdateRoleMutationResult = Apollo.MutationResult<UpdateRoleMutation>;
export type UpdateRoleMutationOptions = Apollo.BaseMutationOptions<UpdateRoleMutation, UpdateRoleMutationVariables>;
export const RemoveRolesDocument = gql`
    mutation removeRoles($data: DeleteRecordsInput!) {
  removeRoles(input: $data)
}
    `;
export type RemoveRolesMutationFn = Apollo.MutationFunction<RemoveRolesMutation, RemoveRolesMutationVariables>;

/**
 * __useRemoveRolesMutation__
 *
 * To run a mutation, you first call `useRemoveRolesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRolesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeRolesMutation, { data, loading, error }] = useRemoveRolesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveRolesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveRolesMutation, RemoveRolesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveRolesMutation, RemoveRolesMutationVariables>(RemoveRolesDocument, options);
      }
export type RemoveRolesMutationHookResult = ReturnType<typeof useRemoveRolesMutation>;
export type RemoveRolesMutationResult = Apollo.MutationResult<RemoveRolesMutation>;
export type RemoveRolesMutationOptions = Apollo.BaseMutationOptions<RemoveRolesMutation, RemoveRolesMutationVariables>;
export const ToggleRoleDocument = gql`
    mutation toggleRole($id: String!) {
  toggleRole(id: $id)
}
    `;
export type ToggleRoleMutationFn = Apollo.MutationFunction<ToggleRoleMutation, ToggleRoleMutationVariables>;

/**
 * __useToggleRoleMutation__
 *
 * To run a mutation, you first call `useToggleRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleRoleMutation, { data, loading, error }] = useToggleRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleRoleMutation(baseOptions?: Apollo.MutationHookOptions<ToggleRoleMutation, ToggleRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleRoleMutation, ToggleRoleMutationVariables>(ToggleRoleDocument, options);
      }
export type ToggleRoleMutationHookResult = ReturnType<typeof useToggleRoleMutation>;
export type ToggleRoleMutationResult = Apollo.MutationResult<ToggleRoleMutation>;
export type ToggleRoleMutationOptions = Apollo.BaseMutationOptions<ToggleRoleMutation, ToggleRoleMutationVariables>;
export const GetRolesTableDocument = gql`
    query getRolesTable($portfolioId: String!, $take: Int! = 10, $after: String, $before: String, $search: String, $active: Boolean) {
  getRoles(
    portfolioId: $portfolioId
    take: $take
    after: $after
    before: $before
    search: $search
    active: $active
  ) @connection(key: "getRolesTable") {
    pagination {
      ...PaginationFields
    }
    data {
      ...RoleCoreFields
      index
      active
      description
      createdAt
      userCount
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${RoleCoreFieldsFragmentDoc}`;

/**
 * __useGetRolesTableQuery__
 *
 * To run a query within a React component, call `useGetRolesTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesTableQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useGetRolesTableQuery(baseOptions: Apollo.QueryHookOptions<GetRolesTableQuery, GetRolesTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRolesTableQuery, GetRolesTableQueryVariables>(GetRolesTableDocument, options);
      }
export function useGetRolesTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRolesTableQuery, GetRolesTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRolesTableQuery, GetRolesTableQueryVariables>(GetRolesTableDocument, options);
        }
export type GetRolesTableQueryHookResult = ReturnType<typeof useGetRolesTableQuery>;
export type GetRolesTableLazyQueryHookResult = ReturnType<typeof useGetRolesTableLazyQuery>;
export type GetRolesTableQueryResult = Apollo.QueryResult<GetRolesTableQuery, GetRolesTableQueryVariables>;
export const GetRolesDropdownDocument = gql`
    query getRolesDropdown($portfolioId: String!, $take: Int! = 10, $after: String, $before: String, $search: String, $active: Boolean) {
  getRoles(
    portfolioId: $portfolioId
    take: $take
    after: $after
    before: $before
    search: $search
    active: $active
  ) @connection(key: "getRolesDropdown") {
    pagination {
      ...PaginationFields
    }
    data {
      ...RoleCoreFields
      active
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${RoleCoreFieldsFragmentDoc}`;

/**
 * __useGetRolesDropdownQuery__
 *
 * To run a query within a React component, call `useGetRolesDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesDropdownQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useGetRolesDropdownQuery(baseOptions: Apollo.QueryHookOptions<GetRolesDropdownQuery, GetRolesDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRolesDropdownQuery, GetRolesDropdownQueryVariables>(GetRolesDropdownDocument, options);
      }
export function useGetRolesDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRolesDropdownQuery, GetRolesDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRolesDropdownQuery, GetRolesDropdownQueryVariables>(GetRolesDropdownDocument, options);
        }
export type GetRolesDropdownQueryHookResult = ReturnType<typeof useGetRolesDropdownQuery>;
export type GetRolesDropdownLazyQueryHookResult = ReturnType<typeof useGetRolesDropdownLazyQuery>;
export type GetRolesDropdownQueryResult = Apollo.QueryResult<GetRolesDropdownQuery, GetRolesDropdownQueryVariables>;
export const GetRoleDocument = gql`
    query getRole($id: String!) {
  getRole(id: $id) {
    ...RoleFields
  }
}
    ${RoleFieldsFragmentDoc}`;

/**
 * __useGetRoleQuery__
 *
 * To run a query within a React component, call `useGetRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRoleQuery(baseOptions: Apollo.QueryHookOptions<GetRoleQuery, GetRoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoleQuery, GetRoleQueryVariables>(GetRoleDocument, options);
      }
export function useGetRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoleQuery, GetRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoleQuery, GetRoleQueryVariables>(GetRoleDocument, options);
        }
export type GetRoleQueryHookResult = ReturnType<typeof useGetRoleQuery>;
export type GetRoleLazyQueryHookResult = ReturnType<typeof useGetRoleLazyQuery>;
export type GetRoleQueryResult = Apollo.QueryResult<GetRoleQuery, GetRoleQueryVariables>;
export const GetRoleStructureDocument = gql`
    query getRoleStructure {
  getRoleStructure {
    title
    description
    sections {
      title
      notes
      permissions {
        key
        title
        note
        dependencies
      }
    }
  }
}
    `;

/**
 * __useGetRoleStructureQuery__
 *
 * To run a query within a React component, call `useGetRoleStructureQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoleStructureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoleStructureQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRoleStructureQuery(baseOptions?: Apollo.QueryHookOptions<GetRoleStructureQuery, GetRoleStructureQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoleStructureQuery, GetRoleStructureQueryVariables>(GetRoleStructureDocument, options);
      }
export function useGetRoleStructureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoleStructureQuery, GetRoleStructureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoleStructureQuery, GetRoleStructureQueryVariables>(GetRoleStructureDocument, options);
        }
export type GetRoleStructureQueryHookResult = ReturnType<typeof useGetRoleStructureQuery>;
export type GetRoleStructureLazyQueryHookResult = ReturnType<typeof useGetRoleStructureLazyQuery>;
export type GetRoleStructureQueryResult = Apollo.QueryResult<GetRoleStructureQuery, GetRoleStructureQueryVariables>;
export const CreateStatusDocument = gql`
    mutation createStatus($data: StatusInput!, $portfolioId: String!) {
  createStatus(input: $data, portfolioId: $portfolioId) {
    id
  }
}
    `;
export type CreateStatusMutationFn = Apollo.MutationFunction<CreateStatusMutation, CreateStatusMutationVariables>;

/**
 * __useCreateStatusMutation__
 *
 * To run a mutation, you first call `useCreateStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStatusMutation, { data, loading, error }] = useCreateStatusMutation({
 *   variables: {
 *      data: // value for 'data'
 *      portfolioId: // value for 'portfolioId'
 *   },
 * });
 */
export function useCreateStatusMutation(baseOptions?: Apollo.MutationHookOptions<CreateStatusMutation, CreateStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStatusMutation, CreateStatusMutationVariables>(CreateStatusDocument, options);
      }
export type CreateStatusMutationHookResult = ReturnType<typeof useCreateStatusMutation>;
export type CreateStatusMutationResult = Apollo.MutationResult<CreateStatusMutation>;
export type CreateStatusMutationOptions = Apollo.BaseMutationOptions<CreateStatusMutation, CreateStatusMutationVariables>;
export const UpdateStatusDocument = gql`
    mutation updateStatus($id: String!, $data: StatusUpdateInput!) {
  updateStatus(id: $id, input: $data) {
    ...StatusFields
  }
}
    ${StatusFieldsFragmentDoc}`;
export type UpdateStatusMutationFn = Apollo.MutationFunction<UpdateStatusMutation, UpdateStatusMutationVariables>;

/**
 * __useUpdateStatusMutation__
 *
 * To run a mutation, you first call `useUpdateStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStatusMutation, { data, loading, error }] = useUpdateStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStatusMutation, UpdateStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStatusMutation, UpdateStatusMutationVariables>(UpdateStatusDocument, options);
      }
export type UpdateStatusMutationHookResult = ReturnType<typeof useUpdateStatusMutation>;
export type UpdateStatusMutationResult = Apollo.MutationResult<UpdateStatusMutation>;
export type UpdateStatusMutationOptions = Apollo.BaseMutationOptions<UpdateStatusMutation, UpdateStatusMutationVariables>;
export const ReorderStatusesDocument = gql`
    mutation reorderStatuses($id: String!, $secondId: String!) {
  reorderStatuses(id: $id, secondId: $secondId)
}
    `;
export type ReorderStatusesMutationFn = Apollo.MutationFunction<ReorderStatusesMutation, ReorderStatusesMutationVariables>;

/**
 * __useReorderStatusesMutation__
 *
 * To run a mutation, you first call `useReorderStatusesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderStatusesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderStatusesMutation, { data, loading, error }] = useReorderStatusesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      secondId: // value for 'secondId'
 *   },
 * });
 */
export function useReorderStatusesMutation(baseOptions?: Apollo.MutationHookOptions<ReorderStatusesMutation, ReorderStatusesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderStatusesMutation, ReorderStatusesMutationVariables>(ReorderStatusesDocument, options);
      }
export type ReorderStatusesMutationHookResult = ReturnType<typeof useReorderStatusesMutation>;
export type ReorderStatusesMutationResult = Apollo.MutationResult<ReorderStatusesMutation>;
export type ReorderStatusesMutationOptions = Apollo.BaseMutationOptions<ReorderStatusesMutation, ReorderStatusesMutationVariables>;
export const ToggleStatusDocument = gql`
    mutation toggleStatus($id: String!) {
  toggleStatus(id: $id)
}
    `;
export type ToggleStatusMutationFn = Apollo.MutationFunction<ToggleStatusMutation, ToggleStatusMutationVariables>;

/**
 * __useToggleStatusMutation__
 *
 * To run a mutation, you first call `useToggleStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleStatusMutation, { data, loading, error }] = useToggleStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleStatusMutation(baseOptions?: Apollo.MutationHookOptions<ToggleStatusMutation, ToggleStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleStatusMutation, ToggleStatusMutationVariables>(ToggleStatusDocument, options);
      }
export type ToggleStatusMutationHookResult = ReturnType<typeof useToggleStatusMutation>;
export type ToggleStatusMutationResult = Apollo.MutationResult<ToggleStatusMutation>;
export type ToggleStatusMutationOptions = Apollo.BaseMutationOptions<ToggleStatusMutation, ToggleStatusMutationVariables>;
export const RemoveStatusesDocument = gql`
    mutation removeStatuses($data: DeleteRecordsInput!) {
  removeStatuses(input: $data)
}
    `;
export type RemoveStatusesMutationFn = Apollo.MutationFunction<RemoveStatusesMutation, RemoveStatusesMutationVariables>;

/**
 * __useRemoveStatusesMutation__
 *
 * To run a mutation, you first call `useRemoveStatusesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveStatusesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeStatusesMutation, { data, loading, error }] = useRemoveStatusesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveStatusesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveStatusesMutation, RemoveStatusesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveStatusesMutation, RemoveStatusesMutationVariables>(RemoveStatusesDocument, options);
      }
export type RemoveStatusesMutationHookResult = ReturnType<typeof useRemoveStatusesMutation>;
export type RemoveStatusesMutationResult = Apollo.MutationResult<RemoveStatusesMutation>;
export type RemoveStatusesMutationOptions = Apollo.BaseMutationOptions<RemoveStatusesMutation, RemoveStatusesMutationVariables>;
export const UpdateWorkOrderStatusSettingsDocument = gql`
    mutation updateWorkOrderStatusSettings($portfolioId: String!, $data: WorkOrderStatusInput!) {
  updateWorkOrderStatusSetting(portfolioId: $portfolioId, input: $data) {
    ...WorkOrdersStatusSettingsFields
  }
}
    ${WorkOrdersStatusSettingsFieldsFragmentDoc}`;
export type UpdateWorkOrderStatusSettingsMutationFn = Apollo.MutationFunction<UpdateWorkOrderStatusSettingsMutation, UpdateWorkOrderStatusSettingsMutationVariables>;

/**
 * __useUpdateWorkOrderStatusSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateWorkOrderStatusSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkOrderStatusSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkOrderStatusSettingsMutation, { data, loading, error }] = useUpdateWorkOrderStatusSettingsMutation({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateWorkOrderStatusSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkOrderStatusSettingsMutation, UpdateWorkOrderStatusSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkOrderStatusSettingsMutation, UpdateWorkOrderStatusSettingsMutationVariables>(UpdateWorkOrderStatusSettingsDocument, options);
      }
export type UpdateWorkOrderStatusSettingsMutationHookResult = ReturnType<typeof useUpdateWorkOrderStatusSettingsMutation>;
export type UpdateWorkOrderStatusSettingsMutationResult = Apollo.MutationResult<UpdateWorkOrderStatusSettingsMutation>;
export type UpdateWorkOrderStatusSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateWorkOrderStatusSettingsMutation, UpdateWorkOrderStatusSettingsMutationVariables>;
export const UpdateIncidentStatusSettingDocument = gql`
    mutation updateIncidentStatusSetting($portfolioId: String!, $data: IncidentStatusInput!) {
  updateIncidentStatusSetting(portfolioId: $portfolioId, input: $data) {
    ...IncidentsStatusSettingsFields
  }
}
    ${IncidentsStatusSettingsFieldsFragmentDoc}`;
export type UpdateIncidentStatusSettingMutationFn = Apollo.MutationFunction<UpdateIncidentStatusSettingMutation, UpdateIncidentStatusSettingMutationVariables>;

/**
 * __useUpdateIncidentStatusSettingMutation__
 *
 * To run a mutation, you first call `useUpdateIncidentStatusSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIncidentStatusSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIncidentStatusSettingMutation, { data, loading, error }] = useUpdateIncidentStatusSettingMutation({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateIncidentStatusSettingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIncidentStatusSettingMutation, UpdateIncidentStatusSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIncidentStatusSettingMutation, UpdateIncidentStatusSettingMutationVariables>(UpdateIncidentStatusSettingDocument, options);
      }
export type UpdateIncidentStatusSettingMutationHookResult = ReturnType<typeof useUpdateIncidentStatusSettingMutation>;
export type UpdateIncidentStatusSettingMutationResult = Apollo.MutationResult<UpdateIncidentStatusSettingMutation>;
export type UpdateIncidentStatusSettingMutationOptions = Apollo.BaseMutationOptions<UpdateIncidentStatusSettingMutation, UpdateIncidentStatusSettingMutationVariables>;
export const GetStatusesTableDocument = gql`
    query getStatusesTable($portfolioId: String!, $recordType: StatusRecordType!, $recordLevel: RecordLevel, $active: Boolean, $search: String, $propertyIds: [String!]) {
  getStatuses(
    portfolioId: $portfolioId
    recordType: $recordType
    recordLevel: $recordLevel
    active: $active
    search: $search
    propertyIds: $propertyIds
  ) {
    ...StatusCoreFields
    color
    index
    active
    property {
      ...PropertyCoreFields
    }
  }
}
    ${StatusCoreFieldsFragmentDoc}
${PropertyCoreFieldsFragmentDoc}`;

/**
 * __useGetStatusesTableQuery__
 *
 * To run a query within a React component, call `useGetStatusesTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatusesTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatusesTableQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      recordType: // value for 'recordType'
 *      recordLevel: // value for 'recordLevel'
 *      active: // value for 'active'
 *      search: // value for 'search'
 *      propertyIds: // value for 'propertyIds'
 *   },
 * });
 */
export function useGetStatusesTableQuery(baseOptions: Apollo.QueryHookOptions<GetStatusesTableQuery, GetStatusesTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStatusesTableQuery, GetStatusesTableQueryVariables>(GetStatusesTableDocument, options);
      }
export function useGetStatusesTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStatusesTableQuery, GetStatusesTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStatusesTableQuery, GetStatusesTableQueryVariables>(GetStatusesTableDocument, options);
        }
export type GetStatusesTableQueryHookResult = ReturnType<typeof useGetStatusesTableQuery>;
export type GetStatusesTableLazyQueryHookResult = ReturnType<typeof useGetStatusesTableLazyQuery>;
export type GetStatusesTableQueryResult = Apollo.QueryResult<GetStatusesTableQuery, GetStatusesTableQueryVariables>;
export const GetStatusesDropdownDocument = gql`
    query getStatusesDropdown($portfolioId: String!, $recordType: StatusRecordType!, $recordLevel: RecordLevel, $active: Boolean, $search: String, $propertyIds: [String!]) {
  getStatuses(
    portfolioId: $portfolioId
    recordType: $recordType
    recordLevel: $recordLevel
    active: $active
    search: $search
    propertyIds: $propertyIds
  ) {
    ...StatusCoreFields
    color
    active
  }
}
    ${StatusCoreFieldsFragmentDoc}`;

/**
 * __useGetStatusesDropdownQuery__
 *
 * To run a query within a React component, call `useGetStatusesDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatusesDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatusesDropdownQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      recordType: // value for 'recordType'
 *      recordLevel: // value for 'recordLevel'
 *      active: // value for 'active'
 *      search: // value for 'search'
 *      propertyIds: // value for 'propertyIds'
 *   },
 * });
 */
export function useGetStatusesDropdownQuery(baseOptions: Apollo.QueryHookOptions<GetStatusesDropdownQuery, GetStatusesDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStatusesDropdownQuery, GetStatusesDropdownQueryVariables>(GetStatusesDropdownDocument, options);
      }
export function useGetStatusesDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStatusesDropdownQuery, GetStatusesDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStatusesDropdownQuery, GetStatusesDropdownQueryVariables>(GetStatusesDropdownDocument, options);
        }
export type GetStatusesDropdownQueryHookResult = ReturnType<typeof useGetStatusesDropdownQuery>;
export type GetStatusesDropdownLazyQueryHookResult = ReturnType<typeof useGetStatusesDropdownLazyQuery>;
export type GetStatusesDropdownQueryResult = Apollo.QueryResult<GetStatusesDropdownQuery, GetStatusesDropdownQueryVariables>;
export const GetFilterableStatusesDocument = gql`
    query getFilterableStatuses($portfolioId: String!, $location: FilterableStatusLocationType!, $search: String) {
  getFilterableStatuses(
    portfolioId: $portfolioId
    location: $location
    search: $search
  ) {
    id
    title
    color
    active
    isDeleted
  }
}
    `;

/**
 * __useGetFilterableStatusesQuery__
 *
 * To run a query within a React component, call `useGetFilterableStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilterableStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilterableStatusesQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      location: // value for 'location'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetFilterableStatusesQuery(baseOptions: Apollo.QueryHookOptions<GetFilterableStatusesQuery, GetFilterableStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilterableStatusesQuery, GetFilterableStatusesQueryVariables>(GetFilterableStatusesDocument, options);
      }
export function useGetFilterableStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilterableStatusesQuery, GetFilterableStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilterableStatusesQuery, GetFilterableStatusesQueryVariables>(GetFilterableStatusesDocument, options);
        }
export type GetFilterableStatusesQueryHookResult = ReturnType<typeof useGetFilterableStatusesQuery>;
export type GetFilterableStatusesLazyQueryHookResult = ReturnType<typeof useGetFilterableStatusesLazyQuery>;
export type GetFilterableStatusesQueryResult = Apollo.QueryResult<GetFilterableStatusesQuery, GetFilterableStatusesQueryVariables>;
export const GetStatusDocument = gql`
    query getStatus($id: String!) {
  getStatus(id: $id) {
    ...StatusFields
  }
}
    ${StatusFieldsFragmentDoc}`;

/**
 * __useGetStatusQuery__
 *
 * To run a query within a React component, call `useGetStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetStatusQuery(baseOptions: Apollo.QueryHookOptions<GetStatusQuery, GetStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStatusQuery, GetStatusQueryVariables>(GetStatusDocument, options);
      }
export function useGetStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStatusQuery, GetStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStatusQuery, GetStatusQueryVariables>(GetStatusDocument, options);
        }
export type GetStatusQueryHookResult = ReturnType<typeof useGetStatusQuery>;
export type GetStatusLazyQueryHookResult = ReturnType<typeof useGetStatusLazyQuery>;
export type GetStatusQueryResult = Apollo.QueryResult<GetStatusQuery, GetStatusQueryVariables>;
export const GetWorkOrderStatusSettingsDocument = gql`
    query getWorkOrderStatusSettings($portfolioId: String!) {
  getWorkOrderStatusSetting(portfolioId: $portfolioId) {
    ...WorkOrdersStatusSettingsFields
  }
}
    ${WorkOrdersStatusSettingsFieldsFragmentDoc}`;

/**
 * __useGetWorkOrderStatusSettingsQuery__
 *
 * To run a query within a React component, call `useGetWorkOrderStatusSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkOrderStatusSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkOrderStatusSettingsQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *   },
 * });
 */
export function useGetWorkOrderStatusSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetWorkOrderStatusSettingsQuery, GetWorkOrderStatusSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkOrderStatusSettingsQuery, GetWorkOrderStatusSettingsQueryVariables>(GetWorkOrderStatusSettingsDocument, options);
      }
export function useGetWorkOrderStatusSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkOrderStatusSettingsQuery, GetWorkOrderStatusSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkOrderStatusSettingsQuery, GetWorkOrderStatusSettingsQueryVariables>(GetWorkOrderStatusSettingsDocument, options);
        }
export type GetWorkOrderStatusSettingsQueryHookResult = ReturnType<typeof useGetWorkOrderStatusSettingsQuery>;
export type GetWorkOrderStatusSettingsLazyQueryHookResult = ReturnType<typeof useGetWorkOrderStatusSettingsLazyQuery>;
export type GetWorkOrderStatusSettingsQueryResult = Apollo.QueryResult<GetWorkOrderStatusSettingsQuery, GetWorkOrderStatusSettingsQueryVariables>;
export const GetIncidentStatusSettingDocument = gql`
    query getIncidentStatusSetting($portfolioId: String!) {
  getIncidentStatusSetting(portfolioId: $portfolioId) {
    ...IncidentsStatusSettingsFields
  }
}
    ${IncidentsStatusSettingsFieldsFragmentDoc}`;

/**
 * __useGetIncidentStatusSettingQuery__
 *
 * To run a query within a React component, call `useGetIncidentStatusSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIncidentStatusSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIncidentStatusSettingQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *   },
 * });
 */
export function useGetIncidentStatusSettingQuery(baseOptions: Apollo.QueryHookOptions<GetIncidentStatusSettingQuery, GetIncidentStatusSettingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIncidentStatusSettingQuery, GetIncidentStatusSettingQueryVariables>(GetIncidentStatusSettingDocument, options);
      }
export function useGetIncidentStatusSettingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIncidentStatusSettingQuery, GetIncidentStatusSettingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIncidentStatusSettingQuery, GetIncidentStatusSettingQueryVariables>(GetIncidentStatusSettingDocument, options);
        }
export type GetIncidentStatusSettingQueryHookResult = ReturnType<typeof useGetIncidentStatusSettingQuery>;
export type GetIncidentStatusSettingLazyQueryHookResult = ReturnType<typeof useGetIncidentStatusSettingLazyQuery>;
export type GetIncidentStatusSettingQueryResult = Apollo.QueryResult<GetIncidentStatusSettingQuery, GetIncidentStatusSettingQueryVariables>;
export const CreateTaxDocument = gql`
    mutation createTax($data: TaxInput!, $portfolioId: String!) {
  createTax(input: $data, portfolioId: $portfolioId) {
    id
  }
}
    `;
export type CreateTaxMutationFn = Apollo.MutationFunction<CreateTaxMutation, CreateTaxMutationVariables>;

/**
 * __useCreateTaxMutation__
 *
 * To run a mutation, you first call `useCreateTaxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaxMutation, { data, loading, error }] = useCreateTaxMutation({
 *   variables: {
 *      data: // value for 'data'
 *      portfolioId: // value for 'portfolioId'
 *   },
 * });
 */
export function useCreateTaxMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaxMutation, CreateTaxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaxMutation, CreateTaxMutationVariables>(CreateTaxDocument, options);
      }
export type CreateTaxMutationHookResult = ReturnType<typeof useCreateTaxMutation>;
export type CreateTaxMutationResult = Apollo.MutationResult<CreateTaxMutation>;
export type CreateTaxMutationOptions = Apollo.BaseMutationOptions<CreateTaxMutation, CreateTaxMutationVariables>;
export const UpdateTaxDocument = gql`
    mutation updateTax($id: String!, $data: TaxInput!) {
  updateTax(id: $id, input: $data) {
    ...TaxFields
  }
}
    ${TaxFieldsFragmentDoc}`;
export type UpdateTaxMutationFn = Apollo.MutationFunction<UpdateTaxMutation, UpdateTaxMutationVariables>;

/**
 * __useUpdateTaxMutation__
 *
 * To run a mutation, you first call `useUpdateTaxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaxMutation, { data, loading, error }] = useUpdateTaxMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateTaxMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaxMutation, UpdateTaxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaxMutation, UpdateTaxMutationVariables>(UpdateTaxDocument, options);
      }
export type UpdateTaxMutationHookResult = ReturnType<typeof useUpdateTaxMutation>;
export type UpdateTaxMutationResult = Apollo.MutationResult<UpdateTaxMutation>;
export type UpdateTaxMutationOptions = Apollo.BaseMutationOptions<UpdateTaxMutation, UpdateTaxMutationVariables>;
export const ToggleTaxDocument = gql`
    mutation toggleTax($id: String!) {
  toggleTax(id: $id)
}
    `;
export type ToggleTaxMutationFn = Apollo.MutationFunction<ToggleTaxMutation, ToggleTaxMutationVariables>;

/**
 * __useToggleTaxMutation__
 *
 * To run a mutation, you first call `useToggleTaxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleTaxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleTaxMutation, { data, loading, error }] = useToggleTaxMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleTaxMutation(baseOptions?: Apollo.MutationHookOptions<ToggleTaxMutation, ToggleTaxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleTaxMutation, ToggleTaxMutationVariables>(ToggleTaxDocument, options);
      }
export type ToggleTaxMutationHookResult = ReturnType<typeof useToggleTaxMutation>;
export type ToggleTaxMutationResult = Apollo.MutationResult<ToggleTaxMutation>;
export type ToggleTaxMutationOptions = Apollo.BaseMutationOptions<ToggleTaxMutation, ToggleTaxMutationVariables>;
export const RemoveTaxesDocument = gql`
    mutation removeTaxes($data: DeleteRecordsInput!) {
  removeTaxes(input: $data)
}
    `;
export type RemoveTaxesMutationFn = Apollo.MutationFunction<RemoveTaxesMutation, RemoveTaxesMutationVariables>;

/**
 * __useRemoveTaxesMutation__
 *
 * To run a mutation, you first call `useRemoveTaxesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTaxesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTaxesMutation, { data, loading, error }] = useRemoveTaxesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveTaxesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTaxesMutation, RemoveTaxesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTaxesMutation, RemoveTaxesMutationVariables>(RemoveTaxesDocument, options);
      }
export type RemoveTaxesMutationHookResult = ReturnType<typeof useRemoveTaxesMutation>;
export type RemoveTaxesMutationResult = Apollo.MutationResult<RemoveTaxesMutation>;
export type RemoveTaxesMutationOptions = Apollo.BaseMutationOptions<RemoveTaxesMutation, RemoveTaxesMutationVariables>;
export const GetTaxesTableDocument = gql`
    query getTaxesTable($portfolioId: String!, $active: Boolean, $search: String, $recordLevel: RecordLevel, $propertyIds: [String!]) {
  getTaxes(
    active: $active
    portfolioId: $portfolioId
    search: $search
    recordLevel: $recordLevel
    propertyIds: $propertyIds
  ) {
    ...TaxCoreFields
    index
    active
    amount
    property {
      ...PropertyCoreFields
    }
    glAccount {
      ...GLAccountCoreFields
    }
    arCode {
      ...ARCodeCoreFields
    }
    chargeCode {
      ...ChargeCodeCoreFields
    }
  }
}
    ${TaxCoreFieldsFragmentDoc}
${PropertyCoreFieldsFragmentDoc}
${GlAccountCoreFieldsFragmentDoc}
${ArCodeCoreFieldsFragmentDoc}
${ChargeCodeCoreFieldsFragmentDoc}`;

/**
 * __useGetTaxesTableQuery__
 *
 * To run a query within a React component, call `useGetTaxesTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxesTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxesTableQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      active: // value for 'active'
 *      search: // value for 'search'
 *      recordLevel: // value for 'recordLevel'
 *      propertyIds: // value for 'propertyIds'
 *   },
 * });
 */
export function useGetTaxesTableQuery(baseOptions: Apollo.QueryHookOptions<GetTaxesTableQuery, GetTaxesTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaxesTableQuery, GetTaxesTableQueryVariables>(GetTaxesTableDocument, options);
      }
export function useGetTaxesTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaxesTableQuery, GetTaxesTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaxesTableQuery, GetTaxesTableQueryVariables>(GetTaxesTableDocument, options);
        }
export type GetTaxesTableQueryHookResult = ReturnType<typeof useGetTaxesTableQuery>;
export type GetTaxesTableLazyQueryHookResult = ReturnType<typeof useGetTaxesTableLazyQuery>;
export type GetTaxesTableQueryResult = Apollo.QueryResult<GetTaxesTableQuery, GetTaxesTableQueryVariables>;
export const GetTaxesDropdownDocument = gql`
    query getTaxesDropdown($portfolioId: String!, $active: Boolean, $search: String, $recordLevel: RecordLevel, $propertyIds: [String!], $includeGLAccount: Boolean!, $includeARCode: Boolean!, $includeChargeCode: Boolean!) {
  getTaxes(
    active: $active
    portfolioId: $portfolioId
    search: $search
    recordLevel: $recordLevel
    propertyIds: $propertyIds
  ) {
    ...TaxCoreFields
    active
    amount
    glAccount @include(if: $includeGLAccount) {
      ...GLAccountCoreFields
    }
    arCode @include(if: $includeARCode) {
      ...ARCodeCoreFields
    }
    chargeCode @include(if: $includeChargeCode) {
      ...ChargeCodeCoreFields
    }
  }
}
    ${TaxCoreFieldsFragmentDoc}
${GlAccountCoreFieldsFragmentDoc}
${ArCodeCoreFieldsFragmentDoc}
${ChargeCodeCoreFieldsFragmentDoc}`;

/**
 * __useGetTaxesDropdownQuery__
 *
 * To run a query within a React component, call `useGetTaxesDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxesDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxesDropdownQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      active: // value for 'active'
 *      search: // value for 'search'
 *      recordLevel: // value for 'recordLevel'
 *      propertyIds: // value for 'propertyIds'
 *      includeGLAccount: // value for 'includeGLAccount'
 *      includeARCode: // value for 'includeARCode'
 *      includeChargeCode: // value for 'includeChargeCode'
 *   },
 * });
 */
export function useGetTaxesDropdownQuery(baseOptions: Apollo.QueryHookOptions<GetTaxesDropdownQuery, GetTaxesDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaxesDropdownQuery, GetTaxesDropdownQueryVariables>(GetTaxesDropdownDocument, options);
      }
export function useGetTaxesDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaxesDropdownQuery, GetTaxesDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaxesDropdownQuery, GetTaxesDropdownQueryVariables>(GetTaxesDropdownDocument, options);
        }
export type GetTaxesDropdownQueryHookResult = ReturnType<typeof useGetTaxesDropdownQuery>;
export type GetTaxesDropdownLazyQueryHookResult = ReturnType<typeof useGetTaxesDropdownLazyQuery>;
export type GetTaxesDropdownQueryResult = Apollo.QueryResult<GetTaxesDropdownQuery, GetTaxesDropdownQueryVariables>;
export const GetTaxDocument = gql`
    query getTax($id: String!) {
  getTax(id: $id) {
    ...TaxFields
  }
}
    ${TaxFieldsFragmentDoc}`;

/**
 * __useGetTaxQuery__
 *
 * To run a query within a React component, call `useGetTaxQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTaxQuery(baseOptions: Apollo.QueryHookOptions<GetTaxQuery, GetTaxQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaxQuery, GetTaxQueryVariables>(GetTaxDocument, options);
      }
export function useGetTaxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaxQuery, GetTaxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaxQuery, GetTaxQueryVariables>(GetTaxDocument, options);
        }
export type GetTaxQueryHookResult = ReturnType<typeof useGetTaxQuery>;
export type GetTaxLazyQueryHookResult = ReturnType<typeof useGetTaxLazyQuery>;
export type GetTaxQueryResult = Apollo.QueryResult<GetTaxQuery, GetTaxQueryVariables>;
export const CreateGlobalTranslationDocument = gql`
    mutation createGlobalTranslation($data: GlobalTranslationInput!) {
  createGlobalTranslation(input: $data) {
    id
  }
}
    `;
export type CreateGlobalTranslationMutationFn = Apollo.MutationFunction<CreateGlobalTranslationMutation, CreateGlobalTranslationMutationVariables>;

/**
 * __useCreateGlobalTranslationMutation__
 *
 * To run a mutation, you first call `useCreateGlobalTranslationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGlobalTranslationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGlobalTranslationMutation, { data, loading, error }] = useCreateGlobalTranslationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateGlobalTranslationMutation(baseOptions?: Apollo.MutationHookOptions<CreateGlobalTranslationMutation, CreateGlobalTranslationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGlobalTranslationMutation, CreateGlobalTranslationMutationVariables>(CreateGlobalTranslationDocument, options);
      }
export type CreateGlobalTranslationMutationHookResult = ReturnType<typeof useCreateGlobalTranslationMutation>;
export type CreateGlobalTranslationMutationResult = Apollo.MutationResult<CreateGlobalTranslationMutation>;
export type CreateGlobalTranslationMutationOptions = Apollo.BaseMutationOptions<CreateGlobalTranslationMutation, CreateGlobalTranslationMutationVariables>;
export const UpdateGlobalTranslationDocument = gql`
    mutation updateGlobalTranslation($id: String!, $data: GlobalTranslationInput!) {
  updateGlobalTranslation(id: $id, input: $data) {
    ...GlobalTranslationCoreFields
    countryCode
  }
}
    ${GlobalTranslationCoreFieldsFragmentDoc}`;
export type UpdateGlobalTranslationMutationFn = Apollo.MutationFunction<UpdateGlobalTranslationMutation, UpdateGlobalTranslationMutationVariables>;

/**
 * __useUpdateGlobalTranslationMutation__
 *
 * To run a mutation, you first call `useUpdateGlobalTranslationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGlobalTranslationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGlobalTranslationMutation, { data, loading, error }] = useUpdateGlobalTranslationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateGlobalTranslationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGlobalTranslationMutation, UpdateGlobalTranslationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGlobalTranslationMutation, UpdateGlobalTranslationMutationVariables>(UpdateGlobalTranslationDocument, options);
      }
export type UpdateGlobalTranslationMutationHookResult = ReturnType<typeof useUpdateGlobalTranslationMutation>;
export type UpdateGlobalTranslationMutationResult = Apollo.MutationResult<UpdateGlobalTranslationMutation>;
export type UpdateGlobalTranslationMutationOptions = Apollo.BaseMutationOptions<UpdateGlobalTranslationMutation, UpdateGlobalTranslationMutationVariables>;
export const UpdateGlobalTranslationTextsDocument = gql`
    mutation updateGlobalTranslationTexts($id: String!, $key: String!, $sources: TranslationKeysScalar, $descriptions: TranslationKeysScalar) {
  updateGlobalTranslationTexts(
    id: $id
    key: $key
    sources: $sources
    descriptions: $descriptions
  )
}
    `;
export type UpdateGlobalTranslationTextsMutationFn = Apollo.MutationFunction<UpdateGlobalTranslationTextsMutation, UpdateGlobalTranslationTextsMutationVariables>;

/**
 * __useUpdateGlobalTranslationTextsMutation__
 *
 * To run a mutation, you first call `useUpdateGlobalTranslationTextsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGlobalTranslationTextsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGlobalTranslationTextsMutation, { data, loading, error }] = useUpdateGlobalTranslationTextsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      key: // value for 'key'
 *      sources: // value for 'sources'
 *      descriptions: // value for 'descriptions'
 *   },
 * });
 */
export function useUpdateGlobalTranslationTextsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGlobalTranslationTextsMutation, UpdateGlobalTranslationTextsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGlobalTranslationTextsMutation, UpdateGlobalTranslationTextsMutationVariables>(UpdateGlobalTranslationTextsDocument, options);
      }
export type UpdateGlobalTranslationTextsMutationHookResult = ReturnType<typeof useUpdateGlobalTranslationTextsMutation>;
export type UpdateGlobalTranslationTextsMutationResult = Apollo.MutationResult<UpdateGlobalTranslationTextsMutation>;
export type UpdateGlobalTranslationTextsMutationOptions = Apollo.BaseMutationOptions<UpdateGlobalTranslationTextsMutation, UpdateGlobalTranslationTextsMutationVariables>;
export const ToggleGlobalTranslationDocument = gql`
    mutation toggleGlobalTranslation($id: String!) {
  toggleGlobalTranslation(id: $id)
}
    `;
export type ToggleGlobalTranslationMutationFn = Apollo.MutationFunction<ToggleGlobalTranslationMutation, ToggleGlobalTranslationMutationVariables>;

/**
 * __useToggleGlobalTranslationMutation__
 *
 * To run a mutation, you first call `useToggleGlobalTranslationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleGlobalTranslationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleGlobalTranslationMutation, { data, loading, error }] = useToggleGlobalTranslationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleGlobalTranslationMutation(baseOptions?: Apollo.MutationHookOptions<ToggleGlobalTranslationMutation, ToggleGlobalTranslationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleGlobalTranslationMutation, ToggleGlobalTranslationMutationVariables>(ToggleGlobalTranslationDocument, options);
      }
export type ToggleGlobalTranslationMutationHookResult = ReturnType<typeof useToggleGlobalTranslationMutation>;
export type ToggleGlobalTranslationMutationResult = Apollo.MutationResult<ToggleGlobalTranslationMutation>;
export type ToggleGlobalTranslationMutationOptions = Apollo.BaseMutationOptions<ToggleGlobalTranslationMutation, ToggleGlobalTranslationMutationVariables>;
export const ImportGlobalTranslationDocument = gql`
    mutation importGlobalTranslation($id: String!, $link: String!) {
  importGlobalTranslation(id: $id, link: $link)
}
    `;
export type ImportGlobalTranslationMutationFn = Apollo.MutationFunction<ImportGlobalTranslationMutation, ImportGlobalTranslationMutationVariables>;

/**
 * __useImportGlobalTranslationMutation__
 *
 * To run a mutation, you first call `useImportGlobalTranslationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportGlobalTranslationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importGlobalTranslationMutation, { data, loading, error }] = useImportGlobalTranslationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      link: // value for 'link'
 *   },
 * });
 */
export function useImportGlobalTranslationMutation(baseOptions?: Apollo.MutationHookOptions<ImportGlobalTranslationMutation, ImportGlobalTranslationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportGlobalTranslationMutation, ImportGlobalTranslationMutationVariables>(ImportGlobalTranslationDocument, options);
      }
export type ImportGlobalTranslationMutationHookResult = ReturnType<typeof useImportGlobalTranslationMutation>;
export type ImportGlobalTranslationMutationResult = Apollo.MutationResult<ImportGlobalTranslationMutation>;
export type ImportGlobalTranslationMutationOptions = Apollo.BaseMutationOptions<ImportGlobalTranslationMutation, ImportGlobalTranslationMutationVariables>;
export const RemoveGlobalTranslationsDocument = gql`
    mutation removeGlobalTranslations($data: DeleteRecordsInput!) {
  removeGlobalTranslations(input: $data)
}
    `;
export type RemoveGlobalTranslationsMutationFn = Apollo.MutationFunction<RemoveGlobalTranslationsMutation, RemoveGlobalTranslationsMutationVariables>;

/**
 * __useRemoveGlobalTranslationsMutation__
 *
 * To run a mutation, you first call `useRemoveGlobalTranslationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveGlobalTranslationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeGlobalTranslationsMutation, { data, loading, error }] = useRemoveGlobalTranslationsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveGlobalTranslationsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveGlobalTranslationsMutation, RemoveGlobalTranslationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveGlobalTranslationsMutation, RemoveGlobalTranslationsMutationVariables>(RemoveGlobalTranslationsDocument, options);
      }
export type RemoveGlobalTranslationsMutationHookResult = ReturnType<typeof useRemoveGlobalTranslationsMutation>;
export type RemoveGlobalTranslationsMutationResult = Apollo.MutationResult<RemoveGlobalTranslationsMutation>;
export type RemoveGlobalTranslationsMutationOptions = Apollo.BaseMutationOptions<RemoveGlobalTranslationsMutation, RemoveGlobalTranslationsMutationVariables>;
export const UploadTranslationDocument = gql`
    mutation uploadTranslation($data: GlobalBaseTranslationInput!) {
  uploadTranslation(input: $data)
}
    `;
export type UploadTranslationMutationFn = Apollo.MutationFunction<UploadTranslationMutation, UploadTranslationMutationVariables>;

/**
 * __useUploadTranslationMutation__
 *
 * To run a mutation, you first call `useUploadTranslationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadTranslationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadTranslationMutation, { data, loading, error }] = useUploadTranslationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUploadTranslationMutation(baseOptions?: Apollo.MutationHookOptions<UploadTranslationMutation, UploadTranslationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadTranslationMutation, UploadTranslationMutationVariables>(UploadTranslationDocument, options);
      }
export type UploadTranslationMutationHookResult = ReturnType<typeof useUploadTranslationMutation>;
export type UploadTranslationMutationResult = Apollo.MutationResult<UploadTranslationMutation>;
export type UploadTranslationMutationOptions = Apollo.BaseMutationOptions<UploadTranslationMutation, UploadTranslationMutationVariables>;
export const GetGlobalTranslationsTableDocument = gql`
    query getGlobalTranslationsTable($active: Boolean, $search: String) {
  getGlobalTranslations(active: $active, search: $search) {
    ...GlobalTranslationCoreFields
    countryCode
    active
  }
}
    ${GlobalTranslationCoreFieldsFragmentDoc}`;

/**
 * __useGetGlobalTranslationsTableQuery__
 *
 * To run a query within a React component, call `useGetGlobalTranslationsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGlobalTranslationsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGlobalTranslationsTableQuery({
 *   variables: {
 *      active: // value for 'active'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetGlobalTranslationsTableQuery(baseOptions?: Apollo.QueryHookOptions<GetGlobalTranslationsTableQuery, GetGlobalTranslationsTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGlobalTranslationsTableQuery, GetGlobalTranslationsTableQueryVariables>(GetGlobalTranslationsTableDocument, options);
      }
export function useGetGlobalTranslationsTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGlobalTranslationsTableQuery, GetGlobalTranslationsTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGlobalTranslationsTableQuery, GetGlobalTranslationsTableQueryVariables>(GetGlobalTranslationsTableDocument, options);
        }
export type GetGlobalTranslationsTableQueryHookResult = ReturnType<typeof useGetGlobalTranslationsTableQuery>;
export type GetGlobalTranslationsTableLazyQueryHookResult = ReturnType<typeof useGetGlobalTranslationsTableLazyQuery>;
export type GetGlobalTranslationsTableQueryResult = Apollo.QueryResult<GetGlobalTranslationsTableQuery, GetGlobalTranslationsTableQueryVariables>;
export const GetGlobalTranslationsDropdownDocument = gql`
    query getGlobalTranslationsDropdown($active: Boolean, $search: String) {
  getGlobalTranslations(active: $active, search: $search) {
    ...GlobalTranslationCoreFields
    active
  }
}
    ${GlobalTranslationCoreFieldsFragmentDoc}`;

/**
 * __useGetGlobalTranslationsDropdownQuery__
 *
 * To run a query within a React component, call `useGetGlobalTranslationsDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGlobalTranslationsDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGlobalTranslationsDropdownQuery({
 *   variables: {
 *      active: // value for 'active'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetGlobalTranslationsDropdownQuery(baseOptions?: Apollo.QueryHookOptions<GetGlobalTranslationsDropdownQuery, GetGlobalTranslationsDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGlobalTranslationsDropdownQuery, GetGlobalTranslationsDropdownQueryVariables>(GetGlobalTranslationsDropdownDocument, options);
      }
export function useGetGlobalTranslationsDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGlobalTranslationsDropdownQuery, GetGlobalTranslationsDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGlobalTranslationsDropdownQuery, GetGlobalTranslationsDropdownQueryVariables>(GetGlobalTranslationsDropdownDocument, options);
        }
export type GetGlobalTranslationsDropdownQueryHookResult = ReturnType<typeof useGetGlobalTranslationsDropdownQuery>;
export type GetGlobalTranslationsDropdownLazyQueryHookResult = ReturnType<typeof useGetGlobalTranslationsDropdownLazyQuery>;
export type GetGlobalTranslationsDropdownQueryResult = Apollo.QueryResult<GetGlobalTranslationsDropdownQuery, GetGlobalTranslationsDropdownQueryVariables>;
export const GetGlobalTranslationOverviewDocument = gql`
    query getGlobalTranslationOverview($id: String!) {
  getGlobalTranslation(id: $id) {
    ...GlobalTranslationCoreFields
    active
  }
}
    ${GlobalTranslationCoreFieldsFragmentDoc}`;

/**
 * __useGetGlobalTranslationOverviewQuery__
 *
 * To run a query within a React component, call `useGetGlobalTranslationOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGlobalTranslationOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGlobalTranslationOverviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGlobalTranslationOverviewQuery(baseOptions: Apollo.QueryHookOptions<GetGlobalTranslationOverviewQuery, GetGlobalTranslationOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGlobalTranslationOverviewQuery, GetGlobalTranslationOverviewQueryVariables>(GetGlobalTranslationOverviewDocument, options);
      }
export function useGetGlobalTranslationOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGlobalTranslationOverviewQuery, GetGlobalTranslationOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGlobalTranslationOverviewQuery, GetGlobalTranslationOverviewQueryVariables>(GetGlobalTranslationOverviewDocument, options);
        }
export type GetGlobalTranslationOverviewQueryHookResult = ReturnType<typeof useGetGlobalTranslationOverviewQuery>;
export type GetGlobalTranslationOverviewLazyQueryHookResult = ReturnType<typeof useGetGlobalTranslationOverviewLazyQuery>;
export type GetGlobalTranslationOverviewQueryResult = Apollo.QueryResult<GetGlobalTranslationOverviewQuery, GetGlobalTranslationOverviewQueryVariables>;
export const GetGlobalTranslationDocument = gql`
    query getGlobalTranslation($id: String!) {
  getGlobalTranslation(id: $id) {
    ...GlobalTranslationCoreFields
    countryCode
  }
}
    ${GlobalTranslationCoreFieldsFragmentDoc}`;

/**
 * __useGetGlobalTranslationQuery__
 *
 * To run a query within a React component, call `useGetGlobalTranslationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGlobalTranslationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGlobalTranslationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGlobalTranslationQuery(baseOptions: Apollo.QueryHookOptions<GetGlobalTranslationQuery, GetGlobalTranslationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGlobalTranslationQuery, GetGlobalTranslationQueryVariables>(GetGlobalTranslationDocument, options);
      }
export function useGetGlobalTranslationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGlobalTranslationQuery, GetGlobalTranslationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGlobalTranslationQuery, GetGlobalTranslationQueryVariables>(GetGlobalTranslationDocument, options);
        }
export type GetGlobalTranslationQueryHookResult = ReturnType<typeof useGetGlobalTranslationQuery>;
export type GetGlobalTranslationLazyQueryHookResult = ReturnType<typeof useGetGlobalTranslationLazyQuery>;
export type GetGlobalTranslationQueryResult = Apollo.QueryResult<GetGlobalTranslationQuery, GetGlobalTranslationQueryVariables>;
export const GetGlobalTranslationFilteredTableDocument = gql`
    query getGlobalTranslationFilteredTable($id: String!, $key: String!) {
  getGlobalTranslationFiltered(id: $id, key: $key) {
    sources
    descriptions
  }
}
    `;

/**
 * __useGetGlobalTranslationFilteredTableQuery__
 *
 * To run a query within a React component, call `useGetGlobalTranslationFilteredTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGlobalTranslationFilteredTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGlobalTranslationFilteredTableQuery({
 *   variables: {
 *      id: // value for 'id'
 *      key: // value for 'key'
 *   },
 * });
 */
export function useGetGlobalTranslationFilteredTableQuery(baseOptions: Apollo.QueryHookOptions<GetGlobalTranslationFilteredTableQuery, GetGlobalTranslationFilteredTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGlobalTranslationFilteredTableQuery, GetGlobalTranslationFilteredTableQueryVariables>(GetGlobalTranslationFilteredTableDocument, options);
      }
export function useGetGlobalTranslationFilteredTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGlobalTranslationFilteredTableQuery, GetGlobalTranslationFilteredTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGlobalTranslationFilteredTableQuery, GetGlobalTranslationFilteredTableQueryVariables>(GetGlobalTranslationFilteredTableDocument, options);
        }
export type GetGlobalTranslationFilteredTableQueryHookResult = ReturnType<typeof useGetGlobalTranslationFilteredTableQuery>;
export type GetGlobalTranslationFilteredTableLazyQueryHookResult = ReturnType<typeof useGetGlobalTranslationFilteredTableLazyQuery>;
export type GetGlobalTranslationFilteredTableQueryResult = Apollo.QueryResult<GetGlobalTranslationFilteredTableQuery, GetGlobalTranslationFilteredTableQueryVariables>;
export const ExportGlobalTranslationDocument = gql`
    query exportGlobalTranslation($id: String!) {
  exportGlobalTranslation(id: $id)
}
    `;

/**
 * __useExportGlobalTranslationQuery__
 *
 * To run a query within a React component, call `useExportGlobalTranslationQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportGlobalTranslationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportGlobalTranslationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExportGlobalTranslationQuery(baseOptions: Apollo.QueryHookOptions<ExportGlobalTranslationQuery, ExportGlobalTranslationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportGlobalTranslationQuery, ExportGlobalTranslationQueryVariables>(ExportGlobalTranslationDocument, options);
      }
export function useExportGlobalTranslationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportGlobalTranslationQuery, ExportGlobalTranslationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportGlobalTranslationQuery, ExportGlobalTranslationQueryVariables>(ExportGlobalTranslationDocument, options);
        }
export type ExportGlobalTranslationQueryHookResult = ReturnType<typeof useExportGlobalTranslationQuery>;
export type ExportGlobalTranslationLazyQueryHookResult = ReturnType<typeof useExportGlobalTranslationLazyQuery>;
export type ExportGlobalTranslationQueryResult = Apollo.QueryResult<ExportGlobalTranslationQuery, ExportGlobalTranslationQueryVariables>;
export const CreateTranslationDocument = gql`
    mutation createTranslation($portfolioId: String!, $data: TranslationInput!) {
  createTranslation(portfolioId: $portfolioId, input: $data) {
    id
  }
}
    `;
export type CreateTranslationMutationFn = Apollo.MutationFunction<CreateTranslationMutation, CreateTranslationMutationVariables>;

/**
 * __useCreateTranslationMutation__
 *
 * To run a mutation, you first call `useCreateTranslationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTranslationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTranslationMutation, { data, loading, error }] = useCreateTranslationMutation({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateTranslationMutation(baseOptions?: Apollo.MutationHookOptions<CreateTranslationMutation, CreateTranslationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTranslationMutation, CreateTranslationMutationVariables>(CreateTranslationDocument, options);
      }
export type CreateTranslationMutationHookResult = ReturnType<typeof useCreateTranslationMutation>;
export type CreateTranslationMutationResult = Apollo.MutationResult<CreateTranslationMutation>;
export type CreateTranslationMutationOptions = Apollo.BaseMutationOptions<CreateTranslationMutation, CreateTranslationMutationVariables>;
export const UpdateTranslationDocument = gql`
    mutation updateTranslation($id: String!, $data: TranslationInput!) {
  updateTranslation(id: $id, input: $data) {
    ...TranslationCoreFields
    countryCode
  }
}
    ${TranslationCoreFieldsFragmentDoc}`;
export type UpdateTranslationMutationFn = Apollo.MutationFunction<UpdateTranslationMutation, UpdateTranslationMutationVariables>;

/**
 * __useUpdateTranslationMutation__
 *
 * To run a mutation, you first call `useUpdateTranslationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTranslationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTranslationMutation, { data, loading, error }] = useUpdateTranslationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateTranslationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTranslationMutation, UpdateTranslationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTranslationMutation, UpdateTranslationMutationVariables>(UpdateTranslationDocument, options);
      }
export type UpdateTranslationMutationHookResult = ReturnType<typeof useUpdateTranslationMutation>;
export type UpdateTranslationMutationResult = Apollo.MutationResult<UpdateTranslationMutation>;
export type UpdateTranslationMutationOptions = Apollo.BaseMutationOptions<UpdateTranslationMutation, UpdateTranslationMutationVariables>;
export const UpdateTranslationTranslationsDocument = gql`
    mutation updateTranslationTranslations($id: String!, $key: String!, $translations: TranslationKeysScalar!) {
  updateTranslationTranslations(id: $id, key: $key, translations: $translations)
}
    `;
export type UpdateTranslationTranslationsMutationFn = Apollo.MutationFunction<UpdateTranslationTranslationsMutation, UpdateTranslationTranslationsMutationVariables>;

/**
 * __useUpdateTranslationTranslationsMutation__
 *
 * To run a mutation, you first call `useUpdateTranslationTranslationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTranslationTranslationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTranslationTranslationsMutation, { data, loading, error }] = useUpdateTranslationTranslationsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      key: // value for 'key'
 *      translations: // value for 'translations'
 *   },
 * });
 */
export function useUpdateTranslationTranslationsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTranslationTranslationsMutation, UpdateTranslationTranslationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTranslationTranslationsMutation, UpdateTranslationTranslationsMutationVariables>(UpdateTranslationTranslationsDocument, options);
      }
export type UpdateTranslationTranslationsMutationHookResult = ReturnType<typeof useUpdateTranslationTranslationsMutation>;
export type UpdateTranslationTranslationsMutationResult = Apollo.MutationResult<UpdateTranslationTranslationsMutation>;
export type UpdateTranslationTranslationsMutationOptions = Apollo.BaseMutationOptions<UpdateTranslationTranslationsMutation, UpdateTranslationTranslationsMutationVariables>;
export const ResetTranslationDocument = gql`
    mutation resetTranslation($id: String!) {
  resetTranslation(id: $id)
}
    `;
export type ResetTranslationMutationFn = Apollo.MutationFunction<ResetTranslationMutation, ResetTranslationMutationVariables>;

/**
 * __useResetTranslationMutation__
 *
 * To run a mutation, you first call `useResetTranslationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetTranslationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetTranslationMutation, { data, loading, error }] = useResetTranslationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResetTranslationMutation(baseOptions?: Apollo.MutationHookOptions<ResetTranslationMutation, ResetTranslationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetTranslationMutation, ResetTranslationMutationVariables>(ResetTranslationDocument, options);
      }
export type ResetTranslationMutationHookResult = ReturnType<typeof useResetTranslationMutation>;
export type ResetTranslationMutationResult = Apollo.MutationResult<ResetTranslationMutation>;
export type ResetTranslationMutationOptions = Apollo.BaseMutationOptions<ResetTranslationMutation, ResetTranslationMutationVariables>;
export const ImportTranslationDocument = gql`
    mutation importTranslation($id: String!, $link: String!) {
  importTranslation(id: $id, link: $link)
}
    `;
export type ImportTranslationMutationFn = Apollo.MutationFunction<ImportTranslationMutation, ImportTranslationMutationVariables>;

/**
 * __useImportTranslationMutation__
 *
 * To run a mutation, you first call `useImportTranslationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportTranslationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importTranslationMutation, { data, loading, error }] = useImportTranslationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      link: // value for 'link'
 *   },
 * });
 */
export function useImportTranslationMutation(baseOptions?: Apollo.MutationHookOptions<ImportTranslationMutation, ImportTranslationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportTranslationMutation, ImportTranslationMutationVariables>(ImportTranslationDocument, options);
      }
export type ImportTranslationMutationHookResult = ReturnType<typeof useImportTranslationMutation>;
export type ImportTranslationMutationResult = Apollo.MutationResult<ImportTranslationMutation>;
export type ImportTranslationMutationOptions = Apollo.BaseMutationOptions<ImportTranslationMutation, ImportTranslationMutationVariables>;
export const ToggleTranslationDocument = gql`
    mutation toggleTranslation($id: String!) {
  toggleTranslation(id: $id)
}
    `;
export type ToggleTranslationMutationFn = Apollo.MutationFunction<ToggleTranslationMutation, ToggleTranslationMutationVariables>;

/**
 * __useToggleTranslationMutation__
 *
 * To run a mutation, you first call `useToggleTranslationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleTranslationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleTranslationMutation, { data, loading, error }] = useToggleTranslationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleTranslationMutation(baseOptions?: Apollo.MutationHookOptions<ToggleTranslationMutation, ToggleTranslationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleTranslationMutation, ToggleTranslationMutationVariables>(ToggleTranslationDocument, options);
      }
export type ToggleTranslationMutationHookResult = ReturnType<typeof useToggleTranslationMutation>;
export type ToggleTranslationMutationResult = Apollo.MutationResult<ToggleTranslationMutation>;
export type ToggleTranslationMutationOptions = Apollo.BaseMutationOptions<ToggleTranslationMutation, ToggleTranslationMutationVariables>;
export const RemoveTranslationsDocument = gql`
    mutation removeTranslations($data: DeleteRecordsInput!) {
  removeTranslations(input: $data)
}
    `;
export type RemoveTranslationsMutationFn = Apollo.MutationFunction<RemoveTranslationsMutation, RemoveTranslationsMutationVariables>;

/**
 * __useRemoveTranslationsMutation__
 *
 * To run a mutation, you first call `useRemoveTranslationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTranslationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTranslationsMutation, { data, loading, error }] = useRemoveTranslationsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveTranslationsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTranslationsMutation, RemoveTranslationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTranslationsMutation, RemoveTranslationsMutationVariables>(RemoveTranslationsDocument, options);
      }
export type RemoveTranslationsMutationHookResult = ReturnType<typeof useRemoveTranslationsMutation>;
export type RemoveTranslationsMutationResult = Apollo.MutationResult<RemoveTranslationsMutation>;
export type RemoveTranslationsMutationOptions = Apollo.BaseMutationOptions<RemoveTranslationsMutation, RemoveTranslationsMutationVariables>;
export const GetTranslationsTableDocument = gql`
    query getTranslationsTable($portfolioId: String!, $active: Boolean, $search: String) {
  getTranslations(portfolioId: $portfolioId, active: $active, search: $search) {
    ...TranslationCoreFields
    countryCode
    active
  }
}
    ${TranslationCoreFieldsFragmentDoc}`;

/**
 * __useGetTranslationsTableQuery__
 *
 * To run a query within a React component, call `useGetTranslationsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTranslationsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTranslationsTableQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      active: // value for 'active'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetTranslationsTableQuery(baseOptions: Apollo.QueryHookOptions<GetTranslationsTableQuery, GetTranslationsTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTranslationsTableQuery, GetTranslationsTableQueryVariables>(GetTranslationsTableDocument, options);
      }
export function useGetTranslationsTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTranslationsTableQuery, GetTranslationsTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTranslationsTableQuery, GetTranslationsTableQueryVariables>(GetTranslationsTableDocument, options);
        }
export type GetTranslationsTableQueryHookResult = ReturnType<typeof useGetTranslationsTableQuery>;
export type GetTranslationsTableLazyQueryHookResult = ReturnType<typeof useGetTranslationsTableLazyQuery>;
export type GetTranslationsTableQueryResult = Apollo.QueryResult<GetTranslationsTableQuery, GetTranslationsTableQueryVariables>;
export const GetTranslationsDropdownDocument = gql`
    query getTranslationsDropdown($portfolioId: String!, $active: Boolean, $search: String) {
  getTranslations(portfolioId: $portfolioId, active: $active, search: $search) {
    ...TranslationCoreFields
    active
  }
}
    ${TranslationCoreFieldsFragmentDoc}`;

/**
 * __useGetTranslationsDropdownQuery__
 *
 * To run a query within a React component, call `useGetTranslationsDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTranslationsDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTranslationsDropdownQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      active: // value for 'active'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetTranslationsDropdownQuery(baseOptions: Apollo.QueryHookOptions<GetTranslationsDropdownQuery, GetTranslationsDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTranslationsDropdownQuery, GetTranslationsDropdownQueryVariables>(GetTranslationsDropdownDocument, options);
      }
export function useGetTranslationsDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTranslationsDropdownQuery, GetTranslationsDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTranslationsDropdownQuery, GetTranslationsDropdownQueryVariables>(GetTranslationsDropdownDocument, options);
        }
export type GetTranslationsDropdownQueryHookResult = ReturnType<typeof useGetTranslationsDropdownQuery>;
export type GetTranslationsDropdownLazyQueryHookResult = ReturnType<typeof useGetTranslationsDropdownLazyQuery>;
export type GetTranslationsDropdownQueryResult = Apollo.QueryResult<GetTranslationsDropdownQuery, GetTranslationsDropdownQueryVariables>;
export const GetTranslationOverviewDocument = gql`
    query getTranslationOverview($id: String!) {
  getTranslation(id: $id) {
    ...TranslationCoreFields
    active
    translations
  }
}
    ${TranslationCoreFieldsFragmentDoc}`;

/**
 * __useGetTranslationOverviewQuery__
 *
 * To run a query within a React component, call `useGetTranslationOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTranslationOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTranslationOverviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTranslationOverviewQuery(baseOptions: Apollo.QueryHookOptions<GetTranslationOverviewQuery, GetTranslationOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTranslationOverviewQuery, GetTranslationOverviewQueryVariables>(GetTranslationOverviewDocument, options);
      }
export function useGetTranslationOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTranslationOverviewQuery, GetTranslationOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTranslationOverviewQuery, GetTranslationOverviewQueryVariables>(GetTranslationOverviewDocument, options);
        }
export type GetTranslationOverviewQueryHookResult = ReturnType<typeof useGetTranslationOverviewQuery>;
export type GetTranslationOverviewLazyQueryHookResult = ReturnType<typeof useGetTranslationOverviewLazyQuery>;
export type GetTranslationOverviewQueryResult = Apollo.QueryResult<GetTranslationOverviewQuery, GetTranslationOverviewQueryVariables>;
export const GetTranslationDocument = gql`
    query getTranslation($id: String!) {
  getTranslation(id: $id) {
    ...TranslationCoreFields
    countryCode
    globalTranslation {
      ...GlobalTranslationCoreFields
    }
  }
}
    ${TranslationCoreFieldsFragmentDoc}
${GlobalTranslationCoreFieldsFragmentDoc}`;

/**
 * __useGetTranslationQuery__
 *
 * To run a query within a React component, call `useGetTranslationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTranslationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTranslationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTranslationQuery(baseOptions: Apollo.QueryHookOptions<GetTranslationQuery, GetTranslationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTranslationQuery, GetTranslationQueryVariables>(GetTranslationDocument, options);
      }
export function useGetTranslationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTranslationQuery, GetTranslationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTranslationQuery, GetTranslationQueryVariables>(GetTranslationDocument, options);
        }
export type GetTranslationQueryHookResult = ReturnType<typeof useGetTranslationQuery>;
export type GetTranslationLazyQueryHookResult = ReturnType<typeof useGetTranslationLazyQuery>;
export type GetTranslationQueryResult = Apollo.QueryResult<GetTranslationQuery, GetTranslationQueryVariables>;
export const GetTranslationFilteredTableDocument = gql`
    query getTranslationFilteredTable($id: String!, $key: String!) {
  getTranslationFiltered(id: $id, key: $key) {
    sources
    descriptions
    translations
  }
}
    `;

/**
 * __useGetTranslationFilteredTableQuery__
 *
 * To run a query within a React component, call `useGetTranslationFilteredTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTranslationFilteredTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTranslationFilteredTableQuery({
 *   variables: {
 *      id: // value for 'id'
 *      key: // value for 'key'
 *   },
 * });
 */
export function useGetTranslationFilteredTableQuery(baseOptions: Apollo.QueryHookOptions<GetTranslationFilteredTableQuery, GetTranslationFilteredTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTranslationFilteredTableQuery, GetTranslationFilteredTableQueryVariables>(GetTranslationFilteredTableDocument, options);
      }
export function useGetTranslationFilteredTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTranslationFilteredTableQuery, GetTranslationFilteredTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTranslationFilteredTableQuery, GetTranslationFilteredTableQueryVariables>(GetTranslationFilteredTableDocument, options);
        }
export type GetTranslationFilteredTableQueryHookResult = ReturnType<typeof useGetTranslationFilteredTableQuery>;
export type GetTranslationFilteredTableLazyQueryHookResult = ReturnType<typeof useGetTranslationFilteredTableLazyQuery>;
export type GetTranslationFilteredTableQueryResult = Apollo.QueryResult<GetTranslationFilteredTableQuery, GetTranslationFilteredTableQueryVariables>;
export const ExportTranslationDocument = gql`
    query exportTranslation($id: String!, $merge: Boolean!) {
  exportTranslation(id: $id, merge: $merge)
}
    `;

/**
 * __useExportTranslationQuery__
 *
 * To run a query within a React component, call `useExportTranslationQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportTranslationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportTranslationQuery({
 *   variables: {
 *      id: // value for 'id'
 *      merge: // value for 'merge'
 *   },
 * });
 */
export function useExportTranslationQuery(baseOptions: Apollo.QueryHookOptions<ExportTranslationQuery, ExportTranslationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportTranslationQuery, ExportTranslationQueryVariables>(ExportTranslationDocument, options);
      }
export function useExportTranslationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportTranslationQuery, ExportTranslationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportTranslationQuery, ExportTranslationQueryVariables>(ExportTranslationDocument, options);
        }
export type ExportTranslationQueryHookResult = ReturnType<typeof useExportTranslationQuery>;
export type ExportTranslationLazyQueryHookResult = ReturnType<typeof useExportTranslationLazyQuery>;
export type ExportTranslationQueryResult = Apollo.QueryResult<ExportTranslationQuery, ExportTranslationQueryVariables>;
export const UploadFilesDocument = gql`
    mutation uploadFiles($files: [Upload!]!, $save: Boolean) {
  uploadFiles(files: $files, save: $save) {
    name
    size
    url
  }
}
    `;
export type UploadFilesMutationFn = Apollo.MutationFunction<UploadFilesMutation, UploadFilesMutationVariables>;

/**
 * __useUploadFilesMutation__
 *
 * To run a mutation, you first call `useUploadFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadFilesMutation, { data, loading, error }] = useUploadFilesMutation({
 *   variables: {
 *      files: // value for 'files'
 *      save: // value for 'save'
 *   },
 * });
 */
export function useUploadFilesMutation(baseOptions?: Apollo.MutationHookOptions<UploadFilesMutation, UploadFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadFilesMutation, UploadFilesMutationVariables>(UploadFilesDocument, options);
      }
export type UploadFilesMutationHookResult = ReturnType<typeof useUploadFilesMutation>;
export type UploadFilesMutationResult = Apollo.MutationResult<UploadFilesMutation>;
export type UploadFilesMutationOptions = Apollo.BaseMutationOptions<UploadFilesMutation, UploadFilesMutationVariables>;
export const CreateGlobalUserDocument = gql`
    mutation createGlobalUser($data: CreateGlobalUserInput!) {
  createGlobalUser(input: $data) {
    id
  }
}
    `;
export type CreateGlobalUserMutationFn = Apollo.MutationFunction<CreateGlobalUserMutation, CreateGlobalUserMutationVariables>;

/**
 * __useCreateGlobalUserMutation__
 *
 * To run a mutation, you first call `useCreateGlobalUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGlobalUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGlobalUserMutation, { data, loading, error }] = useCreateGlobalUserMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateGlobalUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateGlobalUserMutation, CreateGlobalUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGlobalUserMutation, CreateGlobalUserMutationVariables>(CreateGlobalUserDocument, options);
      }
export type CreateGlobalUserMutationHookResult = ReturnType<typeof useCreateGlobalUserMutation>;
export type CreateGlobalUserMutationResult = Apollo.MutationResult<CreateGlobalUserMutation>;
export type CreateGlobalUserMutationOptions = Apollo.BaseMutationOptions<CreateGlobalUserMutation, CreateGlobalUserMutationVariables>;
export const UpdateGlobalUserDocument = gql`
    mutation updateGlobalUser($id: String!, $data: UpdateGlobalUserInput!) {
  updateGlobalUser(id: $id, input: $data) {
    ...GlobalUserFields
  }
}
    ${GlobalUserFieldsFragmentDoc}`;
export type UpdateGlobalUserMutationFn = Apollo.MutationFunction<UpdateGlobalUserMutation, UpdateGlobalUserMutationVariables>;

/**
 * __useUpdateGlobalUserMutation__
 *
 * To run a mutation, you first call `useUpdateGlobalUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGlobalUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGlobalUserMutation, { data, loading, error }] = useUpdateGlobalUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateGlobalUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGlobalUserMutation, UpdateGlobalUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGlobalUserMutation, UpdateGlobalUserMutationVariables>(UpdateGlobalUserDocument, options);
      }
export type UpdateGlobalUserMutationHookResult = ReturnType<typeof useUpdateGlobalUserMutation>;
export type UpdateGlobalUserMutationResult = Apollo.MutationResult<UpdateGlobalUserMutation>;
export type UpdateGlobalUserMutationOptions = Apollo.BaseMutationOptions<UpdateGlobalUserMutation, UpdateGlobalUserMutationVariables>;
export const RemoveGlobalUsersDocument = gql`
    mutation removeGlobalUsers($data: DeleteRecordsInput!) {
  removeGlobalUsers(input: $data)
}
    `;
export type RemoveGlobalUsersMutationFn = Apollo.MutationFunction<RemoveGlobalUsersMutation, RemoveGlobalUsersMutationVariables>;

/**
 * __useRemoveGlobalUsersMutation__
 *
 * To run a mutation, you first call `useRemoveGlobalUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveGlobalUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeGlobalUsersMutation, { data, loading, error }] = useRemoveGlobalUsersMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveGlobalUsersMutation(baseOptions?: Apollo.MutationHookOptions<RemoveGlobalUsersMutation, RemoveGlobalUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveGlobalUsersMutation, RemoveGlobalUsersMutationVariables>(RemoveGlobalUsersDocument, options);
      }
export type RemoveGlobalUsersMutationHookResult = ReturnType<typeof useRemoveGlobalUsersMutation>;
export type RemoveGlobalUsersMutationResult = Apollo.MutationResult<RemoveGlobalUsersMutation>;
export type RemoveGlobalUsersMutationOptions = Apollo.BaseMutationOptions<RemoveGlobalUsersMutation, RemoveGlobalUsersMutationVariables>;
export const MeDocument = gql`
    query me {
  me {
    ...GlobalUserFields
  }
}
    ${GlobalUserFieldsFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const GetGlobalUsersTableDocument = gql`
    query getGlobalUsersTable($take: Int! = 10, $after: String, $before: String, $search: String) {
  getGlobalUsers(take: $take, after: $after, before: $before, search: $search) {
    pagination {
      ...PaginationFields
    }
    data {
      id
      firstName
      lastName
      email
      title
      photo {
        ...FileFields
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${FileFieldsFragmentDoc}`;

/**
 * __useGetGlobalUsersTableQuery__
 *
 * To run a query within a React component, call `useGetGlobalUsersTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGlobalUsersTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGlobalUsersTableQuery({
 *   variables: {
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetGlobalUsersTableQuery(baseOptions?: Apollo.QueryHookOptions<GetGlobalUsersTableQuery, GetGlobalUsersTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGlobalUsersTableQuery, GetGlobalUsersTableQueryVariables>(GetGlobalUsersTableDocument, options);
      }
export function useGetGlobalUsersTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGlobalUsersTableQuery, GetGlobalUsersTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGlobalUsersTableQuery, GetGlobalUsersTableQueryVariables>(GetGlobalUsersTableDocument, options);
        }
export type GetGlobalUsersTableQueryHookResult = ReturnType<typeof useGetGlobalUsersTableQuery>;
export type GetGlobalUsersTableLazyQueryHookResult = ReturnType<typeof useGetGlobalUsersTableLazyQuery>;
export type GetGlobalUsersTableQueryResult = Apollo.QueryResult<GetGlobalUsersTableQuery, GetGlobalUsersTableQueryVariables>;
export const GetGlobalUserDocument = gql`
    query getGlobalUser($id: String!) {
  getGlobalUser(id: $id) {
    ...GlobalUserFields
  }
}
    ${GlobalUserFieldsFragmentDoc}`;

/**
 * __useGetGlobalUserQuery__
 *
 * To run a query within a React component, call `useGetGlobalUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGlobalUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGlobalUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGlobalUserQuery(baseOptions: Apollo.QueryHookOptions<GetGlobalUserQuery, GetGlobalUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGlobalUserQuery, GetGlobalUserQueryVariables>(GetGlobalUserDocument, options);
      }
export function useGetGlobalUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGlobalUserQuery, GetGlobalUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGlobalUserQuery, GetGlobalUserQueryVariables>(GetGlobalUserDocument, options);
        }
export type GetGlobalUserQueryHookResult = ReturnType<typeof useGetGlobalUserQuery>;
export type GetGlobalUserLazyQueryHookResult = ReturnType<typeof useGetGlobalUserLazyQuery>;
export type GetGlobalUserQueryResult = Apollo.QueryResult<GetGlobalUserQuery, GetGlobalUserQueryVariables>;
export const CreateUserDocument = gql`
    mutation createUser($data: UserInput!, $portfolioId: String!) {
  createUser(input: $data, portfolioId: $portfolioId) {
    id
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      data: // value for 'data'
 *      portfolioId: // value for 'portfolioId'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($id: String!, $data: UserUpdateInput!) {
  updateUser(id: $id, input: $data) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdateUserPhotoDocument = gql`
    mutation updateUserPhoto($id: String!, $photo: FileObjectInput) {
  updateUserPhoto(userId: $id, photo: $photo) {
    id
    photo {
      ...FileFields
    }
  }
}
    ${FileFieldsFragmentDoc}`;
export type UpdateUserPhotoMutationFn = Apollo.MutationFunction<UpdateUserPhotoMutation, UpdateUserPhotoMutationVariables>;

/**
 * __useUpdateUserPhotoMutation__
 *
 * To run a mutation, you first call `useUpdateUserPhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPhotoMutation, { data, loading, error }] = useUpdateUserPhotoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      photo: // value for 'photo'
 *   },
 * });
 */
export function useUpdateUserPhotoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserPhotoMutation, UpdateUserPhotoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserPhotoMutation, UpdateUserPhotoMutationVariables>(UpdateUserPhotoDocument, options);
      }
export type UpdateUserPhotoMutationHookResult = ReturnType<typeof useUpdateUserPhotoMutation>;
export type UpdateUserPhotoMutationResult = Apollo.MutationResult<UpdateUserPhotoMutation>;
export type UpdateUserPhotoMutationOptions = Apollo.BaseMutationOptions<UpdateUserPhotoMutation, UpdateUserPhotoMutationVariables>;
export const ToggleUserDocument = gql`
    mutation toggleUser($id: String!) {
  toggleUser(userId: $id)
}
    `;
export type ToggleUserMutationFn = Apollo.MutationFunction<ToggleUserMutation, ToggleUserMutationVariables>;

/**
 * __useToggleUserMutation__
 *
 * To run a mutation, you first call `useToggleUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleUserMutation, { data, loading, error }] = useToggleUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleUserMutation(baseOptions?: Apollo.MutationHookOptions<ToggleUserMutation, ToggleUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleUserMutation, ToggleUserMutationVariables>(ToggleUserDocument, options);
      }
export type ToggleUserMutationHookResult = ReturnType<typeof useToggleUserMutation>;
export type ToggleUserMutationResult = Apollo.MutationResult<ToggleUserMutation>;
export type ToggleUserMutationOptions = Apollo.BaseMutationOptions<ToggleUserMutation, ToggleUserMutationVariables>;
export const AddUserPropertyDocument = gql`
    mutation addUserProperty($id: String!, $data: UserPropertyInput!) {
  addUserProperty(userId: $id, input: $data)
}
    `;
export type AddUserPropertyMutationFn = Apollo.MutationFunction<AddUserPropertyMutation, AddUserPropertyMutationVariables>;

/**
 * __useAddUserPropertyMutation__
 *
 * To run a mutation, you first call `useAddUserPropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserPropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserPropertyMutation, { data, loading, error }] = useAddUserPropertyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddUserPropertyMutation(baseOptions?: Apollo.MutationHookOptions<AddUserPropertyMutation, AddUserPropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserPropertyMutation, AddUserPropertyMutationVariables>(AddUserPropertyDocument, options);
      }
export type AddUserPropertyMutationHookResult = ReturnType<typeof useAddUserPropertyMutation>;
export type AddUserPropertyMutationResult = Apollo.MutationResult<AddUserPropertyMutation>;
export type AddUserPropertyMutationOptions = Apollo.BaseMutationOptions<AddUserPropertyMutation, AddUserPropertyMutationVariables>;
export const UpdateUserPropertyDocument = gql`
    mutation updateUserProperty($id: String!, $data: UserPropertyInput!) {
  updateUserProperty(userId: $id, input: $data)
}
    `;
export type UpdateUserPropertyMutationFn = Apollo.MutationFunction<UpdateUserPropertyMutation, UpdateUserPropertyMutationVariables>;

/**
 * __useUpdateUserPropertyMutation__
 *
 * To run a mutation, you first call `useUpdateUserPropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPropertyMutation, { data, loading, error }] = useUpdateUserPropertyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserPropertyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserPropertyMutation, UpdateUserPropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserPropertyMutation, UpdateUserPropertyMutationVariables>(UpdateUserPropertyDocument, options);
      }
export type UpdateUserPropertyMutationHookResult = ReturnType<typeof useUpdateUserPropertyMutation>;
export type UpdateUserPropertyMutationResult = Apollo.MutationResult<UpdateUserPropertyMutation>;
export type UpdateUserPropertyMutationOptions = Apollo.BaseMutationOptions<UpdateUserPropertyMutation, UpdateUserPropertyMutationVariables>;
export const LoginAsUserDocument = gql`
    mutation loginAsUser($id: String!, $portfolioId: String!) {
  loginAsUser(userId: $id, portfolioId: $portfolioId)
}
    `;
export type LoginAsUserMutationFn = Apollo.MutationFunction<LoginAsUserMutation, LoginAsUserMutationVariables>;

/**
 * __useLoginAsUserMutation__
 *
 * To run a mutation, you first call `useLoginAsUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginAsUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginAsUserMutation, { data, loading, error }] = useLoginAsUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      portfolioId: // value for 'portfolioId'
 *   },
 * });
 */
export function useLoginAsUserMutation(baseOptions?: Apollo.MutationHookOptions<LoginAsUserMutation, LoginAsUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginAsUserMutation, LoginAsUserMutationVariables>(LoginAsUserDocument, options);
      }
export type LoginAsUserMutationHookResult = ReturnType<typeof useLoginAsUserMutation>;
export type LoginAsUserMutationResult = Apollo.MutationResult<LoginAsUserMutation>;
export type LoginAsUserMutationOptions = Apollo.BaseMutationOptions<LoginAsUserMutation, LoginAsUserMutationVariables>;
export const GetUsersTableDocument = gql`
    query getUsersTable($portfolioId: String!, $take: Int! = 10, $after: String, $before: String, $search: String, $propertyIds: [String!], $companyIds: [String!], $roleIds: [String!], $active: Boolean) {
  getUsers(
    portfolioId: $portfolioId
    take: $take
    after: $after
    before: $before
    search: $search
    propertyIds: $propertyIds
    companyIds: $companyIds
    roleIds: $roleIds
    active: $active
  ) @connection(key: "getUsersTable") {
    pagination {
      ...PaginationFields
    }
    data {
      ...UserCoreFields
      index
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}`;

/**
 * __useGetUsersTableQuery__
 *
 * To run a query within a React component, call `useGetUsersTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersTableQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      propertyIds: // value for 'propertyIds'
 *      companyIds: // value for 'companyIds'
 *      roleIds: // value for 'roleIds'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useGetUsersTableQuery(baseOptions: Apollo.QueryHookOptions<GetUsersTableQuery, GetUsersTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersTableQuery, GetUsersTableQueryVariables>(GetUsersTableDocument, options);
      }
export function useGetUsersTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersTableQuery, GetUsersTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersTableQuery, GetUsersTableQueryVariables>(GetUsersTableDocument, options);
        }
export type GetUsersTableQueryHookResult = ReturnType<typeof useGetUsersTableQuery>;
export type GetUsersTableLazyQueryHookResult = ReturnType<typeof useGetUsersTableLazyQuery>;
export type GetUsersTableQueryResult = Apollo.QueryResult<GetUsersTableQuery, GetUsersTableQueryVariables>;
export const GetUsersDropdownDocument = gql`
    query getUsersDropdown($portfolioId: String!, $take: Int! = 10, $after: String, $before: String, $search: String, $propertyIds: [String!], $companyIds: [String!], $roleIds: [String!], $active: Boolean) {
  getUsers(
    portfolioId: $portfolioId
    take: $take
    after: $after
    before: $before
    search: $search
    propertyIds: $propertyIds
    companyIds: $companyIds
    roleIds: $roleIds
    active: $active
  ) @connection(key: "getUsersDropdown") {
    pagination {
      ...PaginationFields
    }
    data {
      ...UserCoreFields
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}`;

/**
 * __useGetUsersDropdownQuery__
 *
 * To run a query within a React component, call `useGetUsersDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersDropdownQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      propertyIds: // value for 'propertyIds'
 *      companyIds: // value for 'companyIds'
 *      roleIds: // value for 'roleIds'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useGetUsersDropdownQuery(baseOptions: Apollo.QueryHookOptions<GetUsersDropdownQuery, GetUsersDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersDropdownQuery, GetUsersDropdownQueryVariables>(GetUsersDropdownDocument, options);
      }
export function useGetUsersDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersDropdownQuery, GetUsersDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersDropdownQuery, GetUsersDropdownQueryVariables>(GetUsersDropdownDocument, options);
        }
export type GetUsersDropdownQueryHookResult = ReturnType<typeof useGetUsersDropdownQuery>;
export type GetUsersDropdownLazyQueryHookResult = ReturnType<typeof useGetUsersDropdownLazyQuery>;
export type GetUsersDropdownQueryResult = Apollo.QueryResult<GetUsersDropdownQuery, GetUsersDropdownQueryVariables>;
export const GetUserDocument = gql`
    query getUser($id: String!) {
  getUser(id: $id) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const GetUserPropertiesDocument = gql`
    query getUserProperties($id: String!) {
  getUserProperties(id: $id) {
    title
    status
    property {
      ...PropertyCoreFields
    }
    role {
      ...RoleCoreFields
      active
    }
    buildings {
      ...BuildingCoreFields
    }
    companies {
      ...CompanyCoreFields
    }
  }
}
    ${PropertyCoreFieldsFragmentDoc}
${RoleCoreFieldsFragmentDoc}
${BuildingCoreFieldsFragmentDoc}
${CompanyCoreFieldsFragmentDoc}`;

/**
 * __useGetUserPropertiesQuery__
 *
 * To run a query within a React component, call `useGetUserPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPropertiesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserPropertiesQuery(baseOptions: Apollo.QueryHookOptions<GetUserPropertiesQuery, GetUserPropertiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserPropertiesQuery, GetUserPropertiesQueryVariables>(GetUserPropertiesDocument, options);
      }
export function useGetUserPropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserPropertiesQuery, GetUserPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserPropertiesQuery, GetUserPropertiesQueryVariables>(GetUserPropertiesDocument, options);
        }
export type GetUserPropertiesQueryHookResult = ReturnType<typeof useGetUserPropertiesQuery>;
export type GetUserPropertiesLazyQueryHookResult = ReturnType<typeof useGetUserPropertiesLazyQuery>;
export type GetUserPropertiesQueryResult = Apollo.QueryResult<GetUserPropertiesQuery, GetUserPropertiesQueryVariables>;
export const GetWorkOrderStatusWidgetDocument = gql`
    query getWorkOrderStatusWidget($portfolioId: String!, $propertyId: String, $categoryIds: [String!], $from: DateTime!, $to: DateTime) {
  getWOStatusWidget(
    portfolioId: $portfolioId
    propertyId: $propertyId
    categoryIds: $categoryIds
    from: $from
    to: $to
  ) {
    name
    count
    percentage
    color
  }
}
    `;

/**
 * __useGetWorkOrderStatusWidgetQuery__
 *
 * To run a query within a React component, call `useGetWorkOrderStatusWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkOrderStatusWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkOrderStatusWidgetQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      propertyId: // value for 'propertyId'
 *      categoryIds: // value for 'categoryIds'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useGetWorkOrderStatusWidgetQuery(baseOptions: Apollo.QueryHookOptions<GetWorkOrderStatusWidgetQuery, GetWorkOrderStatusWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkOrderStatusWidgetQuery, GetWorkOrderStatusWidgetQueryVariables>(GetWorkOrderStatusWidgetDocument, options);
      }
export function useGetWorkOrderStatusWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkOrderStatusWidgetQuery, GetWorkOrderStatusWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkOrderStatusWidgetQuery, GetWorkOrderStatusWidgetQueryVariables>(GetWorkOrderStatusWidgetDocument, options);
        }
export type GetWorkOrderStatusWidgetQueryHookResult = ReturnType<typeof useGetWorkOrderStatusWidgetQuery>;
export type GetWorkOrderStatusWidgetLazyQueryHookResult = ReturnType<typeof useGetWorkOrderStatusWidgetLazyQuery>;
export type GetWorkOrderStatusWidgetQueryResult = Apollo.QueryResult<GetWorkOrderStatusWidgetQuery, GetWorkOrderStatusWidgetQueryVariables>;
export const GetWorkOrderReviewsWidgetDocument = gql`
    query getWorkOrderReviewsWidget($portfolioId: String!, $from: DateTime!, $to: DateTime) {
  getWOReviewsWidget(portfolioId: $portfolioId, from: $from, to: $to) {
    name
    count
  }
}
    `;

/**
 * __useGetWorkOrderReviewsWidgetQuery__
 *
 * To run a query within a React component, call `useGetWorkOrderReviewsWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkOrderReviewsWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkOrderReviewsWidgetQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useGetWorkOrderReviewsWidgetQuery(baseOptions: Apollo.QueryHookOptions<GetWorkOrderReviewsWidgetQuery, GetWorkOrderReviewsWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkOrderReviewsWidgetQuery, GetWorkOrderReviewsWidgetQueryVariables>(GetWorkOrderReviewsWidgetDocument, options);
      }
export function useGetWorkOrderReviewsWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkOrderReviewsWidgetQuery, GetWorkOrderReviewsWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkOrderReviewsWidgetQuery, GetWorkOrderReviewsWidgetQueryVariables>(GetWorkOrderReviewsWidgetDocument, options);
        }
export type GetWorkOrderReviewsWidgetQueryHookResult = ReturnType<typeof useGetWorkOrderReviewsWidgetQuery>;
export type GetWorkOrderReviewsWidgetLazyQueryHookResult = ReturnType<typeof useGetWorkOrderReviewsWidgetLazyQuery>;
export type GetWorkOrderReviewsWidgetQueryResult = Apollo.QueryResult<GetWorkOrderReviewsWidgetQuery, GetWorkOrderReviewsWidgetQueryVariables>;
export const GetWorkOrderRevenueWidgetDocument = gql`
    query getWorkOrderRevenueWidget($portfolioId: String!, $propertyId: String, $categoryIds: [String!], $from: DateTime!, $to: DateTime) {
  getWORevenueWidget(
    portfolioId: $portfolioId
    propertyId: $propertyId
    categoryIds: $categoryIds
    from: $from
    to: $to
  ) {
    name
    laborRevenue
    markupRevenue
    materialRevenue
  }
}
    `;

/**
 * __useGetWorkOrderRevenueWidgetQuery__
 *
 * To run a query within a React component, call `useGetWorkOrderRevenueWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkOrderRevenueWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkOrderRevenueWidgetQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      propertyId: // value for 'propertyId'
 *      categoryIds: // value for 'categoryIds'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useGetWorkOrderRevenueWidgetQuery(baseOptions: Apollo.QueryHookOptions<GetWorkOrderRevenueWidgetQuery, GetWorkOrderRevenueWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkOrderRevenueWidgetQuery, GetWorkOrderRevenueWidgetQueryVariables>(GetWorkOrderRevenueWidgetDocument, options);
      }
export function useGetWorkOrderRevenueWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkOrderRevenueWidgetQuery, GetWorkOrderRevenueWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkOrderRevenueWidgetQuery, GetWorkOrderRevenueWidgetQueryVariables>(GetWorkOrderRevenueWidgetDocument, options);
        }
export type GetWorkOrderRevenueWidgetQueryHookResult = ReturnType<typeof useGetWorkOrderRevenueWidgetQuery>;
export type GetWorkOrderRevenueWidgetLazyQueryHookResult = ReturnType<typeof useGetWorkOrderRevenueWidgetLazyQuery>;
export type GetWorkOrderRevenueWidgetQueryResult = Apollo.QueryResult<GetWorkOrderRevenueWidgetQuery, GetWorkOrderRevenueWidgetQueryVariables>;
export const GetWorkOrderCategoryWidgetDocument = gql`
    query getWorkOrderCategoryWidget($portfolioId: String!, $propertyId: String, $categoryIds: [String!], $from: DateTime!, $to: DateTime) {
  getWOCategoryWidget(
    portfolioId: $portfolioId
    propertyId: $propertyId
    categoryIds: $categoryIds
    from: $from
    to: $to
  ) {
    name
    count
  }
}
    `;

/**
 * __useGetWorkOrderCategoryWidgetQuery__
 *
 * To run a query within a React component, call `useGetWorkOrderCategoryWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkOrderCategoryWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkOrderCategoryWidgetQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      propertyId: // value for 'propertyId'
 *      categoryIds: // value for 'categoryIds'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useGetWorkOrderCategoryWidgetQuery(baseOptions: Apollo.QueryHookOptions<GetWorkOrderCategoryWidgetQuery, GetWorkOrderCategoryWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkOrderCategoryWidgetQuery, GetWorkOrderCategoryWidgetQueryVariables>(GetWorkOrderCategoryWidgetDocument, options);
      }
export function useGetWorkOrderCategoryWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkOrderCategoryWidgetQuery, GetWorkOrderCategoryWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkOrderCategoryWidgetQuery, GetWorkOrderCategoryWidgetQueryVariables>(GetWorkOrderCategoryWidgetDocument, options);
        }
export type GetWorkOrderCategoryWidgetQueryHookResult = ReturnType<typeof useGetWorkOrderCategoryWidgetQuery>;
export type GetWorkOrderCategoryWidgetLazyQueryHookResult = ReturnType<typeof useGetWorkOrderCategoryWidgetLazyQuery>;
export type GetWorkOrderCategoryWidgetQueryResult = Apollo.QueryResult<GetWorkOrderCategoryWidgetQuery, GetWorkOrderCategoryWidgetQueryVariables>;
export const GetCoiWidgetDocument = gql`
    query getCOIWidget($portfolioId: String!, $propertyId: String) {
  getCOIWidget(portfolioId: $portfolioId, propertyId: $propertyId) {
    name
    count
    percentage
  }
}
    `;

/**
 * __useGetCoiWidgetQuery__
 *
 * To run a query within a React component, call `useGetCoiWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoiWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoiWidgetQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useGetCoiWidgetQuery(baseOptions: Apollo.QueryHookOptions<GetCoiWidgetQuery, GetCoiWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoiWidgetQuery, GetCoiWidgetQueryVariables>(GetCoiWidgetDocument, options);
      }
export function useGetCoiWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoiWidgetQuery, GetCoiWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoiWidgetQuery, GetCoiWidgetQueryVariables>(GetCoiWidgetDocument, options);
        }
export type GetCoiWidgetQueryHookResult = ReturnType<typeof useGetCoiWidgetQuery>;
export type GetCoiWidgetLazyQueryHookResult = ReturnType<typeof useGetCoiWidgetLazyQuery>;
export type GetCoiWidgetQueryResult = Apollo.QueryResult<GetCoiWidgetQuery, GetCoiWidgetQueryVariables>;
export const GetTaskOpenWidgetDocument = gql`
    query getTaskOpenWidget($portfolioId: String!, $propertyId: String) {
  getTaskOpenWidget(portfolioId: $portfolioId, propertyId: $propertyId) {
    count
  }
}
    `;

/**
 * __useGetTaskOpenWidgetQuery__
 *
 * To run a query within a React component, call `useGetTaskOpenWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskOpenWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskOpenWidgetQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useGetTaskOpenWidgetQuery(baseOptions: Apollo.QueryHookOptions<GetTaskOpenWidgetQuery, GetTaskOpenWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskOpenWidgetQuery, GetTaskOpenWidgetQueryVariables>(GetTaskOpenWidgetDocument, options);
      }
export function useGetTaskOpenWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskOpenWidgetQuery, GetTaskOpenWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskOpenWidgetQuery, GetTaskOpenWidgetQueryVariables>(GetTaskOpenWidgetDocument, options);
        }
export type GetTaskOpenWidgetQueryHookResult = ReturnType<typeof useGetTaskOpenWidgetQuery>;
export type GetTaskOpenWidgetLazyQueryHookResult = ReturnType<typeof useGetTaskOpenWidgetLazyQuery>;
export type GetTaskOpenWidgetQueryResult = Apollo.QueryResult<GetTaskOpenWidgetQuery, GetTaskOpenWidgetQueryVariables>;
export const GetTaskOverdueWidgetDocument = gql`
    query getTaskOverdueWidget($portfolioId: String!, $propertyId: String) {
  getTaskOverdueWidget(portfolioId: $portfolioId, propertyId: $propertyId) {
    count
  }
}
    `;

/**
 * __useGetTaskOverdueWidgetQuery__
 *
 * To run a query within a React component, call `useGetTaskOverdueWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskOverdueWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskOverdueWidgetQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useGetTaskOverdueWidgetQuery(baseOptions: Apollo.QueryHookOptions<GetTaskOverdueWidgetQuery, GetTaskOverdueWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaskOverdueWidgetQuery, GetTaskOverdueWidgetQueryVariables>(GetTaskOverdueWidgetDocument, options);
      }
export function useGetTaskOverdueWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaskOverdueWidgetQuery, GetTaskOverdueWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaskOverdueWidgetQuery, GetTaskOverdueWidgetQueryVariables>(GetTaskOverdueWidgetDocument, options);
        }
export type GetTaskOverdueWidgetQueryHookResult = ReturnType<typeof useGetTaskOverdueWidgetQuery>;
export type GetTaskOverdueWidgetLazyQueryHookResult = ReturnType<typeof useGetTaskOverdueWidgetLazyQuery>;
export type GetTaskOverdueWidgetQueryResult = Apollo.QueryResult<GetTaskOverdueWidgetQuery, GetTaskOverdueWidgetQueryVariables>;
export const GetWorkOrdersDocument = gql`
    query getWorkOrders($portfolioId: String!, $take: Int! = 10, $after: String, $before: String, $search: String, $statusIds: [String!], $from: DateTime, $to: DateTime, $propertyIds: [String!], $buildingIds: [String!], $assigneeIds: [String!], $categoryIds: [String!], $companyIds: [String!], $priorityIds: [String!], $requestedForIds: [String!], $closedAtFrom: DateTime, $closedAtTo: DateTime, $archived: ArchiveStatusEnum! = NOT_ARCHIVED) {
  getWorkOrders(
    portfolioId: $portfolioId
    take: $take
    after: $after
    before: $before
    search: $search
    to: $to
    from: $from
    statusIds: $statusIds
    propertyIds: $propertyIds
    buildingIds: $buildingIds
    assigneeIds: $assigneeIds
    categoryIds: $categoryIds
    companyIds: $companyIds
    priorityIds: $priorityIds
    requestedForIds: $requestedForIds
    closedAtFrom: $closedAtFrom
    closedAtTo: $closedAtTo
    archived: $archived
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      id
      index
      isArchived
      property {
        ...PropertyCoreFields
      }
      building {
        ...BuildingCoreFields
        active
      }
      category {
        ...CategoryCoreFields
      }
      status {
        ...StatusCoreFields
        color
      }
      priority {
        ...PriorityCoreFields
        color
      }
      company {
        ...CompanyCoreFields
      }
      requestedFor {
        ...UserCoreFields
      }
      assignedTo {
        ...UserCoreFields
      }
      createdBy {
        ...UserCoreFields
      }
      createdByGuest {
        firstName
        lastName
        email
      }
      suite {
        ...SuiteCoreFields
      }
      description
      createdAt
      closedAt
      startDate
      dueDate
      timezone
      charges
      review {
        id
        comment
        score
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${PropertyCoreFieldsFragmentDoc}
${BuildingCoreFieldsFragmentDoc}
${CategoryCoreFieldsFragmentDoc}
${StatusCoreFieldsFragmentDoc}
${PriorityCoreFieldsFragmentDoc}
${CompanyCoreFieldsFragmentDoc}
${UserCoreFieldsFragmentDoc}
${SuiteCoreFieldsFragmentDoc}`;

/**
 * __useGetWorkOrdersQuery__
 *
 * To run a query within a React component, call `useGetWorkOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkOrdersQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *      statusIds: // value for 'statusIds'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      propertyIds: // value for 'propertyIds'
 *      buildingIds: // value for 'buildingIds'
 *      assigneeIds: // value for 'assigneeIds'
 *      categoryIds: // value for 'categoryIds'
 *      companyIds: // value for 'companyIds'
 *      priorityIds: // value for 'priorityIds'
 *      requestedForIds: // value for 'requestedForIds'
 *      closedAtFrom: // value for 'closedAtFrom'
 *      closedAtTo: // value for 'closedAtTo'
 *      archived: // value for 'archived'
 *   },
 * });
 */
export function useGetWorkOrdersQuery(baseOptions: Apollo.QueryHookOptions<GetWorkOrdersQuery, GetWorkOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkOrdersQuery, GetWorkOrdersQueryVariables>(GetWorkOrdersDocument, options);
      }
export function useGetWorkOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkOrdersQuery, GetWorkOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkOrdersQuery, GetWorkOrdersQueryVariables>(GetWorkOrdersDocument, options);
        }
export type GetWorkOrdersQueryHookResult = ReturnType<typeof useGetWorkOrdersQuery>;
export type GetWorkOrdersLazyQueryHookResult = ReturnType<typeof useGetWorkOrdersLazyQuery>;
export type GetWorkOrdersQueryResult = Apollo.QueryResult<GetWorkOrdersQuery, GetWorkOrdersQueryVariables>;
export const GetWorkOrderDocument = gql`
    query getWorkOrder($id: String!) {
  getWorkOrder(workOrderId: $id) {
    ...WorkOrderFields
  }
}
    ${WorkOrderFieldsFragmentDoc}`;

/**
 * __useGetWorkOrderQuery__
 *
 * To run a query within a React component, call `useGetWorkOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetWorkOrderQuery(baseOptions: Apollo.QueryHookOptions<GetWorkOrderQuery, GetWorkOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkOrderQuery, GetWorkOrderQueryVariables>(GetWorkOrderDocument, options);
      }
export function useGetWorkOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkOrderQuery, GetWorkOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkOrderQuery, GetWorkOrderQueryVariables>(GetWorkOrderDocument, options);
        }
export type GetWorkOrderQueryHookResult = ReturnType<typeof useGetWorkOrderQuery>;
export type GetWorkOrderLazyQueryHookResult = ReturnType<typeof useGetWorkOrderLazyQuery>;
export type GetWorkOrderQueryResult = Apollo.QueryResult<GetWorkOrderQuery, GetWorkOrderQueryVariables>;
export const GetWorkOrderChargesDocument = gql`
    query getWorkOrderCharges($workOrderId: String!, $search: String) {
  getWorkOrderCharges(workOrderId: $workOrderId, search: $search) {
    id
    type
    date
    billable
    employeeUser {
      ...UserCoreFields
    }
    hours
    material {
      ...MaterialCoreFields
    }
    notes
    price
    quantity
    total
  }
}
    ${UserCoreFieldsFragmentDoc}
${MaterialCoreFieldsFragmentDoc}`;

/**
 * __useGetWorkOrderChargesQuery__
 *
 * To run a query within a React component, call `useGetWorkOrderChargesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkOrderChargesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkOrderChargesQuery({
 *   variables: {
 *      workOrderId: // value for 'workOrderId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetWorkOrderChargesQuery(baseOptions: Apollo.QueryHookOptions<GetWorkOrderChargesQuery, GetWorkOrderChargesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkOrderChargesQuery, GetWorkOrderChargesQueryVariables>(GetWorkOrderChargesDocument, options);
      }
export function useGetWorkOrderChargesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkOrderChargesQuery, GetWorkOrderChargesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkOrderChargesQuery, GetWorkOrderChargesQueryVariables>(GetWorkOrderChargesDocument, options);
        }
export type GetWorkOrderChargesQueryHookResult = ReturnType<typeof useGetWorkOrderChargesQuery>;
export type GetWorkOrderChargesLazyQueryHookResult = ReturnType<typeof useGetWorkOrderChargesLazyQuery>;
export type GetWorkOrderChargesQueryResult = Apollo.QueryResult<GetWorkOrderChargesQuery, GetWorkOrderChargesQueryVariables>;
export const GetWorkOrderEquipmentDocument = gql`
    query getWorkOrderEquipment($workOrderId: String!, $take: Int! = 10, $after: String, $before: String, $search: String) {
  getWorkOrderEquipment(
    workOrderId: $workOrderId
    take: $take
    after: $after
    before: $before
    search: $search
  ) {
    pagination {
      ...PaginationFields
    }
    data {
      ...EquipmentCoreFields
      index
      active
      category {
        ...EquipmentCategoryCoreFields
      }
      floor {
        ...FloorCoreFields
      }
      suite {
        ...SuiteCoreFields
      }
    }
  }
}
    ${PaginationFieldsFragmentDoc}
${EquipmentCoreFieldsFragmentDoc}
${EquipmentCategoryCoreFieldsFragmentDoc}
${FloorCoreFieldsFragmentDoc}
${SuiteCoreFieldsFragmentDoc}`;

/**
 * __useGetWorkOrderEquipmentQuery__
 *
 * To run a query within a React component, call `useGetWorkOrderEquipmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkOrderEquipmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkOrderEquipmentQuery({
 *   variables: {
 *      workOrderId: // value for 'workOrderId'
 *      take: // value for 'take'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetWorkOrderEquipmentQuery(baseOptions: Apollo.QueryHookOptions<GetWorkOrderEquipmentQuery, GetWorkOrderEquipmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkOrderEquipmentQuery, GetWorkOrderEquipmentQueryVariables>(GetWorkOrderEquipmentDocument, options);
      }
export function useGetWorkOrderEquipmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkOrderEquipmentQuery, GetWorkOrderEquipmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkOrderEquipmentQuery, GetWorkOrderEquipmentQueryVariables>(GetWorkOrderEquipmentDocument, options);
        }
export type GetWorkOrderEquipmentQueryHookResult = ReturnType<typeof useGetWorkOrderEquipmentQuery>;
export type GetWorkOrderEquipmentLazyQueryHookResult = ReturnType<typeof useGetWorkOrderEquipmentLazyQuery>;
export type GetWorkOrderEquipmentQueryResult = Apollo.QueryResult<GetWorkOrderEquipmentQuery, GetWorkOrderEquipmentQueryVariables>;